/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var goldenlayout = {exports: {}};

(function (module, exports) {
	(function($){var lm={"config":{},"container":{},"controls":{},"errors":{},"items":{},"utils":{}};
	lm.utils.F = function () {
	};

	lm.utils.extend = function (subClass, superClass) {
		subClass.prototype = lm.utils.createObject(superClass.prototype);
		subClass.prototype.contructor = subClass;
	};

	lm.utils.createObject = function (prototype) {
		if (typeof Object.create === 'function') {
			return Object.create(prototype);
		} else {
			lm.utils.F.prototype = prototype;
			return new lm.utils.F();
		}
	};

	lm.utils.objectKeys = function (object) {
		var keys, key;

		if (typeof Object.keys === 'function') {
			return Object.keys(object);
		} else {
			keys = [];
			for (key in object) {
				keys.push(key);
			}
			return keys;
		}
	};

	lm.utils.getHashValue = function (key) {
		var matches = location.hash.match(new RegExp(key + '=([^&]*)'));
		return matches ? matches[1] : null;
	};

	lm.utils.getQueryStringParam = function (param) {
		if (window.location.hash) {
			return lm.utils.getHashValue(param);
		} else if (!window.location.search) {
			return null;
		}

		var keyValuePairs = window.location.search.substr(1).split('&'),
			params = {},
			pair,
			i;

		for (i = 0; i < keyValuePairs.length; i++) {
			pair = keyValuePairs[i].split('=');
			params[pair[0]] = pair[1];
		}

		return params[param] || null;
	};

	lm.utils.copy = function (target, source) {
		for (var key in source) {
			target[key] = source[key];
		}
		return target;
	};

	/**
	 * This is based on Paul Irish's shim, but looks quite odd in comparison. Why?
	 * Because
	 * a) it shouldn't affect the global requestAnimationFrame function
	 * b) it shouldn't pass on the time that has passed
	 *
	 * @param   {Function} fn
	 *
	 * @returns {void}
	 */
	lm.utils.animFrame = function (fn) {
		return (window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			function (callback) {
				window.setTimeout(callback, 1000 / 60);
			})(function () {
				fn();
			});
	};

	lm.utils.indexOf = function (needle, haystack) {
		if (!(haystack instanceof Array)) {
			throw new Error('Haystack is not an Array');
		}

		if (haystack.indexOf) {
			return haystack.indexOf(needle);
		} else {
			for (var i = 0; i < haystack.length; i++) {
				if (haystack[i] === needle) {
					return i;
				}
			}
			return -1;
		}
	};

	if (typeof /./ != 'function' && typeof Int8Array != 'object') {
		lm.utils.isFunction = function (obj) {
			return typeof obj == 'function' || false;
		};
	} else {
		lm.utils.isFunction = function (obj) {
			return toString.call(obj) === '[object Function]';
		};
	}

	lm.utils.fnBind = function (fn, context, boundArgs) {

		if (Function.prototype.bind !== undefined) {
			return Function.prototype.bind.apply(fn, [context].concat(boundArgs || []));
		}

		var bound = function () {

			// Join the already applied arguments to the now called ones (after converting to an array again).
			var args = (boundArgs || []).concat(Array.prototype.slice.call(arguments, 0));

			// If not being called as a constructor
			if (!(this instanceof bound)) {
				// return the result of the function called bound to target and partially applied.
				return fn.apply(context, args);
			}
			// If being called as a constructor, apply the function bound to self.
			fn.apply(this, args);
		};
		// Attach the prototype of the function to our newly created function.
		bound.prototype = fn.prototype;
		return bound;
	};

	lm.utils.removeFromArray = function (item, array) {
		var index = lm.utils.indexOf(item, array);

		if (index === -1) {
			throw new Error('Can\'t remove item from array. Item is not in the array');
		}

		array.splice(index, 1);
	};

	lm.utils.moveInArray = function (arr, fromIndex, toIndex) {
		var element = arr[fromIndex];
		arr.splice(fromIndex, 1);
		arr.splice(toIndex, 0, element);
	};

	lm.utils.getBounds = function (element) {
		if (!element[0]) {
			throw new Error("Cannot get bounds of invalid element");
		}
		return element[0].getBoundingClientRect();
	};

	lm.utils.now = function () {
		if (typeof Date.now === 'function') {
			return Date.now();
		} else {
			return (new Date()).getTime();
		}
	};

	lm.utils.getUniqueId = function () {
		return (Math.random() * 1000000000000000)
			.toString(36)
			.replace('.', '');
	};

	/**
	 * A basic XSS filter. It is ultimately up to the
	 * implementing developer to make sure their particular
	 * applications and usecases are save from cross site scripting attacks
	 *
	 * @param   {String} input
	 * @param    {Boolean} keepTags
	 *
	 * @returns {String} filtered input
	 */
	lm.utils.filterXss = function (input, keepTags) {

		var output = input
			.replace(/javascript/gi, 'j&#97;vascript')
			.replace(/expression/gi, 'expr&#101;ssion')
			.replace(/onload/gi, 'onlo&#97;d')
			.replace(/script/gi, '&#115;cript')
			.replace(/onerror/gi, 'on&#101;rror');

		if (keepTags === true) {
			return output;
		} else {
			return output
				.replace(/>/g, '&gt;')
				.replace(/</g, '&lt;');
		}
	};

	/**
	 * Removes html tags from a string
	 *
	 * @param   {String} input
	 *
	 * @returns {String} input without tags
	 */
	lm.utils.stripTags = function (input) {
		return $.trim(input.replace(/(<([^>]+)>)/ig, ''));
	};

	lm.utils.idAsString = function (id) {
		return Array.isArray(id) ? id[0] : id;
	};

	lm.utils.isCustomWorkspaceTab = function (tab) {
		const isWorkspaceTab = tab._layoutManager.config.settings.mode === "workspace";
		const isCustomWorkspaceTab = isWorkspaceTab && tab._layoutManager._componentFactory && tab._layoutManager._componentFactory.createWorkspaceTabs;

		return isCustomWorkspaceTab;
	};

	lm.utils.isCustomWorkspaceWindowTab =  function (tab){
		const isWindowTab = tab._layoutManager.config.settings.mode !== "workspace";
		const isCustomWorkspaceWindowTab = isWindowTab && tab._layoutManager._componentFactory && tab._layoutManager._componentFactory.createWorkspaceWindowTabs;

		return isCustomWorkspaceWindowTab;
	};

	/**
	 * A generic and very fast EventEmitter
	 * implementation. On top of emitting the
	 * actual event it emits an
	 *
	 * lm.utils.EventEmitter.ALL_EVENT
	 *
	 * event for every event triggered. This allows
	 * to hook into it and proxy events forwards
	 *
	 * @constructor
	 */
	lm.utils.EventEmitter = function() {
		this._mSubscriptions = {};
		this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ] = [];

		/**
		 * Listen for events
		 *
		 * @param   {String} sEvent    The name of the event to listen to
		 * @param   {Function} fCallback The callback to execute when the event occurs
		 * @param   {[Object]} oContext The value of the this pointer within the callback function
		 *
		 * @returns {void}
		 */
		this.on = function( sEvent, fCallback, oContext ) {
			if( !lm.utils.isFunction( fCallback ) ) {
				throw new Error( 'Tried to listen to event ' + sEvent + ' with non-function callback ' + fCallback );
			}

			if( !this._mSubscriptions[ sEvent ] ) {
				this._mSubscriptions[ sEvent ] = [];
			}

			this._mSubscriptions[ sEvent ].push( { fn: fCallback, ctx: oContext } );
		};

		/**
		 * Emit an event and notify listeners
		 *
		 * @param   {String} sEvent The name of the event
		 * @param    {Mixed}  various additional arguments that will be passed to the listener
		 *
		 * @returns {void}
		 */
		this.emit = function( sEvent ) {
			var i, ctx, args;

			args = Array.prototype.slice.call( arguments, 1 );

			var subs = this._mSubscriptions[ sEvent ];

			if( subs ) {
	        	subs = subs.slice();
				for( i = 0; i < subs.length; i++ ) {
					ctx = subs[ i ].ctx || {};
	                subs[ i ].fn.apply( ctx, args );
				}
			}

			args.unshift( sEvent );

			var allEventSubs = this._mSubscriptions[ lm.utils.EventEmitter.ALL_EVENT ].slice();

			for( i = 0; i <allEventSubs.length; i++ ) {
				ctx = allEventSubs[ i ].ctx || {};
	            allEventSubs[ i ].fn.apply( ctx, args );
			}
		};

		/**
		 * Removes a listener for an event, or all listeners if no callback and context is provided.
		 *
		 * @param   {String} sEvent    The name of the event
		 * @param   {Function} fCallback The previously registered callback method (optional)
		 * @param   {Object} oContext  The previously registered context (optional)
		 *
		 * @returns {void}
		 */
		this.unbind = function( sEvent, fCallback, oContext ) {
			if( !this._mSubscriptions[ sEvent ] ) {
				// This is removed because when you replace an item there is no subscription for destroy
				// throw new Error( 'No subscribtions to unsubscribe for event ' + sEvent );
				return;
			}

			var i, bUnbound = false;

			for( i = 0; i < this._mSubscriptions[ sEvent ].length; i++ ) {
				if
				(
					( !fCallback || this._mSubscriptions[ sEvent ][ i ].fn === fCallback ) &&
					( !oContext || oContext === this._mSubscriptions[ sEvent ][ i ].ctx )
				) {
					this._mSubscriptions[ sEvent ].splice( i, 1 );
					bUnbound = true;
				}
			}

			if( bUnbound === false ) {
				throw new Error( 'Nothing to unbind for ' + sEvent );
			}
		};

		/**
		 * Alias for unbind
		 */
		this.off = this.unbind;

		/**
		 * Alias for emit
		 */
		this.trigger = this.emit;
	};

	/**
	 * The name of the event that's triggered for every other event
	 *
	 * usage
	 *
	 * myEmitter.on( lm.utils.EventEmitter.ALL_EVENT, function( eventName, argsArray ){
	 * 	//do stuff
	 * });
	 *
	 * @type {String}
	 */
	lm.utils.EventEmitter.ALL_EVENT = '__all';
	lm.utils.DragListener = function (eElement, nButtonCode) {
		lm.utils.EventEmitter.call(this);

		this._eElement = $(eElement);
		this._oDocument = $(document);
		this._eBody = $(document.body);
		this._nButtonCode = nButtonCode || 0;

		/**
		 * The delay after which to start the drag in milliseconds
		 */
		this._nDelay = 200;

		/**
		 * The distance the mouse needs to be moved to qualify as a drag
		 */
		this._nDistance = 10;//TODO - works better with delay only

		this._nX = 0;
		this._nY = 0;

		this._nOriginalX = 0;
		this._nOriginalY = 0;

		this._bDragging = false;

		this._fMove = lm.utils.fnBind(this.onMouseMove, this);
		this._fUp = lm.utils.fnBind(this.onMouseUp, this);
		this._fDown = lm.utils.fnBind(this.onMouseDown, this);


		this._eElement.on('mousedown touchstart', this._fDown);
	};

	lm.utils.DragListener.timeout = null;

	lm.utils.copy(lm.utils.DragListener.prototype, {
		destroy: function () {
			this._eElement.unbind('mousedown touchstart', this._fDown);
			this._oDocument.unbind('mouseup touchend', this._fUp);
			this._eElement = null;
			this._oDocument = null;
			this._eBody = null;
		},

		onMouseDown: function (oEvent) {
			oEvent.preventDefault();

			if (oEvent.button == 0 || oEvent.type === "touchstart") {
				var coordinates = this._getCoordinates(oEvent);

				this._nOriginalX = coordinates.x;
				this._nOriginalY = coordinates.y;

				this._oDocument.on('mousemove touchmove', this._fMove);
				this._oDocument.one('mouseup touchend', this._fUp);

				this._timeout = setTimeout(lm.utils.fnBind(function () { this._startDrag(oEvent); }, this), this._nDelay);
			}
		},

		onMouseMove: function (oEvent) {
			if (this._timeout != null) {
				oEvent.preventDefault();

				var coordinates = this._getCoordinates(oEvent);

				this._nX = coordinates.x - this._nOriginalX;
				this._nY = coordinates.y - this._nOriginalY;

				if (this._bDragging === false) {
					if (
						Math.abs(this._nX) > this._nDistance ||
						Math.abs(this._nY) > this._nDistance
					) {
						clearTimeout(this._timeout);
						this._startDrag(oEvent);
					}
				}

				if (this._bDragging) {
					this.emit('drag', this._nX, this._nY, oEvent);
				}
			}
		},

		onMouseUp: function (oEvent) {
			if (this._timeout != null) {
				clearTimeout(this._timeout);
				this._eBody.removeClass('lm_dragging');
				this._eElement.removeClass('lm_dragging');
				this._oDocument.find('iframe').css('pointer-events', '');
				this._oDocument.unbind('mousemove touchmove', this._fMove);
				this._oDocument.unbind('mouseup touchend', this._fUp);

				if (this._bDragging === true) {
					this._bDragging = false;
					this.emit('dragStop', oEvent, this._nOriginalX + this._nX);
				}
			}
		},

		_startDrag: function (e) {
			this._bDragging = true;
			this._eBody.addClass('lm_dragging');
			this._eElement.addClass('lm_dragging');
			this._oDocument.find('iframe').css('pointer-events', 'none');
			this.emit('dragStart', this._nOriginalX, this._nOriginalY, e);
		},

		_getCoordinates: function (event) {
			event = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : event;
			return {
				x: event.pageX,
				y: event.pageY
			};
		}
	});
	/**
	 * The main class that will be exposed as GoldenLayout.
	 *
	 * @public
	 * @constructor
	 * @param {GoldenLayout config} config
	 * @param {[DOM element container]} container Can be a jQuery selector string or a Dom element. Defaults to body
	 *
	 * @returns {VOID}
	 */
	lm.LayoutManager = function (config, container, componentFactory) {
		if (!$ && window.$) {
			$ = window.$;
		}
		if (!$ || typeof $.noConflict !== 'function') {
			var errorMsg = 'jQuery is missing as dependency for GoldenLayout. ';
			errorMsg += 'Please either expose $ on GoldenLayout\'s scope (e.g. window) or add "jquery" to ';
			errorMsg += 'your paths when using RequireJS/AMD';
			throw new Error(errorMsg);
		}
		lm.utils.EventEmitter.call(this);

		this.isInitialised = false;
		this._isFullPage = false;
		this._resizeTimeoutId = null;
		this._components = { 'lm-react-component': lm.utils.ReactComponentHandler };
		this._itemAreas = [];
		this._resizeFunction = lm.utils.fnBind(this._onResize, this);
		this._unloadFunction = lm.utils.fnBind(this._onUnload, this);
		this._onItemCreatedFunction = lm.utils.fnBind(this._onItemCreated, this);
		this._onItemDestroyedFunction = lm.utils.fnBind(this._onItemDestroyed, this);
		this._maximizedItem = null;
		this._maximizedItemsInTargetContainer = {};
		this._maximizePlaceholder = $('<div class="lm_maximise_place"></div>');
		this._creationTimeoutPassed = false;
		this._subWindowsCreated = false;
		this._dragSources = [];
		this._dragProxies = [];
		this._updatingColumnsResponsive = false;
		this._firstLoad = true;
		this._componentFactory = componentFactory;
		this._ignorePinned = false;
		this._idToMinMaxConstraints = {};

		this.width = null;
		this.height = null;
		this.root = null;
		this.openPopouts = [];
		this.selectedItem = null;
		this.isSubWindow = false;
		this.eventHub = new lm.utils.EventHub(this);
		this.config = this._createConfig(config);
		this.container = container;
		this.dropTargetIndicator = null;
		this.transitionIndicator = null;
		this.tabDropPlaceholder = $('<div class="lm_drop_tab_placeholder"></div>');

		if (this.isSubWindow === true) {
			$('body').css('visibility', 'hidden');
		}

		this._typeToItem = {
			'column': lm.utils.fnBind(lm.items.RowOrColumn, this, [true]),
			'row': lm.utils.fnBind(lm.items.RowOrColumn, this, [false]),
			'stack': lm.items.Stack,
			'component': lm.items.Component
		};
	};

	/**
	 * Hook that allows to access private classes
	 */
	lm.LayoutManager.__lm = lm;

	/**
	 * Takes a GoldenLayout configuration object and
	 * replaces its keys and values recursively with
	 * one letter codes
	 *
	 * @static
	 * @public
	 * @param   {Object} config A GoldenLayout config object
	 *
	 * @returns {Object} minified config
	 */
	lm.LayoutManager.minifyConfig = function (config) {
		return (new lm.utils.ConfigMinifier()).minifyConfig(config);
	};

	/**
	 * Takes a configuration Object that was previously minified
	 * using minifyConfig and returns its original version
	 *
	 * @static
	 * @public
	 * @param   {Object} minifiedConfig
	 *
	 * @returns {Object} the original configuration
	 */
	lm.LayoutManager.unminifyConfig = function (config) {
		return (new lm.utils.ConfigMinifier()).unminifyConfig(config);
	};

	lm.utils.copy(lm.LayoutManager.prototype, {

		/**
		 * Register a component with the layout manager. If a configuration node
		 * of type component is reached it will look up componentName and create the
		 * associated component
		 *
		 *  {
		 *		type: "component",
		 *		componentName: "EquityNewsFeed",
		 *		componentState: { "feedTopic": "us-bluechips" }
		 *  }
		 *
		 * @public
		 * @param   {String} name
		 * @param   {Function} constructor
		 *
		 * @returns {void}
		 */
		registerComponent: function (name, constructor) {
			if (typeof constructor !== 'function') {
				throw new Error('Please register a constructor function');
			}

			if (this._components[name] !== undefined) {
				throw new Error('Component ' + name + ' is already registered');
			}

			this._components[name] = constructor;
		},

		unregisterComponent: function (name) {
			delete this._components[name];
		},

		/**
		 * Creates a layout configuration object based on the the current state
		 *
		 * @public
		 * @returns {Object} GoldenLayout configuration
		 */
		toConfig: function (root) {
			var config, next, i;

			if (this.isInitialised === false) {
				throw new Error('Can\'t create config, layout not yet initialised');
			}

			if (root && !(root instanceof lm.items.AbstractContentItem)) {
				throw new Error('Root must be a ContentItem');
			}

			/*
			 * settings & labels
			 */
			config = {
				settings: lm.utils.copy({}, this.config.settings),
				dimensions: lm.utils.copy({}, this.config.dimensions),
				labels: lm.utils.copy({}, this.config.labels),
				context: lm.utils.copy({}, this.config.context),
				workspacesOptions: lm.utils.copy({}, this.config.workspacesOptions)
			};

			/*
			 * Content
			 */
			config.content = [];
			next = function (configNode, item) {
				var key, i;

				for (key in item.config) {
					if (key !== 'content') {
						configNode[key] = item.config[key];
					}
				}

				if (item.contentItems.length) {
					configNode.content = [];

					for (i = 0; i < item.contentItems.length; i++) {
						configNode.content[i] = {};
						next(configNode.content[i], item.contentItems[i]);
					}
				}
			};

			if (root) {
				next(config, { contentItems: [root] });
			} else {
				next(config, this.root);
			}

			/*
			 * Retrieve config for subwindows
			 */
			this._$reconcilePopoutWindows();
			config.openPopouts = [];
			for (i = 0; i < this.openPopouts.length; i++) {
				config.openPopouts.push(this.openPopouts[i].toConfig());
			}

			/*
			 * Add maximised item
			 */
			config.maximizedItemId = this._maximizedItem ? '__glMaximised' : null;
			return config;
		},

		/**
		 * Returns a previously registered component
		 *
		 * @public
		 * @param   {String} name The name used
		 *
		 * @returns {Function}
		 */
		getComponent: function (name) {
			if (this._components[name] === undefined) {
				throw new lm.errors.ConfigurationError('Unknown component "' + name + '"');
			}

			return this._components[name];
		},

		/**
		 * Creates the actual layout. Must be called after all initial components
		 * are registered. Recurses through the configuration and sets up
		 * the item tree.
		 *
		 * If called before the document is ready it adds itself as a listener
		 * to the document.ready event
		 *
		 * @public
		 *
		 * @returns {void}
		 */
		init: function () {

			/**
			 * Create the popout windows straight away. If popouts are blocked
			 * an error is thrown on the same 'thread' rather than a timeout and can
			 * be caught. This also prevents any further initilisation from taking place.
			 */
			if (this._subWindowsCreated === false) {
				this._createSubWindows();
				this._subWindowsCreated = true;
			}


			/**
			 * If the document isn't ready yet, wait for it.
			 */
			if (document.readyState === 'loading' || document.body === null) {
				$(document).ready(lm.utils.fnBind(this.init, this));
				return;
			}

			/**
			 * If this is a subwindow, wait a few milliseconds for the original
			 * page's js calls to be executed, then replace the bodies content
			 * with GoldenLayout
			 */
			if (this.isSubWindow === true && this._creationTimeoutPassed === false) {
				setTimeout(lm.utils.fnBind(this.init, this), 7);
				this._creationTimeoutPassed = true;
				return;
			}

			if (this.isSubWindow === true) {
				this._adjustToWindowMode();
			}

			this._setContainer();
			this.dropTargetIndicator = new lm.controls.DropTargetIndicator(this.container);
			this.transitionIndicator = new lm.controls.TransitionIndicator();
			this.updateSize();
			this._create(this.config);
			this._bindEvents();
			this.isInitialised = true;
			this._adjustColumnsResponsive();
			this._maximizeContainers();
			this.emit('initialised');
		},

		/**
		 * Updates the layout managers size
		 *
		 * @public
		 * @param   {[int]} width  height in pixels
		 * @param   {[int]} height width in pixels
		 *
		 * @returns {void}
		 */
		updateSize: function (width, height) {
			if (arguments.length === 2) {
				this.width = width;
				this.height = height;
			} else {
				const containerBounds = lm.utils.getBounds(this.container);
				this.width = containerBounds.width;
				this.height = containerBounds.height;
			}

			if (this.isInitialised === true) {
				this.root.callDownwards('setSize', [this.width, this.height]);

				if (this._maximizedItem) {
					this._maximizedItem.element.width(this.width);
					this._maximizedItem.element.height(this.height);
					this._maximizedItem.callDownwards('setSize');
				}

				Object.values(this._maximizedItemsInTargetContainer).forEach((maximizedItemData) => {
					const maximizedItem = maximizedItemData.contentItem;
					const maximizationContainer = maximizedItemData.maximizationContainer;
					const maximizationContainerBounds = lm.utils.getBounds(maximizationContainer.element);

					maximizedItem.element.width(maximizationContainerBounds.width);
					maximizedItem.element.height(maximizationContainerBounds.height);
					maximizedItem.callDownwards('setSize');
				});

				this._adjustColumnsResponsive();
			}
		},

		/**
		 * Destroys the LayoutManager instance itself as well as every ContentItem
		 * within it. After this is called nothing should be left of the LayoutManager.
		 *
		 * @public
		 * @returns {void}
		 */
		destroy: function () {
			if (this.isInitialised === false) {
				return;
			}
			this._onUnload();
			$(window).off('resize', this._resizeFunction);
			$(window).off('unload beforeunload', this._unloadFunction);
			this.root.callDownwards('_$destroy', [], true);
			this.root.contentItems = [];
			this.tabDropPlaceholder.remove();
			this.dropTargetIndicator.destroy();
			this.transitionIndicator.destroy();
			this.eventHub.destroy();

			this._dragSources.forEach(function (dragSource) {
				if (typeof dragSource._dragListener.destroy === "function") {
					dragSource._dragListener.destroy();
				}
				dragSource._element = null;
				dragSource._itemConfig = null;
				dragSource._dragListener = null;
			});
			this._dragSources = [];
		},

		/**
		 * Recursively creates new item tree structures based on a provided
		 * ItemConfiguration object
		 *
		 * @public
		 * @param   {Object} config ItemConfig
		 * @param   {[ContentItem]} parent The item the newly created item should be a child of
		 *
		 * @returns {lm.items.ContentItem}
		 */
		createContentItem: function (config, parent) {
			var typeErrorMsg, contentItem;

			if (typeof config.type !== 'string') {
				throw new lm.errors.ConfigurationError('Missing parameter \'type\'', config);
			}

			if (config.type === 'react-component') {
				config.type = 'component';
				config.componentName = 'lm-react-component';
			}

			if (!this._typeToItem[config.type]) {
				typeErrorMsg = 'Unknown type \'' + config.type + '\'. ' +
					'Valid types are ' + lm.utils.objectKeys(this._typeToItem).join(',');

				throw new lm.errors.ConfigurationError(typeErrorMsg);
			}


			/**
			 * We add an additional stack around every component that's not within a stack anyways.
			 */
			if (
				// If this is a component
				config.type === 'component' &&

				// and it's not already within a stack
				!(parent instanceof lm.items.Stack) &&

				// and we have a parent
				!!parent &&

				// and it's not the topmost item in a new window
				!(this.isSubWindow === true && parent instanceof lm.items.Root)
			) {
				config = {
					type: 'stack',
					width: config.width,
					height: config.height,
					content: [config]
				};
			}

			contentItem = new this._typeToItem[config.type](this, config, parent);
			return contentItem;
		},

		/**
		 * Creates a popout window with the specified content and dimensions
		 *
		 * @param   {Object|lm.itemsAbstractContentItem} configOrContentItem
		 * @param   {[Object]} dimensions A map with width, height, left and top
		 * @param    {[String]} parentId the id of the element this item will be appended to
		 *                             when popIn is called
		 * @param    {[Number]} indexInParent The position of this item within its parent element

		 * @returns {lm.controls.BrowserPopout}
		 */
		createPopout: function (configOrContentItem, dimensions, parentId, indexInParent) {
			var config = configOrContentItem,
				isItem = configOrContentItem instanceof lm.items.AbstractContentItem,
				self = this,
				windowLeft,
				windowTop,
				parent,
				child,
				browserPopout;

			parentId = parentId || null;

			if (isItem) {
				config = this.toConfig(configOrContentItem).content;
				parentId = lm.utils.getUniqueId();

				/**
				 * If the item is the only component within a stack or for some
				 * other reason the only child of its parent the parent will be destroyed
				 * when the child is removed.
				 *
				 * In order to support this we move up the tree until we find something
				 * that will remain after the item is being popped out
				 */
				parent = configOrContentItem.parent;
				child = configOrContentItem;
				while (parent.contentItems.length === 1 && !parent.isRoot) {
					parent = parent.parent;
					child = child.parent;
				}

				parent.addId(parentId);
				if (isNaN(indexInParent)) {
					indexInParent = lm.utils.indexOf(child, parent.contentItems);
				}
			} else {
				if (!(config instanceof Array)) {
					config = [config];
				}
			}


			if (!dimensions && isItem) {
				windowLeft = window.screenX || window.screenLeft;
				windowTop = window.screenY || window.screenTop;
				const bounds = lm.utils.getBounds(configOrContentItem.element);

				dimensions = {
					left: windowLeft + bounds.left,
					top: windowTop + bounds.top,
					width: bounds.width,
					height: bounds.height
				};
			}

			if (!dimensions && !isItem) {
				dimensions = {
					left: window.screenX || window.screenLeft + 20,
					top: window.screenY || window.screenTop + 20,
					width: 500,
					height: 309
				};
			}

			if (isItem) {
				configOrContentItem.remove();
			}

			browserPopout = new lm.controls.BrowserPopout(config, dimensions, parentId, indexInParent, this);

			browserPopout.on('initialised', function () {
				self.emit('windowOpened', browserPopout);
			});

			browserPopout.on('closed', function () {
				self._$reconcilePopoutWindows();
			});

			this.openPopouts.push(browserPopout);

			return browserPopout;
		},

		/**
		 * Attaches DragListener to any given DOM element
		 * and turns it into a way of creating new ContentItems
		 * by 'dragging' the DOM element into the layout
		 *
		 * @param   {jQuery DOM element} element
		 * @param   {Object|Function} itemConfig for the new item to be created, or a function which will provide it
		 *
		 * @returns {void}
		 */
		createDragSource: function (element, itemConfig, customDragListener) {
			this.config.settings.constrainDragToContainer = false;
			var dragSource = new lm.controls.DragSource($(element), itemConfig, this, customDragListener);
			this._dragSources.push(dragSource);

			return dragSource;
		},

		/**
		 * Programmatically selects an item. This deselects
		 * the currently selected item, selects the specified item
		 * and emits a selectionChanged event
		 *
		 * @param   {lm.item.AbstractContentItem} item#
		 * @param   {[Boolean]} _$silent Wheather to notify the item of its selection
		 * @event    selectionChanged
		 *
		 * @returns {VOID}
		 */
		selectItem: function (item, _$silent) {

			if (this.config.settings.selectionEnabled !== true) {
				throw new Error('Please set selectionEnabled to true to use this feature');
			}

			if (item === this.selectedItem) {
				return;
			}

			if (this.selectedItem !== null) {
				this.selectedItem.deselect();
			}

			if (item && _$silent !== true) {
				item.select();
			}

			this.selectedItem = item;

			this.emit('selectionChanged', item);
		},

		/*************************
		 * PACKAGE PRIVATE
		 *************************/
		_$maximiseItem: function (contentItem) {
			const maximizationContainer = this._findItemToMaximizeIn(contentItem);

			if (maximizationContainer != this.root) {
				this._$maximiseInContainer(contentItem, maximizationContainer);
				return;
			}

			if (this._maximizedItem !== null) {
				const contentItem = this._maximizedItem;
				this._$minimiseItem(this._maximizedItem);
				contentItem.isMaximized = false;
			}
			this._maximizedItem = contentItem;
			this._maximizedItem.addId('__glMaximised');
			contentItem.element.addClass('lm_maximised');
			contentItem.element.after(this._maximizePlaceholder);
			this.root.element.prepend(contentItem.element);

			const containerBounds = lm.utils.getBounds(this.container);
			contentItem.element.width(containerBounds.width);
			contentItem.element.height(containerBounds.height);

			contentItem.callDownwards('setSize');
			this._maximizedItem.emit('maximized');
			this.emit('stateChanged');
		},

		_$minimiseItem: function (contentItem) {
			if (this._maximizedItemsInTargetContainer[lm.utils.idAsString(contentItem.config.id)]) {
				this._$minimiseInContainer(contentItem);
				return;
			}
			contentItem.element.removeClass('lm_maximised');
			if (contentItem.hasId('__glMaximised')) {
				contentItem.removeId('__glMaximised');
			}
			this._maximizePlaceholder.after(contentItem.element);
			this._maximizePlaceholder.remove();
			contentItem.parent.callDownwards('setSize');
			this._maximizedItem = null;
			contentItem.emit('minimized');
			this.emit('stateChanged');
		},

		_findItemToMaximizeIn: function (contentItem) {
			if (!contentItem) {
				return this.root;
			}

			if (contentItem.config.workspacesConfig.maximizationBoundary) {
				return contentItem;
			}

			return this._findItemToMaximizeIn(contentItem.parent);
		},
		_$maximiseInContainer: function (contentItem, maximizationContainer) {
			const maximizedDataForTargetContainer = Object.values(this._maximizedItemsInTargetContainer).find(data => data.maximizationContainer === maximizationContainer);
			if (maximizedDataForTargetContainer) {
				this._$minimiseItem(maximizedDataForTargetContainer.contentItem);
				maximizedDataForTargetContainer.contentItem.isMaximized = false;
			}
			const placeholder = $(`<div id="${lm.utils.idAsString(contentItem.config.id)}" class="lm_maximise_target_container_placeholder"></div>`);
			this._maximizedItemsInTargetContainer[lm.utils.idAsString(contentItem.config.id)] = { contentItem, maximizationContainer, placeholder };
			contentItem.addId('__glMaximised');
			contentItem.element.addClass('lm_maximised_in_container');
			contentItem.element.after(placeholder);
			maximizationContainer.element.prepend(contentItem.element);
			const maximizationContainerBounds = lm.utils.getBounds(maximizationContainer.element);
			contentItem.element.width(maximizationContainerBounds.width);
			contentItem.element.height(maximizationContainerBounds.height);
			contentItem.callDownwards('setSize');
			contentItem.emit('maximized');
			this.emit('stateChanged');
		},
		_$minimiseInContainer: function (contentItem) {
			contentItem.element.removeClass('lm_maximised_in_container');
			const placeholder = this._maximizedItemsInTargetContainer[lm.utils.idAsString(contentItem.config.id)].placeholder;
			if (contentItem.hasId('__glMaximised')) {
				contentItem.removeId('__glMaximised');
			}
			placeholder.after(contentItem.element);
			placeholder.remove();
			contentItem.parent.callDownwards('setSize');
			delete this._maximizedItemsInTargetContainer[lm.utils.idAsString(contentItem.config.id)];
			contentItem.emit('minimized');
			this.emit('stateChanged');
		},
		/**
		 * This method is used to get around sandboxed iframe restrictions.
		 * If 'allow-top-navigation' is not specified in the iframe's 'sandbox' attribute
		 * (as is the case with codepens) the parent window is forbidden from calling certain
		 * methods on the child, such as window.close() or setting document.location.href.
		 *
		 * This prevented GoldenLayout popouts from popping in in codepens. The fix is to call
		 * _$closeWindow on the child window's gl instance which (after a timeout to disconnect
		 * the invoking method from the close call) closes itself.
		 *
		 * @packagePrivate
		 *
		 * @returns {void}
		 */
		_$closeWindow: function () {
			window.setTimeout(function () {
				window.close();
			}, 1);
		},

		_$getArea: function (x, y) {
			var i, area, smallestSurface = Infinity, mathingArea = null;

			for (i = 0; i < this._itemAreas.length; i++) {
				area = this._itemAreas[i];
				if (
					x > area.x1 &&
					x < area.x2 &&
					y > area.y1 &&
					y < area.y2 &&
					smallestSurface > area.surface
				) {
					smallestSurface = area.surface;
					mathingArea = area;
				}
			}

			return mathingArea;
		},

		_$createRootItemAreas: function () {
			const { allowDrop, allowDropLeft, allowDropTop, allowDropRight, allowDropBottom } = this.config.workspacesOptions;

			if (allowDrop === false &&
				allowDropLeft !== true &&
				allowDropTop !== true &&
				allowDropRight !== true &&
				allowDropBottom !== true) {
				return;
			}

			var areaSize = 50;
			var sides = { y2: 0, x2: 0, y1: 'y2', x1: 'x2' };
			for (var side in sides) {
				var area = this.root._$getArea();
				area.side = side;
				if (sides[side])
					area[side] = area[sides[side]] - areaSize;
				else if (side === "y2") { // Added to enable proper top drop area and proper tab drop area
					area[side] = areaSize + this.root.element.offset().top;
				} else {
					area[side] = areaSize;
				}
				area.surface = (area.x2 - area.x1) * (area.y2 - area.y1);

				this._itemAreas.push(area);
			}

			if (allowDropLeft === false ||
				allowDrop === false && allowDropLeft !== true) {
				this._itemAreas[1] = undefined;
			}

			if (allowDropTop === false ||
				allowDrop === false && allowDropTop !== true) {
				this._itemAreas[0] = undefined;
			}

			if (allowDropRight === false ||
				allowDrop === false && allowDropRight !== true) {
				this._itemAreas[3] = undefined;
			}

			if (allowDropBottom === false ||
				allowDrop === false && allowDropBottom !== true) {
				this._itemAreas[2] = undefined;
			}

			this._itemAreas = this._itemAreas.filter((ia) => typeof ia !== "undefined");
		},

		_$calculateItemAreas: function () {
			var i, area, allContentItems = this._getAllContentItems();
			this._itemAreas = [];

			/**
			 * If the last item is dragged out, highlight the entire container size to
			 * allow to re-drop it. allContentItems[ 0 ] === this.root at this point
			 *
			 * Don't include root into the possible drop areas though otherwise since it
			 * will used for every gap in the layout, e.g. splitters
			 */
			if (allContentItems.length === 1) {
				this._itemAreas.push(this.root._$getArea());
				return;
			}
			this._$createRootItemAreas();

			for (i = 0; i < allContentItems.length; i++) {

				if (!(allContentItems[i].isStack)) {
					continue;
				}

				const isAllowDropExplicitlyTrue = allContentItems[i].config.workspacesConfig && allContentItems[i].config.workspacesConfig.allowDrop === true;

				if (this.config.workspacesOptions.allowDrop === false && !isAllowDropExplicitlyTrue) {
					continue;
				}

				if (allContentItems[i].config.workspacesConfig && allContentItems[i].config.workspacesConfig.allowDrop === false) {
					continue;
				}

				area = allContentItems[i]._$getArea();

				if (area === null) {
					continue;
				} else if (area instanceof Array) {
					this._itemAreas = this._itemAreas.concat(area);
				} else {
					this._itemAreas.push(area);
					var header = {};
					lm.utils.copy(header, area);
					if (area.contentItem._contentAreaDimensions.header) {
						lm.utils.copy(header, area.contentItem._contentAreaDimensions.header.highlightArea);
						header.surface = (header.x2 - header.x1) * (header.y2 - header.y1);
						this._itemAreas.push(header);
					}

					if (allContentItems[i]._dropSegment) {
						allContentItems[i]._dropSegment = null;
					}
				}
			}

			if (this.config.settings.mode === "workspace") {
				this._itemAreas = [this._itemAreas[this._itemAreas.length - 1]];
			}
		},

		/**
		 * Takes a contentItem or a configuration and optionally a parent
		 * item and returns an initialised instance of the contentItem.
		 * If the contentItem is a function, it is first called
		 *
		 * @packagePrivate
		 *
		 * @param   {lm.items.AbtractContentItem|Object|Function} contentItemOrConfig
		 * @param   {lm.items.AbtractContentItem} parent Only necessary when passing in config
		 *
		 * @returns {lm.items.AbtractContentItem}
		 */
		_$normalizeContentItem: function (contentItemOrConfig, parent) {
			if (!contentItemOrConfig) {
				throw new Error('No content item defined');
			}

			if (lm.utils.isFunction(contentItemOrConfig)) {
				contentItemOrConfig = contentItemOrConfig();
			}

			if (contentItemOrConfig instanceof lm.items.AbstractContentItem) {
				return contentItemOrConfig;
			}

			if ($.isPlainObject(contentItemOrConfig) && contentItemOrConfig.type) {
				var newContentItem = this.createContentItem(contentItemOrConfig, parent);
				newContentItem.callDownwards('_$init');
				return newContentItem;
			} else {
				throw new Error('Invalid contentItem');
			}
		},

		/**
		 * Iterates through the array of open popout windows and removes the ones
		 * that are effectively closed. This is necessary due to the lack of reliably
		 * listening for window.close / unload events in a cross browser compatible fashion.
		 *
		 * @packagePrivate
		 *
		 * @returns {void}
		 */
		_$reconcilePopoutWindows: function () {
			var openPopouts = [], i;

			for (i = 0; i < this.openPopouts.length; i++) {
				if (this.openPopouts[i].getWindow().closed === false) {
					openPopouts.push(this.openPopouts[i]);
				} else {
					this.emit('windowClosed', this.openPopouts[i]);
				}
			}

			if (this.openPopouts.length !== openPopouts.length) {
				this.emit('stateChanged');
				this.openPopouts = openPopouts;
			}

		},

		/***************************
		 * PRIVATE
		 ***************************/
		/**
		 * Returns a flattened array of all content items,
		 * regardles of level or type
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_getAllContentItems: function () {
			var allContentItems = [];

			var addChildren = function (contentItem) {
				allContentItems.push(contentItem);

				if (contentItem.contentItems instanceof Array) {
					for (var i = 0; i < contentItem.contentItems.length; i++) {
						addChildren(contentItem.contentItems[i]);
					}
				}
			};

			addChildren(this.root);

			return allContentItems;
		},

		/**
		 * Binds to DOM/BOM events on init
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_bindEvents: function () {
			if (this._isFullPage) {
				$(window).resize(this._resizeFunction);
			}
			$(window).on('unload beforeunload', this._unloadFunction);

			this.on("itemCreated", this._onItemCreatedFunction);
			this.on("itemDestroyed", this._onItemDestroyedFunction);
		},

		/**
		 * Debounces resize events
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onResize: function () {
			clearTimeout(this._resizeTimeoutId);
			this._resizeTimeoutId = setTimeout(lm.utils.fnBind(this.updateSize, this), 100);
		},

		/**
		 * Extends the default config with the user specific settings and applies
		 * derivations. Please note that there's a seperate method (AbstractContentItem._extendItemNode)
		 * that deals with the extension of item configs
		 *
		 * @param   {Object} config
		 * @static
		 * @returns {Object} config
		 */
		_createConfig: function (config) {
			var windowConfigKey = lm.utils.getQueryStringParam('gl-window');
			if (windowConfigKey) {
				this.isSubWindow = true;
				config = localStorage.getItem(windowConfigKey);
				config = JSON.parse(config);
				config = (new lm.utils.ConfigMinifier()).unminifyConfig(config);
				localStorage.removeItem(windowConfigKey);
			}

			config = $.extend(true, {}, lm.config.defaultConfig, config);

			var nextNode = function (node) {
				for (var key in node) {
					if (key !== 'props' && typeof node[key] === 'object') {
						nextNode(node[key]);
					}
					else if (key === 'type' && node[key] === 'react-component') {
						node.type = 'component';
						node.componentName = 'lm-react-component';
					}
				}
			};

			nextNode(config);

			if (config.settings.hasHeaders === false) {
				config.dimensions.headerHeight = 0;
			}
			if (this._componentFactory.settings && this._componentFactory.settings.splitterSize !== undefined) {
				config.dimensions.borderWidth = this._componentFactory.settings.splitterSize;
			}

			return config;
		},

		/**
		 * This is executed when GoldenLayout detects that it is run
		 * within a previously opened popout window.
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_adjustToWindowMode: function () {
			var popInButton = $('<div class="lm_popin" title="' + this.config.labels.popin + '">' +
				'<div class="lm_icon"></div>' +
				'<div class="lm_bg"></div>' +
				'</div>');

			popInButton.click(lm.utils.fnBind(function () {
				this.emit('popIn');
			}, this));

			document.title = lm.utils.stripTags(this.config.content[0].title);

			$('head').append($('body link, body style, template, .gl_keep'));

			this.container = $('body')
				.html('')
				.css('visibility', 'visible')
				.append(popInButton);

			/*
			 * This seems a bit pointless, but actually causes a reflow/re-evaluation getting around
			 * slickgrid's "Cannot find stylesheet." bug in chrome
			 */
			document.body.offsetHeight; // jshint ignore:line

			/*
			 * Expose this instance on the window object
			 * to allow the opening window to interact with
			 * it
			 */
			window.__glInstance = this;
		},

		/**
		 * Creates Subwindows (if there are any). Throws an error
		 * if popouts are blocked.
		 *
		 * @returns {void}
		 */
		_createSubWindows: function () {
			var i, popout;

			for (i = 0; i < this.config.openPopouts.length; i++) {
				popout = this.config.openPopouts[i];

				this.createPopout(
					popout.content,
					popout.dimensions,
					popout.parentId,
					popout.indexInParent
				);
			}
		},

		/**
		 * Determines what element the layout will be created in
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setContainer: function () {
			var container = $(this.container || 'body');

			if (container.length === 0) {
				throw new Error('GoldenLayout container not found');
			}

			if (container.length > 1) {
				throw new Error('GoldenLayout more than one container element specified');
			}

			if (container[0] === document.body) {
				this._isFullPage = true;

				$('html, body').css({
					height: '100%',
					margin: 0,
					padding: 0,
					overflow: 'hidden'
				});
			}

			this.container = container;
		},

		/**
		 * Kicks of the initial, recursive creation chain
		 *
		 * @param   {Object} config GoldenLayout Config
		 *
		 * @returns {void}
		 */
		_create: function (config) {
			var errorMsg;

			if (!(config.content instanceof Array)) {
				if (config.content === undefined) {
					errorMsg = 'Missing setting \'content\' on top level of configuration';
				} else {
					errorMsg = 'Configuration parameter \'content\' must be an array';
				}

				throw new lm.errors.ConfigurationError(errorMsg, config);
			}

			if (config.content.length > 1) {
				errorMsg = 'Top level content can\'t contain more then one element.';
				throw new lm.errors.ConfigurationError(errorMsg, config);
			}

			this.root = new lm.items.Root(this, { content: config.content }, this.container);
			this.root.callDownwards('_$init');

			if (config.maximizedItemId === '__glMaximised') {
				this.root.getItemsById(config.maximizedItemId)[0].toggleMaximise();
			}
		},

		/**
		 * Called when the window is closed or the user navigates away
		 * from the page
		 *
		 * @returns {void}
		 */
		_onUnload: function () {
			if (this.config.settings.closePopoutsOnUnload === true) {
				for (var i = 0; i < this.openPopouts.length; i++) {
					this.openPopouts[i].close();
				}
			}
		},

		_onItemCreated: function () {
			this._idToMinMaxConstraints = {};
		},
		_onItemDestroyed: function () {
			this._idToMinMaxConstraints = {};
		},

		/**
		 * Adjusts the number of columns to be lower to fit the screen and still maintain minItemWidth.
		 *
		 * @returns {void}
		 */
		_adjustColumnsResponsive: function () {

			// If there is no min width set, or not content items, do nothing.
			if (!this._useResponsiveLayout() || this._updatingColumnsResponsive || !this.config.dimensions || !this.config.dimensions.minItemWidth || this.root.contentItems.length === 0 || !this.root.contentItems[0].isRow) {
				this._firstLoad = false;
				return;
			}

			this._firstLoad = false;

			// If there is only one column, do nothing.
			var columnCount = this.root.contentItems[0].contentItems.length;
			if (columnCount <= 1) {
				return;
			}

			// If they all still fit, do nothing.
			var minItemWidth = this.config.dimensions.minItemWidth;
			var totalMinWidth = columnCount * minItemWidth;
			if (totalMinWidth <= this.width) {
				return;
			}

			// this.container[0].parentElement.parentElement.parentElement.offsetWidth true width for workspaceContents
			if (!this.container.is(":visible")) {
				return;
			}

			// Prevent updates while it is already happening.
			this._updatingColumnsResponsive = true;

			// Figure out how many columns to stack, and put them all in the first stack container.
			var finalColumnCount = Math.max(Math.floor(this.width / minItemWidth), 1);
			var stackColumnCount = columnCount - finalColumnCount;

			var rootContentItem = this.root.contentItems[0];
			var firstStackContainer = this._findAllStackContainers()[0];
			for (var i = 0; i < stackColumnCount; i++) {
				// Stack from right.
				var column = rootContentItem.contentItems[rootContentItem.contentItems.length - 1];
				this._addChildContentItemsToContainer(firstStackContainer, column);
			}

			this._updatingColumnsResponsive = false;
		},
		_maximizeContainers: function () {
			const maximizedItems = this.root.getItemsByFilter((i) => {
				return i.config.workspacesConfig && i.config.workspacesConfig.isMaximized && i.type != "component";
			});

			if (maximizedItems.length) {
				maximizedItems.forEach((mi) => {
					mi.toggleMaximise();
				});
			}
		},
		/**
		 * Determines if responsive layout should be used.
		 *
		 * @returns {bool} - True if responsive layout should be used; otherwise false.
		 */
		_useResponsiveLayout: function () {
			return this.config.settings && (this.config.settings.responsiveMode == 'always' || (this.config.settings.responsiveMode == 'onload' && this._firstLoad));
		},

		/**
		 * Adds all children of a node to another container recursively.
		 * @param {object} container - Container to add child content items to.
		 * @param {object} node - Node to search for content items.
		 * @returns {void}
		 */
		_addChildContentItemsToContainer: function (container, node) {
			if (node.type === 'stack') {
				node.contentItems.forEach(function (item) {
					container.addChild(item);
					node.removeChild(item, true);
				});
			}
			else {
				node.contentItems.forEach(lm.utils.fnBind(function (item) {
					this._addChildContentItemsToContainer(container, item);
				}, this));
			}
		},

		/**
		 * Finds all the stack containers.
		 * @returns {array} - The found stack containers.
		 */
		_findAllStackContainers: function () {
			var stackContainers = [];
			this._findAllStackContainersRecursive(stackContainers, this.root);

			return stackContainers;
		},

		/**
		 * Finds all the stack containers.
		 *
		 * @param {array} - Set of containers to populate.
		 * @param {object} - Current node to process.
		 *
		 * @returns {void}
		 */
		_findAllStackContainersRecursive: function (stackContainers, node) {
			node.contentItems.forEach(lm.utils.fnBind(function (item) {
				if (item.type == 'stack') {
					stackContainers.push(item);
				}
				else if (!item.isComponent) {
					this._findAllStackContainersRecursive(stackContainers, item);
				}
			}, this));
		},
		restoreMaximizedContainers: function () {
			this.root.getItemsByFilter((item) => {
				return item.hasId("__glMaximised") && item.type !== "component";
			}).forEach((item) => {
				this._$minimiseItem(item);
			});
		}
	});
	/**
	 * Expose the Layoutmanager as the single entrypoint using UMD
	 */
	(function () {
		/* global define */
		{
			lm.LayoutManager.default = lm.LayoutManager;
			module.exports = lm.LayoutManager;
		}
		window.GoldenLayout = lm.LayoutManager;
	})();

	lm.config.defaultConfig = {
		openPopouts: [],
		settings: {
			hasHeaders: true,
			constrainDragToContainer: true,
			reorderEnabled: true,
			selectionEnabled: false,
			popoutWholeStack: false,
			blockedPopoutsThrowError: true,
			closePopoutsOnUnload: true,
			showMinimizeIcon: false,
			showPopoutIcon: true,
			showMaximizeIcon: true,
			showCloseIcon: true,
			responsiveMode: 'always', // Can be onload, always, or none.
			tabOverlapAllowance: 0, // maximum pixel overlap per tab
			reorderOnTabMenuClick: true,
			tabControlOffset: 10,
			workspaceInnerDrag: true,
			mode: "default"
		},
		dimensions: {
			borderWidth: 5,
			borderGrabWidth: 15,
			minItemHeight: 20,
			maxItemHeight: 32767,
			minItemWidth: 20,
			maxItemWidth: 32767,
			headerHeight: 20,
			dragProxyWidth: 500,
			dragProxyHeight: 500
		},
		labels: {
			close: 'close',
			maximize: 'maximize',
			restore: 'restore',
			minimize: "minimize",
			popout: 'eject',
			popin: 'pop in',
			tabDropdown: 'additional tabs'
		},
		workspacesOptions: {
			// workspaces related options go here
		}
	};

	lm.config.itemDefaultConfig = () => ({
		isClosable: true,
		reorderEnabled: true,
		title: '',
		workspacesConfig: {
			// workspaces related properties
		}
	});
	lm.container.ItemContainer = function (config, parent, layoutManager) {
		lm.utils.EventEmitter.call(this);

		this.width = null;
		this.height = null;
		this.title = config.componentName;
		this.parent = parent;
		this.layoutManager = layoutManager;
		this.isHidden = false;

		this._config = config;
		this._element = $([
			'<div class="lm_item_container">',
			'<div class="lm_content"></div>',
			'</div>'
		].join(''));

		this._contentElement = this._element.find('.lm_content');
	};

	lm.utils.copy(lm.container.ItemContainer.prototype, {

		/**
		 * Get the inner DOM element the container's content
		 * is intended to live in
		 *
		 * @returns {DOM element}
		 */
		getElement: function () {
			return this._contentElement;
		},

		/**
		 * Hide the container. Notifies the containers content first
		 * and then hides the DOM node. If the container is already hidden
		 * this should have no effect
		 *
		 * @returns {void}
		 */
		hide: function () {
			this.emit('hide');
			this.isHidden = true;
			this._element.hide();
		},

		/**
		 * Shows a previously hidden container. Notifies the
		 * containers content first and then shows the DOM element.
		 * If the container is already visible this has no effect.
		 *
		 * @returns {void}
		 */
		show: function () {
			this.emit('show');
			this.isHidden = false;
			this._element.show();
			// call shown only if the container has a valid size
			if (this.height != 0 || this.width != 0) {
				this.emit('shown');
			}
		},

		/**
		 * Set the size from within the container. Traverses up
		 * the item tree until it finds a row or column element
		 * and resizes its items accordingly.
		 *
		 * If this container isn't a descendant of a row or column
		 * it returns false
		 * @todo  Rework!!!
		 * @param {Number} width  The new width in pixel
		 * @param {Number} height The new height in pixel
		 *
		 * @returns {Boolean} resizeSuccesful
		 */
		setSize: function (width, height) {
			var rowOrColumn = this.parent,
				rowOrColumnChild = this,
				totalPixel,
				percentage,
				direction,
				newSize,
				delta,
				i;

			if (!width && !height || (width && height)) {
				return false;
			}

			while ((!rowOrColumn.isColumn && height) || (!rowOrColumn.isRow && width) || rowOrColumn.contentItems.length <= 1) {
				rowOrColumnChild = rowOrColumn;
				rowOrColumn = rowOrColumn.parent;


				/**
				 * No row or column has been found
				 */
				if (rowOrColumn.isRoot) {
					return false;
				}
			}

			this.layoutManager._ignorePinned = true;
			rowOrColumn._calculateRelativeSizes();
			direction = rowOrColumn.isColumn ? "height" : "width";
			newSize = direction === "height" ? height : width;

			const currentElementSize = this._element[direction]();
			let elementSize = currentElementSize;
			
			if (elementSize === 0 && this._config.workspacesConfig.cachedBounds && this._config.workspacesConfig.cachedBounds[direction] > 0) {
				elementSize = this._config.workspacesConfig.cachedBounds[direction];
			} else if (elementSize === 0) {
				return false;
			}

			totalPixel = elementSize * (1 / (rowOrColumnChild.config[direction] / 100));
			percentage = (newSize / totalPixel) * 100;
			delta = (rowOrColumnChild.config[direction] - percentage) / (rowOrColumn.contentItems.length - 1);

			for (i = 0; i < rowOrColumn.contentItems.length; i++) {
				if (rowOrColumn.contentItems[i] === rowOrColumnChild) {
					rowOrColumn.contentItems[i].config[direction] = percentage;
				} else {
					rowOrColumn.contentItems[i].config[direction] += delta;
				}
			}

			if (currentElementSize > 0) {
				rowOrColumn.callDownwards('setSize');
			}

			this.layoutManager._ignorePinned = false;

			return true;
		},

		/**
		 * Closes the container if it is closable. Can be called by
		 * both the component within at as well as the contentItem containing
		 * it. Emits a close event before the container itself is closed.
		 *
		 * @returns {void}
		 */
		close: function () {
			if (this._config.isClosable) {
				this.emit('close');
				this.parent.close();
			}
		},

		/**
		 * Returns the current state object
		 *
		 * @returns {Object} state
		 */
		getState: function () {
			return this._config.componentState;
		},

		/**
		 * Merges the provided state into the current one
		 *
		 * @param   {Object} state
		 *
		 * @returns {void}
		 */
		extendState: function (state) {
			this.setState($.extend(true, this.getState(), state));
		},

		/**
		 * Notifies the layout manager of a stateupdate
		 *
		 * @param {serialisable} state
		 */
		setState: function (state) {
			this._config.componentState = state;
			this.parent.emitBubblingEvent('stateChanged');
		},

		/**
		 * Set's the components title
		 *
		 * @param {String} title
		 */
		setTitle: function (title) {
			this.parent.setTitle(title);
		},

		/**
		 * Set's the containers size. Called by the container's component.
		 * To set the size programmatically from within the container please
		 * use the public setSize method
		 *
		 * @param {[Int]} width  in px
		 * @param {[Int]} height in px
		 *
		 * @returns {void}
		 */
		_$setSize: function (width, height) {
			if (width !== this.width || height !== this.height) {
				this.width = width;
				this.height = height;
				var cl = this._contentElement[0];
				var hdelta = cl.offsetWidth - cl.clientWidth;
				var vdelta = cl.offsetHeight - cl.clientHeight;
				this._contentElement.width(this.width - hdelta)
					.height(this.height - vdelta);
				this.emit('resize');
			}
		}
	});

	/**
	 * Pops a content item out into a new browser window.
	 * This is achieved by
	 *
	 *    - Creating a new configuration with the content item as root element
	 *    - Serializing and minifying the configuration
	 *    - Opening the current window's URL with the configuration as a GET parameter
	 *    - GoldenLayout when opened in the new window will look for the GET parameter
	 *      and use it instead of the provided configuration
	 *
	 * @param {Object} config GoldenLayout item config
	 * @param {Object} dimensions A map with width, height, top and left
	 * @param {String} parentId The id of the element the item will be appended to on popIn
	 * @param {Number} indexInParent The position of this element within its parent
	 * @param {lm.LayoutManager} layoutManager
	 */
	lm.controls.BrowserPopout = function( config, dimensions, parentId, indexInParent, layoutManager ) {
		lm.utils.EventEmitter.call( this );
		this.isInitialised = false;

		this._config = config;
		this._dimensions = dimensions;
		this._parentId = parentId;
		this._indexInParent = indexInParent;
		this._layoutManager = layoutManager;
		this._popoutWindow = null;
		this._id = null;
	};

	lm.utils.copy( lm.controls.BrowserPopout.prototype, {

		toConfig: function() {
			if( this.isInitialised === false ) {
				throw new Error( 'Can\'t create config, layout not yet initialised' );
			}
			return {
				dimensions: {
					width: this.getGlInstance().width,
					height: this.getGlInstance().height,
					left: this._popoutWindow.screenX || this._popoutWindow.screenLeft,
					top: this._popoutWindow.screenY || this._popoutWindow.screenTop
				},
				content: this.getGlInstance().toConfig().content,
				parentId: this._parentId,
				indexInParent: this._indexInParent
			};
		},

		getGlInstance: function() {
			return this._popoutWindow.__glInstance;
		},

		getWindow: function() {
			return this._popoutWindow;
		},

		close: function() {
			if( this.getGlInstance() ) {
				this.getGlInstance()._$closeWindow();
			} else {
				try {
					this.getWindow().close();
				} catch( e ) {
				}
			}
		},

		/**
		 * Returns the popped out item to its original position. If the original
		 * parent isn't available anymore it falls back to the layout's topmost element
		 */
		popIn: function() {
			var childConfig,
				parentItem;
				this._indexInParent;

			if( this._parentId ) {

				/*
				 * The $.extend call seems a bit pointless, but it's crucial to
				 * copy the config returned by this.getGlInstance().toConfig()
				 * onto a new object. Internet Explorer keeps the references
				 * to objects on the child window, resulting in the following error
				 * once the child window is closed:
				 *
				 * The callee (server [not server application]) is not available and disappeared
				 */
				childConfig = $.extend( true, {}, this.getGlInstance().toConfig() ).content[ 0 ];
				parentItem = this._layoutManager.root.getItemsById( this._parentId )[ 0 ];

				/*
				 * Fallback if parentItem is not available. Either add it to the topmost
				 * item or make it the topmost item if the layout is empty
				 */
				if( !parentItem ) {
					if( this._layoutManager.root.contentItems.length > 0 ) {
						parentItem = this._layoutManager.root.contentItems[ 0 ];
					} else {
						parentItem = this._layoutManager.root;
					}
				}
			}

			parentItem.addChild( childConfig, this._indexInParent );
			this.close();
		},

		/**
		 * Serialises a map of key:values to a window options string
		 *
		 * @param   {Object} windowOptions
		 *
		 * @returns {String} serialised window options
		 */
		_serializeWindowOptions: function( windowOptions ) {
			var windowOptionsString = [], key;

			for( key in windowOptions ) {
				windowOptionsString.push( key + '=' + windowOptions[ key ] );
			}

			return windowOptionsString.join( ',' );
		},

		/**
		 * Creates the URL for the new window, including the
		 * config GET parameter
		 *
		 * @returns {String} URL
		 */
		_createUrl: function() {
			var config = { content: this._config },
				storageKey = 'gl-window-config-' + lm.utils.getUniqueId(),
				urlParts;

			config = ( new lm.utils.ConfigMinifier() ).minifyConfig( config );

			try {
				localStorage.setItem( storageKey, JSON.stringify( config ) );
			} catch( e ) {
				throw new Error( 'Error while writing to localStorage ' + e.toString() );
			}

			urlParts = document.location.href.split( '?' );

			// URL doesn't contain GET-parameters
			if( urlParts.length === 1 ) {
				return urlParts[ 0 ] + '?gl-window=' + storageKey;

				// URL contains GET-parameters
			} else {
				return document.location.href + '&gl-window=' + storageKey;
			}
		},

		/**
		 * Move the newly created window roughly to
		 * where the component used to be.
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_positionWindow: function() {
			this._popoutWindow.moveTo( this._dimensions.left, this._dimensions.top );
			this._popoutWindow.focus();
		},

		/**
		 * Callback when the new window is opened and the GoldenLayout instance
		 * within it is initialised
		 *
		 * @returns {void}
		 */
		_onInitialised: function() {
			this.isInitialised = true;
			this.getGlInstance().on( 'popIn', this.popIn, this );
			this.emit( 'initialised' );
		},

		/**
		 * Invoked 50ms after the window unload event
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onClose: function() {
			setTimeout( lm.utils.fnBind( this.emit, this, [ 'closed' ] ), 50 );
		}
	} );
	/**
	 * This class creates a temporary container
	 * for the component whilst it is being dragged
	 * and handles drag events
	 *
	 * @constructor
	 * @private
	 *
	 * @param {Number} x              The initial x position
	 * @param {Number} y              The initial y position
	 * @param {lm.utils.DragListener} dragListener
	 * @param {lm.LayoutManager} layoutManager
	 * @param {lm.item.AbstractContentItem} contentItem
	 * @param {lm.item.AbstractContentItem} originalParent
	 */
	lm.controls.DragProxy = function (x, y, dragListener, layoutManager, contentItem, originalParent) {

		lm.utils.EventEmitter.call(this);

		this._dragListener = dragListener;
		this._layoutManager = layoutManager;
		this._contentItem = contentItem;
		this._originalParent = originalParent;

		this._area = null;
		this._lastValidArea = null;

		this._dragListener.on('drag', this._onDrag, this);
		this._dragListener.on('dragStop', this._onDrop, this);

		this.element = $(lm.controls.DragProxy._template);
		if (originalParent && originalParent._side) {
			this._sided = originalParent._sided;
			this.element.addClass('lm_' + originalParent._side);
			if (['right', 'bottom'].indexOf(originalParent._side) >= 0)
				this.element.find('.lm_content').after(this.element.find('.lm_header'));
		}

		this.element.css({ left: x, top: y });

		this.element.find('.lm_tab').attr('title', lm.utils.stripTags(this._contentItem.config.title));
		this.element.find('.lm_title').text(this._contentItem.config.title);
		this.childElementContainer = this.element.find('.lm_content');
		this.childElementContainer.append(contentItem.element);

		if (this._originalParent &&
			this._originalParent.layoutManager.config &&
			this._originalParent.layoutManager.config.settings &&
			this._originalParent.layoutManager.config.settings.disableDragProxy) {
			this.element.find('.lm_content').css("display", "none");
		}

		this._updateTree();
		this._layoutManager._$calculateItemAreas();
		this._setDimensions();

		$(document.body).append(this.element);

		const containerBounds = lm.utils.getBounds(this._layoutManager.container);

		this._minX = containerBounds.left;
		this._minY = containerBounds.top;
		this._maxX = containerBounds.width + this._minX;
		this._maxY = containerBounds.height + this._minY;
		// TODO review this
		this._width = this._layoutManager.config.dimensions.dragProxyWidth;
		this._height = this._layoutManager.config.dimensions.dragProxyHeight;

		this._setDropPosition(x, y);
	};

	lm.controls.DragProxy._template = '<div class="lm_dragProxy">' +
		'<div class="lm_header">' +
		'<ul class="lm_tabs">' +
		'<li class="lm_tab lm_active"><i class="lm_left"></i>' +
		'<span class="lm_title"></span>' +
		'<i class="lm_right"></i></li>' +
		'</ul>' +
		'</div>' +
		'<div class="lm_content"></div>' +
		'</div>';

	lm.utils.copy(lm.controls.DragProxy.prototype, {

		/**
		 * Callback on every mouseMove event during a drag. Determines if the drag is
		 * still within the valid drag area and calls the layoutManager to highlight the
		 * current drop area
		 *
		 * @param   {Number} offsetX The difference from the original x position in px
		 * @param   {Number} offsetY The difference from the original y position in px
		 * @param   {jQuery DOM event} event
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onDrag: function (offsetX, offsetY, event) {

			event = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : event;

			var x = event.pageX,
				y = event.pageY,
				isWithinContainer = x > this._minX && x < this._maxX && y > this._minY && y < this._maxY;

			if (!isWithinContainer && this._layoutManager.config.settings.constrainDragToContainer === true) {
				return;
			}

			this._setDropPosition(x, y);
		},

		/**
		 * Sets the target position, highlighting the appropriate area
		 *
		 * @param   {Number} x The x position in px
		 * @param   {Number} y The y position in px
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setDropPosition: function (x, y) {
			this.element.css({ left: x, top: y });
			this._area = this._layoutManager._$getArea(x, y);

			if (this._area !== null) {
				this._lastValidArea = this._area;
				this._area.contentItem._$highlightDropZone(x, y, this._area);
			} else if (this._lastValidArea !== null) {
				this._lastValidArea.contentItem._$highlightDropZone(x, y, this._area);
				this._lastValidArea = this._area;
			}
		},

		/**
		 * Callback when the drag has finished. Determines the drop area
		 * and adds the child to it
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_onDrop: function (e) {
			this._layoutManager.dropTargetIndicator.hide();
			this.element.find('.lm_content').css("display", "");

			/*
			 * Valid drop area found
			 */
			if (this._area !== null && !(e && e.canceled)) {
				this._area.contentItem._$onDrop(this._contentItem, this._area);

				if (this._originalParent && this._area.contentItem !== this._originalParent) {
					this._layoutManager.emit('parentChanged', this._contentItem, this._originalParent);
				}
				/**
				 * No valid drop area available at present, but one has been found before.
				 * Use it
				 */
			} else if (this._lastValidArea !== null && !(e && e.canceled)) {
				this._lastValidArea.contentItem._$onDrop(this._contentItem, this._lastValidArea);

				/**
				 * No valid drop area found during the duration of the drag. Return
				 * content item to its original position if a original parent is provided.
				 * (Which is not the case if the drag had been initiated by createDragSource)
				 */
			} else if (this._originalParent && !(e && e.canceled)) {
				this._originalParent.addChild(this._contentItem);

				/**
				 * The drag didn't ultimately end up with adding the content item to
				 * any container. In order to ensure clean up happens, destroy the
				 * content item.
				 */
			} else {
				this._contentItem._$destroy();
			}

			this.element.remove();

			const dragProxyIndex = this._layoutManager._dragProxies.indexOf(this);
			if (dragProxyIndex > -1) {
				this._layoutManager._dragProxies.splice(dragProxyIndex, 1);
			}
			this._layoutManager.emit('itemDropped', this._contentItem);
		},

		/**
		 * Removes the item from its original position within the tree
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_updateTree: function () {

			/**
			 * parent is null if the drag had been initiated by a external drag source
			 */
			if (this._contentItem.parent) {
				this._contentItem.parent.removeChild(this._contentItem, true);
			}

			this._contentItem._$setParent(this);
		},

		/**
		 * Updates the Drag Proxie's dimensions
		 *
		 * @private
		 *
		 * @returns {void}
		 */
		_setDimensions: function () {
			this._contentItem.callDownwards('_$show');
		}
	});

	/**
	 * Allows for any DOM item to create a component on drag
	 * start tobe dragged into the Layout
	 *
	 * @param {jQuery element} element
	 * @param {Object} itemConfig the configuration for the contentItem that will be created
	 * @param {LayoutManager} layoutManager
	 *
	 * @constructor
	 */
	lm.controls.DragSource = function (element, itemConfig, layoutManager, customDragListener) {
		this._element = element;
		this._itemConfig = itemConfig;
		this._layoutManager = layoutManager;
		this._dragListener = null;
		this._dragProxy = null;

		this._createDragListener(customDragListener);
	};

	lm.utils.copy(lm.controls.DragSource.prototype, {

		/**
		 * Called initially and after every drag
		 *
		 * @returns {void}
		 */
		_createDragListener: function (customDragListener) {
			if (this._dragListener !== null) {
				this._dragListener.destroy();
			}

			this._dragListener = customDragListener || new lm.utils.DragListener(this._element);
			if (typeof this._dragListener.on != "function") {
				return;
			}
			this._dragListener.on('dragStart', this._onDragStart, this);
			this._dragListener.on('dragStop', this._createDragListener, this);
		},

		/**
		 * Callback for the DragListener's dragStart event
		 *
		 * @param   {int} x the x position of the mouse on dragStart
		 * @param   {int} y the x position of the mouse on dragStart
		 *
		 * @returns {void}
		 */
		_onDragStart: function (x, y) {
			var itemConfig = this._itemConfig;
			if (lm.utils.isFunction(itemConfig)) {
				itemConfig = itemConfig();
			}
			var contentItem = this._layoutManager._$normalizeContentItem($.extend(true, {}, itemConfig));
				this._dragProxy = new lm.controls.DragProxy(x, y, this._dragListener, this._layoutManager, contentItem, null);

			this._layoutManager.transitionIndicator.transitionElements(this._element, this._dragProxy.element);
		}
	});

	lm.controls.DropTargetIndicator = function () {
		this.element = $(lm.controls.DropTargetIndicator._template);
		$(document.body).append(this.element);
	};

	// lm.controls.DropTargetIndicator._template = '<div class="lm_dropTargetIndicator"><div class="lm_inner"></div></div>';
	lm.controls.DropTargetIndicator._template = '<div class="lm_dropTargetIndicator"><div class="lm_inner"><span></span><span></span><span></span></div></div>';
	lm.utils.copy(lm.controls.DropTargetIndicator.prototype, {
		destroy: function () {
			this.element.remove();
		},

		highlight: function (x1, y1, x2, y2) {
			this.highlightArea({ x1: x1, y1: y1, x2: x2, y2: y2 });
		},

		highlightArea: function (area) {
			if (!area) {
				this.element.hide();
			}else {
				this.element.css({
					left: area.x1,
					top: area.y1,
					width: area.x2 - area.x1,
					height: area.y2 - area.y1
				}).show();
			}
		},

		hide: function () {
			this.element.hide();
		}
	});
	/**
	 * This class represents a header above a Stack ContentItem.
	 *
	 * @param {lm.LayoutManager} layoutManager
	 * @param {lm.item.AbstractContentItem} parent
	 */
	lm.controls.Header = function (layoutManager, parent) {
		lm.utils.EventEmitter.call(this);

		this.layoutManager = layoutManager;
		this.element = $(lm.controls.Header._template);

		if (this.layoutManager.config.settings.selectionEnabled === true) {
			this.element.addClass('lm_selectable');
			this.element.on('click touchstart', lm.utils.fnBind(this._onHeaderClick, this));
		}

		if (this.layoutManager.config.settings.mode === "workspace") {
			this.element.addClass('header_double');
		}

		if (this.layoutManager.config.settings.mode === "workspace" && this.layoutManager._componentFactory) {
			const headerControls = this.element.children(".lm_controls")[0];
			const workspaceControlsContainer = this.element.children(".lm_workspace_controls")[0];
			const logoContainer = this.element.children(".lm_logo")[0];

			if (this.layoutManager._componentFactory.createLogo) {
				this.layoutManager._componentFactory.createLogo({ domNode: logoContainer });
			}

			if (this.layoutManager._componentFactory.createAddWorkspace) {
				this.layoutManager._componentFactory.createAddWorkspace({ domNode: workspaceControlsContainer });
			}

			if (this.layoutManager._componentFactory.createSystemButtons) {
				this.layoutManager._componentFactory.createSystemButtons({ domNode: headerControls });
			}
		} else if (this.layoutManager._componentFactory) {
			this.element.children(".lm_controls")[0];
			const tabControls = this.element.children(".lm_tabs_controls")[0];
			const logoContainer = this.element.children(".lm_logo")[0];

			if (this.layoutManager._componentFactory.createBeforeGroupTabs) {
				this.layoutManager._componentFactory.createBeforeGroupTabs({
					domNode: logoContainer,
					groupId: lm.utils.idAsString(parent.config.id),
					workspaceId: this.layoutManager.config.workspacesOptions.workspaceId,
					elementId: lm.utils.idAsString(parent.config.id)
				});
			}

			if (this.layoutManager._componentFactory.createAfterGroupTabs) {
				const options = this.layoutManager._componentFactory.createAfterGroupTabsOptions({
					element: tabControls,
					contentItem: parent,
				});
				this.layoutManager._componentFactory.createAfterGroupTabs(options);
			}
		}

		this.tabsContainer = this.element.find('.lm_tabs');
		this.tabDropdownContainer = this.element.find('.lm_tabdropdown_list');
		this.tabDropdownContainer.hide();
		this.controlsContainer = this.element.find('.lm_controls');
		this.workspaceControlsContainer = this.layoutManager.config.settings.mode === "workspace" ? this.element.find('.lm_workspace_controls') : undefined;
		this.tabsControlsContainer = this.layoutManager.config.settings.mode !== "workspace" ? this.element.find('.lm_tabs_controls') : undefined;
		this.parent = parent;
		this.tabs = [];
		this.activeContentItem = null;
		this.closeButton = null;
		this.tabDropdownButton = null;
		this.hideAdditionalTabsDropdown = lm.utils.fnBind(this._hideAdditionalTabsDropdown, this);
		$(document).mouseup(this.hideAdditionalTabsDropdown);

		this._lastVisibleTabIndex = -1;
		this._tabControlOffset = this.layoutManager.config.settings.tabControlOffset;
		this._isDestroyed = false;
		if (!(this.layoutManager.config.settings.mode === "workspace" && this.layoutManager._componentFactory && this.layoutManager._componentFactory.createSystemButtons)) {
			this._createControls();
		}
	};

	lm.controls.Header._template = [
		'<div class="lm_header">',
		'<div class="lm_logo"></div>',
		'<ul class="lm_tabs"></ul>',
		'<ul class="lm_workspace_controls"></ul>',
		'<ul class="lm_tabs_controls"></ul>',
		'<div class="move_area"></div>',
		'<ul class="lm_controls"></ul>',
		'<ul class="lm_tabdropdown_list"></ul>',
		'</div>'
	].join('');

	lm.utils.copy(lm.controls.Header.prototype, {

		/**
		 * Creates a new tab and associates it with a contentItem
		 *
		 * @param    {lm.item.AbstractContentItem} contentItem
		 * @param    {Integer} index The position of the tab
		 *
		 * @returns {void}
		 */
		createTab: function (contentItem, index) {
			var tab, i;

			//If there's already a tab relating to the
			//content item, don't do anything
			for (i = 0; i < this.tabs.length; i++) {
				if (this.tabs[i].contentItem === contentItem) {
					return;
				}
			}

			tab = new lm.controls.Tab(this, contentItem);

			if (this.tabs.length === 0) {
				this.tabs.push(tab);
				this.tabsContainer.append(tab.element);
				return;
			}

			if (index === undefined || index > this.tabs.length) {
				index = this.tabs.length;
			}

			if (index > 0) {
				this.tabs[index - 1].element.after(tab.element);
			} else {
				this.tabs[0].element.before(tab.element);
			}

			this.tabs.splice(index, 0, tab);
			this._updateTabSizesWithoutDropdown();
		},
		moveTab: function (fromIndex, toIndex) {
			lm.utils.moveInArray(this.tabs, fromIndex, toIndex);

			this._updateTabSizesWithoutDropdown();
			this.parent._syncContentItemOrder();
		},

		/**
		 * Finds a tab based on the contentItem its associated with and removes it.
		 *
		 * @param    {lm.item.AbstractContentItem} contentItem
		 *
		 * @returns {void}
		 */
		removeTab: function (contentItem) {
			for (var i = 0; i < this.tabs.length; i++) {
				if (this.tabs[i].contentItem === contentItem) {
					this.tabs[i]._$destroy();
					this.tabs.splice(i, 1);
					return;
				}
			}

			throw new Error('contentItem is not controlled by this header');
		},

		/**
		 * The programmatical equivalent of clicking a Tab.
		 *
		 * @param {lm.item.AbstractContentItem} contentItem
		 */
		setActiveContentItem: function (contentItem) {
			var i, j, isActive, activeTab;

			for (i = 0; i < this.tabs.length; i++) {
				isActive = this.tabs[i].contentItem === contentItem;
				this.tabs[i].setActive(isActive);
				if (isActive === true) {
					this.activeContentItem = contentItem;
					this.parent.config.activeItemIndex = i;
				}
			}

			if (this.layoutManager.config.settings.reorderOnTabMenuClick) {
				/**
				 * If the tab selected was in the dropdown, move everything down one to make way for this one to be the first.
				 * This will make sure the most used tabs stay visible.
				 */
				if (this._lastVisibleTabIndex !== -1 && this.parent.config.activeItemIndex > this._lastVisibleTabIndex) {
					activeTab = this.tabs[this.parent.config.activeItemIndex];
					for (j = this.parent.config.activeItemIndex; j > 0; j--) {
						this.tabs[j] = this.tabs[j - 1];
					}
					this.tabs[0] = activeTab;
					this.parent.config.activeItemIndex = 0;
				}
			}

			this.parent.emitBubblingEvent('stateChanged');
		},

		/**
		 * Programmatically operate with header position.
		 *
		 * @param {string} position one of ('top','left','right','bottom') to set or empty to get it.
		 *
		 * @returns {string} previous header position
		 */
		position: function (position) {
			var previous = this.parent._header.show;
			if (previous && !this.parent._side)
				previous = 'top';
			if (position !== undefined && this.parent._header.show != position) {
				this.parent._header.show = position;
				this.parent._setupHeaderPosition();
			}
			return previous;
		},

		/**
		 * Programmatically set closability.
		 *
		 * @package private
		 * @param {Boolean} isClosable Whether to enable/disable closability.
		 *
		 * @returns {Boolean} Whether the action was successful
		 */
		_$setClosable: function (isClosable) {
			if (this.closeButton && this._isClosable()) {
				this.closeButton.element[isClosable ? "show" : "hide"]();
				return true;
			}

			return false;
		},

		/**
		 * Destroys the entire header
		 *
		 * @package private
		 *
		 * @returns {void}
		 */
		_$destroy: function () {
			if (this._isDestroyed) {
				return;
			}

			this._isDestroyed = true;
			this.emit('destroy', this);

			for (var i = 0; i < this.tabs.length; i++) {
				this.tabs[i]._$destroy();
			}

			$(document).off('mouseup', this.hideAdditionalTabsDropdown);
			this.element.remove();
		},

		/**
		 * get settings from header
		 *
		 * @returns {string} when exists
		 */
		_getHeaderSetting: function (name) {
			if (name in this.parent._header)
				return this.parent._header[name];
		},
		/**
		 * Creates the popout, maximise and close buttons in the header's top right corner
		 *
		 * @returns {void}
		 */
		_createControls: function () {
			const isGroupHeader = this.layoutManager.config.settings.mode !== "workspace";
			if (isGroupHeader && this.layoutManager._componentFactory.createGroupHeaderButtons) {
				const workspaceWindowTabOptions = this.layoutManager._componentFactory.createGroupHeaderButtonsOptions({ element: this.controlsContainer[0], contentItem: this.parent });
				this.layoutManager._componentFactory.createGroupHeaderButtons(workspaceWindowTabOptions);
				return;
			}

			var closeStack,
				popout,
				label,
				maximizeLabel,
				restoreLabel,
				maximize,
				maximizeButton,
				tabDropdownLabel,
				showTabDropdown;

			/**
			 * Dropdown to show additional tabs.
			 */
			showTabDropdown = lm.utils.fnBind(this._showAdditionalTabsDropdown, this);
			tabDropdownLabel = this.layoutManager.config.labels.tabDropdown;
			this.tabDropdownButton = new lm.controls.HeaderButton(this, tabDropdownLabel, 'lm_tabdropdown', showTabDropdown);
			this.tabDropdownButton.element.hide();

			/**
			 * Popout control to launch component in new window.
			 */
			if (this._getHeaderSetting('popout')) {
				popout = lm.utils.fnBind(this._onPopoutClick, this);
				label = this._getHeaderSetting('popout');
				new lm.controls.HeaderButton(this, label, 'lm_popout', popout);
			}

			if (this._getHeaderSetting("minimize")) {
				minimizeLabel = this._getHeaderSetting('minimize');
				minimizeButton = new lm.controls.HeaderButton(this, minimizeLabel, 'lm_minimise', undefined);
			}

			/**
			 * Maximize control - set the component to the full size of the layout
			 */
			if (this._getHeaderSetting('maximize')) {
				if (this.layoutManager.config.settings.mode !== "workspace") {
					maximize = lm.utils.fnBind(this.parent.toggleMaximise, this.parent);
				}

				maximizeLabel = this._getHeaderSetting('maximize');

				// TODO
				// whether is a function or not should be a config
				maximizeButton = new lm.controls.HeaderButton(this, maximizeLabel, 'lm_maximise', maximize);

				restoreLabel = this._getHeaderSetting('restore');

				this.parent.on('maximized', function () {
					maximizeButton.element.attr('title', restoreLabel);
				});

				this.parent.on('minimized', function () {
					maximizeButton.element.attr('title', maximizeLabel);
				});
			}

			/**
			 * Close button
			 */
			if (this._isClosable()) {
				if (this.layoutManager.config.settings.mode !== "workspace") {
					closeStack = lm.utils.fnBind(this.parent.remove, this.parent);
				}
				label = this._getHeaderSetting('close');
				this.closeButton = new lm.controls.HeaderButton(this, label, 'lm_close', closeStack);
			}
		},

		/**
		 * Shows drop down for additional tabs when there are too many to display.
		 *
		 * @returns {void}
		 */
		_showAdditionalTabsDropdown: function () {
			this.tabDropdownContainer.show();
		},

		/**
		 * Hides drop down for additional tabs when there are too many to display.
		 *
		 * @returns {void}
		 */
		_hideAdditionalTabsDropdown: function (e) {
			this.tabDropdownContainer.hide();
		},

		/**
		 * Checks whether the header is closable based on the parent config and
		 * the global config.
		 *
		 * @returns {Boolean} Whether the header is closable.
		 */
		_isClosable: function () {
			return this.parent.config.isClosable && this.layoutManager.config.settings.showCloseIcon;
		},

		_onPopoutClick: function () {
			this.parent.emit("popoutRequested");
			// Do nothing the workspaces application should handle the popout behaviour
		},

		/**
		 * Invoked when the header's background is clicked (not it's tabs or controls)
		 *
		 * @param    {jQuery DOM event} event
		 *
		 * @returns {void}
		 */
		_onHeaderClick: function (event) {
			if (event.target === this.element[0]) {
				this.parent.select();
			}
		},

		/**
		 * Pushes the tabs to the tab dropdown if the available space is not sufficient
		 *
		 * @returns {void}
		 */
		_updateTabSizes: function (showTabMenu) {
			if (this.tabs.length === 0) {
				return;
			}

			//Show the menu based on function argument
			this.tabDropdownButton.element.toggle(showTabMenu === true);

			var size = function (val) {
				return val ? 'width' : 'height';
			};
			this.element.css(size(!this.parent._sided), '');
			// this.element[size(this.parent._sided)](this.layoutManager.config.dimensions.headerHeight);
			var availableWidth = this.element.outerWidth() - this.controlsContainer.outerWidth() - this._tabControlOffset,
				cumulativeTabWidth = 0,
				visibleTabWidth = 0,
				tabElement,
				i,
				j,
				marginLeft,
				overlap = 0,
				tabWidth,
				tabOverlapAllowance = this.layoutManager.config.settings.tabOverlapAllowance,
				tabOverlapAllowanceExceeded = false,
				activeIndex = (this.activeContentItem ? this.tabs.indexOf(this.activeContentItem.tab) : 0),
				activeTab = this.tabs[activeIndex];
			if (this.parent._sided)
				availableWidth = this.element.outerHeight() - this.controlsContainer.outerHeight() - this._tabControlOffset;
			this._lastVisibleTabIndex = -1;

			for (i = 0; i < this.tabs.length; i++) {
				tabElement = this.tabs[i].element;

				//Put the tab in the tabContainer so its true width can be checked
				this.tabsContainer.append(tabElement);
				tabWidth = tabElement.outerWidth() + parseInt(tabElement.css('margin-right'), 10);

				cumulativeTabWidth += tabWidth;

				//Include the active tab's width if it isn't already
				//This is to ensure there is room to show the active tab
				if (activeIndex <= i) {
					visibleTabWidth = cumulativeTabWidth;
				} else {
					visibleTabWidth = cumulativeTabWidth + activeTab.element.outerWidth() + parseInt(activeTab.element.css('margin-right'), 10);
				}

				// If the tabs won't fit, check the overlap allowance.
				if (visibleTabWidth > availableWidth) {

					//Once allowance is exceeded, all remaining tabs go to menu.
					if (!tabOverlapAllowanceExceeded) {

						//No overlap for first tab or active tab
						//Overlap spreads among non-active, non-first tabs
						if (activeIndex > 0 && activeIndex <= i) {
							overlap = (visibleTabWidth - availableWidth) / (i - 1);
						} else {
							overlap = (visibleTabWidth - availableWidth) / i;
						}

						//Check overlap against allowance.
						if (overlap < tabOverlapAllowance) {
							for (j = 0; j <= i; j++) {
								marginLeft = (j !== activeIndex && j !== 0) ? '-' + overlap + 'px' : '';
								this.tabs[j].element.css({ 'z-index': i - j, 'margin-left': marginLeft });
							}
							this._lastVisibleTabIndex = i;
							this.tabsContainer.append(tabElement);
						} else {
							tabOverlapAllowanceExceeded = true;
						}

					} else if (i === activeIndex) {
						//Active tab should show even if allowance exceeded. (We left room.)
						tabElement.css({ 'z-index': 'auto', 'margin-left': '' });
						this.tabsContainer.append(tabElement);
					}

					if (tabOverlapAllowanceExceeded && i !== activeIndex) {
						if (showTabMenu) {
							//Tab menu already shown, so we just add to it.
							tabElement.css({ 'z-index': 'auto', 'margin-left': '' });
							this.tabDropdownContainer.append(tabElement);
						} else {
							//We now know the tab menu must be shown, so we have to recalculate everything.
							this._updateTabSizes(true);
							return;
						}
					}

				}
				else {
					this._lastVisibleTabIndex = i;
					tabElement.css({ 'z-index': 'auto', 'margin-left': '' });
					this.tabsContainer.append(tabElement);
				}
			}

		},

		/**
		 * Applies the necessary tab styles without using a dropdown
		 *
		 * @returns {void}
		 */
		_updateTabSizesWithoutDropdown: function (showTabMenu) {
			if (this.tabs.length === 0) {
				return;
			}

			var size = function (val) {
				return val ? 'width' : 'height';
			};
			this.element.css(size(!this.parent._sided), '');
			// this.element[size(this.parent._sided)](this.layoutManager.config.dimensions.headerHeight);
			this.element.outerWidth() - this.controlsContainer.outerWidth() - this._tabControlOffset;
				var cumulativeTabWidth = 0,
				tabElement,
				i,
				tabWidth;
				this.layoutManager.config.settings.tabOverlapAllowance;
				var activeIndex = (this.activeContentItem ? this.tabs.indexOf(this.activeContentItem.tab) : 0),
				activeTab = this.tabs[activeIndex];
			if (this.parent._sided)
				this.element.outerHeight() - this.controlsContainer.outerHeight() - this._tabControlOffset;

			for (i = 0; i < this.tabs.length; i++) {
				tabElement = this.tabs[i].element;

				//Put the tab in the tabContainer so its true width can be checked
				this.tabsContainer.append(tabElement);
				tabWidth = tabElement.outerWidth() + parseInt(tabElement.css('margin-right'), 10);

				cumulativeTabWidth += tabWidth;

				//Include the active tab's width if it isn't already
				//This is to ensure there is room to show the active tab
				if (activeIndex <= i) ; else {
					cumulativeTabWidth + activeTab.element.outerWidth() + parseInt(activeTab.element.css('margin-right'), 10);
				}

				tabElement.css({ 'z-index': 'auto', 'margin-left': '' });
			}

		},

		_getLastIndexOfPinnedTab(filter) {
			const lastPinnedTab = this.tabs.reduce((acc, t) => {
				if (t.isPinned && (typeof filter != "function" || filter(t))) {
					return t;
				}
				return acc;
			}, undefined);

			if (!lastPinnedTab) {
				return -1;
			}

			return this.tabs.indexOf(lastPinnedTab);
		}
	});


	lm.controls.HeaderButton = function( header, label, cssClass, action ) {
		this._header = header;
		this.element = $( '<li class="' + cssClass + '" title="' + label + '"></li>' );
		this._header.on( 'destroy', this._$destroy, this );
		this._action = action;
		this.element.on( 'click touchstart', this._action );
		this._header.controlsContainer.append( this.element );
	};

	lm.utils.copy( lm.controls.HeaderButton.prototype, {
		_$destroy: function() {
			this.element.off();
			this.element.remove();
		}
	} );
	lm.controls.Splitter = function( isVertical, size, grabSize ) {
		this._isVertical = isVertical;
		this._size = size;
		this._grabSize = grabSize < size ? size : grabSize;

		this.element = this._createElement();
		this._dragListener = new lm.utils.DragListener( this.element );
	};

	lm.utils.copy( lm.controls.Splitter.prototype, {
		on: function( event, callback, context ) {
			this._dragListener.on( event, callback, context );
		},

		_$destroy: function() {
			this.element.remove();
		},

		_createElement: function() {
			var dragHandle = $( '<div class="lm_drag_handle"></div>' );
			var element    = $( '<div class="lm_splitter"></div>' );
			element.append(dragHandle);

			var handleExcessSize = this._grabSize - this._size;
			var handleExcessPos  = handleExcessSize / 2;

			if( this._isVertical ) {
				dragHandle.css( 'top', -handleExcessPos );
				dragHandle.css( 'height', this._size + handleExcessSize );
				element.addClass( 'lm_vertical' );
				element[ 'height' ]( this._size );
			} else {
				dragHandle.css( 'left', -handleExcessPos );
				dragHandle.css( 'width', this._size + handleExcessSize );
				element.addClass( 'lm_horizontal' );
				element[ 'width' ]( this._size );
			}

			return element;
		}
	} );

	/**
	 * Represents an individual tab within a Stack's header
	 *
	 * @param {lm.controls.Header} header
	 * @param {lm.items.AbstractContentItem} contentItem
	 *
	 * @constructor
	 */
	lm.controls.Tab = function (header, contentItem) {
		this.header = header;
		this.contentItem = contentItem;
		this._layoutManager = this.contentItem.layoutManager;
		const isWorkspaceTab = this._layoutManager.config.settings.mode === "workspace";
		const isCustomWorkspaceTab = lm.utils.isCustomWorkspaceTab(this);
		const isCustomWorkspaceWindowTab = lm.utils.isCustomWorkspaceWindowTab(this);
		this.element = isCustomWorkspaceTab || isCustomWorkspaceWindowTab ? $(lm.controls.Tab._customTabTemplate) : $(lm.controls.Tab._template);

		this._elementOffset = 0;
		this._xOfLastReorder = 0;
		this.titleElement = isCustomWorkspaceTab ? $(undefined) : this.element.find('.lm_title');
		this.closeElement = isCustomWorkspaceTab ? $(undefined) : this.element.find('.lm_close_tab');
		this.closeElement[contentItem.config.isClosable ? 'show' : 'hide']();
		this.isActive = false;
		this.isPinned = false;
		this.title = contentItem.config.title;

		this.setTitle(this.title);
		this.contentItem.on('titleChanged', this.setTitle, this);

		if (
			this._layoutManager.config.settings.reorderEnabled === true &&
			contentItem.config.reorderEnabled === true
		) {
			this._dragListener = new lm.utils.TabDragListener(this.element);
			this._dragListener.on('dragStart', this._onDragStart, this);
			this._dragListener.on('reorderStart', this._onReorderStart, this);
			this.contentItem.on('destroy', this._dragListener.destroy, this._dragListener);
		}

		this._onTabClickFn = lm.utils.fnBind(this._onTabClick, this);
		this._onCloseClickFn = lm.utils.fnBind(this._onCloseClick, this);

		if (isWorkspaceTab && contentItem.config.noTabHeader) {
			this.element.hide();
		}

		this.element.on('mousedown touchstart', this._onTabClickFn);

		if (this.contentItem.config.isClosable) {
			this.closeElement.on('click touchstart', this._onCloseClickFn);
			this.closeElement.on('mousedown', this._onCloseMousedown);
		} else {
			this.closeElement.remove();
		}

		this.contentItem.tab = this;
		this.contentItem.emit('tab', this);
		this.contentItem.layoutManager.emit('tabCreated', this);

		if (this.contentItem.isComponent) {
			this.contentItem.container.tab = this;
			this.contentItem.container.emit('tab', this);
		}

		if (isCustomWorkspaceTab) {
			const workspaceTabOptions = this._layoutManager._componentFactory.createWorkspaceTabsOptions({ element: this.element[0], contentItem });
			this._layoutManager._componentFactory.createWorkspaceTabs(workspaceTabOptions);
		}

		if (isCustomWorkspaceWindowTab) {
			const workspaceWindowTabOptions = this._layoutManager._componentFactory.createWorkspaceWindowTabsOptions({ element: this.element[0], contentItem });
			this._layoutManager._componentFactory.createWorkspaceWindowTabs(workspaceWindowTabOptions);
		}
	};

	/**
	 * The tab's html template
	 *
	 * @type {String}
	 */
	lm.controls.Tab._template = '<li class="lm_tab"><i class="lm_left"></i>' +
		'<span class="lm_title"></span><div class="lm_close_tab"></div>' +
		'<i class="lm_right"></i></li>';

	lm.controls.Tab._customTabTemplate = `<li class="lm_tab"></li>`;

	lm.utils.copy(lm.controls.Tab.prototype, {

		/**
		 * Sets the tab's title to the provided string and sets
		 * its title attribute to a pure text representation (without
		 * html tags) of the same string.
		 *
		 * @public
		 * @param {String} title
		 */
		setTitle: function (title) {
			this.title = title;
			if (!lm.utils.isCustomWorkspaceTab(this)) {
				this.element.attr('title', lm.utils.stripTags(title));
			}
			this.titleElement.text(title);
		},

		onCloseClick: undefined,
		pin: function (index) {
			if (this.isPinned) {
				return;
			}
			this.titleElement.hide();
			this.closeElement.hide();

			const currentIndex = this.header.tabs.indexOf(this);
			const lastPinnedTabIndex = this.header._getLastIndexOfPinnedTab();

			let newIndex = lastPinnedTabIndex + 1;
			if (typeof index === "number") {
				newIndex = Math.min(index, lastPinnedTabIndex + 1);			}

			this.header.moveTab(currentIndex, newIndex);
			this.element.addClass('lm_pinned');
			this.isPinned = true;
		},
		unpin: function () {
			if (!this.isPinned) {
				return;
			}
			this.titleElement.show();
			this.closeElement.show();

			const currentIndex = this.header.tabs.indexOf(this);
			const lastPinnedTabIndex = this.header._getLastIndexOfPinnedTab();
			if (currentIndex != lastPinnedTabIndex) {
				this.header.moveTab(currentIndex, lastPinnedTabIndex);
			}

			this.element.removeClass('lm_pinned');

			this.isPinned = false;
		},

		/**
		 * Sets this tab's active state. To programmatically
		 * switch tabs, use header.setActiveContentItem( item ) instead.
		 *
		 * @public
		 * @param {Boolean} isActive
		 */
		setActive: function (isActive) {
			if (isActive === this.isActive) {
				return;
			}
			this.isActive = isActive;

			if (isActive) {
				this.element.addClass('lm_active');
			} else {
				this.element.removeClass('lm_active');
			}
		},

		/**
		 * Destroys the tab
		 *
		 * @private
		 * @returns {void}
		 */
		_$destroy: function () {
			this.element.off('mousedown touchstart', this._onTabClickFn);
			this.closeElement.off('click touchstart', this._onCloseClickFn);
			if (this._dragListener) {
				this.contentItem.off('destroy', this._dragListener.destroy, this._dragListener);
				this._dragListener.off('dragStart', this._onDragStart);
				this._dragListener.off('reorderStart', this._onReorderStart);
				this._dragListener = null;
			}
			this.element.remove();
		},

		/**
		 * Callback for the DragListener
		 *
		 * @param   {Number} x The tabs absolute x position
		 * @param   {Number} y The tabs absolute y position
		 *
		 * @private
		 * @returns {void}
		 */
		_onDragStart: function (x, y) {
			if (this.contentItem.parent.isMaximized === true) {
				this.contentItem.parent.toggleMaximise();
			}
			const isWorkspaceLayout = this.contentItem.layoutManager.config.settings.mode === "workspace";
			const hasLessThanTwoTabs = this.contentItem.parent.header.tabs.length < 2;
			const isMissingWindowId = !this.contentItem.config.windowId && (this.contentItem.config.componentState && !this.contentItem.config.componentState.windowId);
			const isWorkspaceExtractEnabled = !this.contentItem.layoutManager.config.settings.workspaceInnerDrag && isWorkspaceLayout;

			if (isWorkspaceLayout && hasLessThanTwoTabs) {
				return;
			}

			if (!isWorkspaceLayout && isMissingWindowId) {
				return;
			}

			if (this._layoutManager.config && this._layoutManager.config.workspacesOptions.allowExtract === false &&
				this.contentItem.config.workspacesConfig && this.contentItem.config.workspacesConfig.allowExtract !== true) {
				return;
			} else if (this.contentItem.config.workspacesConfig && this.contentItem.config.workspacesConfig.allowExtract === false) {
				return;
			}

			if (isWorkspaceExtractEnabled) {
				return;
			}
			this._layoutManager.restoreMaximizedContainers.apply(this._layoutManager);
			const newProxy = new lm.controls.DragProxy(
				x,
				y,
				this._dragListener,
				this._layoutManager,
				this.contentItem,
				this.header.parent
			);

			this._layoutManager._dragProxies.push(newProxy);
		},

		_onReorderStart: function (x, y) {
			const tabX = this.element[0].getBoundingClientRect().x;
			const parentX = this.header.element[0].getBoundingClientRect().x;
			const tabXParentOffset = tabX - parentX;
			const tabWidth = this.element[0].getBoundingClientRect().width;
			this._elementOffset = tabXParentOffset - x;

			const isWorkspaceTab = this._layoutManager.config.settings.mode === "workspace";
			const isWorkspaceTabReorderLocked = isWorkspaceTab && this.contentItem.config.workspacesConfig.allowWorkspaceTabReorder === false;
			const isWindowTabReorderLocked = !isWorkspaceTab && this.contentItem.config.workspacesConfig.allowReorder === false;

			if (isWorkspaceTabReorderLocked || isWindowTabReorderLocked) {
				return;
			}

			this._xOfLastReorder = x;
			this.element.css("position", `absolute`);
			this.element.css("z-index", `42`);
			this.element.css("left", `${x + this._elementOffset}px`);
			this.element.css("width", `${tabWidth}px`);

			this._dragListener.on("reorder", this._onReorder, this);
			this._dragListener.on("reorderStop", this._onReorderStop, this);

		},
		_onReorder: function (x, y) {
			this.element.css("left", `${x + this._elementOffset}px`);
			const tabIndex = this.header.tabs.indexOf(this);

			if (this._xOfLastReorder > x && tabIndex > 0) {
				const previousTabDimensions = lm.utils.getBounds(this.header.tabs[tabIndex - 1].element);

				if (x < previousTabDimensions.x + previousTabDimensions.width / 2) {
					this.header.moveTab(tabIndex, tabIndex - 1);
					this._xOfLastReorder = x;
				}
			} else if (this._xOfLastReorder < x && tabIndex < this.header.tabs.length - 1) {
				const nextTabDimensions = lm.utils.getBounds(this.header.tabs[tabIndex + 1].element);

				if (x > nextTabDimensions.x + nextTabDimensions.width / 2) {
					this.header.moveTab(tabIndex, tabIndex + 1);
					this._xOfLastReorder = x;
				}
			}
			this.element.css("z-index", `42`);
		},
		_onReorderStop: function (x, y) {
			const tabIndex = this.header.tabs.indexOf(this);
			const lastPinnedTabIndex = this.header._getLastIndexOfPinnedTab((t) => t != this);

			// Triggered when a pinned tab is put after an unpinned one
			if (this.isPinned && lastPinnedTabIndex + 1 < tabIndex) {
				this.header.moveTab(tabIndex, lastPinnedTabIndex + 1);
			}

			// Triggered when a unpinned tab is put before a pinned one
			if (!this.isPinned && tabIndex < lastPinnedTabIndex) {
				this.header.moveTab(tabIndex, lastPinnedTabIndex);
			}

			this.element.css("left", "");
			this.element.css("width", "");
			this.element.css("position", "");
			this.element.css("z-index", `auto`);

			this._dragListener.off("reorder", this._onReorder);
			this._dragListener.off("reorderStop", this._onReorderStop);
		},
		/**
		 * Callback when the tab is clicked
		 *
		 * @param {jQuery DOM event} event
		 *
		 * @private
		 * @returns {void}
		 */
		_onTabClick: function (event) {
			// left mouse button or tap
			if (event.button === 0 || event.type === 'touchstart') {
				var activeContentItem = this.header.parent.getActiveContentItem();
				if (this.contentItem !== activeContentItem) {
					this.header.parent.setActiveContentItem(this.contentItem);
				}

				// middle mouse button
			} else if (event.button === 1 && this.contentItem.config.isClosable) {
				this._onCloseClick(event);
			}
		},

		/**
		 * Callback when the tab's close button is
		 * clicked
		 *
		 * @param   {jQuery DOM event} event
		 *
		 * @private
		 * @returns {void}
		 */
		_onCloseClick: function (event) {
			this.contentItem.layoutManager.emit('tabCloseRequested', this);
			if (this.onCloseClick) {
				this.onCloseClick(event);
			}
		},


		/**
		 * Callback to capture tab close button mousedown
		 * to prevent tab from activating.
		 *
		 * @param (jQuery DOM event) event
		 *
		 * @private
		 * @returns {void}
		 */
		_onCloseMousedown: function (event) {
			event.stopPropagation();
		}
	});

	lm.controls.TransitionIndicator = function() {
		this._element = $( '<div class="lm_transition_indicator"></div>' );
		$( document.body ).append( this._element );

		this._toElement = null;
		this._fromDimensions = null;
		this._totalAnimationDuration = 200;
		this._animationStartTime = null;
	};

	lm.utils.copy( lm.controls.TransitionIndicator.prototype, {
		destroy: function() {
			this._element.remove();
		},

		transitionElements: function( fromElement, toElement ) {
			/**
			 * TODO - This is not quite as cool as expected. Review.
			 */
			return;
		},

		_nextAnimationFrame: function() {
			var toDimensions = this._measure( this._toElement ),
				animationProgress = ( lm.utils.now() - this._animationStartTime ) / this._totalAnimationDuration,
				currentFrameStyles = {},
				cssProperty;

			if( animationProgress >= 1 ) {
				this._element.hide();
				return;
			}

			toDimensions.opacity = 0;

			for( cssProperty in this._fromDimensions ) {
				currentFrameStyles[ cssProperty ] = this._fromDimensions[ cssProperty ] +
					( toDimensions[ cssProperty ] - this._fromDimensions[ cssProperty ] ) *
					animationProgress;
			}

			this._element.css( currentFrameStyles );
			lm.utils.animFrame( lm.utils.fnBind( this._nextAnimationFrame, this ) );
		},

		_measure: function( element ) {
			var offset = element.offset();

			return {
				left: offset.left,
				top: offset.top,
				width: element.outerWidth(),
				height: element.outerHeight()
			};
		}
	} );
	lm.errors.ConfigurationError = function( message, node ) {
		Error.call( this );

		this.name = 'Configuration Error';
		this.message = message;
		this.node = node;
	};

	lm.errors.ConfigurationError.prototype = new Error();

	/**
	 * This is the baseclass that all content items inherit from.
	 * Most methods provide a subset of what the sub-classes do.
	 *
	 * It also provides a number of functions for tree traversal
	 *
	 * @param {lm.LayoutManager} layoutManager
	 * @param {item node configuration} config
	 * @param {lm.item} parent
	 *
	 * @event stateChanged
	 * @event beforeItemDestroyed
	 * @event itemDestroyed
	 * @event itemCreated
	 * @event componentCreated
	 * @event rowCreated
	 * @event columnCreated
	 * @event stackCreated
	 *
	 * @constructor
	 */
	lm.items.AbstractContentItem = function (layoutManager, config, parent) {
		lm.utils.EventEmitter.call(this);

		this.config = this._extendItemNode(config);
		this.type = config.type;
		this.contentItems = [];
		this.parent = parent;

		this.isInitialised = false;
		this.isMaximized = Array.isArray(config.id) && config.id.includes("__glMaximised");
		this.isRoot = false;
		this.isRow = false;
		this.isColumn = false;
		this.isStack = false;
		this.isComponent = false;
		// This property is added in order the patch the issue which is present when a child has been replaced and the active content item is changed
		// When you change the selected tab when a new child participates the hide method is invoked on the old child and the new doesn't here the event
		// This flag is used to indicate that and to change the visibility of the new child
		this.isVisible = true;

		this.layoutManager = layoutManager;
		this._pendingEventPropagations = {};
		this._throttledEvents = ['stateChanged'];
		this._isDestroyed = false;

		this.on(lm.utils.EventEmitter.ALL_EVENT, this._propagateEvent, this);

		if (config.content) {
			this._createContentItems(config);
		}
	};

	lm.utils.copy(lm.items.AbstractContentItem.prototype, {

		/**
		 * Set the size of the component and its children, called recursively
		 *
		 * @abstract
		 * @returns void
		 */
		setSize: function () {
			throw new Error('Abstract Method');
		},

		/**
		 * Calls a method recursively downwards on the tree
		 *
		 * @param   {String} functionName      the name of the function to be called
		 * @param   {[Array]}functionArguments optional arguments that are passed to every function
		 * @param   {[bool]} bottomUp          Call methods from bottom to top, defaults to false
		 * @param   {[bool]} skipSelf          Don't invoke the method on the class that calls it, defaults to false
		 *
		 * @returns {void}
		 */
		callDownwards: function (functionName, functionArguments, bottomUp, skipSelf) {
			var i;

			if (bottomUp !== true && skipSelf !== true) {
				this[functionName].apply(this, functionArguments || []);
			}
			for (i = 0; i < this.contentItems.length; i++) {
				this.contentItems[i].callDownwards(functionName, functionArguments, bottomUp);
			}
			if (bottomUp === true && skipSelf !== true) {
				this[functionName].apply(this, functionArguments || []);
			}
		},

		/**
		 * Removes a child node (and its children) from the tree
		 *
		 * @param   {lm.items.ContentItem} contentItem
		 *
		 * @returns {void}
		 */
		removeChild: function (contentItem, keepChild) {

			/*
			 * Get the position of the item that's to be removed within all content items this node contains
			 */
			var index = lm.utils.indexOf(contentItem, this.contentItems);

			/*
			 * Make sure the content item to be removed is actually a child of this item
			 */
			if (index === -1) {
				throw new Error('Can\'t remove child item. Unknown content item');
			}

			/**
			 * Call ._$destroy on the content item. This also calls ._$destroy on all its children
			 */
			if (keepChild !== true) {
				this.contentItems[index]._$destroy();
			}

			/**
			 * Remove the content item from this nodes array of children
			 */
			this.contentItems.splice(index, 1);

			/**
			 * Remove the item from the configuration
			 */
			this.config.content.splice(index, 1);

			/**
			 * If this node still contains other content items, adjust their size
			 */
			if (this.contentItems.length > 0) {
				this.callDownwards('setSize');

				/**
				 * If this was the last content item, remove this node as well
				 */
			} else if (!(this instanceof lm.items.Root) && this.config.isClosable === true) {
				this.parent.removeChild(this);
			}
		},

		/**
		 * Sets up the tree structure for the newly added child
		 * The responsibility for the actual DOM manipulations lies
		 * with the concrete item
		 *
		 * @param {lm.items.AbstractContentItem} contentItem
		 * @param {[Int]} index If omitted item will be appended
		 */
		addChild: function (contentItem, index) {
			if (index === undefined || index > this.contentItems.length) {
				index = this.contentItems.length;
			}

			this.contentItems.splice(index, 0, contentItem);

			if (this.config.content === undefined) {
				this.config.content = [];
			}

			this.config.content.splice(index, 0, contentItem.config);
			contentItem.parent = this;

			if (contentItem.parent.isInitialised === true && contentItem.isInitialised === false) {
				contentItem._$init();
			}
		},

		/**
		 * Replaces oldChild with newChild. This used to use jQuery.replaceWith... which for
		 * some reason removes all event listeners, so isn't really an option.
		 *
		 * @param   {lm.item.AbstractContentItem} oldChild
		 * @param   {lm.item.AbstractContentItem} newChild
		 *
		 * @returns {void}
		 */
		replaceChild: function (oldChild, newChild, _$destroyOldChild) {

			newChild = this.layoutManager._$normalizeContentItem(newChild);

			var index = lm.utils.indexOf(oldChild, this.contentItems),
				parentNode = oldChild.element[0].parentNode;

			if (index === -1) {
				throw new Error('Can\'t replace child. oldChild is not child of this');
			}

			parentNode.replaceChild(newChild.element[0], oldChild.element[0]);
			const isOldChildVisible = oldChild.isVisible;
			/*
			 * Optionally destroy the old content item
			 */
			if (_$destroyOldChild === true) {
				oldChild.parent = null;
				oldChild._$destroy();
			}

			/*
			 * Wire the new contentItem into the tree
			 */
			this.contentItems[index] = newChild;
			newChild.parent = this;

			/*
			 * Update tab reference
			 */
			if (this.isStack) {
				this.header.tabs[index].contentItem = newChild;
				newChild.tab = this.header.tabs[index];
			}

			//TODO This doesn't update the config... refactor to leave item nodes untouched after creation
			if (newChild.parent.isInitialised === true && newChild.isInitialised === false) {
				newChild._$init();
			}

			if (!isOldChildVisible) {
				newChild._$hide();
			}

			this.callDownwards('setSize');
		},
		replaceChildren: function (newChildren) {
			newChildren = newChildren.map(c => this.layoutManager._$normalizeContentItem(c));
			const oldChildren = this.contentItems;

			this.addChild(newChildren[0]);

			oldChildren.forEach((ci) => this.removeChild(ci));
			newChildren.slice(1).forEach((nc) => this.addChild(nc));

			this.callDownwards('setSize');
		},
		/**
		 * Convenience method.
		 * Shorthand for this.parent.removeChild( this )
		 *
		 * @returns {void}
		 */
		remove: function () {
			this.parent.removeChild(this);
		},

		/**
		 * Removes the component from the layout and creates a new
		 * browser window with the component and its children inside
		 *
		 * @returns {lm.controls.BrowserPopout}
		 */
		popout: function () {
			var browserPopout = this.layoutManager.createPopout(this);
			this.emitBubblingEvent('stateChanged');
			return browserPopout;
		},

		/**
		 * Maximises the Item or minimises it if it is already maximised
		 *
		 * @returns {void}
		 */
		toggleMaximise: function (e) {
			e && e.preventDefault();
			if (this.isMaximized === true) {
				this.layoutManager._$minimiseItem(this);
			} else {
				this.layoutManager._$maximiseItem(this);
			}

			this.isMaximized = !this.isMaximized;
			this.emitBubblingEvent('stateChanged');
		},

		/**
		 * Selects the item if it is not already selected
		 *
		 * @returns {void}
		 */
		select: function () {
			if (this.layoutManager.selectedItem !== this) {
				this.layoutManager.selectItem(this, true);
				this.element.addClass('lm_selected');
			}
		},

		/**
		 * De-selects the item if it is selected
		 *
		 * @returns {void}
		 */
		deselect: function () {
			if (this.layoutManager.selectedItem === this) {
				this.layoutManager.selectedItem = null;
				this.element.removeClass('lm_selected');
			}
		},

		/**
		 * Set this component's title
		 *
		 * @public
		 * @param {String} title
		 *
		 * @returns {void}
		 */
		setTitle: function (title) {
			this.config.title = title;
			this.emit('titleChanged', title);
			this.emit('stateChanged');
		},

		/**
		 * Checks whether a provided id is present
		 *
		 * @public
		 * @param   {String}  id
		 *
		 * @returns {Boolean} isPresent
		 */
		hasId: function (id) {
			if (!this.config.id) {
				return false;
			} else if (typeof this.config.id === 'string') {
				return this.config.id === id;
			} else if (this.config.id instanceof Array) {
				return lm.utils.indexOf(id, this.config.id) !== -1;
			}
		},

		/**
		 * Adds an id. Adds it as a string if the component doesn't
		 * have an id yet or creates/uses an array
		 *
		 * @public
		 * @param {String} id
		 *
		 * @returns {void}
		 */
		addId: function (id) {
			if (this.hasId(id)) {
				return;
			}

			if (!this.config.id) {
				this.config.id = id;
			} else if (typeof this.config.id === 'string') {
				this.config.id = [this.config.id, id];
			} else if (this.config.id instanceof Array) {
				this.config.id.push(id);
			}
		},

		/**
		 * Removes an existing id. Throws an error
		 * if the id is not present
		 *
		 * @public
		 * @param   {String} id
		 *
		 * @returns {void}
		 */
		removeId: function (id) {
			if (!this.hasId(id)) {
				throw new Error('Id not found');
			}

			if (typeof this.config.id === 'string') {
				delete this.config.id;
			} else if (this.config.id instanceof Array) {
				var index = lm.utils.indexOf(id, this.config.id);
				this.config.id.splice(index, 1);
			}
		},

		/****************************************
		 * SELECTOR
		 ****************************************/
		getItemsByFilter: function (filter) {
			var result = [],
				next = function (contentItem) {
					for (var i = 0; i < contentItem.contentItems.length; i++) {

						if (filter(contentItem.contentItems[i]) === true) {
							result.push(contentItem.contentItems[i]);
						}

						next(contentItem.contentItems[i]);
					}
				};

			next(this);
			return result;
		},

		getItemsById: function (id) {
			return this.getItemsByFilter(function (item) {
				if (item.config.id instanceof Array) {
					return lm.utils.indexOf(id, item.config.id) !== -1;
				} else {
					return item.config.id === id;
				}
			});
		},

		getItemsByType: function (type) {
			return this._$getItemsByProperty('type', type);
		},

		getComponentsByName: function (componentName) {
			var components = this._$getItemsByProperty('componentName', componentName),
				instances = [],
				i;

			for (i = 0; i < components.length; i++) {
				// Preserve the Gl logic and if instance is something meaningful return instance however if instance is just an empty object or undefined return the component
				// In theory this is the correct behaviour, there is no mention of an instance in the docs
				instances.push(components[i].instance && Object.keys(components[i].instance).length !== 0 ? components[i].instance : components[i]);
			}

			return instances;
		},

		/****************************************
		 * PACKAGE PRIVATE
		 ****************************************/
		_$getItemsByProperty: function (key, value) {
			return this.getItemsByFilter(function (item) {
				return item[key] === value;
			});
		},

		_$setParent: function (parent) {
			this.parent = parent;
		},

		_$highlightDropZone: function (x, y, area) {
			this.layoutManager.dropTargetIndicator.highlightArea(area);
		},

		_$onDrop: function (contentItem) {
			this.addChild(contentItem);
		},

		_$hide: function () {
			this._callOnActiveComponents('hide');
			this.element.hide();
			this.isVisible = false;
			this.layoutManager.updateSize();
		},

		_$show: function () {
			this._callOnActiveComponents('show');
			this.element.show();
			this.isVisible = true;
			this.layoutManager.updateSize();
		},

		_callOnActiveComponents: function (methodName) {
			var stacks = this.getItemsByType('stack'),
				activeContentItem,
				i;

			for (i = 0; i < stacks.length; i++) {
				activeContentItem = stacks[i].getActiveContentItem();

				if (activeContentItem && activeContentItem.isComponent) {
					activeContentItem.container[methodName]();
				}
			}
		},

		/**
		 * Destroys this item ands its children
		 *
		 * @returns {void}
		 */
		_$destroy: function () {
			if (this._isDestroyed) {
				return;
			}

			this._isDestroyed = true;
			this.emitBubblingEvent('beforeItemDestroyed');
			this.callDownwards('_$destroy', [], true, true);
			this.element.remove();
			this.emitBubblingEvent('itemDestroyed');
		},

		/**
		 * Returns the area the component currently occupies in the format
		 *
		 * {
		 *		x1: int
		 *		xy: int
		 *		y1: int
		 *		y2: int
		 *		contentItem: contentItem
		 * }
		 */
		_$getArea: function (element) {
			element = element || this.element;
			const elementBounds = lm.utils.getBounds(element);

			return {
				x1: elementBounds.left,
				y1: elementBounds.top,
				x2: elementBounds.left + elementBounds.width,
				y2: elementBounds.top + elementBounds.height,
				surface: elementBounds.width * elementBounds.height,
				contentItem: this
			};
		},

		/**
		 * The tree of content items is created in two steps: First all content items are instantiated,
		 * then init is called recursively from top to bottem. This is the basic init function,
		 * it can be used, extended or overwritten by the content items
		 *
		 * Its behaviour depends on the content item
		 *
		 * @package private
		 *
		 * @returns {void}
		 */
		_$init: function () {
			var i;
			this.setSize();

			for (i = 0; i < this.contentItems.length; i++) {
				this.childElementContainer.append(this.contentItems[i].element);
			}

			this.isInitialised = true;
			this.emitBubblingEvent('itemCreated');
			this.emitBubblingEvent(this.type + 'Created');
		},

		/**
		 * Emit an event that bubbles up the item tree.
		 *
		 * @param   {String} name The name of the event
		 *
		 * @returns {void}
		 */
		emitBubblingEvent: function (name) {
			var event = new lm.utils.BubblingEvent(name, this);
			this.emit(name, event);
		},

		/**
		 * Private method, creates all content items for this node at initialisation time
		 * PLEASE NOTE, please see addChild for adding contentItems add runtime
		 * @private
		 * @param   {configuration item node} config
		 *
		 * @returns {void}
		 */
		_createContentItems: function (config) {
			var oContentItem, i;

			if (!(config.content instanceof Array)) {
				throw new lm.errors.ConfigurationError('content must be an Array', config);
			}

			for (i = 0; i < config.content.length; i++) {
				oContentItem = this.layoutManager.createContentItem(config.content[i], this);
				this.contentItems.push(oContentItem);
			}
		},

		/**
		 * Extends an item configuration node with default settings
		 * @private
		 * @param   {configuration item node} config
		 *
		 * @returns {configuration item node} extended config
		 */
		_extendItemNode: function (config) {
			const defaultConfig = lm.config.itemDefaultConfig();
			for (var key in defaultConfig) {
				if (config[key] === undefined) {
					config[key] = defaultConfig[key];
				}
			}

			return config;
		},

		/**
		 * Called for every event on the item tree. Decides whether the event is a bubbling
		 * event and propagates it to its parent
		 *
		 * @param    {String} name the name of the event
		 * @param   {lm.utils.BubblingEvent} event
		 *
		 * @returns {void}
		 */
		_propagateEvent: function (name, event) {
			if (event instanceof lm.utils.BubblingEvent &&
				event.isPropagationStopped === false &&
				this.isInitialised === true) {

				/**
				 * In some cases (e.g. if an element is created from a DragSource) it
				 * doesn't have a parent and is not below root. If that's the case
				 * propagate the bubbling event from the top level of the substree directly
				 * to the layoutManager
				 */
				if (this.isRoot === false && this.parent) {
					this.parent.emit.apply(this.parent, Array.prototype.slice.call(arguments, 0));
				} else {
					this._scheduleEventPropagationToLayoutManager(name, event);
				}
			}
		},

		/**
		 * All raw events bubble up to the root element. Some events that
		 * are propagated to - and emitted by - the layoutManager however are
		 * only string-based, batched and sanitized to make them more usable
		 *
		 * @param {String} name the name of the event
		 *
		 * @private
		 * @returns {void}
		 */
		_scheduleEventPropagationToLayoutManager: function (name, event) {
			if (lm.utils.indexOf(name, this._throttledEvents) === -1) {
				this.layoutManager.emit(name, event.origin);
			} else {
				if (this._pendingEventPropagations[name] !== true) {
					this._pendingEventPropagations[name] = true;
					lm.utils.animFrame(lm.utils.fnBind(this._propagateEventToLayoutManager, this, [name, event]));
				}
			}

		},

		/**
		 * Callback for events scheduled by _scheduleEventPropagationToLayoutManager
		 *
		 * @param {String} name the name of the event
		 *
		 * @private
		 * @returns {void}
		 */
		_propagateEventToLayoutManager: function (name, event) {
			this._pendingEventPropagations[name] = false;
			this.layoutManager.emit(name, event);
		},
		_memoizeConstraint(constraintProperty, value) {
			const id = lm.utils.idAsString(this.config.id);
			if (!id) {
				return;
			}
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[id];
			if (memoizedConstraints) {
				this.layoutManager._idToMinMaxConstraints[id][constraintProperty] = value;
			} else {
				this.layoutManager._idToMinMaxConstraints[id] = { [`${constraintProperty}`]: value };
			}
		},
	});

	/**
	 * @param {[type]} layoutManager [description]
	 * @param {[type]} config      [description]
	 * @param {[type]} parent        [description]
	 */
	lm.items.Component = function (layoutManager, config, parent) {
		lm.items.AbstractContentItem.call(this, layoutManager, config, parent);

		var ComponentConstructor = layoutManager.getComponent(this.config.componentName),
			componentConfig = $.extend(true, {}, this.config.componentState || {});

		componentConfig.componentName = this.config.componentName;
		this.componentName = this.config.componentName;

		if (this.config.title === '') {
			this.config.title = this.config.componentName;
		}

		this.isComponent = true;
		this.container = new lm.container.ItemContainer(this.config, this, layoutManager);
		this.instance = new ComponentConstructor(this.container, componentConfig);
		this.element = this.container._element;
	};

	lm.utils.extend(lm.items.Component, lm.items.AbstractContentItem);

	lm.utils.copy(lm.items.Component.prototype, {

		close: function () {
			this.parent.removeChild(this);
		},

		setSize: function () {
			if (this.element.is(':visible')) {
				// Do not update size of hidden components to prevent unwanted reflows
				const elementBounds = lm.utils.getBounds(this.element);
				this.emit("size-changed", { width: elementBounds.width, height: elementBounds.height });
				this.container._$setSize(elementBounds.width, elementBounds.height);
			}
		},

		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinWidth() {
			if (!this.config.workspacesConfig) {
				return this.layoutManager.config.dimensions.minItemWidth;
			}
			return this.config.workspacesConfig.minWidth || this.layoutManager.config.dimensions.minItemWidth;
		},

		/**
		   * Returns the min width of the row or column
		   * @returns {number | undefined}
		   */
		getMaxWidth() {
			if (!this.config.workspacesConfig) {
				return this.layoutManager.config.dimensions.maxItemWidth;
			}
			return this.config.workspacesConfig.maxWidth || this.layoutManager.config.dimensions.maxItemWidth;
		},

		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinHeight() {
			if (!this.config.workspacesConfig) {
				return this.layoutManager.config.dimensions.minItemHeight;
			}
			return this.config.workspacesConfig.minHeight || this.layoutManager.config.dimensions.minItemHeight;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxHeight() {
			if (!this.config.workspacesConfig) {
				return this.layoutManager.config.dimensions.maxItemHeight;
			}
			return this.config.workspacesConfig.maxHeight || this.layoutManager.config.dimensions.maxItemHeight;
		},
		_$init: function () {
			lm.items.AbstractContentItem.prototype._$init.call(this);
			this.container.emit('open');
		},

		_$hide: function () {
			this.container.hide();
			lm.items.AbstractContentItem.prototype._$hide.call(this);
		},

		_$show: function () {
			this.container.show();
			lm.items.AbstractContentItem.prototype._$show.call(this);
		},

		_$shown: function () {
			this.container.shown();
			lm.items.AbstractContentItem.prototype._$shown.call(this);
		},

		_$destroy: function () {
			this.container.emit('destroy', this);
			lm.items.AbstractContentItem.prototype._$destroy.call(this);
		},

		/**
		 * Dragging onto a component directly is not an option
		 *
		 * @returns null
		 */
		_$getArea: function () {
			return null;
		}
	});

	lm.items.Root = function (layoutManager, config, containerElement) {
		lm.items.AbstractContentItem.call(this, layoutManager, config, null);
		this.isRoot = true;
		this.type = 'root';
		this.element = $('<div class="lm_goldenlayout lm_item lm_root"></div>');
		this.childElementContainer = this.element;
		this._containerElement = containerElement;
		this._containerElement.append(this.element);
	};

	lm.utils.extend(lm.items.Root, lm.items.AbstractContentItem);

	lm.utils.copy(lm.items.Root.prototype, {
		addChild: function (contentItem) {
			if (this.contentItems.length > 0) {
				throw new Error('Root node can only have a single child');
			}

			contentItem = this.layoutManager._$normalizeContentItem(contentItem, this);
			this.childElementContainer.append(contentItem.element);
			lm.items.AbstractContentItem.prototype.addChild.call(this, contentItem);

			this.callDownwards('setSize');
			this.emitBubblingEvent('stateChanged');
		},

		setSize: function (width, height) {
			const containerBounds = lm.utils.getBounds(this._containerElement);
			width = (typeof width === 'undefined') ? containerBounds.width : width;
			height = (typeof height === 'undefined') ? containerBounds.height : height;

			this.element.width(width);
			this.element.height(height);

			/*
			 * Root can be empty
			 */
			if (this.contentItems[0]) {
				this.contentItems[0].element.width(width);
				this.contentItems[0].element.height(height);
			}
		},

		/**
			 * Returns the min width of the row or column
			 * @returns {number | undefined}
			 */
		getMinWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minWidth === "number") {
				return memoizedConstraints.minWidth;
			}
			const elementMinWidth = this.config.workspacesConfig.minWidth || this.layoutManager.config.dimensions.minItemWidth;
			const contentsMinWidth = this.contentItems.reduce((minWidth, ci) => {
				minWidth += ci.getMinWidth() || this.layoutManager.config.dimensions.minItemWidth;
				return minWidth;
			}, 0);
			const result = Math.max(elementMinWidth, contentsMinWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minWidth", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxWidth === "number") {
				return memoizedConstraints.maxWidth;
			}
			const elementMaxWidth = this.config.workspacesConfig.maxWidth || this.layoutManager.config.dimensions.maxItemWidth;
			const contentsMaxWidth = this.contentItems.reduce((maxWidth, ci) => {
				maxWidth += ci.getMaxWidth() || this.layoutManager.config.dimensions.maxItemWidth;
				return maxWidth;
			}, 0);

			const result = Math.min(elementMaxWidth, contentsMaxWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxWidth", result);
			
			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minHeight === "number") {
				return memoizedConstraints.minHeight;
			}
			const elementMinHeight = this.config.workspacesConfig.minHeight || this.layoutManager.config.dimensions.minItemHeight;
			const contentsMinHeight = this.contentItems.reduce((minHeight, ci) => {
				minHeight += ci.getMinHeight() || this.layoutManager.config.dimensions.minItemHeight;
				return minHeight;
			}, 0);

			const result =  Math.max(elementMinHeight, contentsMinHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minHeight", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxHeight === "number") {
				return memoizedConstraints.maxHeight;
			}
			const elementMaxHeight = this.config.workspacesConfig.maxHeight || this.layoutManager.config.dimensions.maxItemHeight;
			const contentsMaxHeight = this.contentItems.reduce((maxHeight, ci) => {
				maxHeight += ci.getMaxHeight() || this.layoutManager.config.dimensions.maxItemHeight;
				return maxHeight;
			}, 0);

			const result =  Math.min(elementMaxHeight, contentsMaxHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxHeight", result);

			return result;
		},
		_$highlightDropZone: function (x, y, area) {
			this.layoutManager.tabDropPlaceholder.remove();
			lm.items.AbstractContentItem.prototype._$highlightDropZone.apply(this, arguments);
		},

		_$onDrop: function (contentItem, area) {
			var stack;

			if (contentItem.isComponent) {
				stack = this.layoutManager.createContentItem({
					type: 'stack',
					header: contentItem.config.header || {}
				}, this);
				stack._$init();
				stack.addChild(contentItem);
				contentItem = stack;
			}

			if (!this.contentItems.length) {
				this.addChild(contentItem);
			} else {
				var type = area.side[0] == 'x' ? 'row' : 'column';
				var dimension = area.side[0] == 'x' ? 'width' : 'height';
				var insertBefore = area.side[1] == '2';
				var column = this.contentItems[0];
				if (!column instanceof lm.items.RowOrColumn || column.type != type) {
					var rowOrColumn = this.layoutManager.createContentItem({ type: type }, this);
					this.replaceChild(column, rowOrColumn);
					rowOrColumn.addChild(contentItem, insertBefore ? 0 : undefined, true);
					rowOrColumn.addChild(column, insertBefore ? undefined : 0, true);
					column.config[dimension] = 50;
					contentItem.config[dimension] = 50;
					rowOrColumn.callDownwards('setSize');
				} else {
					var sibbling = column.contentItems[insertBefore ? 0 : column.contentItems.length - 1];
					column.addChild(contentItem, insertBefore ? 0 : undefined, true);
					sibbling.config[dimension] *= 0.5;
					contentItem.config[dimension] = sibbling.config[dimension];
					column.callDownwards('setSize');
				}
			}
		}
	});



	lm.items.RowOrColumn = function (isColumn, layoutManager, config, parent) {
		lm.items.AbstractContentItem.call(this, layoutManager, config, parent);

		this.isRow = !isColumn;
		this.isColumn = isColumn;

		this.element = $('<div class="lm_item lm_' + (isColumn ? 'column' : 'row') + '"></div>');
		this.childElementContainer = this.element;
		this._splitterSize = layoutManager.config.dimensions.borderWidth;
		this._splitterGrabSize = layoutManager.config.dimensions.borderGrabWidth;
		this._isColumn = isColumn;
		this._dimension = isColumn ? 'height' : 'width';
		this._splitter = [];
		this._splitterPosition = null;
		this._splitterMinPosition = null;
		this._splitterMaxPosition = null;
		this._layoutManager = layoutManager;
	};

	lm.utils.extend(lm.items.RowOrColumn, lm.items.AbstractContentItem);

	lm.utils.copy(lm.items.RowOrColumn.prototype, {

		/**
		 * Add a new contentItem to the Row or Column
		 *
		 * @param {lm.item.AbstractContentItem} contentItem
		 * @param {[int]} index The position of the new item within the Row or Column.
		 *                      If no index is provided the item will be added to the end
		 * @param {[bool]} _$suspendResize If true the items won't be resized. This will leave the item in
		 *                                 an inconsistent state and is only intended to be used if multiple
		 *                                 children need to be added in one go and resize is called afterwards
		 *
		 * @returns {void}
		 */
		addChild: function (contentItem, index, _$suspendResize) {

			var newItemSize, itemSize, i, splitterElement;

			contentItem = this.layoutManager._$normalizeContentItem(contentItem, this);

			if (index === undefined || index > this.contentItems.length) {
				index = this.contentItems.length;
			}

			if (this.contentItems.length > 0) {
				splitterElement = this._createSplitter(Math.max(0, index - 1)).element;

				if (index > 0) {
					this.contentItems[index - 1].element.after(splitterElement);
					splitterElement.after(contentItem.element);
				} else {
					this.contentItems[0].element.before(splitterElement);
					splitterElement.before(contentItem.element);
				}
			} else {
				this.childElementContainer.append(contentItem.element);
			}

			lm.items.AbstractContentItem.prototype.addChild.call(this, contentItem, index);

			newItemSize = (1 / this.contentItems.length) * 100;

			if (_$suspendResize === true) {
				this.emitBubblingEvent('stateChanged');
				return;
			}

			for (i = 0; i < this.contentItems.length; i++) {
				if (this.contentItems[i] === contentItem) {
					contentItem.config[this._dimension] = newItemSize;
				} else {
					itemSize = this.contentItems[i].config[this._dimension] *= (100 - newItemSize) / 100;
					this.contentItems[i].config[this._dimension] = itemSize;
				}
			}

			this.callDownwards('setSize');
			this.emitBubblingEvent('stateChanged');
		},

		/**
		 * Removes a child of this element
		 *
		 * @param   {lm.items.AbstractContentItem} contentItem
		 * @param   {boolean} keepChild   If true the child will be removed, but not destroyed
		 *
		 * @returns {void}
		 */
		removeChild: function (contentItem, keepChild) {
			var removedItemSize = contentItem.config[this._dimension],
				index = lm.utils.indexOf(contentItem, this.contentItems),
				splitterIndex = Math.max(index - 1, 0),
				i,
				childItem;

			if (index === -1) {
				throw new Error('Can\'t remove child. ContentItem is not child of this Row or Column');
			}

			/**
			 * Remove the splitter before the item or after if the item happens
			 * to be the first in the row/column
			 */
			if (this._splitter[splitterIndex]) {
				this._splitter[splitterIndex]._$destroy();
				this._splitter.splice(splitterIndex, 1);
			}

			/**
			 * Allocate the space that the removed item occupied to the remaining items
			 */
			for (i = 0; i < this.contentItems.length; i++) {
				if (this.contentItems[i] !== contentItem) {
					this.contentItems[i].config[this._dimension] += removedItemSize / (this.contentItems.length - 1);
				}
			}

			lm.items.AbstractContentItem.prototype.removeChild.call(this, contentItem, keepChild);

			if (this.contentItems.length === 1 && this.config.isClosable === true) {
				childItem = this.contentItems[0];
				this.contentItems = [];
				this.parent.replaceChild(this, childItem, true);
			} else {
				this.callDownwards('setSize');
				this.emitBubblingEvent('stateChanged');
			}
		},

		/**
		 * Replaces a child of this Row or Column with another contentItem
		 *
		 * @param   {lm.items.AbstractContentItem} oldChild
		 * @param   {lm.items.AbstractContentItem} newChild
		 *
		 * @returns {void}
		 */
		replaceChild: function (oldChild, newChild) {
			var size = oldChild.config[this._dimension];
			// If the dimension of the new element is set after the replace call
			// a recalculation occurs in replace child because the children won't ever add up to 100
			// the recalculation appears to the user as a flicker/jump and moves the splitter with a few pixels
			newChild.config = newChild.config || {};
			newChild.config[this._dimension] = size;
			lm.items.AbstractContentItem.prototype.replaceChild.call(this, oldChild, newChild);
			this.callDownwards('setSize');
			this.emitBubblingEvent('stateChanged');
		},

		/**
		 * Called whenever the dimensions of this item or one of its parents change
		 *
		 * @returns {void}
		 */
		setSize: function () {
			if (this.contentItems.length > 0) {
				this._calculateRelativeSizes();
				this._setAbsoluteSizes();
			}
			this.emitBubblingEvent('stateChanged');
			this.emit('resize');
		},

		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minWidth === "number") {
				return memoizedConstraints.minWidth;
			}
			const elementMinWidth = this.config.workspacesConfig.minWidth || this.layoutManager.config.dimensions.minItemWidth;
			const contentsMinWidth = this.contentItems.reduce((minWidth, ci) => {
				if (this.config.type === "row") {
					minWidth += ci.getMinWidth() || this.layoutManager.config.dimensions.minItemWidth;
				} else if (this.config.type === "column") {
					minWidth = Math.max(ci.getMinWidth() || this.layoutManager.config.dimensions.minItemWidth, minWidth);
				}
				return minWidth;
			}, 0);
			const result = Math.max(elementMinWidth, contentsMinWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minWidth", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxWidth === "number") {
				return memoizedConstraints.maxWidth;
			}
			const elementMaxWidth = this.config.workspacesConfig.maxWidth || this.layoutManager.config.dimensions.maxItemWidth;
			if (!this.contentItems.length) {
				// When there are no content items the item constraint should be returned directly
				return elementMaxWidth;
			}
			const contentsMaxWidth = this.contentItems.reduce((maxWidth, ci) => {
				if (this.config.type === "row") {
					maxWidth += ci.getMaxWidth() || this.layoutManager.config.dimensions.maxItemWidth;
				} else if (this.config.type === "column") {
					maxWidth = Math.min(ci.getMaxWidth() || this.layoutManager.config.dimensions.maxItemWidth, maxWidth || elementMaxWidth);
				}
				return maxWidth;
			}, 0);

			const result = Math.min(elementMaxWidth, contentsMaxWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxWidth", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minHeight === "number") {
				return memoizedConstraints.minHeight;
			}
			const elementMinHeight = this.config.workspacesConfig.minHeight || this.layoutManager.config.dimensions.minItemHeight;
			const contentsMinHeight = this.contentItems.reduce((minHeight, ci) => {
				if (this.config.type === "row") {
					minHeight = Math.max(ci.getMinHeight() || this.layoutManager.config.dimensions.minItemHeight, minHeight);
				} else if (this.config.type === "column") {
					minHeight += ci.getMinHeight() || this.layoutManager.config.dimensions.minItemHeight;
				}
				return minHeight;
			}, 0);

			const result = Math.max(elementMinHeight, contentsMinHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minHeight", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxHeight === "number") {
				return memoizedConstraints.maxHeight;
			}
			const elementMaxHeight = this.config.workspacesConfig.maxHeight || this.layoutManager.config.dimensions.maxItemHeight;
			if (!this.contentItems.length) {
				// When there are no content items the item constraint should be returned directly
				return elementMaxHeight;
			}
			const contentsMaxHeight = this.contentItems.reduce((maxHeight, ci) => {
				if (this.config.type === "row") {
					maxHeight = Math.min(ci.getMaxHeight() || this.layoutManager.config.dimensions.maxItemHeight, maxHeight || elementMaxHeight);
				} else if (this.config.type === "column") {
					maxHeight += ci.getMaxHeight() || this.layoutManager.config.dimensions.maxItemHeight;
				}
				return maxHeight;
			}, 0);

			const result = Math.min(elementMaxHeight, contentsMaxHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxHeight", result);

			return result;
		},

		/**
		 * Invoked recursively by the layout manager. AbstractContentItem.init appends
		 * the contentItem's DOM elements to the container, RowOrColumn init adds splitters
		 * in between them
		 *
		 * @package private
		 * @override AbstractContentItem._$init
		 * @returns {void}
		 */
		_$init: function () {
			if (this.isInitialised === true) return;

			var i;

			lm.items.AbstractContentItem.prototype._$init.call(this);

			for (i = 0; i < this.contentItems.length - 1; i++) {
				this.contentItems[i].element.after(this._createSplitter(i).element);
			}
		},

		/**
		 * Turns the relative sizes calculated by _calculateRelativeSizes into
		 * absolute pixel values and applies them to the children's DOM elements
		 *
		 * Assigns additional pixels to counteract Math.floor
		 *
		 * @private
		 * @returns {void}
		 */
		_setAbsoluteSizes: function () {
			var i,
				sizeData = this._calculateAbsoluteSizes();

			const pinnedItemsInCollection = this.contentItems.filter((ci) => ci.config.workspacesConfig.isPinned && !this._layoutManager._ignorePinned);
			let additionalPixels = sizeData.additionalPixel;
			const boundsCache = this.contentItems.reduce((acc, ci) => {
				acc.set(ci, lm.utils.getBounds(ci.element));
				return acc;
			}, new Map());
			const pinnedItemsWhichWillReceivePixel = pinnedItemsInCollection.filter((pi) => {
				const elementBounds = boundsCache.get(pi);
				const currentSize = this.isColumn ? elementBounds.height : elementBounds.width;
				const indexInCollection = this.contentItems.indexOf(pi);

				return Math.floor(currentSize) > Math.floor(sizeData.itemSizes[indexInCollection]);
			});


			pinnedItemsWhichWillReceivePixel.forEach((pi) => {
				const elementBounds = boundsCache.get(pi);
				const currentSize = this.isColumn ? elementBounds.height : elementBounds.width;
				const indexInCollection = this.contentItems.indexOf(pi);
				const pixelsRequired = Math.floor(currentSize - sizeData.itemSizes[indexInCollection]);

				const pixelsToAdd = Math.min(additionalPixels, pixelsRequired);
				sizeData.itemSizes[indexInCollection] += pixelsToAdd;
				additionalPixels -= pixelsToAdd;
			});

			const pixelPerItem = Math.ceil(additionalPixels / (this.contentItems.length - pinnedItemsInCollection.length));

			for (i = 0; i < this.contentItems.length; i++) {
				if (additionalPixels > 0 && !this.contentItems[i].config.workspacesConfig.isPinned) {
					const pixelsToAdd = Math.min(additionalPixels, pixelPerItem);
					sizeData.itemSizes[i] += pixelsToAdd;
					additionalPixels -= pixelsToAdd;
				}

				const height = this.isColumn ? sizeData.itemSizes[i] : sizeData.totalHeight;
				const width = this.isColumn ? sizeData.totalWidth : sizeData.itemSizes[i];

				this.contentItems[i].element.css({
					'width': width,
					'height': height
				});

				if (this._isColumn && this.contentItems[i].config.workspacesConfig.isPinned && this._layoutManager._ignorePinned) {
					this.contentItems[i].config.workspacesConfig.pinnedSize = height;
				} else if (this.contentItems[i].config.workspacesConfig.isPinned && this._layoutManager._ignorePinned) {
					this.contentItems[i].config.workspacesConfig.pinnedSize = width;
				}
			}
		},

		/**
		 * Calculates the absolute sizes of all of the children of this Item.
		 * @returns {object} - Set with absolute sizes and additional pixels.
		 */
		_calculateAbsoluteSizes: function () {
			const elementBounds = lm.utils.getBounds(this.element);
			var i,
				totalSplitterSize = (this.contentItems.length - 1) * this._splitterSize,
				totalWidth = elementBounds.width,
				totalHeight = elementBounds.height,
				totalAssigned = 0,
				additionalPixel,
				itemSize,
				itemSizes = [];

			if (this._isColumn) {
				totalHeight -= totalSplitterSize;
			} else {
				totalWidth -= totalSplitterSize;
			}

			for (i = 0; i < this.contentItems.length; i++) {
				if (this._isColumn) {
					itemSize = Math.floor(totalHeight * (this.contentItems[i].config.height / 100));
				} else {
					itemSize = Math.floor(totalWidth * (this.contentItems[i].config.width / 100));
				}

				totalAssigned += itemSize;
				itemSizes.push(itemSize);
			}

			additionalPixel = Math.floor((this._isColumn ? totalHeight : totalWidth) - totalAssigned);

			return {
				itemSizes: itemSizes,
				additionalPixel: additionalPixel,
				totalWidth: totalWidth,
				totalHeight: totalHeight
			};
		},

		/**
		 * Calculates the relative sizes of all children of this Item. The logic
		 * is as follows:
		 *
		 * - Add up the total size of all items that have a configured size
		 *
		 * - If the total == 100 (check for floating point errors)
		 *        Excellent, job done
		 *
		 * - If the total is > 100,
		 *        set the size of items without set dimensions to 1/3 and add this to the total
		 *        set the size off all items so that the total is hundred relative to their original size
		 *
		 * - If the total is < 100
		 *        If there are items without set dimensions, distribute the remainder to 100 evenly between them
		 *        If there are no items without set dimensions, increase all items sizes relative to
		 *        their original size so that they add up to 100
		 *
		 * @private
		 * @returns {void}
		 */
		_calculateRelativeSizes: function () {

			var i,
				total = 0,
				itemsWithoutSetDimension = [],
				dimension = this._isColumn ? 'height' : 'width';

			for (i = 0; i < this.contentItems.length; i++) {
				if (this.contentItems[i].config[dimension] !== undefined) {
					total += this.contentItems[i].config[dimension];
				} else {
					itemsWithoutSetDimension.push(this.contentItems[i]);
				}
			}

			/**
			 * Everything adds up to hundred, all good :-)
			 */
			if (Math.round(total) === 100) {
				this._respectItemWidthConstraints();
				this._respectItemHeightConstraints();
				return;
			}

			/**
			 * Allocate the remaining size to the items without a set dimension
			 */
			if (Math.round(total) < 100 && itemsWithoutSetDimension.length > 0) {
				for (i = 0; i < itemsWithoutSetDimension.length; i++) {
					itemsWithoutSetDimension[i].config[dimension] = (100 - total) / itemsWithoutSetDimension.length;
				}
				this._respectItemWidthConstraints();
				this._respectItemHeightConstraints();
				return;
			}

			/**
			 * If the total is > 100, but there are also items without a set dimension left, assing 50
			 * as their dimension and add it to the total
			 *
			 * This will be reset in the next step
			 */
			if (Math.round(total) > 100) {
				for (i = 0; i < itemsWithoutSetDimension.length; i++) {
					itemsWithoutSetDimension[i].config[dimension] = 50;
					total += 50;
				}
			}

			/**
			 * Set every items size relative to 100 relative to its size to total
			 */
			for (i = 0; i < this.contentItems.length; i++) {
				this.contentItems[i].config[dimension] = (this.contentItems[i].config[dimension] / total) * 100;
			}

			this._respectItemWidthConstraints();
			this._respectItemHeightConstraints();
		},

		/**
		 * Adjusts the column widths to respect the dimensions minItemWidth if set.
		 * @returns {}
		 */
		_respectItemWidthConstraints: function () {
			var minItemWidth = this.layoutManager.config.dimensions ? (this.layoutManager.config.dimensions.minItemWidth || 0) : 0,
				maxItemWidth = this.layoutManager.config.dimensions ? (this.layoutManager.config.dimensions.maxItemWidth || 32767) : 32767,
				sizeData = null,
				entriesOverMin = [],
				entriesUnderMax = [],
				totalOverMin = 0,
				totalUnderMin = 0,
				totalOverMax = 0,
				totalUnderMax = 0,
				remainingWidthToReduce = 0,
				remainingWidthToEnlarge = 0,
				itemSize = 0,
				contentItem = null,
				reducePercent,
				enlargePercent,
				reducedWidth,
				enlargedWidth,
				allEntries = [],
				entry;

			if (this._isColumn || !minItemWidth || this.contentItems.length <= 1) {
				return;
			}

			sizeData = this._calculateAbsoluteSizes();
			maxItemWidth = Math.min(maxItemWidth, sizeData.totalWidth);

			/**
			 * Figure out how much we are under the min item size total and how much room we have to use.
			 */
			for (var i = 0; i < this.contentItems.length; i++) {
				contentItem = this.contentItems[i];
				itemSize = sizeData.itemSizes[i];
				const elementBounds = lm.utils.getBounds(contentItem.element);
				const pinnedSize = contentItem.config.workspacesConfig.pinnedSize || elementBounds.width;
				const contentItemMaxWidth = contentItem.config.workspacesConfig.isPinned && !this._layoutManager._ignorePinned ? pinnedSize : contentItem.getMaxWidth();
				const contentItemMinWidth = contentItem.config.workspacesConfig.isPinned && !this._layoutManager._ignorePinned ? pinnedSize : contentItem.getMinWidth();
				const validContentItemMaxWidth = Math.min((contentItemMaxWidth === undefined) ? maxItemWidth : contentItemMaxWidth, sizeData.totalWidth);
				const validContentItemMinWidth = (contentItemMinWidth === undefined) ? minItemWidth : contentItemMinWidth;

				if (itemSize < validContentItemMinWidth) {
					totalUnderMin += validContentItemMinWidth - itemSize;
					entry = {
						maxWidth: validContentItemMaxWidth,
						minWidth: validContentItemMinWidth,
						width: validContentItemMinWidth
					};

				} else {
					totalOverMin += Math.min(itemSize, validContentItemMaxWidth) - validContentItemMinWidth;
					entry = {
						maxWidth: validContentItemMaxWidth,
						minWidth: validContentItemMinWidth,
						width: itemSize
					};
					entriesOverMin.push(entry);
				}

				if (itemSize > validContentItemMaxWidth) {
					totalOverMax += itemSize - validContentItemMaxWidth;
					entry.width = validContentItemMaxWidth;
				} else {
					totalUnderMax += validContentItemMaxWidth - Math.max(itemSize, validContentItemMinWidth);
					entriesUnderMax.push(entry);
				}

				allEntries.push(entry);
			}

			const isMinWidthImpossible = totalUnderMin === 0 || totalUnderMin > totalOverMin;
			const isMaxWidthImpossible = totalOverMax === 0 || totalOverMax > totalUnderMax;
			/**
			 * If there is nothing under min, or there is not enough over to make up the difference, do nothing.
			 */
			if (isMinWidthImpossible && isMaxWidthImpossible) {
				return true;
			}

			if (!isMinWidthImpossible) {
				/**
						 * Evenly reduce all columns that are over the min item width to make up the difference.
						 */
				reducePercent = totalUnderMin / totalOverMin;
				remainingWidthToReduce = totalUnderMin;
				for (i = 0; i < entriesOverMin.length; i++) {
					entry = entriesOverMin[i];
					reducedWidth = Math.round((entry.width - entry.minWidth) * reducePercent);
					remainingWidthToReduce -= reducedWidth;
					entry.width -= reducedWidth;
				}
			}

			if (!isMaxWidthImpossible) {
				/**
				 * Evenly enlarge all that are over the max item width to make up the difference.
				 */
				enlargePercent = totalOverMax / totalUnderMax;
				remainingWidthToEnlarge = totalOverMax;
				for (i = 0; i < entriesUnderMax.length; i++) {
					entry = entriesUnderMax[i];
					enlargedWidth = Math.round((entry.maxWidth - entry.width) * enlargePercent);
					remainingWidthToEnlarge -= enlargedWidth;
					entry.width += enlargedWidth;
				}
			}

			if (!isMinWidthImpossible) {
				/**
						 * Take anything remaining from the last item.
						 */
				if (remainingWidthToReduce !== 0) {
					allEntries[allEntries.length - 1].width -= remainingWidthToReduce;
				}
			}

			if (!isMaxWidthImpossible) {
				/**
				  * Take anything remaining from the last item.
				  */
				if (remainingWidthToEnlarge !== 0) {
					allEntries[allEntries.length - 1].width += remainingWidthToEnlarge;
				}
			}

			/**
			 * Set every items size relative to 100 relative to its size to total
			 */
			for (i = 0; i < this.contentItems.length; i++) {
				this.contentItems[i].config.width = (allEntries[i].width / sizeData.totalWidth) * 100;
			}

			return false;
		},
		/**
		  * Adjusts the column widths to respect the dimensions minItemWidth if set.
		  * @returns {}
		  */
		_respectItemHeightConstraints: function () {
			var minItemHeight = this.layoutManager.config.dimensions ? (this.layoutManager.config.dimensions.minItemHeight || 0) : 0,
				maxItemHeight = this.layoutManager.config.dimensions ? (this.layoutManager.config.dimensions.maxItemHeight || 32767) : 32767,
				sizeData = null,
				entriesOverMin = [],
				entriesUnderMax = [],
				totalOverMin = 0,
				totalUnderMin = 0,
				totalOverMax = 0,
				totalUnderMax = 0,
				remainingHeight = 0,
				remainingHeightToReduce = 0,
				remainingHeightToEnlarge = 0,
				itemSize = 0,
				contentItem = null,
				reducePercent,
				enlargePercent,
				enlargedHeight,
				allEntries = [],
				entry;

			if (this._isRow || !minItemHeight || this.contentItems.length <= 1) {
				return;
			}

			sizeData = this._calculateAbsoluteSizes();
			maxItemHeight = Math.min(sizeData.totalHeight, maxItemHeight);

			/**
			 * Figure out how much we are under the min item size total and how much room we have to use.
			 */
			for (var i = 0; i < this.contentItems.length; i++) {

				contentItem = this.contentItems[i];
				itemSize = sizeData.itemSizes[i];

				const pinnedSize = contentItem.config.workspacesConfig.pinnedSize || lm.utils.getBounds(contentItem.element).height;
				const contentItemMaxHeight = contentItem.config.workspacesConfig.isPinned && !this._layoutManager._ignorePinned ? pinnedSize : contentItem.getMaxHeight();
				const contentItemMinHeight = contentItem.config.workspacesConfig.isPinned && !this._layoutManager._ignorePinned ? pinnedSize : contentItem.getMinHeight();
				const validContentItemMaxHeight = Math.min((contentItemMaxHeight === undefined) ? maxItemHeight : contentItemMaxHeight, sizeData.totalHeight);
				const validContentItemMinHeight = (contentItemMinHeight === undefined) ? minItemHeight : contentItemMinHeight;

				if (itemSize < validContentItemMinHeight) {
					totalUnderMin += validContentItemMinHeight - itemSize;
					entry = {
						maxHeight: validContentItemMaxHeight,
						minHeight: validContentItemMinHeight,
						height: validContentItemMinHeight
					};
				} else {
					totalOverMin += Math.min(itemSize, validContentItemMaxHeight) - validContentItemMinHeight;
					entry = {
						maxHeight: validContentItemMaxHeight,
						minHeight: validContentItemMinHeight,
						height: itemSize
					};
					entriesOverMin.push(entry);
				}

				if (itemSize > validContentItemMaxHeight) {
					totalOverMax += itemSize - validContentItemMaxHeight;
					entry.height = validContentItemMaxHeight;
				} else {
					totalUnderMax += validContentItemMaxHeight - Math.max(itemSize, validContentItemMinHeight);
					entriesUnderMax.push(entry);
				}

				allEntries.push(entry);
			}

			const isMinHeightImpossible = totalUnderMin === 0 || totalUnderMin > totalOverMin;
			const isMaxHeightImpossible = totalOverMax === 0 || totalOverMax > totalUnderMax;
			/**
			 * If there is nothing under min, or there is not enough over to make up the difference, do nothing.
			 */
			if (isMinHeightImpossible && isMaxHeightImpossible) {
				return true;
			}

			if (!isMinHeightImpossible) {
				/**
				 * Evenly reduce all columns that are over the min item width to make up the difference.
				 */
				reducePercent = totalUnderMin / totalOverMin;
				remainingHeight = totalUnderMin;
				for (i = 0; i < entriesOverMin.length; i++) {
					entry = entriesOverMin[i];
					remainingHeightToReduce = Math.round((entry.height - minItemHeight) * reducePercent);
					remainingHeight -= remainingHeightToReduce;
					entry.height -= remainingHeightToReduce;
				}
			}

			if (!isMaxHeightImpossible) {
				/**
				 * Evenly enlarge all that are over the max item width to make up the difference.
				 */
				enlargePercent = totalOverMax / totalUnderMax;
				remainingHeightToEnlarge = totalOverMax;
				for (i = 0; i < entriesUnderMax.length; i++) {
					entry = entriesUnderMax[i];
					enlargedHeight = Math.round((entry.maxHeight - entry.height) * enlargePercent);
					remainingHeightToEnlarge -= enlargedHeight;
					entry.height += enlargedHeight;
				}
			}

			if (!isMinHeightImpossible) {
				/**
				 * Take anything remaining from the last item.
				 */
				if (remainingHeight !== 0) {
					allEntries[allEntries.length - 1].height -= remainingHeight;
				}
			}

			if (!isMaxHeightImpossible) {
				/**
				  * Take anything remaining from the last item.
				  */
				if (remainingHeightToEnlarge !== 0) {
					allEntries[allEntries.length - 1].height += remainingHeightToEnlarge;
				}
			}

			/**
			 * Set every items size relative to 100 relative to its size to total
			 */
			for (i = 0; i < this.contentItems.length; i++) {
				this.contentItems[i].config.height = (allEntries[i].height / sizeData.totalHeight) * 100;
			}

			return false;
		},

		/**
		 * Instantiates a new lm.controls.Splitter, binds events to it and adds
		 * it to the array of splitters at the position specified as the index argument
		 *
		 * What it doesn't do though is append the splitter to the DOM
		 *
		 * @param   {Int} index The position of the splitter
		 *
		 * @returns {lm.controls.Splitter}
		 */
		_createSplitter: function (index) {
			var splitter;
			splitter = new lm.controls.Splitter(this._isColumn, this._splitterSize, this._splitterGrabSize);
			splitter.on('drag', lm.utils.fnBind(this._onSplitterDrag, this, [splitter]), this);
			splitter.on('dragStop', lm.utils.fnBind(this._onSplitterDragStop, this, [splitter]), this);
			splitter.on('dragStart', lm.utils.fnBind(this._onSplitterDragStart, this, [splitter]), this);
			this._splitter.splice(index, 0, splitter);
			return splitter;
		},

		/**
		 * Locates the instance of lm.controls.Splitter in the array of
		 * registered splitters and returns a map containing the contentItem
		 * before and after the splitters, both of which are affected if the
		 * splitter is moved
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {Object} A map of contentItems that the splitter affects
		 */
		_getItemsForSplitter: function (splitter) {
			var index = lm.utils.indexOf(splitter, this._splitter);

			return {
				before: this.contentItems[index],
				after: this.contentItems[index + 1]
			};
		},

		/**
		 * Gets the minimum dimensions for the given item configuration array
		 * @param item
		 * @private
		 */
		_getMinimumDimensions: function (arr) {
			var minWidth = 0, minHeight = 0;

			for (var i = 0; i < arr.length; ++i) {
				minWidth = Math.max(arr[i].getMinWidth() || 0, minWidth);
				minHeight = Math.max(arr[i].getMinHeight() || 0, minHeight);
			}

			return { horizontal: minWidth, vertical: minHeight };
		},
		/**
		 * Gets the minimum dimensions for the given item configuration array
		 * @param item
		 * @private
		 */
		_getMaximumDimensions: function (arr) {
			var maxWidth = 32767, maxHeight = 32767;

			for (var i = 0; i < arr.length; ++i) {
				maxWidth = Math.min(arr[i].getMaxWidth() || 0, maxWidth);
				maxHeight = Math.min(arr[i].getMaxHeight() || 0, maxHeight);
			}

			return { horizontal: maxWidth, vertical: maxHeight };
		},

		_setMinMaxSplitterPosition(items) {
			const minSize = this.layoutManager.config.dimensions[this._isColumn ? 'minItemHeight' : 'minItemWidth'];
			const maxSize = this.layoutManager.config.dimensions[this.isColumn ? 'maxItemHeight' : 'maxItemWidth'];

			var beforeMinDim = this._getMinimumDimensions([...items.before.contentItems, items.before]);
			var beforeMaxDim = this._getMaximumDimensions([...items.before.contentItems, items.before]);
			var beforeMinSize = this._isColumn ? beforeMinDim.vertical : beforeMinDim.horizontal;
			var beforeMaxSize = this.isColumn ? beforeMaxDim.vertical : beforeMaxDim.horizontal;

			var afterMinDim = this._getMinimumDimensions([...items.after.contentItems, items.after]);
			var afterMaxDim = this._getMaximumDimensions([...items.after.contentItems, items.after]);
			var afterMinSize = this._isColumn ? afterMinDim.vertical : afterMinDim.horizontal;
			var afterMaxSize = this.isColumn ? afterMaxDim.vertical : afterMaxDim.horizontal;

			var splitterMinPositionFromBeforeElement = -1 * (items.before.element[this._dimension]() - (beforeMinSize || minSize));
			var splitterMinPositionFromAfterElement = -1 * ((afterMaxSize || maxSize) - items.after.element[this._dimension]());

			var splitterMaxPositionFromBeforeElement = (beforeMaxSize || maxSize) - items.before.element[this._dimension]();
			var splitterMaxPositionFromAfterElement = items.after.element[this._dimension]() - (afterMinSize || minSize);

			this._splitterPosition = 0;
			this._splitterMinPosition = Math.max(splitterMinPositionFromBeforeElement, splitterMinPositionFromAfterElement);
			this._splitterMaxPosition = Math.min(splitterMaxPositionFromBeforeElement, splitterMaxPositionFromAfterElement);
		},
		/**
		 * Invoked when a splitter's dragListener fires dragStart. Calculates the splitters
		 * movement area once (so that it doesn't need calculating on every mousemove event)
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {void}
		 */
		_onSplitterDragStart: function (splitter) {
			this.layoutManager._ignorePinned = true;
			var items = this._getItemsForSplitter(splitter);
			this._setMinMaxSplitterPosition(items);
		},

		/**
		 * Invoked when a splitter's DragListener fires drag. Updates the splitters DOM position,
		 * but not the sizes of the elements the splitter controls in order to minimize resize events
		 *
		 * @param   {lm.controls.Splitter} splitter
		 * @param   {Int} offsetX  Relative pixel values to the splitters original position. Can be negative
		 * @param   {Int} offsetY  Relative pixel values to the splitters original position. Can be negative
		 *
		 * @returns {void}
		 */
		_onSplitterDrag: function (splitter, offsetX, offsetY) {
			if (this._layoutManager.config && this.config.workspacesConfig.allowSplitters === false) {
				return;
			}
			var offset = this._isColumn ? offsetY : offsetX;

			if (offset > this._splitterMinPosition && offset < this._splitterMaxPosition) {
				this._splitterPosition = offset;
				splitter.element.css(this._isColumn ? 'top' : 'left', offset);
			}

			this._layoutManager.emit("splitterDragged", splitter);
		},

		/**
		 * Invoked when a splitter's DragListener fires dragStop. Resets the splitters DOM position,
		 * and applies the new sizes to the elements before and after the splitter and their children
		 * on the next animation frame
		 *
		 * @param   {lm.controls.Splitter} splitter
		 *
		 * @returns {void}
		 */
		_onSplitterDragStop: function (splitter) {

			if (this._layoutManager.config && this.config.workspacesConfig.allowSplitters === false) {
				return;
			}

			var items = this._getItemsForSplitter(splitter),
				sizeBefore = items.before.element[this._dimension](),
				sizeAfter = items.after.element[this._dimension](),
				splitterPositionInRange = (this._splitterPosition + sizeBefore) / (sizeBefore + sizeAfter),
				totalRelativeSize = items.before.config[this._dimension] + items.after.config[this._dimension];

			items.before.config[this._dimension] = splitterPositionInRange * totalRelativeSize;
			items.after.config[this._dimension] = (1 - splitterPositionInRange) * totalRelativeSize;

			splitter.element.css({
				'top': 0,
				'left': 0
			});

			lm.utils.animFrame(() => {
				lm.utils.fnBind(this.callDownwards, this, ['setSize'])();
				this._layoutManager._ignorePinned = false;
				// ensuring that if there are maximized items after splitter drag their bounds will be correct
				// they will be correct because update size applies again the rule that the maximized items should have the size of their maximization container
				if (Object.values(this.layoutManager._maximizedItemsInTargetContainer).length) {
					this._layoutManager.updateSize();
				}
			});

			this._layoutManager.emit("splitterDragStopped", splitter);
		}
	});

	lm.items.Stack = function (layoutManager, config, parent) {
		lm.items.AbstractContentItem.call(this, layoutManager, config, parent);
		this.element = $('<div class="lm_item lm_stack"></div>');
		this._activeContentItem = null;
		var cfg = layoutManager.config;
		this._header = { // defaults' reconstruction from old configuration style
			show: cfg.settings.hasHeaders === true && config.hasHeaders !== false,
			popout: cfg.settings.showPopoutIcon && cfg.labels.popout,
			maximize: cfg.settings.showMaximizeIcon && cfg.labels.maximize,
			minimize: cfg.settings.showMinimizeIcon && cfg.labels.minimize,
			close: cfg.settings.showCloseIcon && cfg.labels.close,
		};
		if (cfg.header) // load simplified version of header configuration (https://github.com/deepstreamIO/golden-layout/pull/245)
			lm.utils.copy(this._header, cfg.header);
		if (config.header) // load from stack
			lm.utils.copy(this._header, config.header);
		if (config.content && config.content[0] && config.content[0].header) // load from component if stack omitted
			lm.utils.copy(this._header, config.content[0].header);

		this._dropZones = {};
		this._dropSegment = null;
		this._contentAreaDimensions = null;
		this._dropIndex = null;

		this.isStack = true;

		if (layoutManager._componentFactory && layoutManager._componentFactory.createId && (!this.config.id || !this.config.id.length)) {
			const newId = layoutManager._componentFactory.createId();
			if (newId) {
				this.addId(newId);
			}
		}

		this.childElementContainer = $('<div class="lm_items"></div>');
		this.header = new lm.controls.Header(layoutManager, this);

		this.element.append(this.header.element);
		this.element.append(this.childElementContainer);
		this._setupHeaderPosition();
		this._$validateClosability();
	};

	lm.utils.extend(lm.items.Stack, lm.items.AbstractContentItem);

	lm.utils.copy(lm.items.Stack.prototype, {

		setSize: function () {
			var headerBoundingRect = lm.utils.getBounds(this.header.element);
			const elementBounds = lm.utils.getBounds(this.element);
			var i,
				headerSize = this._header.show ? headerBoundingRect.height : 0,
				contentWidth = elementBounds.width - (this._sided ? headerSize : 0),
				contentHeight = elementBounds.height - (!this._sided ? headerSize : 0);

			this.childElementContainer.width(contentWidth);
			this.childElementContainer.height(contentHeight);

			for (i = 0; i < this.contentItems.length; i++) {
				this.contentItems[i].element.width(contentWidth).height(contentHeight);
			}
			this.emit('resize');
			this.emitBubblingEvent('stateChanged');
		},

		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minWidth === "number") {
				return memoizedConstraints.minWidth;
			}
			const elementMinWidth = this.config.workspacesConfig.minWidth || this.layoutManager.config.dimensions.minItemWidth;
			const result = this.contentItems.reduce((minWidth, ci) => {
				return Math.max(minWidth, ci.getMinWidth() || this.layoutManager.config.dimensions.minItemWidth);
			}, elementMinWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minWidth", result);

			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxWidth() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxWidth === "number") {
				return memoizedConstraints.maxWidth;
			}
			const elementMaxWidth = this.config.workspacesConfig.maxWidth || this.layoutManager.config.dimensions.maxItemWidth;
			const result = this.contentItems.reduce((maxWidth, ci) => {
				const childMaxWidth = ci.getMaxWidth();
				return Math.min(maxWidth, childMaxWidth || this.layoutManager.config.dimensions.maxItemWidth);
			}, elementMaxWidth);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxWidth", result);
			return result;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMinHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.minHeight === "number") {
				return memoizedConstraints.minHeight;
			}
			const elementMinHeight = this.config.workspacesConfig.minHeight || this.layoutManager.config.dimensions.minItemHeight;
			const headerElement = this.header.element;
			let headerHeight = headerElement ? this.realHeight(headerElement) : 0;

			if (this.config.workspacesConfig.wrapper) {
				headerHeight = 0;
			}
			const minHeight = this.contentItems.reduce((minHeight, ci) => {
				return Math.max(minHeight, ci.getMinHeight() + headerHeight || this.layoutManager.config.dimensions.minItemHeight);
			}, elementMinHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "minHeight", minHeight);

			return minHeight;
		},
		/**
		 * Returns the min width of the row or column
		 * @returns {number | undefined}
		 */
		getMaxHeight() {
			const memoizedConstraints = this.layoutManager._idToMinMaxConstraints[lm.utils.idAsString(this.config.id)];
			if (memoizedConstraints && typeof memoizedConstraints.maxHeight === "number") {
				return memoizedConstraints.maxHeight;
			}
			const elementMaxHeight = this.config.workspacesConfig.maxHeight || this.layoutManager.config.dimensions.maxItemHeight;
			const headerElement = this.header.element;
			let headerHeight = headerElement ? this.realHeight(headerElement) : 0;

			if (this.config.workspacesConfig.wrapper) {
				headerHeight = 0;
			}
			const maxHeight = this.contentItems.reduce((maxHeight, ci) => {
				return Math.min(maxHeight, ci.getMaxHeight() + headerHeight || this.layoutManager.config.dimensions.maxItemHeight);
			}, elementMaxHeight);

			lm.items.AbstractContentItem.prototype._memoizeConstraint.call(this, "maxHeight", maxHeight);

			return maxHeight;
		},
		realHeight: function (obj) {
			if (!obj || !obj[0]) {
				return 0;
			}
			const heightWithoutClone = lm.utils.getBounds(obj).height;

			if (heightWithoutClone > 0) {
				return heightWithoutClone;
			}

			var clone = obj.clone();
			clone.css("visibility", "hidden");
			$('body').append(clone);
			var height = lm.utils.getBounds(clone).height;
			clone.remove();
			return height;
		},
		_$init: function () {
			var i, initialItem;

			if (this.isInitialised === true) return;

			lm.items.AbstractContentItem.prototype._$init.call(this);

			for (i = 0; i < this.contentItems.length; i++) {
				this.header.createTab(this.contentItems[i]);
				this.contentItems[i]._$hide();
			}

			if (this.contentItems.length > 0) {
				initialItem = this.contentItems[this.config.activeItemIndex || 0];

				if (!initialItem) {
					throw new Error('Configured activeItemIndex out of bounds');
				}

				this.setActiveContentItem(initialItem);

				const pinnedItems = this.contentItems.filter(t => t.config.workspacesConfig.isPinned);

				pinnedItems.forEach((pi) => {
					pi.tab.pin();
				});
			}
		},

		setActiveContentItem: function (contentItem) {
			if (lm.utils.indexOf(contentItem, this.contentItems) === -1) {
				throw new Error('contentItem is not a child of this stack');
			}

			const oldItem = this._activeContentItem;
			if (this._activeContentItem !== null) {
				this._activeContentItem._$hide();
			}

			this._activeContentItem = contentItem;
			this.header.setActiveContentItem(contentItem);
			contentItem._$show();
			this.emit('activeContentItemChanged', contentItem);
			this.layoutManager.emit('activeContentItemChanged', contentItem);
			if (oldItem) {
				oldItem.emit("focusLost");
			}
			this.emitBubblingEvent('stateChanged');
		},

		getActiveContentItem: function () {
			return this.header.activeContentItem;
		},

		addChild: function (contentItem, index, activate = true) {
			contentItem = this.layoutManager._$normalizeContentItem(contentItem, this);
			const lastPinnedIndex = this.header._getLastIndexOfPinnedTab();

			const isPinned = contentItem.config && contentItem.config.workspacesConfig && contentItem.config.workspacesConfig.isPinned;
			if (index >= 0 && index <= lastPinnedIndex && !isPinned) {
				index = lastPinnedIndex + 1;
			}

			lm.items.AbstractContentItem.prototype.addChild.call(this, contentItem, index);
			this.childElementContainer.append(contentItem.element);
			this.header.createTab(contentItem, index);

			if (isPinned) {
				contentItem.tab.pin(index);
			}

			if ($(this.layoutManager.container).is(":visible") && activate) {
				this.setActiveContentItem(contentItem);
			} else {
				contentItem._$hide();
			}
			this.callDownwards('setSize');
			this._$validateClosability();
			this.emitBubblingEvent('stateChanged');
		},

		removeChild: function (contentItem, keepChild) {
			var index = lm.utils.indexOf(contentItem, this.contentItems);
			lm.items.AbstractContentItem.prototype.removeChild.call(this, contentItem, keepChild);
			this.header.removeTab(contentItem);
			if (this.header.activeContentItem === contentItem) {
				if (this.contentItems.length > 0) {
					const itemToFocus = this._getItemToFocusAfterRemove.call(this, index);
					this.setActiveContentItem(itemToFocus);
				} else {
					this._activeContentItem = null;
				}
			}

			this._syncActiveItemIndex();

			this._$validateClosability();
			this.emitBubblingEvent('stateChanged');
		},

		/**
		 * Validates that the stack is still closable or not. If a stack is able
		 * to close, but has a non closable component added to it, the stack is no
		 * longer closable until all components are closable.
		 *
		 * @returns {void}
		 */
		_$validateClosability: function () {
			var isClosable,
				len,
				i;

			isClosable = this.header._isClosable();

			for (i = 0, len = this.contentItems.length; i < len; i++) {
				if (!isClosable) {
					break;
				}

				isClosable = this.contentItems[i].config.isClosable;
			}

			this.header._$setClosable(isClosable);
		},

		_$destroy: function () {
			lm.items.AbstractContentItem.prototype._$destroy.call(this);
			this.header._$destroy();
		},


		/**
		 * Ok, this one is going to be the tricky one: The user has dropped {contentItem} onto this stack.
		 *
		 * It was dropped on either the stacks header or the top, right, bottom or left bit of the content area
		 * (which one of those is stored in this._dropSegment). Now, if the user has dropped on the header the case
		 * is relatively clear: We add the item to the existing stack... job done (might be good to have
		 * tab reordering at some point, but lets not sweat it right now)
		 *
		 * If the item was dropped on the content part things are a bit more complicated. If it was dropped on either the
		 * top or bottom region we need to create a new column and place the items accordingly.
		 * Unless, of course if the stack is already within a column... in which case we want
		 * to add the newly created item to the existing column...
		 * either prepend or append it, depending on wether its top or bottom.
		 *
		 * Same thing for rows and left / right drop segments... so in total there are 9 things that can potentially happen
		 * (left, top, right, bottom) * is child of the right parent (row, column) + header drop
		 *
		 * @param    {lm.item} contentItem
		 *
		 * @returns {void}
		 */
		_$onDrop: function (contentItem) {

			if (this._dropSegment === null) {
				return;
			}
			/*
			 * The item was dropped on the header area. Just add it as a child of this stack and
			 * get the hell out of this logic
			 */
			if (this._dropSegment === 'header') {
				this._resetHeaderDropZone();
				this.addChild(contentItem, this._dropIndex);
				return;
			}

			/*
			 * The stack is empty. Let's just add the element.
			 */
			if (this._dropSegment === 'body') {
				this.addChild(contentItem);
				return;
			}

			/*
			 * The item was dropped on the top-, left-, bottom- or right- part of the content. Let's
			 * aggregate some conditions to make the if statements later on more readable
			 */
			var isVertical = this._dropSegment === 'top' || this._dropSegment === 'bottom',
				isHorizontal = this._dropSegment === 'left' || this._dropSegment === 'right',
				insertBefore = this._dropSegment === 'top' || this._dropSegment === 'left',
				hasCorrectParent = (isVertical && this.parent.isColumn) || (isHorizontal && this.parent.isRow),
				type = isVertical ? 'column' : 'row',
				dimension = isVertical ? 'height' : 'width',
				index,
				stack,
				rowOrColumn;

			/*
			 * The content item can be either a component or a stack. If it is a component, wrap it into a stack
			 */
			if (contentItem.isComponent) {
				stack = this.layoutManager.createContentItem({
					type: 'stack',
					header: contentItem.config.header || {}
				}, this);
				stack._$init();
				stack.addChild(contentItem);
				contentItem = stack;
			}

			/*
			 * If the item is dropped on top or bottom of a column or left and right of a row, it's already
			 * layd out in the correct way. Just add it as a child
			 */
			if (hasCorrectParent) {
				index = lm.utils.indexOf(this, this.parent.contentItems);
				this.parent.addChild(contentItem, insertBefore ? index : index + 1, true);
				this.config[dimension] *= 0.5;
				contentItem.config[dimension] = this.config[dimension];
				this.parent.callDownwards('setSize');
				/*
				 * This handles items that are dropped on top or bottom of a row or left / right of a column. We need
				 * to create the appropriate contentItem for them to live in
				 */
			} else {
				type = isVertical ? 'column' : 'row';
				rowOrColumn = this.layoutManager.createContentItem({ type: type }, this);
				this.parent.replaceChild(this, rowOrColumn);

				rowOrColumn.addChild(contentItem, insertBefore ? 0 : undefined, true);
				rowOrColumn.addChild(this, insertBefore ? undefined : 0, true);

				this.config[dimension] = 50;
				contentItem.config[dimension] = 50;
				rowOrColumn.callDownwards('setSize');
			}
		},

		/**
		 * If the user hovers above the header part of the stack, indicate drop positions for tabs.
		 * otherwise indicate which segment of the body the dragged item would be dropped on
		 *
		 * @param    {Int} x Absolute Screen X
		 * @param    {Int} y Absolute Screen Y
		 *
		 * @returns {void}
		 */
		_$highlightDropZone: function (x, y) {
			var segment, area;

			for (segment in this._contentAreaDimensions) {
				area = this._contentAreaDimensions[segment].hoverArea;

				if (area.x1 < x && area.x2 > x && area.y1 < y && area.y2 > y) {

					if (segment === 'header') {
						this._dropSegment = 'header';
						this._highlightHeaderDropZone(this._sided ? y : x);
					} else {
						this._resetHeaderDropZone();
						this._highlightBodyDropZone(segment);
					}

					return;
				}
			}
			this._dropSegment = null;
			this._resetHeaderDropZone();
			this.layoutManager.dropTargetIndicator.highlightArea(null);
		},

		_$getArea: function () {
			if (this.element.is(':visible') === false) {
				return null;
			}

			var getArea = lm.items.AbstractContentItem.prototype._$getArea,
				headerArea = getArea.call(this, this.header.element),
				contentArea = getArea.call(this, this.childElementContainer),
				contentWidth = contentArea.x2 - contentArea.x1,
				contentHeight = contentArea.y2 - contentArea.y1;

			if (!this.config.workspacesConfig ||
				(this.config.workspacesConfig.allowDrop !== false && this.config.workspacesConfig.allowDropHeader !== false) ||
				this.config.workspacesConfig.allowDropHeader === true) {
				this._contentAreaDimensions = {
					header: {
						hoverArea: {
							x1: headerArea.x1,
							y1: headerArea.y1,
							x2: headerArea.x2,
							y2: headerArea.y2
						},
						highlightArea: {
							x1: headerArea.x1,
							y1: headerArea.y1,
							x2: headerArea.x2,
							y2: headerArea.y2
						}
					}
				};
			} else {
				this._contentAreaDimensions = {};
			}

			/**
			 * If this Stack is a parent to rows, columns or other stacks only its
			 * header is a valid dropzone.
			 */
			if (this._activeContentItem && this._activeContentItem.isComponent === false) {
				return headerArea;
			}

			/**
			 * Highlight the entire body if the stack is empty
			 */
			if (this.contentItems.length === 0) {

				this._contentAreaDimensions.body = {
					hoverArea: {
						x1: contentArea.x1,
						y1: contentArea.y1,
						x2: contentArea.x2,
						y2: contentArea.y2
					},
					highlightArea: {
						x1: contentArea.x1,
						y1: contentArea.y1,
						x2: contentArea.x2,
						y2: contentArea.y2
					}
				};

				return getArea.call(this, this.element);
			}

			if (this.layoutManager.config.settings.mode !== "workspace") {

				if (!this.config.workspacesConfig ||
					(this.config.workspacesConfig.allowDrop !== false && this.config.workspacesConfig.allowDropLeft !== false) ||
					this.config.workspacesConfig.allowDropLeft === true) {
					this._contentAreaDimensions.left = {
						hoverArea: {
							x1: contentArea.x1,
							y1: contentArea.y1,
							x2: contentArea.x1 + contentWidth * 0.25,
							y2: contentArea.y2
						},
						highlightArea: {
							x1: contentArea.x1,
							y1: contentArea.y1,
							x2: contentArea.x1 + contentWidth * 0.5,
							y2: contentArea.y2
						}
					};
				}

				if (!this.config.workspacesConfig ||
					(this.config.workspacesConfig.allowDrop !== false && this.config.workspacesConfig.allowDropTop !== false) ||
					this.config.workspacesConfig.allowDropTop === true) {
					this._contentAreaDimensions.top = {
						hoverArea: {
							x1: contentArea.x1 + contentWidth * 0.25,
							y1: contentArea.y1,
							x2: contentArea.x1 + contentWidth * 0.75,
							y2: contentArea.y1 + contentHeight * 0.5
						},
						highlightArea: {
							x1: contentArea.x1,
							y1: contentArea.y1,
							x2: contentArea.x2,
							y2: contentArea.y1 + contentHeight * 0.5
						}
					};
				}

				if (!this.config.workspacesConfig ||
					(this.config.workspacesConfig.allowDrop !== false && this.config.workspacesConfig.allowDropRight !== false) ||
					this.config.workspacesConfig.allowDropRight === true) {
					this._contentAreaDimensions.right = {
						hoverArea: {
							x1: contentArea.x1 + contentWidth * 0.75,
							y1: contentArea.y1,
							x2: contentArea.x2,
							y2: contentArea.y2
						},
						highlightArea: {
							x1: contentArea.x1 + contentWidth * 0.5,
							y1: contentArea.y1,
							x2: contentArea.x2,
							y2: contentArea.y2
						}
					};
				}

				if (!this.config.workspacesConfig ||
					(this.config.workspacesConfig.allowDrop !== false && this.config.workspacesConfig.allowDropBottom !== false) ||
					this.config.workspacesConfig.allowDropBottom === true) {
					this._contentAreaDimensions.bottom = {
						hoverArea: {
							x1: contentArea.x1 + contentWidth * 0.25,
							y1: contentArea.y1 + contentHeight * 0.5,
							x2: contentArea.x1 + contentWidth * 0.75,
							y2: contentArea.y2
						},
						highlightArea: {
							x1: contentArea.x1,
							y1: contentArea.y1 + contentHeight * 0.5,
							x2: contentArea.x2,
							y2: contentArea.y2
						}
					};
				}
			}


			return getArea.call(this, this.element);
		},

		_highlightHeaderDropZone: function (x) {
			var i,
				tabElement,
				tabsLength = this.header.tabs.length,
				isAboveTab = false,
				tabTop,
				tabLeft,
				offset,
				placeHolderLeft,
				headerOffset,
				tabWidth,
				halfX;

			// Empty stack
			if (tabsLength === 0) {
				headerOffset = this.header.element.offset();

				this.layoutManager.dropTargetIndicator.highlightArea({
					x1: headerOffset.left,
					x2: headerOffset.left + 100,
					y1: headerOffset.top + lm.utils.getBounds(this.header.element).height - 20,
					y2: headerOffset.top + lm.utils.getBounds(this.header.element).height
				});

				return;
			}

			for (i = 0; i < tabsLength; i++) {
				tabElement = this.header.tabs[i].element;
				offset = tabElement.offset();
				const tabElementBounds = lm.utils.getBounds(tabElement);
				if (this._sided) {
					tabLeft = offset.top;
					tabTop = offset.left;
					tabWidth = tabElementBounds.height;
				} else {
					tabLeft = offset.left;
					tabTop = offset.top;
					tabWidth = tabElementBounds.width;
				}

				if (x > tabLeft && x < tabLeft + tabWidth) {
					isAboveTab = true;
					break;
				}
			}

			if (isAboveTab === false && x < tabLeft) {
				return;
			}

			halfX = tabLeft + tabWidth / 2;

			if (x < halfX) {
				this._dropIndex = i;
				tabElement.before(this.layoutManager.tabDropPlaceholder);
			} else {
				this._dropIndex = Math.min(i + 1, tabsLength);
				tabElement.after(this.layoutManager.tabDropPlaceholder);
			}

			const tabDropPlaceholderBounds = lm.utils.getBounds(this.layoutManager.tabDropPlaceholder);
			if (this._sided) {
				placeHolderTop = this.layoutManager.tabDropPlaceholder.offset().top;
				this.layoutManager.dropTargetIndicator.highlightArea({
					x1: tabTop,
					x2: tabTop + tabElement.innerHeight(),
					y1: placeHolderTop,
					y2: placeHolderTop + tabDropPlaceholderBounds.width
				});
				return;
			}
			placeHolderLeft = this.layoutManager.tabDropPlaceholder.offset().left;

			this.layoutManager.dropTargetIndicator.highlightArea({
				x1: placeHolderLeft,
				x2: placeHolderLeft + tabDropPlaceholderBounds.width,
				y1: tabTop,
				y2: tabTop + tabElement.innerHeight()
			});
		},

		_resetHeaderDropZone: function () {
			this.layoutManager.tabDropPlaceholder.remove();
		},

		_setupHeaderPosition: function () {
			var side = ['right', 'left', 'bottom'].indexOf(this._header.show) >= 0 && this._header.show;
			this.header.element.toggle(!!this._header.show);
			this._side = side;
			this._sided = ['right', 'left'].indexOf(this._side) >= 0;
			this.element.removeClass('lm_left lm_right lm_bottom');
			if (this._side)
				this.element.addClass('lm_' + this._side);
			if (this.element.find('.lm_header').length && this.childElementContainer) {
				var headerPosition = ['right', 'bottom'].indexOf(this._side) >= 0 ? 'before' : 'after';
				this.header.element[headerPosition](this.childElementContainer);
				this.callDownwards('setSize');
			}
		},

		_highlightBodyDropZone: function (segment) {
			var highlightArea = this._contentAreaDimensions[segment].highlightArea;
			this.layoutManager.dropTargetIndicator.highlightArea(highlightArea);
			this._dropSegment = segment;
		},

		_syncContentItemOrder: function () {
			const newContentOrder = [];
			this.header.tabs.forEach((t) => {
				const tabContentItemId = Array.isArray(t.contentItem.config.id) ? t.contentItem.config.id[0] : t.contentItem.config.id;
				const nextContentItem = this.contentItems.find((ci) => {
					const contentItemId = Array.isArray(ci.config.id) ? ci.config.id[0] : ci.config.id;

					return tabContentItemId === contentItemId;
				});

				if (nextContentItem) {
					newContentOrder.push(nextContentItem);
				}
			});

			if (this.contentItems.length === newContentOrder.length) {
				this.contentItems = newContentOrder;
			}
		},
		_getItemToFocusAfterRemove: function (index) {
			for (let i = index - 1; i >= 0; i--) {
				const currentItem = this.contentItems[i];

				if (!currentItem.config.noTabHeader) {
					return currentItem;
				}
			}

			for (let i = index + 1; i < this.contentItems.length; i++) {
				const currentItem = this.contentItems[i];

				if (!currentItem.config.noTabHeader) {
					return currentItem;
				}
			}

			return this.contentItems[Math.max(index - 1, 0)];
		},
		_syncActiveItemIndex: function () {
			var index = lm.utils.indexOf(this._activeContentItem, this.contentItems);

			if (index > -1) {
				this.config.activeItemIndex = index;
			}
		}
	});

	lm.utils.BubblingEvent = function( name, origin ) {
		this.name = name;
		this.origin = origin;
		this.isPropagationStopped = false;
	};

	lm.utils.BubblingEvent.prototype.stopPropagation = function() {
		this.isPropagationStopped = true;
	};
	/**
	 * Minifies and unminifies configs by replacing frequent keys
	 * and values with one letter substitutes. Config options must
	 * retain array position/index, add new options at the end.
	 *
	 * @constructor
	 */
	lm.utils.ConfigMinifier = function() {
		this._keys = [
			'settings',
			'hasHeaders',
			'constrainDragToContainer',
			'selectionEnabled',
			'dimensions',
			'borderWidth',
			'minItemHeight',
			'minItemWidth',
			'headerHeight',
			'dragProxyWidth',
			'dragProxyHeight',
			'labels',
			'close',
			'maximize',
			'minimize',
			'popout',
			'content',
			'componentName',
			'componentState',
			'id',
			'width',
			'type',
			'height',
			'isClosable',
			'title',
			'popoutWholeStack',
			'openPopouts',
			'parentId',
			'activeItemIndex',
			'reorderEnabled',
			'borderGrabWidth',




			//Maximum 36 entries, do not cross this line!
		];
		if( this._keys.length > 36 ) {
			throw new Error( 'Too many keys in config minifier map' );
		}

		this._values = [
			true,
			false,
			'row',
			'column',
			'stack',
			'component',
			'close',
			'maximize',
			'minimize',
			'open in new window'
		];
	};

	lm.utils.copy( lm.utils.ConfigMinifier.prototype, {

		/**
		 * Takes a GoldenLayout configuration object and
		 * replaces its keys and values recursively with
		 * one letter counterparts
		 *
		 * @param   {Object} config A GoldenLayout config object
		 *
		 * @returns {Object} minified config
		 */
		minifyConfig: function( config ) {
			var min = {};
			this._nextLevel( config, min, '_min' );
			return min;
		},

		/**
		 * Takes a configuration Object that was previously minified
		 * using minifyConfig and returns its original version
		 *
		 * @param   {Object} minifiedConfig
		 *
		 * @returns {Object} the original configuration
		 */
		unminifyConfig: function( minifiedConfig ) {
			var orig = {};
			this._nextLevel( minifiedConfig, orig, '_max' );
			return orig;
		},

		/**
		 * Recursive function, called for every level of the config structure
		 *
		 * @param   {Array|Object} orig
		 * @param   {Array|Object} min
		 * @param    {String} translationFn
		 *
		 * @returns {void}
		 */
		_nextLevel: function( from, to, translationFn ) {
			var key, minKey;

			for( key in from ) {

				/**
				 * For in returns array indices as keys, so let's cast them to numbers
				 */
				if( from instanceof Array ) key = parseInt( key, 10 );

				/**
				 * In case something has extended Object prototypes
				 */
				if( !from.hasOwnProperty( key ) ) continue;

				/**
				 * Translate the key to a one letter substitute
				 */
				minKey = this[ translationFn ]( key, this._keys );

				/**
				 * For Arrays and Objects, create a new Array/Object
				 * on the minified object and recurse into it
				 */
				if( typeof from[ key ] === 'object' ) {
					to[ minKey ] = from[ key ] instanceof Array ? [] : {};
					this._nextLevel( from[ key ], to[ minKey ], translationFn );

					/**
					 * For primitive values (Strings, Numbers, Boolean etc.)
					 * minify the value
					 */
				} else {
					to[ minKey ] = this[ translationFn ]( from[ key ], this._values );
				}
			}
		},

		/**
		 * Minifies value based on a dictionary
		 *
		 * @param   {String|Boolean} value
		 * @param   {Array<String|Boolean>} dictionary
		 *
		 * @returns {String} The minified version
		 */
		_min: function( value, dictionary ) {
			/**
			 * If a value actually is a single character, prefix it
			 * with ___ to avoid mistaking it for a minification code
			 */
			if( typeof value === 'string' && value.length === 1 ) {
				return '___' + value;
			}

			var index = lm.utils.indexOf( value, dictionary );

			/**
			 * value not found in the dictionary, return it unmodified
			 */
			if( index === -1 ) {
				return value;

				/**
				 * value found in dictionary, return its base36 counterpart
				 */
			} else {
				return index.toString( 36 );
			}
		},

		_max: function( value, dictionary ) {
			/**
			 * value is a single character. Assume that it's a translation
			 * and return the original value from the dictionary
			 */
			if( typeof value === 'string' && value.length === 1 ) {
				return dictionary[ parseInt( value, 36 ) ];
			}

			/**
			 * value originally was a single character and was prefixed with ___
			 * to avoid mistaking it for a translation. Remove the prefix
			 * and return the original character
			 */
			if( typeof value === 'string' && value.substr( 0, 3 ) === '___' ) {
				return value[ 3 ];
			}
			/**
			 * value was not minified
			 */
			return value;
		}
	} );

	/**
	 * An EventEmitter singleton that propagates events
	 * across multiple windows. This is a little bit trickier since
	 * windows are allowed to open childWindows in their own right
	 *
	 * This means that we deal with a tree of windows. Hence the rules for event propagation are:
	 *
	 * - Propagate events from this layout to both parents and children
	 * - Propagate events from parent to this and children
	 * - Propagate events from children to the other children (but not the emitting one) and the parent
	 *
	 * @constructor
	 *
	 * @param {lm.LayoutManager} layoutManager
	 */
	lm.utils.EventHub = function( layoutManager ) {
		lm.utils.EventEmitter.call( this );
		this._layoutManager = layoutManager;
		this._dontPropagateToParent = null;
		this._childEventSource = null;
		this.on( lm.utils.EventEmitter.ALL_EVENT, lm.utils.fnBind( this._onEventFromThis, this ) );
		this._boundOnEventFromChild = lm.utils.fnBind( this._onEventFromChild, this );
		$( window ).on( 'gl_child_event', this._boundOnEventFromChild );
	};

	/**
	 * Called on every event emitted on this eventHub, regardles of origin.
	 *
	 * @private
	 *
	 * @param {Mixed}
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._onEventFromThis = function() {
		var args = Array.prototype.slice.call( arguments );

		if( this._layoutManager.isSubWindow && args[ 0 ] !== this._dontPropagateToParent ) {
			this._propagateToParent( args );
		}
		this._propagateToChildren( args );

		//Reset
		this._dontPropagateToParent = null;
		this._childEventSource = null;
	};

	/**
	 * Called by the parent layout.
	 *
	 * @param   {Array} args Event name + arguments
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._$onEventFromParent = function( args ) {
		this._dontPropagateToParent = args[ 0 ];
		this.emit.apply( this, args );
	};

	/**
	 * Callback for child events raised on the window
	 *
	 * @param   {DOMEvent} event
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._onEventFromChild = function( event ) {
		this._childEventSource = event.originalEvent.__gl;
		this.emit.apply( this, event.originalEvent.__glArgs );
	};

	/**
	 * Propagates the event to the parent by emitting
	 * it on the parent's DOM window
	 *
	 * @param   {Array} args Event name + arguments
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._propagateToParent = function( args ) {
		var event,
			eventName = 'gl_child_event';

		if( document.createEvent ) {
			event = window.opener.document.createEvent( 'HTMLEvents' );
			event.initEvent( eventName, true, true );
		} else {
			event = window.opener.document.createEventObject();
			event.eventType = eventName;
		}

		event.eventName = eventName;
		event.__glArgs = args;
		event.__gl = this._layoutManager;

		if( document.createEvent ) {
			window.opener.dispatchEvent( event );
		} else {
			window.opener.fireEvent( 'on' + event.eventType, event );
		}
	};

	/**
	 * Propagate events to children
	 *
	 * @param   {Array} args Event name + arguments
	 * @private
	 *
	 * @returns {void}
	 */
	lm.utils.EventHub.prototype._propagateToChildren = function( args ) {
		var childGl, i;

		for( i = 0; i < this._layoutManager.openPopouts.length; i++ ) {
			childGl = this._layoutManager.openPopouts[ i ].getGlInstance();

			if( childGl && childGl !== this._childEventSource ) {
				childGl.eventHub._$onEventFromParent( args );
			}
		}
	};


	/**
	 * Destroys the EventHub
	 *
	 * @public
	 * @returns {void}
	 */

	lm.utils.EventHub.prototype.destroy = function() {
		$( window ).off( 'gl_child_event', this._boundOnEventFromChild );
	};
	/**
	 * A specialised GoldenLayout component that binds GoldenLayout container
	 * lifecycle events to react components
	 *
	 * @constructor
	 *
	 * @param {lm.container.ItemContainer} container
	 * @param {Object} state state is not required for react components
	 */
	lm.utils.ReactComponentHandler = function( container, state ) {
		this._reactComponent = null;
		this._originalComponentWillUpdate = null;
		this._container = container;
		this._initialState = state;
		this._reactClass = this._getReactClass();
		this._container.on( 'open', this._render, this );
		this._container.on( 'destroy', this._destroy, this );
	};

	lm.utils.copy( lm.utils.ReactComponentHandler.prototype, {

		/**
		 * Creates the react class and component and hydrates it with
		 * the initial state - if one is present
		 *
		 * By default, react's getInitialState will be used
		 *
		 * @private
		 * @returns {void}
		 */
		_render: function() {
			this._reactComponent = ReactDOM.render( this._getReactComponent(), this._container.getElement()[ 0 ] );
			this._originalComponentWillUpdate = this._reactComponent.componentWillUpdate || function() {
				};
			this._reactComponent.componentWillUpdate = this._onUpdate.bind( this );
			if( this._container.getState() ) {
				this._reactComponent.setState( this._container.getState() );
			}
		},

		/**
		 * Removes the component from the DOM and thus invokes React's unmount lifecycle
		 *
		 * @private
		 * @returns {void}
		 */
		_destroy: function() {
			ReactDOM.unmountComponentAtNode( this._container.getElement()[ 0 ] );
			this._container.off( 'open', this._render, this );
			this._container.off( 'destroy', this._destroy, this );
		},

		/**
		 * Hooks into React's state management and applies the componentstate
		 * to GoldenLayout
		 *
		 * @private
		 * @returns {void}
		 */
		_onUpdate: function( nextProps, nextState ) {
			this._container.setState( nextState );
			this._originalComponentWillUpdate.call( this._reactComponent, nextProps, nextState );
		},

		/**
		 * Retrieves the react class from GoldenLayout's registry
		 *
		 * @private
		 * @returns {React.Class}
		 */
		_getReactClass: function() {
			var componentName = this._container._config.component;
			var reactClass;

			if( !componentName ) {
				throw new Error( 'No react component name. type: react-component needs a field `component`' );
			}

			reactClass = this._container.layoutManager.getComponent( componentName );

			if( !reactClass ) {
				throw new Error( 'React component "' + componentName + '" not found. ' +
					'Please register all components with GoldenLayout using `registerComponent(name, component)`' );
			}

			return reactClass;
		},

		/**
		 * Copies and extends the properties array and returns the React element
		 *
		 * @private
		 * @returns {React.Element}
		 */
		_getReactComponent: function() {
			var defaultProps = {
				glEventHub: this._container.layoutManager.eventHub,
				glContainer: this._container,
			};
			var props = $.extend( defaultProps, this._container._config.props );
			return React.createElement( this._reactClass, props );
		}
	} );
	lm.utils.TabDragListener = function (eElement, nButtonCode) {
	    lm.utils.EventEmitter.call(this);

	    this._eElement = $(eElement);
	    this._oDocument = $(document);
	    this._eBody = $(document.body);
	    this._nButtonCode = nButtonCode || 0;

	    /**
	     * The delay after which to start the drag in milliseconds
	     */
	    this._nDelay = 400;

	    /**
	     * The distance the mouse needs to be moved to qualify as a drag
	     */
	    this._nDistance = 10;//TODO - works better with delay only

	    this._nX = 0;
	    this._nY = 0;

	    this._nOriginalX = 0;
	    this._nOriginalY = 0;

	    this._bDragging = false;

	    this._fMove = lm.utils.fnBind(this.onMouseMove, this);
	    this._fUp = lm.utils.fnBind(this.onMouseUp, this);
	    this._fDown = lm.utils.fnBind(this.onMouseDown, this);
	    this._parentBounds = null;

	    this._eElement.on('mousedown touchstart', this._fDown);
	};

	lm.utils.TabDragListener.timeout = null;
	lm.utils.TabDragListener.reorderTimeout = null;

	lm.utils.copy(lm.utils.TabDragListener.prototype, {
	    destroy: function () {
	        this._eElement.unbind('mousedown touchstart', this._fDown);
	        this._oDocument.unbind('mouseup touchend', this._fUp);
	        this._eElement = null;
	        this._oDocument = null;
	        this._eBody = null;
	    },

	    onMouseDown: function (oEvent) {
	        oEvent.preventDefault();

	        if (oEvent.button == 0 || oEvent.type === "touchstart") {
	            var coordinates = this._getCoordinates(oEvent);

	            this._nOriginalX = coordinates.x;
	            this._nOriginalY = coordinates.y;

	            this._oDocument.on('mousemove touchmove', this._fMove);
	            this._oDocument.one('mouseup touchend', this._fUp);
	            const parent = this._eElement.parent();
	            this._parentBounds = parent[0]?.getBoundingClientRect();

	            this.reorderTimeout = setTimeout(lm.utils.fnBind(function () { this._startReorder(oEvent); }, this), this._nDelay);
	        }
	    },

	    onMouseMove: function (oEvent) {
	        const coordinates = this._getCoordinates(oEvent);
	        if (this._timeout != null) {
	            oEvent.preventDefault();

	            this._nX = coordinates.x - this._nOriginalX;
	            this._nY = coordinates.y - this._nOriginalY;

	            if (this._bDragging === false) {
	                if (
	                    Math.abs(this._nX) > this._nDistance ||
	                    Math.abs(this._nY) > this._nDistance
	                ) {
	                    clearTimeout(this._timeout);
	                    this._startDrag(oEvent);
	                }
	            }

	            if (this._bDragging) {
	                this.emit('drag', this._nX, this._nY, oEvent);
	            }

	        } else if (this._inReorder) {
	            const tolerance = 15;

	            if (!this._parentBounds) {
	                const parent = this._eElement && this._eElement.parent();
	                if (!parent || !parent[0]) {
	                    return;
	                }
	                this._parentBounds = parent[0].getBoundingClientRect();
	            }

	            const isXOverTolerance = this._parentBounds.left - coordinates.x > tolerance || coordinates.x - this._parentBounds.right > tolerance;
	            const isYOverTolerance = this._parentBounds.top - coordinates.y > tolerance || coordinates.y - this._parentBounds.bottom > tolerance;

	            if (isXOverTolerance || isYOverTolerance) {
	                this._timeout = setTimeout(lm.utils.fnBind(function () { this._startDrag(oEvent); }, this), this._nDelay);
	            } else {
	                this._onReorder(oEvent);
	            }
	        }
	    },

	    onMouseUp: function (oEvent) {
	        // if (this._timeout != null) {
	        this._parentBounds = null;
	        this._stopReorder(oEvent);
	        clearTimeout(this._timeout);
	        this._timeout = null;
	        this._eBody.removeClass('lm_dragging');
	        this._eElement.removeClass('lm_dragging');
	        this._oDocument.find('iframe').css('pointer-events', '');
	        this._oDocument.unbind('mousemove touchmove', this._fMove);
	        this._oDocument.unbind('mouseup touchend', this._fUp);

	        if (this._bDragging === true) {
	            this._bDragging = false;
	            this.emit('dragStop', oEvent, this._nOriginalX + this._nX);
	        }
	        // }
	    },

	    _startDrag: function (e) {
	        this._stopReorder(e);
	        this._bDragging = true;
	        this._eBody.addClass('lm_dragging');
	        this._eElement.addClass('lm_dragging');
	        this._oDocument.find('iframe').css('pointer-events', 'none');
	        this.emit('dragStart', this._nOriginalX, this._nOriginalY, e);
	    },

	    _startReorder: function (e) {
	        this._inReorder = true;
	        this._oDocument.find('iframe').css('pointer-events', 'none');
	        this.emit('reorderStart', this._nOriginalX, this._nOriginalY, e);
	    },
	    _onReorder: function (e) {
	        if (this._inReorder) {
	            const coordinates = this._getCoordinates(e);
	            this.emit("reorder", coordinates.x, coordinates.y);
	        }
	    },
	    _stopReorder: function (e) {
	        clearTimeout(this.reorderTimeout);

	        if (this._inReorder !== null) {
	            const coordinates = this._getCoordinates(e);

	            this.emit("reorderStop", coordinates.x, coordinates.y);
	        }
	        this._inReorder = false;
	        this._parentBounds = null;
	    },
	    _getCoordinates: function (event) {
	        event = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : event;
	        return {
	            x: event.pageX,
	            y: event.pageY
	        };
	    }
	});})(window.$);
} (goldenlayout));

var goldenlayoutExports = goldenlayout.exports;
var GoldenLayout = /*@__PURE__*/getDefaultExportFromCjs(goldenlayoutExports);

var ResizeObserver$1 = {exports: {}};

(function (module, exports) {
	(function (global, factory) {
	    module.exports = factory() ;
	}(commonjsGlobal, (function () {
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();

	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.Math === Math) {
	            return commonjsGlobal;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();

	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();

	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }

	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());

	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });

	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });

	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }

	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());

	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());

	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());

	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });

	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();

	    return index;

	}))); 
} (ResizeObserver$1));

var ResizeObserverExports = ResizeObserver$1.exports;
var ResizeObserver = /*@__PURE__*/getDefaultExportFromCjs(ResizeObserverExports);

/* @ts-self-types="./index.d.ts" */
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let nanoid = (size = 21) => {
  let id = '';
  let i = size | 0;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};

// wrapping the nanoid lib to enable easier stubbing in tests.
var wrappedNanoId = { nanoid: nanoid };

const idAsString = (id) => Array.isArray(id) ? id[0] : id;
const getAllWindowsFromConfig = (contents = []) => {
    const recursiveElementTraversal = (currItem) => {
        if (currItem.type === "component") {
            return currItem.id ? [currItem] : [];
        }
        return currItem.content.reduce((acc, currContent) => {
            acc = [...acc, ...recursiveElementTraversal(currContent)];
            return acc;
        }, []);
    };
    return contents.reduce((acc, ci) => {
        return [...acc, ...recursiveElementTraversal(ci)];
    }, []);
};
const getAllWindowsFromItem = (item) => {
    const result = [];
    const recursiveTraversal = (item) => {
        if (item.type === "window") {
            result.push(item);
            return;
        }
        item.children.forEach((c) => recursiveTraversal(c));
    };
    recursiveTraversal(item);
    return result;
};
const getAllItemsFromConfig = (contents) => {
    const recursiveElementTraversal = (currItem) => {
        if (currItem.type === "component") {
            return currItem.id ? [currItem] : [];
        }
        const resultArray = currItem.content.reduce((acc, currContent) => {
            acc = [...acc, ...recursiveElementTraversal(currContent)];
            return acc;
        }, []);
        return [...resultArray, currItem];
    };
    return contents.reduce((acc, ci) => {
        return [...acc, ...recursiveElementTraversal(ci)];
    }, []);
};
const getElementBounds = (element) => {
    const rawBounds = $(element)[0].getBoundingClientRect();
    return {
        x: Math.round(rawBounds.x),
        y: Math.round(rawBounds.y),
        left: Math.round(rawBounds.left),
        top: Math.round(rawBounds.top),
        width: Math.round(rawBounds.width),
        height: Math.round(rawBounds.height),
    };
};
const createWaitFor = (signalsToWait, timeout) => {
    let resolve;
    let reject;
    let signals = 0;
    const t = setTimeout(() => {
        reject();
    }, 10000);
    const signal = () => {
        signals++;
        if (signals >= signalsToWait) {
            clearTimeout(t);
            resolve();
        }
    };
    const rejectWaitFor = (e) => {
        clearTimeout(t);
        reject(e);
    };
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        reject: rejectWaitFor,
        signal,
        promise
    };
};
const getWorkspaceContextName = (id) => `___workspace___${id}`;
const getRealHeight = (obj) => {
    if (!obj || !obj[0]) {
        return 0;
    }
    const clone = obj.clone();
    clone.css("visibility", "hidden");
    $("body").append(clone);
    const height = clone[0].getBoundingClientRect().height;
    clone.remove();
    return height;
};
const isOperationSupported = (operation) => {
    switch (operation) {
        case "isWindowInWorkspace":
        case "addWindow":
        case "addContainer":
        case "getWorkspaceSnapshot":
        case "openWorkspace":
        case "saveLayout":
        case "exportAllLayouts":
        case "deleteLayout":
        case "getAllWorkspacesSummaries":
        case "maximizeItem":
        case "restoreItem":
        case "closeItem":
        case "setItemTitle":
        case "addWorkspaceChildren":
        case "ejectWindow":
        case "createWorkspace":
        case "forceLoadWindow":
        case "focusItem":
        case "bundleWorkspace":
        case "bundleItem":
        case "getFrameSummary":
        case "moveFrame":
        case "getFrameSnapshot":
        case "getSnapshot":
        case "moveWindowTo":
        case "generateLayout":
        case "ping":
        case "hibernateWorkspace":
        case "resumeWorkspace":
        case "lockWorkspace":
        case "lockContainer":
        case "lockWindow":
        case "resizeItem":
        case "pinWorkspace":
        case "unpinWorkspace":
        case "getWorkspaceIcon":
        case "setWorkspaceIcon":
        case "initFrame":
        case "createFrame":
        case "initFrameFromSnapshot":
        case "getWorkspacesLayouts":
        case "setMaximizationBoundary":
        case "operationCheck":
        case "getDecorationsSize":
        case "showChannelsLink":
        case "hideChannelsLink":
        case "changeChannelsLinkColor":
        case "isIgnoreContextsOnLayoutSaveSupported":
            return true;
        default:
            return false;
    }
};
const extractWindowSummariesFromSnapshot = (snapshot) => {
    const result = [];
    const getAllWindows = (item, parentId) => {
        if (item.type === "component") {
            result.push({
                itemId: idAsString(item.id),
                parentId,
                config: item.workspacesConfig
            });
            return;
        }
        item.content.forEach((c) => getAllWindows(c, idAsString(item.id)));
    };
    getAllWindows(snapshot, undefined);
    return result;
};
const generateId = () => {
    return wrappedNanoId.nanoid(10);
};
const generateWindowId = () => {
    return `g42-${generateId()}`;
};
const getWorkspaceLayoutContainerId = (workspaceId) => {
    return `nestHere${workspaceId}`;
};

class WorkspaceStore {
    constructor() {
        this._idToLayout = {};
    }
    get layouts() {
        return Object.values(this._idToLayout);
    }
    get workspaceIds() {
        return Object.keys(this._idToLayout);
    }
    set workspaceLayout(layout) {
        this._workspaceLayout = layout;
    }
    get workspaceLayout() {
        return this._workspaceLayout;
    }
    get workspaceLayoutHeader() {
        return this._workspaceLayout.root.contentItems[0].header;
    }
    getWorkspaceLayoutItemById(itemId) {
        return this.workspaceLayout.root.getItemsById(itemId)[0];
    }
    getById(id) {
        id = idAsString(id);
        return this._idToLayout[id];
    }
    getByContainerId(id) {
        id = idAsString(id);
        return this._idToLayout[id] || this.getByContainerIdCore(id);
    }
    removeById(id) {
        delete this._idToLayout[id];
    }
    removeLayout(id) {
        var _a;
        (_a = this._idToLayout[id].layout) === null || _a === void 0 ? void 0 : _a.destroy();
        this._idToLayout[id].layout = undefined;
    }
    addOrUpdate(id, windows, layout) {
        const workspace = this.getById(id);
        if (workspace) {
            workspace.layout = layout;
            workspace.windows = this.mergeWindows(workspace.windows, windows);
            return;
        }
        this._idToLayout[id] = {
            id,
            windows,
            layout,
            hibernatedWindows: [],
            lastActive: Date.now()
        };
    }
    getWindow(id) {
        const winId = idAsString(id);
        return this.layouts.reduce((acc, l) => acc || l.windows.find((w) => w.id === winId || w.windowId === winId), undefined);
    }
    getActiveWorkspace() {
        const activeWorkspaceId = this.workspaceLayout.root.contentItems[0].getActiveContentItem().config.id;
        return this.getById(activeWorkspaceId);
    }
    addWindow(window, workspaceId) {
        const workspace = this.getById(workspaceId);
        workspace.windows = workspace.windows.filter(w => w.id !== window.id);
        workspace.windows.push(window);
    }
    removeWindow(window, workspaceId) {
        const workspace = this.getById(workspaceId);
        workspace.windows = workspace.windows.filter(w => w.id !== window.id);
    }
    getByWindowId(windowId) {
        windowId = idAsString(windowId);
        const resultFromWindowCollection = this.layouts.find((l) => l.windows.some((w) => w.id === windowId || w.windowId === windowId));
        if (resultFromWindowCollection) {
            return resultFromWindowCollection;
        }
        return this.layouts.find((l) => {
            if (!(l === null || l === void 0 ? void 0 : l.layout)) {
                return false;
            }
            return l.layout.root.getItemsById(windowId)[0];
        });
    }
    getWindowContentItem(windowId) {
        const placementIdResult = this.layouts.filter((l) => l.layout).reduce((acc, w) => {
            return acc || w.layout.root.getItemsById(windowId)[0];
        }, undefined);
        if (placementIdResult && placementIdResult.isComponent) {
            return placementIdResult;
        }
        const windowIdResult = this.layouts.filter((l) => l.layout).reduce((acc, w) => {
            return acc ||
                w.layout.root.getItemsByFilter((c) => c.isComponent && c.config.componentState.windowId === windowId)[0];
        }, undefined);
        if (!(windowIdResult === null || windowIdResult === void 0 ? void 0 : windowIdResult.isComponent)) {
            return undefined;
        }
        return windowIdResult;
    }
    getContainer(containerId) {
        containerId = idAsString(containerId);
        const workspaces = this.layouts.reduce((acc, w) => {
            if (w.layout) {
                acc.push(w.layout);
            }
            return acc;
        }, []);
        const result = workspaces.reduce((acc, w) => {
            const contentItem = w.root.getItemsById(containerId)[0];
            if ((contentItem === null || contentItem === void 0 ? void 0 : contentItem.type) === "component") {
                return acc;
            }
            return acc || contentItem;
        }, undefined);
        return result;
    }
    getWorkspaceContext(workspaceId) {
        var _a, _b, _c;
        const workspace = this.getById(workspaceId);
        return (_c = (_b = (_a = workspace === null || workspace === void 0 ? void 0 : workspace.layout) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.workspacesOptions) === null || _c === void 0 ? void 0 : _c.context;
    }
    syncWorkspaceOrder() {
        const workspaceStack = this.workspaceLayout.root.getItemsByType("stack")[0];
        if (workspaceStack.type !== "stack") {
            return;
        }
        const idsInNewOrder = workspaceStack.contentItems.map((ci) => idAsString(ci.config.id));
        const newIdToLayout = {};
        idsInNewOrder.forEach((id) => {
            newIdToLayout[id] = this._idToLayout[id];
        });
        if (Object.keys(newIdToLayout).length === Object.keys(this._idToLayout).length) {
            this._idToLayout = newIdToLayout;
        }
    }
    getWorkspaceContentItem(workspaceId) {
        return this.workspaceLayout.root.getItemsById(workspaceId)[0];
    }
    getWorkspaceTabElement(workspaceId) {
        var _a;
        return (_a = this.getWorkspaceContentItem(workspaceId)) === null || _a === void 0 ? void 0 : _a.tab;
    }
    getByContainerIdCore(id) {
        const workspaces = this.layouts.reduce((acc, w) => {
            if (w.layout) {
                acc.push(w);
            }
            return acc;
        }, []);
        const result = workspaces.find((w) => w.layout.root.getItemsById(id)[0]);
        return result;
    }
    mergeWindows(oldWindows, newWindows) {
        return newWindows.map(w => {
            let windowId = w.windowId;
            if (!windowId) {
                const sameWindowInOldWindows = oldWindows.find((oldWin) => oldWin.id === w.id);
                windowId = sameWindowInOldWindows === null || sameWindowInOldWindows === void 0 ? void 0 : sameWindowInOldWindows.windowId;
            }
            return Object.assign(Object.assign({}, w), { windowId });
        });
    }
}
var store = new WorkspaceStore();

const EmptyVisibleWindowName = "emptyVisibleWindow";
const EmptyFrameQueryParam = "emptyFrame";
const DisableCustomButtonsQueryParam = "disableCustomButtons";
const WorkspaceNameQueryParam = "workspaceName";
const WorkspaceNamesQueryParam = "workspaceNames";
const ContextQueryParam = "context";
const BuildQueryParam = "build";
const PlatformControlMethod = "T42.Web.Platform.Control";
const DefaultMaxSize = 32767;
const DefaultMinSize = 20;
const PlaceholderAppName = "no-app-window";
const AddWindowButtonLabel = "Add App";
const AddWorkspaceButtonLabel = "Add Workspace";
const GroupHeaderMaximizeLabel = "Maximize";
const GroupHeaderRestoreLabel = "Restore";
const EjectButtonLabel = "Extract";
const WorkspaceWindowCloseButtonLabel = "Close";
const FrameCloseButtonLabel = "Close";
const FrameMaximizeButtonLabel = "Maximize";
const FrameRestoreButtonLabel = "Restore";
const FrameMinimizeButtonLabel = "Minimize";
const FDC3HelloRequestType = "WCP1Hello";
const FDC3HelloResponseType = "WCP2LoadUrl";

class WorkspacesUIExecutor {
    constructor() {
        this.workspaceLayoutElementId = "#outter-layout-container";
    }
    addInvisibleStyle(transparentColor) {
        const style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = `.lm_content.transparent-color { background-color: ${transparentColor}; }`;
        document.getElementsByTagName("head")[0].appendChild(style);
    }
    makeContentInvisible() {
        $(".lm_item_container .lm_content .lm_item_container .lm_content").addClass("transparent-color");
    }
    hideWorkspaceRootItem(workspaceId) {
        const workspace = store.getById(workspaceId);
        if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
            return;
        }
        $(workspace.layout.root.contentItems[0].element[0]).hide();
    }
    showWorkspaceRootItem(workspaceId, tabObserver) {
        const workspace = store.getById(workspaceId);
        if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
            return;
        }
        $(workspace.layout.root.contentItems[0].element[0]).show();
        workspace.layout.root.getItemsByType("stack").forEach((s) => {
            tabObserver.refreshTabsMaxWidth(s.header.tabsContainer);
        });
    }
    waitForTransition(element) {
        if (!this.hasTransition(element)) {
            return Promise.resolve();
        }
        return new Promise((res) => {
            let unsub = () => {
                // do nothing
            };
            const transitionEnd = (e) => {
                if (!e.pseudoElement && e.path[0] === element) {
                    res();
                    unsub();
                }
            };
            const transitionCancel = (e) => {
                if (!e.pseudoElement && e.path[0] === element) {
                    res();
                    unsub();
                }
            };
            unsub = () => {
                element.removeEventListener("transitionend", transitionEnd);
                element.removeEventListener("transitioncancel", transitionCancel);
            };
            element.addEventListener("transitionend", transitionEnd);
            element.addEventListener("transitioncancel", transitionCancel);
        });
    }
    changeTheme(themeName, allThemes) {
        const htmlTag = $("html");
        allThemes.forEach((t) => htmlTag.removeClass(t));
        htmlTag.addClass(themeName);
    }
    getFrameLayoutContainerBounds() {
        const bounds = getElementBounds(this.getFrameLayoutContainer());
        return bounds;
    }
    getFrameLayoutContainer() {
        return $(this.workspaceLayoutElementId)[0];
    }
    getFrameDecorationsSize() {
        const frameContainerBounds = this.getFrameLayoutContainerBounds();
        const height = window.innerHeight - frameContainerBounds.height;
        const width = window.innerWidth - frameContainerBounds.width;
        return {
            height,
            width
        };
    }
    getWorkspaceDecorationsSize(workspaceContainerBounds) {
        const frameContainerBounds = this.getFrameLayoutContainerBounds();
        return {
            height: frameContainerBounds.height - workspaceContainerBounds.height,
            width: frameContainerBounds.width - workspaceContainerBounds.width
        };
    }
    getGroupDecorationsSize(groupId) {
        const group = store.getContainer(groupId);
        const groupSize = getElementBounds(group.element);
        const windowSize = getElementBounds(group.contentItems[0].element);
        return {
            height: groupSize.height - windowSize.height,
            width: groupSize.width - windowSize.width
        };
    }
    hasTransition(element) {
        const transition = window.getComputedStyle(element, null).getPropertyValue("transition");
        return transition !== "all 0s ease 0s";
    }
}
WorkspacesUIExecutor.HibernationIconClass = "lm_hibernationIcon";
var uiExecutor = new WorkspacesUIExecutor();

class TabObserver {
    init() {
        this.containerElement = uiExecutor.getFrameLayoutContainer();
        this.setupEvents();
        this.injectContainerStyle();
    }
    refreshTabsMaxWidth(tabsElement) {
        const tabChildren = tabsElement.children();
        const visibleTabs = this.visibleTabs($(tabsElement));
        const width = visibleTabs.reduce((acc, vt) => {
            const tabSize = this.getTabWidth(vt);
            return acc + tabSize;
        }, 0);
        tabsElement.css("max-width", `${width}px`);
        Array.from(tabChildren).forEach((tab) => {
            const title = $(tab).children(".lm_title");
            const tabWidth = getElementBounds(tab).width;
            title.css("max-width", `${tabWidth * 0.75}px`);
            this.refreshTabClasses(tab);
        });
    }
    setupEvents() {
        const observer = new MutationObserver((records) => {
            Array.from(records).forEach((r) => {
                if (r.type === "childList" && r.target.classList.contains("lm_tabs")) {
                    const tabs = $(r.target);
                    this.handleTabCountChanged(tabs, Array.from(r.removedNodes), Array.from(r.addedNodes));
                }
                else if (r.type === "attributes"
                    && r.target.classList.contains("lm_stack")
                    && r.attributeName === "style") {
                    const stackElement = $(r.target);
                    this.handleTabHeaderResized(stackElement);
                }
            });
        });
        observer.observe(this.containerElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["style"],
            attributeOldValue: false,
            characterData: false,
            characterDataOldValue: false
        });
        return () => {
            observer.disconnect();
        };
    }
    getCssVarPx(varName) {
        const value = getComputedStyle(document.documentElement).getPropertyValue(varName);
        return parseInt(value);
    }
    injectContainerStyle() {
        const tabSizeDropLock = this.getCssVarPx("--wsp-tab-size-hide-button-lock");
        const tabSizeDropClose = this.getCssVarPx("--wsp-tab-size-hide-button-close");
        const tabSizeDropTitle = this.getCssVarPx("--wsp-tab-size-hide-title");
        const cssContainer = `
            @container header-tab (max-width: ${tabSizeDropLock}px) {
                .wsp-tab .wsp-tab-lock-icon {
                    transform: scale(0);
                    width:0;
                }
                .wsp-tab {
                    --wsp-tab-gap: 0;
                    --wsp-tab-title-margin: 0 0 0 var(--spacing-8);
                }
            }

            @container header-tab (max-width: ${tabSizeDropClose}px) {
                .wsp-tab .wsp-tab-close-btn {
                    transform: scale(0);
                    width:0;
                }
            }

            @container header-tab (max-width: ${tabSizeDropTitle}px) {
                .wsp-tab {
                    justify-content: center;
                }

                .wsp-tab .lm_title {
                    display: none;
                }
            }
        `;
        const styleTag = $("<style></style>");
        styleTag.text(cssContainer);
        $("head").append(styleTag);
    }
    handleTabCountChanged(tabsElement, removedNodes, _) {
        const tabChildren = tabsElement.children();
        const visibleTabs = this.visibleTabs($(tabsElement));
        const width = visibleTabs.reduce((acc, vt) => {
            const tabSize = this.getTabWidth(vt);
            return acc + tabSize;
        }, 0);
        tabsElement.css("max-width", `${width}px`);
        Array.from(tabChildren).forEach((tab) => {
            const title = $(tab).children(".lm_title");
            const tabWidth = getElementBounds(tab).width;
            title.css("max-width", `${tabWidth * 0.75}px`);
            if (removedNodes.length) {
                this.refreshTabClasses(tab);
            }
        });
    }
    handleTabHeaderResized(stackElement) {
        const headerElement = stackElement.children(".lm_header");
        const tabElements = headerElement.children(".lm_tabs");
        const visibleTabs = this.visibleTabs($(tabElements));
        visibleTabs.forEach((tab, i) => {
            const title = $(tab).children(".lm_title");
            const tabLength = getElementBounds(visibleTabs[i]).width;
            title.css("max-width", `${tabLength * 0.75}px`);
            this.refreshTabClasses(tab);
        });
    }
    refreshTabClasses(tab) {
        const tabOuterWidth = $(tab).outerWidth();
        const classes = tab.classList;
        const removeAll = () => {
            classes.remove("lm_tab_mini");
            classes.remove("lm_tab_small");
            classes.remove("lm_tab_mid");
        };
        if (this.isTabPinned(tab)) {
            removeAll();
        }
        else if (tabOuterWidth >= 35 && tabOuterWidth < 55) {
            classes.remove("lm_tab_mini");
            classes.remove("lm_tab_small");
            classes.add("lm_tab_mid");
        }
        else if (tabOuterWidth >= 25 && tabOuterWidth < 35) {
            classes.remove("lm_tab_mini");
            classes.remove("lm_tab_mid");
            classes.add("lm_tab_small");
        }
        else if (tabOuterWidth >= 55) {
            removeAll();
        }
        else if (tabOuterWidth < 25) {
            classes.remove("lm_tab_mid");
            classes.remove("lm_tab_small");
            classes.add("lm_tab_mini");
        }
    }
    visibleTabs(tabsContainer) {
        return Array.from(tabsContainer.children()).filter((t) => $(t).is(":visible")).map((t) => t);
    }
    isTabPinned(tabElement) {
        return tabElement.classList.contains("lm_pinned");
    }
    getTabWidth(tabElement) {
        if (this.isTabPinned(tabElement)) {
            return getElementBounds(tabElement).width;
        }
        return 200;
    }
}

function createRegistry(options) {
    if (options && options.errorHandling
        && typeof options.errorHandling !== "function"
        && options.errorHandling !== "log"
        && options.errorHandling !== "silent"
        && options.errorHandling !== "throw") {
        throw new Error("Invalid options passed to createRegistry. Prop errorHandling should be [\"log\" | \"silent\" | \"throw\" | (err) => void], but " + typeof options.errorHandling + " was passed");
    }
    var _userErrorHandler = options && typeof options.errorHandling === "function" && options.errorHandling;
    var callbacks = {};
    function add(key, callback, replayArgumentsArr) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            callbacksForKey = [];
            callbacks[key] = callbacksForKey;
        }
        callbacksForKey.push(callback);
        if (replayArgumentsArr) {
            setTimeout(function () {
                replayArgumentsArr.forEach(function (replayArgument) {
                    var _a;
                    if ((_a = callbacks[key]) === null || _a === void 0 ? void 0 : _a.includes(callback)) {
                        try {
                            if (Array.isArray(replayArgument)) {
                                callback.apply(undefined, replayArgument);
                            }
                            else {
                                callback.apply(undefined, [replayArgument]);
                            }
                        }
                        catch (err) {
                            _handleError(err, key);
                        }
                    }
                });
            }, 0);
        }
        return function () {
            var allForKey = callbacks[key];
            if (!allForKey) {
                return;
            }
            allForKey = allForKey.reduce(function (acc, element, index) {
                if (!(element === callback && acc.length === index)) {
                    acc.push(element);
                }
                return acc;
            }, []);
            if (allForKey.length === 0) {
                delete callbacks[key];
            }
            else {
                callbacks[key] = allForKey;
            }
        };
    }
    function execute(key) {
        var argumentsArr = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argumentsArr[_i - 1] = arguments[_i];
        }
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey || callbacksForKey.length === 0) {
            return [];
        }
        var results = [];
        callbacksForKey.forEach(function (callback) {
            try {
                var result = callback.apply(undefined, argumentsArr);
                results.push(result);
            }
            catch (err) {
                results.push(undefined);
                _handleError(err, key);
            }
        });
        return results;
    }
    function _handleError(exceptionArtifact, key) {
        var errParam = exceptionArtifact instanceof Error ? exceptionArtifact : new Error(exceptionArtifact);
        if (_userErrorHandler) {
            _userErrorHandler(errParam);
            return;
        }
        var msg = "[ERROR] callback-registry: User callback for key \"" + key + "\" failed: " + errParam.stack;
        if (options) {
            switch (options.errorHandling) {
                case "log":
                    return console.error(msg);
                case "silent":
                    return;
                case "throw":
                    throw new Error(msg);
            }
        }
        console.error(msg);
    }
    function clear() {
        callbacks = {};
    }
    function clearKey(key) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            return;
        }
        delete callbacks[key];
    }
    return {
        add: add,
        execute: execute,
        clear: clear,
        clearKey: clearKey
    };
}
createRegistry.default = createRegistry;
var lib = createRegistry;


var registryFactory = /*@__PURE__*/getDefaultExportFromCjs(lib);

class ComponentStateMonitor {
    constructor() {
        this._visibilityState = {
            logo: undefined,
            workspaceTabs: {},
            addWorkspace: undefined,
            systemButtons: undefined,
            workspaceContents: {},
            beforeGroupTabs: {},
            workspaceWindowTabs: {},
            afterGroupTabs: {},
            groupHeaderButtons: {},
        };
        this._lastSelectedWorkspaceWindowTab = {};
        this._callbackRegistry = registryFactory();
        this._componentsFactory = {};
        this._decoratedFactory = {};
        this._observer = new MutationObserver((mutations) => {
            Array.from(mutations).forEach((m) => {
                const targetDiv = m.target;
                const workspaceId = this.getWorkspaceIdFromContents(targetDiv);
                const action = targetDiv.style.display === "none" ? "workspace-contents-hidden" : "workspace-contents-shown";
                this._callbackRegistry.execute(action, workspaceId);
            });
        });
    }
    get decoratedFactory() {
        return this._decoratedFactory;
    }
    init(frameId, componentsFactory) {
        this._componentsFactory = componentsFactory;
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createAddWorkspace) {
            this.decoratedFactory.createAddWorkspace = (args) => {
                args.frameId = frameId;
                this._visibilityState.addWorkspace = args;
                return this._componentsFactory.createAddWorkspace(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createWorkspaceTabs) {
            this.decoratedFactory.createWorkspaceTabs = (args) => {
                var _a;
                if (args.isSelected === true) {
                    this.changeSelectedWorkspaceState(args);
                }
                const previousEntry = (_a = this._visibilityState.workspaceTabs[args.workspaceId]) !== null && _a !== void 0 ? _a : {};
                this._visibilityState.workspaceTabs[args.workspaceId] = Object.assign(Object.assign({}, previousEntry), args);
                this.setupCleanup(this._componentsFactory.removeWorkspaceTabs, "workspaceTabs", args.workspaceId, undefined, undefined, args.workspaceId);
                return componentsFactory.createWorkspaceTabs(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createLogo) {
            this.decoratedFactory.createLogo = (args) => {
                args.frameId = frameId;
                this._visibilityState.logo = args;
                return this._componentsFactory.createLogo(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createSystemButtons) {
            this.decoratedFactory.createSystemButtons = (args) => {
                var _a, _b, _c, _d;
                args.frameId = frameId;
                args.close = (_a = args.close) !== null && _a !== void 0 ? _a : { visible: false };
                args.maximize = (_b = args.maximize) !== null && _b !== void 0 ? _b : { visible: false };
                args.restore = (_c = args.restore) !== null && _c !== void 0 ? _c : { visible: false };
                args.minimize = (_d = args.minimize) !== null && _d !== void 0 ? _d : { visible: false };
                args.close.title = FrameCloseButtonLabel;
                args.maximize.title = FrameMaximizeButtonLabel;
                args.restore.title = FrameRestoreButtonLabel;
                args.minimize.title = FrameMinimizeButtonLabel;
                this._visibilityState.systemButtons = args;
                return componentsFactory.createSystemButtons(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createWorkspaceContents) {
            this.decoratedFactory.createWorkspaceContents = (args) => {
                const visibilityStateEntry = args;
                this._visibilityState.workspaceContents[args.workspaceId] = (visibilityStateEntry);
                const unsub = this.onWorkspaceClosed(args.workspaceId, () => {
                    this.cleanupWorkspaceContents(args.workspaceId);
                    unsub();
                });
                this.subscribeForWorkspaceContentsVisibility(args.workspaceId);
                return componentsFactory.createWorkspaceContents(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createBeforeGroupTabs) {
            this.decoratedFactory.createBeforeGroupTabs = (args) => {
                this._visibilityState.beforeGroupTabs[args.groupId] = args;
                this.setupCleanup(this._componentsFactory.removeBeforeGroupTabs, "beforeGroupTabs", args.groupId, undefined, args.groupId, args.workspaceId);
                return componentsFactory.createBeforeGroupTabs(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createWorkspaceWindowTabs) {
            this.decoratedFactory.createWorkspaceWindowTabs = (args) => {
                if (args.isSelected === true) {
                    this.changeSelectedWorkspaceWindowState(args);
                }
                this._visibilityState.workspaceWindowTabs[args.placementId] = args;
                this.setupCleanup(this._componentsFactory.removeWorkspaceWindowTabs, "workspaceWindowTabs", args.placementId, args.placementId, args.groupId, args.workspaceId);
                return componentsFactory.createWorkspaceWindowTabs(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createAfterGroupTabs) {
            this.decoratedFactory.createAfterGroupTabs = (args) => {
                this._visibilityState.afterGroupTabs[args.groupId] = args;
                this.setupCleanup(this._componentsFactory.removeAfterGroupTabs, "afterGroupTabs", args.groupId, undefined, args.groupId, args.workspaceId);
                return componentsFactory.createAfterGroupTabs(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.createGroupHeaderButtons) {
            this.decoratedFactory.createGroupHeaderButtons = (args) => {
                this._visibilityState.groupHeaderButtons[args.groupId] = args;
                this.setupCleanup(this._componentsFactory.removeGroupHeaderButtons, "groupHeaderButtons", args.groupId, undefined, args.groupId, args.workspaceId);
                return componentsFactory.createGroupHeaderButtons(args);
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.updateAddWorkspace) {
            this.decoratedFactory.updateAddWorkspace = (args) => {
                if (!this._visibilityState.addWorkspace) {
                    return;
                }
                this._visibilityState.addWorkspace = Object.assign(Object.assign({}, this._visibilityState.addWorkspace), args);
                componentsFactory.updateAddWorkspace(args);
            };
        }
        else {
            this.decoratedFactory.updateAddWorkspace = () => {
                // do nothing
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.updateWorkspaceTabs) {
            this.decoratedFactory.updateWorkspaceTabs = (args) => {
                var _a;
                if (!this._visibilityState.workspaceTabs[args.workspaceId]) {
                    return;
                }
                if (args.isSelected === true) {
                    this.changeSelectedWorkspaceState(args);
                }
                const previousEntry = (_a = this._visibilityState.workspaceTabs[args.workspaceId]) !== null && _a !== void 0 ? _a : {};
                this._visibilityState.workspaceTabs[args.workspaceId] = Object.assign(Object.assign({}, previousEntry), args);
                componentsFactory.updateWorkspaceTabs(args);
            };
        }
        else {
            this.decoratedFactory.updateWorkspaceTabs = () => {
                // do nothing
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.updateWorkspaceWindowTabs) {
            this.decoratedFactory.updateWorkspaceWindowTabs = (args) => {
                var _a;
                if (!this._visibilityState.workspaceWindowTabs[args.placementId]) {
                    return;
                }
                if (args.isSelected === true) {
                    this.changeSelectedWorkspaceWindowState(args);
                }
                const previousEntry = (_a = this._visibilityState.workspaceTabs[args.placementId]) !== null && _a !== void 0 ? _a : {};
                args.channels = Object.assign(Object.assign({}, this._visibilityState.workspaceWindowTabs[args.placementId].channels), args.channels);
                args.close = Object.assign(Object.assign({}, this._visibilityState.workspaceWindowTabs[args.placementId].close), args.close);
                this._visibilityState.workspaceWindowTabs[args.placementId] = Object.assign(Object.assign({}, previousEntry), args);
                componentsFactory.updateWorkspaceWindowTabs(args);
            };
        }
        else {
            this.decoratedFactory.updateWorkspaceWindowTabs = () => {
                // do nothing
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.updateAfterGroupTabs) {
            this.decoratedFactory.updateAfterGroupTabs = (args) => {
                var _a;
                if (!this._visibilityState.afterGroupTabs[args.groupId]) {
                    return;
                }
                const previousEntry = (_a = this._visibilityState.afterGroupTabs[args.groupId]) !== null && _a !== void 0 ? _a : {};
                args.addWindow = Object.assign(Object.assign({}, this._visibilityState.afterGroupTabs[args.groupId].addWindow), args.addWindow);
                this._visibilityState.afterGroupTabs[args.groupId] = Object.assign(Object.assign({}, previousEntry), args);
                componentsFactory.updateAfterGroupTabs(args);
            };
        }
        else {
            this.decoratedFactory.updateAfterGroupTabs = () => {
                // do nothing
            };
        }
        if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.updateGroupHeaderButtons) {
            this.decoratedFactory.updateGroupHeaderButtons = (args) => {
                var _a;
                if (!this._visibilityState.groupHeaderButtons[args.groupId]) {
                    return;
                }
                const previousEntry = (_a = this._visibilityState.groupHeaderButtons[args.groupId]) !== null && _a !== void 0 ? _a : {};
                args.addWindow = Object.assign(Object.assign({}, this._visibilityState.groupHeaderButtons[args.groupId].addWindow), args.addWindow);
                args.maximize = Object.assign(Object.assign({}, this._visibilityState.groupHeaderButtons[args.groupId].maximize), args.maximize);
                args.restore = Object.assign(Object.assign({}, this._visibilityState.groupHeaderButtons[args.groupId].restore), args.restore);
                args.eject = Object.assign(Object.assign({}, this._visibilityState.groupHeaderButtons[args.groupId].eject), args.eject);
                this._visibilityState.groupHeaderButtons[args.groupId] = Object.assign(Object.assign({}, previousEntry), args);
                componentsFactory.updateGroupHeaderButtons(args);
            };
        }
        else {
            this.decoratedFactory.updateGroupHeaderButtons = () => {
                // do nothing
            };
        }
        if (componentsFactory) {
            this.decoratedFactory.createId = () => {
                return generateId();
            };
            this.decoratedFactory.createWorkspaceTabsOptions = ({ element, contentItem }) => {
                var _a, _b;
                const itemIndex = contentItem.parent.contentItems.indexOf(contentItem);
                const isSelected = itemIndex === (contentItem.parent.config.activeItemIndex || 0); // copied from the stack init in GL
                return {
                    domNode: element,
                    workspaceId: idAsString(contentItem.config.id),
                    title: contentItem.config.title,
                    isSelected,
                    isPinned: contentItem.config.workspacesConfig.isPinned,
                    icon: contentItem.config.workspacesConfig.icon,
                    showSaveButton: (_a = contentItem.config.workspacesConfig.showSaveButton) !== null && _a !== void 0 ? _a : true,
                    showCloseButton: (_b = contentItem.config.workspacesConfig.showCloseButton) !== null && _b !== void 0 ? _b : true,
                    layoutName: contentItem.config.workspacesConfig.layoutName
                };
            };
            this.decoratedFactory.createWorkspaceWindowTabsOptions = ({ element, contentItem }) => {
                var _a, _b;
                const itemIndex = contentItem.parent.contentItems.indexOf(contentItem);
                const isSelected = itemIndex === (contentItem.parent.config.activeItemIndex || 0); // copied from the stack init in GL
                return {
                    domNode: element,
                    groupId: idAsString(contentItem.parent.config.id),
                    placementId: idAsString(contentItem.config.id),
                    windowId: (_a = contentItem.config.componentState) === null || _a === void 0 ? void 0 : _a.windowId,
                    workspaceId: idAsString(contentItem.layoutManager.root.config.id),
                    title: contentItem.config.title,
                    isSelected,
                    channels: {
                        color: "transparent",
                        visible: false
                    },
                    close: {
                        title: WorkspaceWindowCloseButtonLabel,
                        visible: (_b = contentItem.config.workspacesConfig.showCloseButton) !== null && _b !== void 0 ? _b : true
                    }
                };
            };
            this.decoratedFactory.createAfterGroupTabsOptions = ({ element, contentItem }) => {
                return {
                    isAddWindowPopupActive: false,
                    domNode: element,
                    groupId: idAsString(contentItem.config.id),
                    workspaceId: contentItem.layoutManager.config.workspacesOptions.workspaceId,
                    addWindow: {
                        visible: true,
                        title: AddWindowButtonLabel
                    },
                };
            };
            this.decoratedFactory.createGroupHeaderButtonsOptions = ({ element, contentItem }) => {
                return {
                    isAddWindowPopupActive: false,
                    domNode: element,
                    groupId: idAsString(contentItem.config.id),
                    workspaceId: contentItem.layoutManager.config.workspacesOptions.workspaceId,
                    addWindow: {
                        visible: true,
                        title: AddWindowButtonLabel
                    },
                    eject: {
                        visible: true,
                        title: EjectButtonLabel
                    },
                    maximize: {
                        visible: !contentItem.isMaximized,
                        title: GroupHeaderMaximizeLabel
                    },
                    restore: {
                        visible: contentItem.isMaximized,
                        title: GroupHeaderRestoreLabel
                    }
                };
            };
            if (componentsFactory === null || componentsFactory === void 0 ? void 0 : componentsFactory.settings) {
                this.decoratedFactory.settings = componentsFactory.settings;
            }
        }
    }
    reInitialize(incomingFactory) {
        if ((incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createLogo) && this._visibilityState.logo) {
            incomingFactory.createLogo(this._visibilityState.logo);
        }
        if ((incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createAddWorkspace) && this._visibilityState.addWorkspace) {
            incomingFactory.createAddWorkspace(this._visibilityState.addWorkspace);
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createWorkspaceTabs) {
            Object.values(this._visibilityState.workspaceTabs).forEach((wt) => {
                incomingFactory.createWorkspaceTabs(wt);
            });
        }
        if ((incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createSystemButtons) && this._visibilityState.systemButtons) {
            incomingFactory.createSystemButtons(this._visibilityState.systemButtons);
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createWorkspaceContents) {
            Object.values(this._visibilityState.workspaceContents).forEach((wc) => {
                incomingFactory.createWorkspaceContents(wc);
            });
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createBeforeGroupTabs) {
            Object.values(this._visibilityState.beforeGroupTabs).forEach((bgt) => {
                incomingFactory.createBeforeGroupTabs(bgt);
            });
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createWorkspaceWindowTabs) {
            Object.values(this._visibilityState.workspaceWindowTabs).forEach((wwt) => {
                incomingFactory.createWorkspaceWindowTabs(wwt);
            });
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createAfterGroupTabs) {
            Object.values(this._visibilityState.afterGroupTabs).forEach((agt) => {
                incomingFactory.createAfterGroupTabs(agt);
            });
        }
        if (incomingFactory === null || incomingFactory === void 0 ? void 0 : incomingFactory.createGroupHeaderButtons) {
            Object.values(this._visibilityState.groupHeaderButtons).forEach((ghb) => {
                incomingFactory.createGroupHeaderButtons(ghb);
            });
        }
        this._componentsFactory = incomingFactory;
    }
    onWorkspaceContentsShown(callback) {
        this._callbackRegistry.add("workspace-contents-shown", callback);
    }
    onWorkspaceContentsHidden(callback) {
        this._callbackRegistry.add("workspace-contents-hidden", callback);
    }
    notifyWorkspaceClosed(workspaceId) {
        this._callbackRegistry.execute(`workspace-closed-${workspaceId}`, workspaceId);
    }
    notifyGroupClosed(groupId) {
        this._callbackRegistry.execute(`group-closed-${groupId}`, groupId);
    }
    notifyWindowClosed(placementId) {
        this._callbackRegistry.execute(`window-closed-${placementId}`, placementId);
    }
    onWorkspaceClosed(workspaceId, callback) {
        return this._callbackRegistry.add(`workspace-closed-${workspaceId}`, callback);
    }
    onGroupClosed(groupId, callback) {
        return this._callbackRegistry.add(`group-closed-${groupId}`, callback);
    }
    onWindowClosed(placementId, callback) {
        return this._callbackRegistry.add(`window-closed-${placementId}`, callback);
    }
    subscribeForWorkspaceContentsVisibility(workspaceId) {
        const contentsElement = document.getElementById(getWorkspaceLayoutContainerId(workspaceId));
        if (!contentsElement) {
            return;
        }
        this._observer.observe(contentsElement, {
            attributes: true,
            attributeFilter: ["style"]
        });
    }
    getWorkspaceIdFromContents(element) {
        return element.id.split("nestHere")[1];
    }
    changeSelectedWorkspaceState(args) {
        const previouslySelected = this._lastSelectedWorkspaceTab;
        if (previouslySelected) {
            this.decoratedFactory.updateWorkspaceTabs({ workspaceId: previouslySelected.workspaceId, isSelected: false });
        }
        this._lastSelectedWorkspaceTab = args;
    }
    changeSelectedWorkspaceWindowState(args) {
        const previouslySelected = this._lastSelectedWorkspaceWindowTab[args.groupId];
        if (previouslySelected) {
            this.decoratedFactory.updateWorkspaceWindowTabs({ placementId: previouslySelected.placementId, isSelected: false });
        }
        this._lastSelectedWorkspaceWindowTab[args.groupId] = args;
    }
    cleanupWorkspaceContents(workspaceId) {
        if (!workspaceId) {
            return;
        }
        this._componentsFactory.removeWorkspaceContents({ workspaceId });
        delete this._visibilityState.workspaceContents[workspaceId];
        const workspaceLayoutContainer = document.getElementById(getWorkspaceLayoutContainerId(workspaceId));
        if (workspaceLayoutContainer) {
            workspaceLayoutContainer.remove();
        }
    }
    setupCleanup(removeFactoryFunction, stateKey, elementId, placementId, groupId, workspaceId) {
        let windowUnsub = () => {
            // do nothing
        };
        let groupUnsub = () => {
            // do nothing
        };
        let workspaceUnsub = () => {
            // do nothing
        };
        const cleanUp = () => {
            if (removeFactoryFunction) {
                removeFactoryFunction({ elementId });
            }
            delete this._visibilityState[stateKey][elementId];
            windowUnsub();
            groupUnsub();
            workspaceUnsub();
        };
        if (placementId) {
            windowUnsub = this.onWindowClosed(placementId, cleanUp);
        }
        if (groupId) {
            groupUnsub = this.onGroupClosed(groupId, cleanUp);
        }
        if (workspaceId) {
            workspaceUnsub = this.onWorkspaceClosed(workspaceId, cleanUp);
        }
    }
}
var componentStateMonitor = new ComponentStateMonitor();

class LayoutController {
    constructor(emitter, _stateResolver, _options, _configFactory, _wrapperFactory, _layoutComponentsFactory, linkController) {
        this.emitter = emitter;
        this._stateResolver = _stateResolver;
        this._options = _options;
        this._configFactory = _configFactory;
        this._wrapperFactory = _wrapperFactory;
        this._layoutComponentsFactory = _layoutComponentsFactory;
        this.linkController = linkController;
        this._maximizedId = "__glMaximised";
        this.getImmediateChildEmptyWindow = (contentItem) => {
            if (contentItem.type === "component") {
                if (contentItem.config.componentName === EmptyVisibleWindowName) {
                    return contentItem;
                }
                return;
            }
            if (contentItem.type === "stack") {
                return contentItem.getComponentsByName(EmptyVisibleWindowName)[0];
            }
            return contentItem.contentItems.reduce((acc, ci) => {
                if (acc) {
                    return acc;
                }
                if (ci.type === "component") {
                    if (ci.config.componentName === EmptyVisibleWindowName) {
                        return ci;
                    }
                    return;
                }
                return ci.contentItems.find(ci => ci.type === "component" && ci.config.componentName === EmptyVisibleWindowName);
            }, undefined);
        };
    }
    get bounds() {
        return getElementBounds(document.getElementById("outter-layout-container"));
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this._frameId = config.frameId;
            this._showLoadingIndicator = config.showLoadingIndicator;
            this._tabObserver = new TabObserver();
            this._tabObserver.init();
            yield this.initWorkspaceConfig(config.workspaceLayout);
            this.refreshLayoutSize();
            yield Promise.all(config.workspaceConfigs.map((c) => __awaiter(this, void 0, void 0, function* () {
                yield this.initWorkspaceContents(c.id, c.config, false);
                this.emitter.raiseEvent("workspace-added", { workspace: store.getById(c.id) });
            })));
            this.setupOuterLayout();
            store.workspaceIds.forEach((id) => {
                this.setupContentLayouts(id);
            });
        });
    }
    reinit(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.reinitWorkspaceConfig(config.workspaceLayout);
            this.refreshLayoutSize();
            yield Promise.all(config.workspaceConfigs.map((c) => __awaiter(this, void 0, void 0, function* () {
                yield this.initWorkspaceContents(c.id, c.config, false);
                this.emitter.raiseEvent("workspace-added", { workspace: store.getById(c.id) });
            })));
            this._tabObserver.refreshTabsMaxWidth(store.workspaceLayoutHeader.tabsContainer);
            store.workspaceIds.forEach((id) => {
                this.setupContentLayouts(id);
            });
        });
    }
    addWindow(config, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            parentId = parentId || idAsString(store.workspaceLayout.root.contentItems[0].getActiveContentItem().config.id);
            const workspace = store.getByContainerId(parentId);
            if (this._stateResolver.isWorkspaceHibernated(workspace.id)) {
                throw new Error(`Could not add window to ${workspace.id} because its hibernated`);
            }
            if (!workspace.layout) {
                this.hideAddButton(workspace.id);
                yield this.initWorkspaceContents(workspace.id, config, true);
                return;
            }
            let contentItem = workspace.layout.root.getItemsByFilter((ci) => ci.isColumn || ci.isRow)[0];
            if (parentId && parentId !== workspace.id) {
                contentItem = workspace.layout.root.getItemsById(parentId)[0];
            }
            if (!contentItem) {
                contentItem = workspace.layout.root.getItemsByFilter((ci) => ci.isStack)[0];
            }
            const { placementId, windowId, url, appName } = this.getWindowInfoFromConfig(config);
            this._layoutComponentsFactory.registerWindowComponent(workspace.layout, idAsString(placementId));
            const emptyVisibleWindow = this.getImmediateChildEmptyWindow(contentItem);
            const workspaceContentItem = store.getWorkspaceContentItem(workspace.id);
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
            if (config.type === "component") {
                this.applyLockConfig(config, contentItem, workspaceWrapper, parentId === workspace.id);
            }
            else {
                const allItems = [...getAllItemsFromConfig(config.content), config];
                allItems.forEach((item) => {
                    this.applyLockConfig(item, contentItem, workspaceWrapper, parentId === workspace.id);
                });
            }
            return new Promise((res) => {
                var _a, _b;
                const unsub = this.emitter.onContentComponentCreated((component) => {
                    if (component.config.id === placementId) {
                        unsub();
                        res();
                    }
                });
                // if the root element is a stack you must add the window to the stack
                if (workspace.layout.root.contentItems[0].type === "stack" && config.type !== "component") {
                    config = getAllWindowsFromConfig([config])[0];
                }
                if (emptyVisibleWindow &&
                    emptyVisibleWindow.parent &&
                    !((_a = emptyVisibleWindow.parent.config.workspacesConfig) === null || _a === void 0 ? void 0 : _a.wrapper)) {
                    // Triggered when the API level parent is an empty group
                    const group = this._configFactory.wrapInGroup([config]);
                    group.workspacesConfig.wrapper = false;
                    const _c = ((_b = emptyVisibleWindow.parent.config) === null || _b === void 0 ? void 0 : _b.workspacesConfig) || {}, options = __rest(_c, ["wrapper"]);
                    group.workspacesConfig = Object.assign(Object.assign({}, group.workspacesConfig), options);
                    // Replacing the whole stack in order to trigger the header logic and the properly update the title
                    emptyVisibleWindow.parent.parent.replaceChild(emptyVisibleWindow.parent, group);
                    workspace.windows = workspace.windows.filter((w) => w.id !== idAsString(emptyVisibleWindow.config.id));
                    return;
                }
                else if (emptyVisibleWindow) {
                    // Triggered when the API level parent is an empty group/column
                    emptyVisibleWindow.parent.replaceChild(emptyVisibleWindow, config);
                    workspace.windows = workspace.windows.filter((w) => w.id !== idAsString(emptyVisibleWindow.config.id));
                    return;
                }
                contentItem.addChild(config);
            });
        });
    }
    addContainer(config, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const workspace = store.getByContainerId(parentId);
            if (this._stateResolver.isWorkspaceHibernated(workspace.id)) {
                throw new Error(`Could not add container to ${workspace.id} because its hibernated`);
            }
            if (!workspace.layout) {
                const containerId = config.id || this._configFactory.getId();
                if (config) {
                    config.id = containerId;
                }
                this.hideAddButton(workspace.id);
                yield this.initWorkspaceContents(workspace.id, config, true);
                return idAsString(containerId);
            }
            let contentItem = workspace.layout.root.getItemsByFilter((ci) => ci.isColumn || ci.isRow)[0];
            if (parentId) {
                contentItem = workspace.layout.root.getItemsById(parentId)[0];
            }
            if (!contentItem) {
                contentItem = workspace.layout.root.getItemsByFilter((ci) => ci.isStack)[0];
            }
            if (workspace.id === parentId) {
                if (config.type === "column" || config.type === "stack") {
                    this.bundleWorkspace(workspace.id, "row");
                }
                else if (config.type === "row") {
                    this.bundleWorkspace(workspace.id, "column");
                }
                contentItem = workspace.layout.root.contentItems[0];
            }
            if (config.content) {
                getAllWindowsFromConfig(config.content).forEach((w) => {
                    this._layoutComponentsFactory.registerWindowComponent(workspace.layout, idAsString(w.id));
                });
            }
            if (config.content) {
                const allItems = [...getAllItemsFromConfig(config.content), config];
                const workspaceContentItem = store.getWorkspaceContentItem(workspace.id);
                const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
                allItems.forEach((item) => {
                    this.applyLockConfig(item, contentItem, workspaceWrapper, parentId === workspace.id);
                });
            }
            if (contentItem.type === "component") {
                throw new Error("The target item for add container can't be a component");
            }
            const groupWrapperChild = contentItem.contentItems
                .find((ci) => ci.type === "stack" && ci.config.workspacesConfig.wrapper === true);
            const hasGroupWrapperAPlaceholder = ((_a = groupWrapperChild === null || groupWrapperChild === void 0 ? void 0 : groupWrapperChild.contentItems[0]) === null || _a === void 0 ? void 0 : _a.config.componentName) === EmptyVisibleWindowName;
            return new Promise((res, rej) => {
                let unsub = () => {
                    // safety
                };
                const timeout = setTimeout(() => {
                    unsub();
                    rej(`Component with id ${config.id} could not be created in 10000ms`);
                }, 10000);
                unsub = this.emitter.onContentItemCreated((wId, item) => {
                    if (wId === workspace.id && item.type === config.type) {
                        res(idAsString(item.config.id));
                        unsub();
                        clearTimeout(timeout);
                    }
                });
                if ((groupWrapperChild === null || groupWrapperChild === void 0 ? void 0 : groupWrapperChild.contentItems.length) === 1 && hasGroupWrapperAPlaceholder) {
                    const emptyVisibleWindow = contentItem.getComponentsByName(EmptyVisibleWindowName)[0];
                    workspace.windows = workspace.windows.filter((w) => w.id !== emptyVisibleWindow.config.id);
                    emptyVisibleWindow.parent.replaceChild(emptyVisibleWindow, config);
                }
                else {
                    contentItem.addChild(config);
                }
            });
        });
    }
    closeContainer(itemId) {
        const workspace = store.getByContainerId(itemId) || store.getByWindowId(itemId);
        if (!workspace) {
            throw new Error(`Could not find container ${itemId} to close in any workspace`);
        }
        const contentItem = workspace.layout.root.getItemsById(itemId)[0];
        if (contentItem.parent.isRoot) {
            this.resetWorkspace(workspace.id);
        }
        else {
            contentItem.remove();
        }
    }
    bundleWorkspace(workspaceId, type) {
        const workspace = store.getById(workspaceId);
        const contentConfigs = workspace.layout.root.contentItems.map((ci) => {
            var _a;
            return (_a = this._wrapperFactory.getContainerWrapper({ itemId: ci.config.id })) === null || _a === void 0 ? void 0 : _a.config;
        });
        const oldChild = workspace.layout.root.contentItems[0];
        const newChild = { type, content: contentConfigs, workspacesConfig: {} };
        workspace.layout.root.replaceChild(oldChild, newChild);
        const windowsInOldChild = oldChild.getItemsByType("component");
        const placementIdsOfWindowsInOldChild = windowsInOldChild.map((w) => idAsString(w.config.id));
        this.linkController.refreshLinks(placementIdsOfWindowsInOldChild);
    }
    bundleItem(itemId, type) {
        var _a;
        const oldChild = store.getContainer(itemId);
        if (!oldChild) {
            throw new Error(`Cannot find item ${itemId} to bundle it into a ${type}`);
        }
        if (oldChild.parent.type === type) {
            throw new Error(`Cannot bundle item ${itemId} to ${type} because its parent is a ${oldChild.parent.type}`);
        }
        const oldChildConfig = (_a = this._wrapperFactory.getContainerWrapper({ itemId })) === null || _a === void 0 ? void 0 : _a.config;
        const newChild = { type, content: [oldChildConfig], workspacesConfig: {} };
        oldChild.parent.replaceChild(oldChild, newChild);
        const windowsInOldChild = oldChild.getItemsByType("component");
        const placementIdsOfWindowsInOldChild = windowsInOldChild.map((w) => idAsString(w.config.id));
        this.linkController.refreshLinks(placementIdsOfWindowsInOldChild);
    }
    hideAddButton(workspaceId) {
        $(`#${getWorkspaceLayoutContainerId(workspaceId)}`).children(".add-button").hide();
    }
    showAddButton(workspaceId) {
        $(`#${getWorkspaceLayoutContainerId(workspaceId)}`).children(".add-button").show();
    }
    addWorkspace(id, config) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const stack = store.workspaceLayout.root.getItemsByFilter((ci) => ci.isStack)[0];
            const componentConfig = {
                componentName: this._configFactory.getWorkspaceLayoutComponentName(id),
                type: "component",
                workspacesConfig: Object.assign({}, config.workspacesOptions),
                id,
                noTabHeader: (_a = config === null || config === void 0 ? void 0 : config.workspacesOptions) === null || _a === void 0 ? void 0 : _a.noTabHeader,
                title: ((_b = config === null || config === void 0 ? void 0 : config.workspacesOptions) === null || _b === void 0 ? void 0 : _b.title) || this._configFactory.getWorkspaceTitle(this._stateResolver.getWorkspaceTitles())
            };
            let shouldActivateChild = true;
            if (componentConfig.noTabHeader === true) {
                shouldActivateChild = false;
            }
            else if (typeof config.workspacesOptions.selected === "boolean") {
                shouldActivateChild = config.workspacesOptions.selected;
            }
            this._layoutComponentsFactory.registerWorkspaceComponent(id);
            const index = (_c = config.workspacesOptions) === null || _c === void 0 ? void 0 : _c.positionIndex;
            (_d = config.workspacesOptions) === null || _d === void 0 ? true : delete _d.positionIndex;
            if (index < 0) {
                throw new Error(`Cannot place the workspace on index ${index} because its negative`);
            }
            const lastPinnedTabIndex = stack.header._getLastIndexOfPinnedTab();
            if (index <= lastPinnedTabIndex && !config.workspacesOptions.isPinned) {
                throw new Error(`Cannot place and unpinned workspace before the last pinned workspace at position ${lastPinnedTabIndex}`);
            }
            stack.addChild(componentConfig, index, shouldActivateChild);
            yield this.initWorkspaceContents(id, config, false);
            const workspaceContentItem = store.getWorkspaceContentItem(id);
            const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId: id, workspaceContentItem });
            if (wrapper.isPinned) {
                uiExecutor.waitForTransition(workspaceContentItem.tab.element[0]).then(() => {
                    this._tabObserver.refreshTabsMaxWidth(workspaceContentItem.parent.header.tabsContainer);
                });
            }
            this.setupContentLayouts(id);
        });
    }
    reinitializeWorkspace(id, config) {
        var _a, _b;
        const workspaceContentItem = store.getWorkspaceContentItem(id);
        store.removeLayout(id);
        if ((_a = config.workspacesOptions) === null || _a === void 0 ? void 0 : _a.reuseWorkspaceId) {
            // Making sure that the property doesn't leak in a workspace summary or a saved layout
            delete config.workspacesOptions.reuseWorkspaceId;
        }
        if ((_b = config.workspacesOptions) === null || _b === void 0 ? void 0 : _b.title) {
            this.setWorkspaceTitle(idAsString(workspaceContentItem.config.id), config.workspacesOptions.title);
        }
        this.hideAddButton(id);
        return this.initWorkspaceContents(id, config, false);
    }
    removeWorkspace(workspaceId) {
        const workspaceToBeRemoved = store.getWorkspaceLayoutItemById(workspaceId);
        if (!workspaceToBeRemoved) {
            throw new Error(`Could not find workspace to remove with id ${workspaceId}`);
        }
        if (store.getById(workspaceId)) {
            store.removeLayout(workspaceId);
        }
        store.removeById(workspaceId);
        workspaceToBeRemoved.remove();
    }
    resetWorkspace(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            workspace.hibernatedWindows = [];
            workspace.windows
                .filter((w) => w.appName || w.windowId)
                .forEach((w) => {
                const item = store.getWindowContentItem(w.id);
                if (item) {
                    this.emitter.raiseEvent("tab-close-requested", { item });
                }
            });
            const windowContentItems = workspace.layout.root.getItemsByType("component");
            windowContentItems.forEach((wci) => {
                wci.remove();
            });
            store.removeLayout(workspace.id);
            this.showAddButton(workspace.id);
        });
    }
    getDragElement() {
        const dragElement = $(".lm_dragProxy");
        return dragElement[0];
    }
    setDragElementSize(contentWidth, contentHeight) {
        const dragElement = this.getDragElement();
        if (!dragElement) {
            const observer = new MutationObserver((mutations) => {
                let targetElement;
                Array.from(mutations).forEach((m) => {
                    const newItems = $(m.addedNodes);
                    if (!targetElement) {
                        targetElement = newItems.find(".lm_dragProxy");
                    }
                });
                if (targetElement) {
                    observer.disconnect();
                    this.setDragElementSize(contentWidth, contentHeight);
                }
            });
            observer.observe($("body")[0], { childList: true, subtree: true });
        }
        else {
            dragElement.setAttribute("width", `${contentWidth}px`);
            dragElement.setAttribute("height", `${contentHeight}px`);
            const dragProxyContent = $(dragElement).children(".lm_content").children(".lm_item_container")[0];
            dragProxyContent.setAttribute("width", `${contentWidth}px`);
            dragProxyContent.setAttribute("height", `${contentHeight}px`);
            dragProxyContent.setAttribute("style", "");
        }
    }
    removeLayoutElement(windowId) {
        let resultLayout;
        store.layouts.filter((l) => l.layout).forEach((l) => {
            const elementToRemove = l.layout.root.getItemsById(windowId)[0];
            if (elementToRemove && l.windows.find((w) => w.id === windowId)) {
                l.windows = l.windows.filter((w) => w.id !== windowId);
                elementToRemove.remove();
                resultLayout = l;
            }
        });
        return resultLayout;
    }
    setWindowTitle(windowId, title) {
        const item = store.getWindowContentItem(windowId);
        if (!item) {
            throw new Error(`Could not find window ${windowId} to change its title to ${title}`);
        }
        item.setTitle(title);
        item.config.componentState.title = title;
        componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId: idAsString(item.config.id), title });
    }
    setWorkspaceTitle(workspaceId, title) {
        const item = store.getWorkspaceLayoutItemById(workspaceId);
        item.setTitle(title);
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId, title });
    }
    focusWindow(windowId) {
        const layoutWithWindow = store.getByWindowId(windowId);
        if (!layoutWithWindow) {
            throw new Error(`Could not find workspace for window ${windowId}`);
        }
        if (this._stateResolver.isWorkspaceHibernated(layoutWithWindow.id)) {
            throw new Error(`Could not focus window ${windowId} because the workspace ${layoutWithWindow.id} is hibernated`);
        }
        const item = layoutWithWindow.layout.root.getItemsById(windowId)[0];
        item.parent.setActiveContentItem(item);
    }
    focusWorkspace(workspaceId) {
        const item = store.getWorkspaceLayoutItemById(workspaceId);
        item.parent.setActiveContentItem(item);
    }
    maximizeWindow(windowId) {
        const layoutWithWindow = store.getByWindowId(windowId);
        if (!layoutWithWindow) {
            throw new Error(`Could not find workspace for window ${windowId}`);
        }
        if (this._stateResolver.isWorkspaceHibernated(layoutWithWindow.id)) {
            throw new Error(`Could not maximize window ${windowId} because the workspace ${layoutWithWindow.id} is hibernated`);
        }
        const item = layoutWithWindow.layout.root.getItemsById(windowId)[0];
        if (item.parent.hasId(this._maximizedId)) {
            return;
        }
        item.parent.layoutManager._$maximiseItem(item.parent);
        item.parent.isMaximized = item.parent.hasId("__glMaximised");
    }
    restoreWindow(windowId) {
        const layoutWithWindow = store.getByWindowId(windowId);
        if (!layoutWithWindow) {
            throw new Error(`Could not find workspace for window ${windowId}`);
        }
        if (this._stateResolver.isWorkspaceHibernated(layoutWithWindow.id)) {
            throw new Error(`Could not restore window ${windowId} because the workspace ${layoutWithWindow.id} is hibernated`);
        }
        const item = layoutWithWindow.layout.root.getItemsById(windowId)[0];
        if (item.parent.hasId(this._maximizedId)) {
            item.parent.layoutManager._$minimiseItem(item.parent);
            item.parent.isMaximized = item.parent.hasId("__glMaximised");
        }
    }
    maximizeContainer(itemId) {
        const contentItem = store.getContainer(itemId);
        if (!contentItem) {
            throw new Error(`Could not find item ${itemId} in frame ${this._frameId}`);
        }
        if (!contentItem.hasId("__glMaximised")) {
            contentItem.layoutManager._$maximiseItem(contentItem);
            contentItem.isMaximized = contentItem.hasId("__glMaximised");
        }
    }
    restoreContainer(itemId) {
        const contentItem = store.getContainer(itemId);
        if (!contentItem) {
            throw new Error(`Could not find item ${itemId} in frame ${this._frameId}`);
        }
        if (contentItem.hasId("__glMaximised")) {
            contentItem.layoutManager._$minimiseItem(contentItem);
            contentItem.isMaximized = contentItem.hasId("__glMaximised");
        }
    }
    showLoadedWindow(placementId, windowId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.waitForWindowContainer(placementId);
            const winContainer = store.getWindowContentItem(placementId);
            const workspace = store.getByWindowId(placementId);
            const winContainerConfig = winContainer.config;
            winContainerConfig.componentState.windowId = windowId;
            workspace.windows.find((w) => w.id === placementId).windowId = windowId;
            winContainer.parent.replaceChild(winContainer, winContainerConfig);
        });
    }
    isWindowVisible(placementId) {
        placementId = idAsString(placementId);
        const contentItem = store.getWindowContentItem(placementId);
        const parentStack = contentItem.parent;
        if (parentStack.contentItems.length === 1) {
            return true;
        }
        return parentStack.getActiveContentItem().config.id === placementId;
    }
    showHibernationIcon(workspaceId) {
        var _a;
        const tab = (_a = store.getWorkspaceContentItem(workspaceId)) === null || _a === void 0 ? void 0 : _a.tab;
        if (!tab) {
            return;
        }
        const saveButton = tab.element.children(".lm_saveButton");
        saveButton.addClass("lm_hibernationIcon");
        saveButton.attr("title", "hibernated");
    }
    showSaveIcon(workspaceId) {
        var _a;
        const tab = (_a = store.getWorkspaceContentItem(workspaceId)) === null || _a === void 0 ? void 0 : _a.tab;
        if (!tab) {
            console.error("Could not find the tab for", workspaceId);
            return;
        }
        const saveButton = tab.element.children(".lm_saveButton");
        saveButton.removeClass("lm_hibernationIcon");
        saveButton.attr("title", "save");
    }
    hideLoadingIndicator(itemId) {
        const windowContentItem = store.getWindowContentItem(itemId);
        if (windowContentItem === null || windowContentItem === void 0 ? void 0 : windowContentItem.tab) {
            const hibernationIcon = windowContentItem.tab.element[0].getElementsByClassName("lm_hibernationIcon")[0];
            hibernationIcon === null || hibernationIcon === void 0 ? void 0 : hibernationIcon.remove();
        }
    }
    refreshWorkspaceSize(workspaceId) {
        const workspaceContainer = document.getElementById(getWorkspaceLayoutContainerId(workspaceId));
        const workspace = store.getById(workspaceId);
        if (workspaceContainer && (workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
            const bounds = getElementBounds(workspaceContainer);
            workspace.layout.updateSize(bounds.width, bounds.height);
        }
    }
    resizeRow(workspace, rowItem, height) {
        const component = rowItem.getItemsByType("component")[0];
        const wspWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace });
        let heightToResize = height;
        if (wspWrapper.isSelected) {
            heightToResize = this.validateRowHeight(rowItem, height);
        }
        if (!heightToResize) {
            return;
        }
        if (typeof height === "number") {
            const stackHeaderSize = getRealHeight(component.parent.header.element);
            heightToResize -= stackHeaderSize;
        }
        this.resizeComponentCore(workspace, component, undefined, heightToResize);
    }
    resizeColumn(workspace, columnItem, width) {
        const component = columnItem.getItemsByType("component")[0];
        const wspWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace });
        let widthToResize = width;
        if (wspWrapper.isSelected) {
            widthToResize = this.validateColumnWidth(columnItem, width);
        }
        if (!widthToResize) {
            return;
        }
        this.resizeComponentCore(workspace, component, widthToResize);
    }
    resizeStack(workspace, stackItem, width, height) {
        const widthToResize = this.validateStackWidth(stackItem, width);
        let heightToResize = this.validateStackHeight(stackItem, height);
        const component = stackItem.getItemsByType("component")[0];
        if (typeof heightToResize === "number") {
            const stackHeaderSize = getRealHeight(component.parent.header.element);
            heightToResize -= stackHeaderSize;
        }
        this.resizeComponentCore(workspace, component, widthToResize, heightToResize);
    }
    resizeComponent(workspace, componentItem, width, height) {
        this.resizeComponentCore(workspace, componentItem, width, height);
    }
    togglePinWorkspace(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        if (workspaceWrapper.isPinned) {
            this.unpinWorkspace(workspaceId);
        }
        else {
            this.pinWorkspace(workspaceId, undefined);
        }
    }
    pinWorkspace(workspaceId, icon) {
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId, workspaceContentItem });
        const iconToUse = icon || wrapper.icon;
        if (!iconToUse) {
            throw new Error(`Workspace ${workspaceId} cannot be pinned because ${iconToUse} is an invalid icon`);
        }
        workspaceContentItem.tab.pin();
        if (icon) {
            wrapper.icon = icon;
        }
        uiExecutor.waitForTransition(workspaceContentItem.tab.element[0]).then(() => {
            this._tabObserver.refreshTabsMaxWidth(workspaceContentItem.parent.header.tabsContainer);
        });
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId, icon, isPinned: true });
    }
    unpinWorkspace(workspaceId) {
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        workspaceContentItem.tab.unpin();
        uiExecutor.waitForTransition(workspaceContentItem.tab.element[0]).then(() => {
            this._tabObserver.refreshTabsMaxWidth(workspaceContentItem.parent.header.tabsContainer);
        });
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId, isPinned: false });
    }
    hideWorkspaceRootItem(workspaceId) {
        uiExecutor.hideWorkspaceRootItem(workspaceId);
    }
    showWorkspaceRootItem(workspaceId) {
        uiExecutor.showWorkspaceRootItem(workspaceId, this._tabObserver);
    }
    refreshTabSizes(workspaceId) {
        var _a, _b, _c;
        const stacks = (_c = (_b = (_a = store.getById(workspaceId)) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.root.getItemsByType("stack")) !== null && _c !== void 0 ? _c : [];
        stacks.forEach((s) => { var _a; return (_a = s.header) === null || _a === void 0 ? void 0 : _a._updateTabSizesWithoutDropdown(); });
    }
    resizeComponentCore(workspace, componentItem, width, height) {
        var _a, _b;
        const widthToResize = this.validateComponentWidth(componentItem, width);
        const heightToResize = this.validateComponentHeight(componentItem, height);
        if (typeof widthToResize === "number") {
            let result;
            // Resizing twice to increase accuracy
            if ((workspace === null || workspace === void 0 ? void 0 : workspace.id) === ((_a = store.getActiveWorkspace()) === null || _a === void 0 ? void 0 : _a.id)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                result = componentItem.container.setSize(widthToResize, undefined);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                componentItem.container.setSize(widthToResize, undefined);
            }
            else {
                result = this.resizeWidthAndUpdateCache(componentItem, widthToResize);
                this.resizeWidthAndUpdateCache(componentItem, widthToResize);
            }
            if (!result) {
                throw new Error(`Failed to resize window ${componentItem.config.id} to ${widthToResize} width.
                 This is most likely caused by a missing row parent element - to change the width please make sure that there is a row element`);
            }
        }
        if (typeof heightToResize === "number") {
            let result;
            // Resizing twice to increase accuracy
            if ((workspace === null || workspace === void 0 ? void 0 : workspace.id) === ((_b = store.getActiveWorkspace()) === null || _b === void 0 ? void 0 : _b.id)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                result = componentItem.container.setSize(undefined, heightToResize);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                componentItem.container.setSize(undefined, heightToResize);
            }
            else {
                result = this.resizeHeightAndUpdateCache(componentItem, heightToResize);
                this.resizeHeightAndUpdateCache(componentItem, heightToResize);
            }
            if (!result) {
                throw new Error(`Failed to resize component ${componentItem.config.id} to ${heightToResize} height.
                     This is most likely caused by a missing column parent element - to change the height please make sure that there is a column element`);
            }
        }
    }
    resizeWidthAndUpdateCache(componentItem, widthToResize) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const result = componentItem.container.setSize(widthToResize, undefined);
        componentItem.config.workspacesConfig.cachedBounds.width = widthToResize;
        return result;
    }
    resizeHeightAndUpdateCache(componentItem, heightToResize) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const result = componentItem.container.setSize(undefined, heightToResize);
        componentItem.config.workspacesConfig.cachedBounds.height = heightToResize;
        return result;
    }
    validateRowHeight(item, height) {
        if (!height) {
            return;
        }
        const parent = item.parent;
        const parentMaxHeight = parent.getMaxHeight();
        const itemMaxHeight = item.getMaxHeight();
        const itemMinHeight = item.getMinHeight();
        const parentHeight = getElementBounds(parent.element).height;
        const neighboursMinHeights = parent.contentItems.filter((ci) => ci !== item).reduce((acc, ci) => {
            acc += ci.getMinHeight();
            return acc;
        }, 0);
        const maxHeightConstraintFromNeighbours = parentHeight - neighboursMinHeights;
        if (maxHeightConstraintFromNeighbours <= 0) {
            return;
        }
        const neighoursMaxHeights = parent.contentItems.filter((ci) => ci !== item).reduce((acc, ci) => {
            acc += ci.getMaxHeight();
            return acc;
        }, 0);
        const minHeightConstraintFromNeighbours = Math.max(parentHeight - neighoursMaxHeights, 0);
        const smallestMaxConstraint = Math.min(parentMaxHeight, itemMaxHeight, maxHeightConstraintFromNeighbours);
        const biggestMinConstraint = Math.max(minHeightConstraintFromNeighbours, itemMinHeight);
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, height), smallestMaxConstraint);
    }
    validateColumnWidth(item, width) {
        if (!width) {
            return;
        }
        const parent = item.parent;
        const parentMaxWidth = parent.getMaxWidth();
        const itemMaxWidth = item.getMaxWidth();
        const itemMinWidth = item.getMinWidth();
        const parentWidth = getElementBounds(parent.element).width;
        const neighboursMinWidths = parent.contentItems.filter((ci) => ci !== item).reduce((acc, ci) => {
            acc += ci.getMinWidth();
            return acc;
        }, 0);
        const maxWidthConstraintFromNeighbours = parentWidth - neighboursMinWidths;
        if (maxWidthConstraintFromNeighbours <= 0) {
            return;
        }
        const neighoursMaxWidths = parent.contentItems.filter((ci) => ci !== item).reduce((acc, ci) => {
            acc += ci.getMaxWidth();
            return acc;
        }, 0);
        const minWidthConstraintFromNeighbours = Math.max(parentWidth - neighoursMaxWidths, 0);
        const smallestMaxConstraint = Math.min(parentMaxWidth, itemMaxWidth, maxWidthConstraintFromNeighbours);
        const biggestMinConstraint = Math.max(minWidthConstraintFromNeighbours, itemMinWidth);
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, width), smallestMaxConstraint);
    }
    validateStackHeight(item, height) {
        if (!height) {
            return;
        }
        const itemMaxHeight = item.getMaxHeight();
        const itemMinHeight = item.getMinHeight();
        const smallestMaxConstraint = itemMaxHeight;
        const biggestMinConstraint = itemMinHeight;
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, height), smallestMaxConstraint);
    }
    validateStackWidth(item, width) {
        if (!width) {
            return;
        }
        const itemMaxWidth = item.getMaxWidth();
        const itemMinWidth = item.getMinWidth();
        const smallestMaxConstraint = itemMaxWidth;
        const biggestMinConstraint = itemMinWidth;
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, width), smallestMaxConstraint);
    }
    validateComponentHeight(item, height) {
        if (!height) {
            return;
        }
        const itemMaxHeight = item.getMaxHeight();
        const itemMinHeight = item.getMinHeight();
        const smallestMaxConstraint = itemMaxHeight;
        const biggestMinConstraint = itemMinHeight;
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, height), smallestMaxConstraint);
    }
    validateComponentWidth(item, width) {
        if (!width) {
            return;
        }
        const itemMaxWidth = item.getMaxWidth();
        const itemMinWidth = item.getMinWidth();
        const smallestMaxConstraint = itemMaxWidth;
        const biggestMinConstraint = itemMinWidth;
        if (smallestMaxConstraint < biggestMinConstraint) {
            return;
        }
        return Math.min(Math.max(biggestMinConstraint, width), smallestMaxConstraint);
    }
    initWorkspaceContents(id, config, useWorkspaceSpecificConfig) {
        if (!config || (config.type !== "component" && !config.content.length)) {
            store.addOrUpdate(id, []);
            this.showAddButton(id);
            return Promise.resolve();
        }
        const waitFor = createWaitFor(2);
        if (!config.settings) {
            config.settings = this._configFactory.getDefaultWorkspaceSettings();
        }
        if (config.type && config.type !== "workspace") {
            // Wrap the component in a column when you don't have a workspace;
            config = {
                settings: this._configFactory.getDefaultWorkspaceSettings(),
                content: [
                    config
                ]
            };
        }
        const workspaceContentItem = store.getWorkspaceContentItem(id);
        const optionsFromItem = workspaceContentItem.config.workspacesConfig;
        const optionsFromConfig = config.workspacesOptions;
        const mergedOptions = useWorkspaceSpecificConfig ? Object.assign({}, optionsFromItem, optionsFromConfig) : optionsFromConfig;
        if (typeof mergedOptions.selected === "boolean") {
            delete mergedOptions.selected;
        }
        workspaceContentItem.config.workspacesConfig = mergedOptions;
        config.workspacesOptions = mergedOptions;
        config.workspacesOptions.workspaceId = id;
        const factorySettings = componentStateMonitor.decoratedFactory.settings;
        if ((factorySettings === null || factorySettings === void 0 ? void 0 : factorySettings.splitterSize) !== undefined) {
            config.settings.splitterSize = factorySettings.splitterSize;
        }
        const layout = new GoldenLayout(config, $(`#${getWorkspaceLayoutContainerId(id)}`), componentStateMonitor.decoratedFactory);
        store.addOrUpdate(id, []);
        this._layoutComponentsFactory.registerEmptyWindowComponent(layout, id);
        getAllWindowsFromConfig(config.content).forEach((element) => {
            this._layoutComponentsFactory.registerWindowComponent(layout, idAsString(element.id));
        });
        const layoutContainer = $(`#${getWorkspaceLayoutContainerId(id)}`);
        let resizeAnimationFrameId;
        const resizeObserver = new ResizeObserver(() => {
            // Debounce using requestAnimationFrame to prevent ResizeObserver loop errors
            if (resizeAnimationFrameId) {
                cancelAnimationFrame(resizeAnimationFrameId);
            }
            resizeAnimationFrameId = requestAnimationFrame(() => {
                this.emitter.raiseEvent("workspace-container-resized", { workspaceId: id });
            });
        });
        resizeObserver.observe(layoutContainer[0]);
        layout.on("initialised", () => {
            const allWindows = getAllWindowsFromConfig(layout.toConfig().content);
            store.addOrUpdate(id, allWindows.map((w) => {
                const winContentItem = layout.root.getItemsById(idAsString(w.id))[0];
                const winElement = winContentItem.element;
                return {
                    id: idAsString(w.id),
                    bounds: getElementBounds(winElement),
                    windowId: w.componentState.windowId,
                };
            }), layout);
            this.emitter.raiseEvent("content-layout-init", { layout });
            const bounds = getElementBounds(layoutContainer);
            layout.updateSize(bounds.width, bounds.height);
            waitFor.signal();
        });
        layout.on("stateChanged", () => {
            this.emitter.raiseEvent("content-layout-state-changed", { layoutId: id });
        });
        layout.on("itemCreated", (item) => {
            var _a, _b;
            if (!item.isComponent) {
                if (item.isRoot) {
                    if (!item.id || !item.id.length) {
                        item.addId(id);
                    }
                    return;
                }
                if (!item.config.id || !item.config.id.length) {
                    item.addId(this._configFactory.getId());
                }
                if (item.type === "row" || item.type === "column" || item.type === "stack") {
                    item.on("maximized", () => {
                        this.emitter.raiseEvent("container-maximized", { container: item });
                    });
                    item.on("minimized", () => {
                        this.emitter.raiseEvent("container-restored", { container: item });
                    });
                }
            }
            else {
                item.on("size-changed", () => {
                    const windowWithChangedSize = store.getById(id).windows.find((w) => w.id === item.config.id);
                    if (windowWithChangedSize) {
                        windowWithChangedSize.bounds = getElementBounds(item.element);
                    }
                    const itemId = item.config.id;
                    this.emitter.raiseEvent("content-item-resized", { target: item.element[0], id: idAsString(itemId) });
                });
                if (item.config.componentName === EmptyVisibleWindowName || ((_a = item.parent) === null || _a === void 0 ? void 0 : _a.config.workspacesConfig.wrapper)) {
                    (_b = item.tab) === null || _b === void 0 ? void 0 : _b.header.position(false);
                }
            }
            this.emitter.raiseEvent("content-item-created", { workspaceId: id, item });
        });
        layout.on("itemDestroyed", (item) => {
            this.emitter.raiseEvent("content-item-removed", { workspaceId: id, item });
            if (item.type === "component") {
                this._layoutComponentsFactory.unregisterWindowComponent(layout, item.config.componentName);
            }
        });
        layout.on("stackCreated", (stack) => {
            const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem: stack });
            if (wrapper.showMaximizeButton === false) {
                this.hideMaximizeButton(stack, wrapper.id);
            }
            if (layout.config.workspacesOptions.showEjectButtons === false && wrapper.showEjectButton !== true) {
                this.hideEjectButton(stack, wrapper.id);
            }
            if (wrapper.showEjectButton === false) {
                this.hideEjectButton(stack, wrapper.id);
            }
            if (layout.config.workspacesOptions.showAddWindowButtons === false && wrapper.showAddWindowButton !== true) {
                this.hideAddWindowButton(stack, wrapper.id);
            }
            if (wrapper.showAddWindowButton === false) {
                this.hideAddWindowButton(stack, wrapper.id);
            }
            stack.on("activeContentItemChanged", () => {
                const activeItem = stack.getActiveContentItem();
                if (!activeItem.isComponent) {
                    return;
                }
                const clickedTabId = activeItem.config.id;
                const toFront = [{
                        id: idAsString(activeItem.config.id),
                        bounds: getElementBounds(activeItem.element),
                        windowId: activeItem.config.componentState.windowId,
                        appName: activeItem.config.componentState.appName,
                        url: activeItem.config.componentState.url,
                    }];
                const allTabsInTabGroup = stack.header.tabs.reduce((acc, t) => {
                    const contentItemConfig = t.contentItem.config;
                    if (contentItemConfig.type === "component") {
                        const win = {
                            id: idAsString(contentItemConfig.id),
                            bounds: getElementBounds(t.contentItem.element),
                            windowId: contentItemConfig.componentState.windowId,
                            appName: contentItemConfig.componentState.appName,
                            url: contentItemConfig.componentState.url,
                        };
                        acc.push(win);
                    }
                    return acc;
                }, []);
                const toBack = allTabsInTabGroup
                    .filter((t) => t.id !== clickedTabId);
                this.emitter.raiseEvent("tab-selection-changed", { item: activeItem });
                this.emitter.raiseEvent("selection-changed", { toBack, toFront });
            });
            stack.on("popoutRequested", () => {
                const activeItem = stack.getActiveContentItem();
                this.emitter.raiseEvent("eject-requested", { item: activeItem });
            });
        });
        layout.on("tabCreated", (tab) => {
            tab._dragListener.on("drag", () => {
                this.emitter.raiseEvent("tab-drag", { tab });
            });
            tab._dragListener.on("dragStart", () => {
                this.emitter.raiseEvent("tab-drag-start", { tab });
            });
            tab._dragListener.on("dragStop", () => {
                this.emitter.raiseEvent("tab-drag-end", { tab });
            });
            const initialIndexes = new Map();
            tab._dragListener.on("reorderStart", () => {
                initialIndexes.clear();
                tab.header.tabs.forEach((t, index) => {
                    initialIndexes.set(index, t);
                });
            });
            tab._dragListener.on("reorderStop", () => {
                tab.header.tabs.forEach((t, index) => {
                    if (initialIndexes.has(index) && initialIndexes.get(index) !== t) {
                        this.emitter.raiseEvent("tab-reordered", { item: t.contentItem });
                    }
                });
                initialIndexes.clear();
            });
            tab.element.on("mousedown", () => {
                this.emitter.raiseEvent("tab-element-mouse-down", { tab });
            });
            this.refreshTabSizeClass(tab);
            if (this._showLoadingIndicator && (tab === null || tab === void 0 ? void 0 : tab.contentItem.type) === "component" && !this._stateResolver.isWindowLoaded(tab.contentItem.config.id)) {
                const hibernationIcon = document.createElement("div");
                hibernationIcon.classList.add("lm_saveButton", "lm_hibernationIcon");
                tab.element[0].prepend(hibernationIcon);
            }
        });
        layout.on("tabCloseRequested", (tab) => {
            this.emitter.raiseEvent("tab-close-requested", { item: tab.contentItem });
        });
        layout.on("componentCreated", (component) => {
            const result = this.emitter.raiseEvent("content-component-created", { component, workspaceId: id });
            if (Array.isArray(result)) {
                Promise.all(result).then(() => {
                    waitFor.signal();
                }).catch((e) => waitFor.reject(e));
            }
            else {
                result.then(() => {
                    waitFor.signal();
                }).catch((e) => waitFor.reject(e));
            }
        });
        layout.on("activeContentItemChanged", (component) => {
            this.emitter.raiseEvent("workspace-global-selection-changed", { component, workspaceId: id });
        });
        layout.on("itemDropped", (item) => {
            this.emitter.raiseEvent("item-dropped", { item });
        });
        layout._ignorePinned = true;
        layout.init();
        return waitFor.promise.then(() => {
            layout._ignorePinned = false;
        });
    }
    initWorkspaceConfig(workspaceConfig) {
        return new Promise((res) => {
            workspaceConfig.settings.selectionEnabled = true;
            const factorySettings = componentStateMonitor.decoratedFactory.settings;
            if (factorySettings === null || factorySettings === void 0 ? void 0 : factorySettings.splitterSize) {
                workspaceConfig.settings.splitterSize = factorySettings.splitterSize;
            }
            store.workspaceLayout = new GoldenLayout(workspaceConfig, $(uiExecutor.getFrameLayoutContainer()), componentStateMonitor.decoratedFactory);
            let resizeAnimationFrameId;
            const outerResizeObserver = new ResizeObserver((entries) => {
                // Debounce using requestAnimationFrame to prevent ResizeObserver loop errors
                if (resizeAnimationFrameId) {
                    cancelAnimationFrame(resizeAnimationFrameId);
                }
                resizeAnimationFrameId = requestAnimationFrame(() => {
                    Array.from(entries).forEach((e) => {
                        this.emitter.raiseEvent("outer-layout-container-resized", { target: e.target });
                    });
                });
            });
            outerResizeObserver.observe($("#outter-layout-container")[0]);
            this.registerWorkspaceComponents(workspaceConfig);
            store.workspaceLayout.on("initialised", () => {
                this.emitter.raiseEvent("workspace-layout-initialised", {});
                const stack = store.workspaceLayout.root.getItemsByType("stack")[0];
                const tabs = stack.header.tabs;
                tabs.forEach((tab) => {
                    var _a, _b, _c;
                    const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace: undefined, workspaceContentItem: tab.contentItem });
                    if (wrapper.isPinned) {
                        uiExecutor.waitForTransition(tab.element[0]).then(() => {
                            this._tabObserver.refreshTabsMaxWidth(tab.contentItem.parent.header.tabsContainer);
                        });
                    }
                    if ((_c = (_b = (_a = tab.contentItem) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.workspacesConfig) === null || _c === void 0 ? void 0 : _c.selected) {
                        delete tab.contentItem.config.workspacesConfig.selected;
                    }
                });
                res();
            });
            store.workspaceLayout.on("stackCreated", (stack) => {
                const closeButton = stack.header.controlsContainer.children(".lm_close")[0];
                if (closeButton) {
                    closeButton.onclick = () => {
                        this.emitter.raiseEvent("close-frame", {});
                    };
                }
                const headerElement = stack.header.element[0];
                const mutationObserver = new MutationObserver(() => {
                    const addButton = this.getElementByClass(headerElement, "lm_add_button");
                    if (addButton && componentStateMonitor.decoratedFactory.createAddWorkspace) {
                        addButton.onclick = (e) => {
                            e.stopPropagation();
                            this.emitter.raiseEvent("workspace-add-button-clicked", { bounds: getElementBounds(addButton) });
                        };
                    }
                });
                const observerConfig = { attributes: false, childList: true, subtree: true };
                mutationObserver.observe(stack.header.element[0], observerConfig);
                stack.on("activeContentItemChanged", () => __awaiter(this, void 0, void 0, function* () {
                    if (store.workspaceIds.length === 0) {
                        return;
                    }
                    const activeItem = stack.getActiveContentItem();
                    const activeWorkspaceId = activeItem.config.id;
                    yield this.waitForLayout(idAsString(activeWorkspaceId));
                    // don't ignore the windows from the currently selected workspace because the event
                    // which adds the workspacesFrame hasn't still added the new workspace and the active item status the last tab
                    const allOtherWindows = store.workspaceIds.reduce((acc, id) => {
                        return [...acc, ...store.getById(id).windows];
                    }, []);
                    const toBack = allOtherWindows;
                    this.emitter.raiseEvent("workspace-selection-changed", { workspace: store.getById(activeWorkspaceId), toBack });
                }));
            });
            store.workspaceLayout.on("itemCreated", (item) => {
                if (item.isComponent) {
                    item.on("size-changed", () => {
                        this.emitter.raiseEvent("workspace-content-container-resized", { target: item, id: idAsString(item.config.id) });
                        this.emitter.raiseEventWithDynamicName(`workspace-content-container-resized-${item.config.id}`, item);
                    });
                    item.container.on("hide", () => {
                        this.emitter.raiseEvent("will-hide-workspace-tab", { workspaceId: idAsString(item.config.id) });
                    });
                }
            });
            store.workspaceLayout.on("tabCreated", (tab) => {
                this.refreshTabSizeClass(tab);
                const initialIndexes = new Map();
                tab._dragListener.on("reorderStart", () => {
                    initialIndexes.clear();
                    tab.header.tabs.forEach((t, index) => {
                        initialIndexes.set(index, t);
                    });
                });
                tab._dragListener.on("reorderStop", () => {
                    store.syncWorkspaceOrder();
                    tab.header.tabs.forEach((t, index) => {
                        if (initialIndexes.has(index) && initialIndexes.get(index) !== t) {
                            const workspace = store.getById(t.contentItem.config.id);
                            this.emitter.raiseEvent("workspace-tab-reordered", { workspace });
                        }
                    });
                    initialIndexes.clear();
                });
            });
            store.workspaceLayout.on("tabCloseRequested", (tab) => {
                this.emitter.raiseEvent("workspace-tab-close-requested", { workspace: store.getById(tab.contentItem.config.id) });
            });
            store.workspaceLayout.on("itemDestroyed", (item) => {
                if (item.type === "component") {
                    this._layoutComponentsFactory.unregisterWorkspaceComponent(item.config.componentName);
                }
            });
            store.workspaceLayout.on("itemDestroyed", (item) => {
                this.emitter.raiseEvent("workspace-tab-destroyed", { workspaceId: idAsString(item.config.id) });
            });
            store.workspaceLayout.init();
        });
    }
    reinitWorkspaceConfig(config) {
        const stackConfig = config.content[0];
        if (stackConfig.type !== "stack") {
            throw new Error(`Cannot reinitialize the frame with config ${JSON.stringify(config)}`);
        }
        this.registerWorkspaceComponents(config);
        const outerWorkspaceStack = store.workspaceLayout.root.getItemsByType("stack")[0];
        outerWorkspaceStack.replaceChildren(stackConfig.content);
    }
    setupOuterLayout() {
        this.emitter.onOuterLayoutContainerResized((target) => {
            const bounds = getElementBounds(target);
            store.workspaceLayout.updateSize(bounds.width, bounds.height);
        });
    }
    setupContentLayouts(id) {
        const unsub = this.emitter.onContentContainerResized((item) => {
            var _a;
            const currLayout = (_a = store.getById(id)) === null || _a === void 0 ? void 0 : _a.layout;
            if (currLayout) {
                // The size must be passed in order to handle resizes like maximize of the browser
                const containerElement = $(`#${getWorkspaceLayoutContainerId(id)}`);
                const bounds = getElementBounds(containerElement[0]);
                currLayout.updateSize(bounds.width, bounds.height);
            }
        }, id);
        const workspaceDestroyedUnsub = this.emitter.onWorkspaceTabDestroyed((workspaceId) => {
            if (workspaceId === id) {
                unsub();
                workspaceDestroyedUnsub();
            }
        });
    }
    waitForLayout(id) {
        return new Promise((res) => {
            const unsub = this.emitter.onContentLayoutInit((layout) => {
                if (layout.root.config.id === id) {
                    res();
                    unsub();
                }
            });
            if (store.getById(id)) {
                res();
                unsub();
            }
        });
    }
    waitForWindowContainer(placementId) {
        return new Promise((res) => {
            const unsub = this.emitter.onContentComponentCreated((component) => {
                if (component.config.id === placementId) {
                    res();
                    unsub();
                }
            });
            if (store.getWindowContentItem(placementId)) {
                res();
                unsub();
            }
        });
    }
    getWindowInfoFromConfig(config) {
        if (config.type !== "component") {
            return this.getWindowInfoFromConfig(config.content[0]);
        }
        return {
            placementId: idAsString(config.id),
            windowId: config.componentState.windowId,
            appName: config.componentState.appName,
            url: config.componentState.url
        };
    }
    refreshLayoutSize() {
        const bounds = uiExecutor.getFrameLayoutContainerBounds();
        store.workspaceLayout.updateSize(bounds.width, bounds.height);
    }
    refreshTabSizeClass(tab) {
        const tabs = tab.header.tabs;
        const haveClassSmall = tabs.map((t) => t.element).some((e) => e.hasClass("lm_tab_small"));
        const haveClassMini = tabs.map((t) => t.element).some((e) => e.hasClass("lm_tab_mini"));
        if (haveClassSmall) {
            tab.element.addClass("lm_tab_small");
        }
        if (haveClassMini) {
            tab.element.addClass("lm_tab_mini");
        }
    }
    getElementByClass(root, className) {
        const elements = root.getElementsByClassName(className);
        if (elements.length > 1) {
            throw new Error(`Multiple elements with class ${className} in element with id ${root.id} and class ${root.className} are not supported`);
        }
        return elements[0];
    }
    applyLockConfig(itemConfig, parent, workspaceWrapper, isParentWorkspace) {
        var _a, _b, _c, _d, _e;
        const parentAllowDrop = isParentWorkspace ? workspaceWrapper.allowDrop : parent.config.workspacesConfig.allowDrop;
        const parentAllowSplitters = isParentWorkspace ? workspaceWrapper.allowSplitters : parent.config.workspacesConfig.allowSplitters;
        if (itemConfig.type === "stack") {
            if (typeof itemConfig.workspacesConfig.allowDrop === "undefined") {
                itemConfig.workspacesConfig.allowDrop = (_a = itemConfig.workspacesConfig.allowDrop) !== null && _a !== void 0 ? _a : parentAllowDrop;
            }
            if (typeof itemConfig.workspacesConfig.allowExtract === "undefined") {
                const parentAllowExtract = workspaceWrapper.allowExtract;
                itemConfig.workspacesConfig.allowExtract = (_b = itemConfig.workspacesConfig.allowExtract) !== null && _b !== void 0 ? _b : parentAllowExtract;
            }
            if (typeof itemConfig.workspacesConfig.allowReorder === "undefined") {
                const parentAllowReorder = workspaceWrapper.allowWindowReorder;
                itemConfig.workspacesConfig.allowReorder = (_c = itemConfig.workspacesConfig.allowReorder) !== null && _c !== void 0 ? _c : parentAllowReorder;
            }
            if (typeof itemConfig.workspacesConfig.showAddWindowButton === "undefined") {
                itemConfig.workspacesConfig.showAddWindowButton = workspaceWrapper.showAddWindowButtons;
            }
            if (typeof itemConfig.workspacesConfig.showEjectButton === "undefined") {
                itemConfig.workspacesConfig.showEjectButton = workspaceWrapper.showEjectButtons;
            }
        }
        else if (itemConfig.type === "row" || itemConfig.type === "column") {
            if (typeof itemConfig.workspacesConfig.allowDrop === "undefined") {
                itemConfig.workspacesConfig.allowDrop = (_d = itemConfig.workspacesConfig.allowDrop) !== null && _d !== void 0 ? _d : parentAllowDrop;
            }
            if (typeof itemConfig.workspacesConfig.allowSplitters === "undefined") {
                itemConfig.workspacesConfig.allowSplitters = (_e = itemConfig.workspacesConfig.allowSplitters) !== null && _e !== void 0 ? _e : parentAllowSplitters;
            }
        }
        else if (itemConfig.type === "component") {
            if (typeof itemConfig.workspacesConfig.allowExtract === "undefined") {
                const parentAllowExtract = isParentWorkspace ? workspaceWrapper.allowExtract : parent.config.workspacesConfig.allowExtract;
                itemConfig.workspacesConfig.allowExtract = parentAllowExtract;
            }
            if (typeof itemConfig.workspacesConfig.allowReorder === "undefined") {
                const parentAllowReorder = isParentWorkspace ? workspaceWrapper.allowWindowReorder : parent.config.workspacesConfig.allowReorder;
                itemConfig.workspacesConfig.allowReorder = parentAllowReorder;
            }
            if (typeof itemConfig.workspacesConfig.showCloseButton === "undefined") {
                itemConfig.workspacesConfig.showWindowCloseButtons = workspaceWrapper.showWindowCloseButtons;
            }
        }
    }
    registerWorkspaceComponents(workspaceConfig) {
        workspaceConfig.content[0].content.forEach((configObj) => {
            const workspaceId = configObj.id;
            this._layoutComponentsFactory.registerWorkspaceComponent(idAsString(workspaceId));
        });
    }
    hideMaximizeButton(stack, groupId) {
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({ groupId, maximize: { visible: false }, restore: { visible: false } });
    }
    hideEjectButton(stack, groupId) {
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({ groupId, eject: { visible: false } });
    }
    hideAddWindowButton(stack, groupId) {
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({ groupId, addWindow: { visible: false } });
        componentStateMonitor.decoratedFactory.updateAfterGroupTabs({ groupId, addWindow: { visible: false } });
    }
}

class LayoutEventEmitter {
    constructor(registry) {
        this._registry = registry;
    }
    onWorkspaceLayoutInit(callback) {
        return this._registry.add("workspace-layout-initialised", callback);
    }
    onContentLayoutInit(callback) {
        return this._registry.add("content-layout-init", callback);
    }
    onOuterLayoutContainerResized(callback) {
        return this._registry.add("outer-layout-container-resized", callback);
    }
    onContentContainerResized(callback, id) {
        if (id) {
            return this._registry.add(`workspace-content-container-resized-${id}`, callback);
        }
        return this._registry.add("workspace-content-container-resized", callback);
    }
    onWorkspaceContainerResized(callback) {
        return this._registry.add("workspace-container-resized", callback);
    }
    onContentItemResized(callback) {
        return this._registry.add("content-item-resized", callback);
    }
    onContentComponentCreated(callback) {
        return this._registry.add("content-component-created", callback);
    }
    onFrameCloseRequested(callback) {
        return this._registry.add("close-frame", callback);
    }
    onRestoreRequested(callback) {
        return this._registry.add("restore-frame", callback);
    }
    onMaximizeRequested(callback) {
        return this._registry.add("maximize-frame", callback);
    }
    onMinimizeRequested(callback) {
        return this._registry.add("minimize-frame", callback);
    }
    onMoveAreaChanged(callback) {
        return this._registry.add("move-area-changed", callback);
    }
    onTabCloseRequested(callback) {
        return this._registry.add("tab-close-requested", callback);
    }
    onTabDragStart(callback) {
        return this._registry.add("tab-drag-start", callback);
    }
    onTabDrag(callback) {
        return this._registry.add("tab-drag", callback);
    }
    onTabDragEnd(callback) {
        return this._registry.add("tab-drag-end", callback);
    }
    onTabElementMouseDown(callback) {
        return this._registry.add("tab-element-mouse-down", callback);
    }
    onSelectionChanged(callback) {
        return this._registry.add("selection-changed", callback);
    }
    onWorkspaceAdded(callback) {
        return this._registry.add("workspace-added", callback);
    }
    onWorkspaceSelectionChanged(callback) {
        return this._registry.add("workspace-selection-changed", callback);
    }
    onWorkspaceTabCloseRequested(callback) {
        return this._registry.add("workspace-tab-close-requested", callback);
    }
    onAddButtonClicked(callback) {
        return this._registry.add("add-button-clicked", callback);
    }
    onContentLayoutStateChanged(callback) {
        return this._registry.add("content-layout-state-changed", callback);
    }
    onContentItemCreated(callback) {
        return this._registry.add("content-item-created", callback);
    }
    onWorkspaceAddButtonClicked(callback) {
        return this._registry.add("workspace-add-button-clicked", callback);
    }
    onWorkspaceSaveRequested(callback) {
        return this._registry.add("workspace-save-requested", callback);
    }
    onContainerMaximized(callback) {
        return this._registry.add("container-maximized", callback);
    }
    onContainerRestored(callback) {
        return this._registry.add("container-restored", callback);
    }
    onEjectRequested(callback) {
        return this._registry.add("eject-requested", callback);
    }
    onComponentSelectedInWorkspace(callback) {
        return this._registry.add("workspace-global-selection-changed", callback);
    }
    onItemDropped(callback) {
        return this._registry.add("item-dropped", callback);
    }
    onContentItemRemoved(callback) {
        return this._registry.add("content-item-removed", callback);
    }
    onWorkspaceLockConfigurationChanged(callback) {
        return this._registry.add("workspace-lock-configuration-changed", callback);
    }
    onContainerLockConfigurationChanged(callback) {
        return this._registry.add("container-lock-configuration-changed", callback);
    }
    onWindowLockConfigurationChanged(callback) {
        return this._registry.add("window-lock-configuration-changed", callback);
    }
    onWillHideWorkspaceTab(callback) {
        return this._registry.add("will-hide-workspace-tab", callback);
    }
    onWorkspaceTabDestroyed(callback) {
        return this._registry.add("workspace-tab-destroyed", callback);
    }
    onTabSelectionChanged(callback) {
        return this._registry.add("tab-selection-changed", callback);
    }
    onWorkspaceTabReorder(callback) {
        return this._registry.add("workspace-tab-reordered", callback);
    }
    onTabReorder(callback) {
        return this._registry.add("tab-reordered", callback);
    }
    raiseEvent(name, data) {
        const result = this._registry.execute(name, ...Object.values(data));
        if ((Array.isArray(result) && result.some((r) => r && r.then)) ||
            (result && !Array.isArray(result) && result.then)) {
            return result;
        }
        return Promise.resolve(result);
    }
    raiseEventWithDynamicName(name, ...args) {
        this._registry.execute(name, ...args);
    }
}

class IFrameController {
    constructor(glue, platformCommunicator) {
        this._registry = registryFactory();
        this._idToFrame = {};
        this._glue = glue;
        this._platformCommunicator = platformCommunicator;
    }
    startFrame(id, url, layoutState, windowId, appName) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.startCore(id, url, layoutState, windowId, appName);
        });
    }
    moveFrame(id, bounds) {
        const frame = this._idToFrame[id];
        const jFrame = $(frame);
        if (bounds.width !== 0 && bounds.height !== 0) {
            jFrame.css("top", `${bounds.top}px`);
            jFrame.css("left", `${bounds.left}px`);
        }
        jFrame.css("width", `${bounds.width}px`);
        jFrame.css("height", `${bounds.height}px`);
    }
    // The windows which are send to the back must be first
    selectionChanged(toFront, toBack) {
        toBack.forEach(id => {
            $(this._idToFrame[id]).css("z-index", "-1");
        });
        toFront.forEach(id => {
            if ($(this._idToFrame[id]).hasClass("maximized-active-tab")) {
                $(this._idToFrame[id]).css("z-index", this.getMaximizedFrameZIndex());
            }
            else {
                $(this._idToFrame[id]).css("z-index", "19");
            }
        });
    }
    maximizeTab(id) {
        $(this._idToFrame[id]).addClass("maximized-active-tab");
    }
    restoreTab(id) {
        $(this._idToFrame[id]).removeClass("maximized-active-tab");
    }
    selectionChangedDeep(toFront, toBack) {
        toBack.forEach(id => {
            // The numbers is based on the z index of golden layout elements
            $(this._idToFrame[id]).css("z-index", "-1");
        });
        toFront.forEach(id => {
            if ($(this._idToFrame[id]).hasClass("maximized-active-tab")) {
                // The numbers is based on the z index of golden layout elements
                $(this._idToFrame[id]).css("z-index", "42");
            }
            else {
                // The numbers is based on the z index of golden layout elements
                $(this._idToFrame[id]).css("z-index", "19");
            }
        });
    }
    bringToFront(id) {
        // Z index is this high to guarantee top most position
        $(this._idToFrame[id]).css("z-index", "999");
    }
    remove(id) {
        const frame = this._idToFrame[id];
        if (!frame) {
            return;
        }
        delete this._idToFrame[id];
        frame.remove();
        this._registry.execute("frame-removed", id);
    }
    onFrameLoaded(callback) {
        return this._registry.add("frameLoaded", callback);
    }
    onFrameRemoved(callback) {
        return this._registry.add("frame-removed", callback);
    }
    onFrameContentClicked(callback) {
        return this._registry.add("frame-content-clicked", callback);
    }
    onWindowTitleChanged(callback) {
        return this._registry.add("window-title-changed", callback);
    }
    hasFrame(id) {
        return !!this._idToFrame[id];
    }
    getWindowId(id) {
        if (!this.hasFrame(id)) {
            return undefined;
        }
        return this._idToFrame[id].name.split("#wsp")[0];
    }
    getWindowIdByWindow(w) {
        const frame = Object.values(this._idToFrame).find((f) => f.contentWindow === w);
        if (!frame) {
            return undefined;
        }
        return frame.name.split("#wsp")[0];
    }
    startCore(id, url, layoutState, windowId, appName) {
        return __awaiter(this, void 0, void 0, function* () {
            windowId = windowId || generateWindowId();
            if (this._idToFrame[id]) {
                return this._idToFrame[id];
            }
            if (!url) {
                throw new Error(`The url of window with itemId ${id} is undefined`);
            }
            const frame = document.createElement("iframe");
            frame.name = `${windowId}#wsp`;
            frame.loading = "lazy";
            frame.style.top = "30000px";
            frame.style.width = "30000px";
            frame.style.width = "0px";
            frame.style.height = "0px";
            frame.src = url;
            const sandboxing = yield this.getSandboxSettingsForApp(appName);
            if (sandboxing) {
                frame.setAttribute("sandbox", sandboxing.flags);
            }
            const permissionsPolicy = yield this.getPermissionsPolicyForApp(appName);
            if (permissionsPolicy) {
                frame.setAttribute("allow", permissionsPolicy.flags);
            }
            document.body.appendChild(frame);
            this._registry.execute("frameLoaded", id);
            frame.setAttribute("id", id);
            $(frame).css("position", "absolute");
            this._idToFrame[id] = frame;
            yield this.waitForWindow(windowId);
            return frame;
        });
    }
    waitForWindow(windowId) {
        return new Promise((res, rej) => {
            let unsub = () => {
                // safety
            };
            const timeout = setTimeout(() => {
                rej(`Window with id ${windowId} did not appear in 5000ms`);
                unsub();
            }, 5000);
            unsub = this._glue.windows.onWindowAdded((w) => {
                if (w.id === windowId) {
                    unsub();
                    res();
                    clearTimeout(timeout);
                }
            });
            const glueWindow = this._glue.windows.list().find((w) => w.id === windowId);
            if (glueWindow) {
                res();
                unsub();
                clearTimeout(timeout);
            }
        });
    }
    getMaximizedFrameZIndex() {
        return "42";
    }
    getSandboxSettingsForApp(appName) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const systemConfig = yield this._platformCommunicator.askForSettings();
            const systemSandboxing = systemConfig.iframeSandbox;
            if (!appName) {
                return systemSandboxing;
            }
            const app = this._glue.appManager.application(appName);
            return ((_b = (_a = app === null || app === void 0 ? void 0 : app.userProperties) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.workspacesSandbox) || systemSandboxing;
        });
    }
    getPermissionsPolicyForApp(appName) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const systemConfig = yield this._platformCommunicator.askForSettings();
            const systemPermissionsPolicy = systemConfig.iframePermissionsPolicy;
            if (!appName) {
                return systemPermissionsPolicy;
            }
            const app = this._glue.appManager.application(appName);
            return ((_b = (_a = app === null || app === void 0 ? void 0 : app.userProperties) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.iframePermissionsPolicy) || systemPermissionsPolicy;
        });
    }
}

class Storage {
    constructor() {
        this.LAST_SESSION_KEY = "g42_workspace_frame_cache";
    }
    get(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }
    set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
}
var storage = new Storage();

class StartupReader {
    get config() {
        return this._config;
    }
    loadConfig() {
        const urlParams = new URLSearchParams(window.location.search);
        const emptyFrameParam = urlParams.get(EmptyFrameQueryParam);
        const disableCustomButtons = urlParams.get(DisableCustomButtonsQueryParam);
        const workspaceNameParam = urlParams.get(WorkspaceNameQueryParam);
        const workspaceNamesParam = urlParams.get(WorkspaceNamesQueryParam);
        const contextParam = urlParams.get(ContextQueryParam);
        const buildParam = urlParams.get(BuildQueryParam);
        let workspaceNamesArr = [];
        let context;
        try {
            workspaceNamesArr = JSON.parse(workspaceNamesParam) || workspaceNamesArr;
        }
        catch (error) {
            // do nothing
        }
        try {
            context = JSON.parse(contextParam);
        }
        catch (error) {
            // do nothing
        }
        if (workspaceNameParam) {
            workspaceNamesArr.push(workspaceNameParam);
        }
        const result = {
            emptyFrame: emptyFrameParam != null && emptyFrameParam !== undefined,
            disableCustomButtons: disableCustomButtons != null && disableCustomButtons !== undefined,
            workspaceNames: workspaceNamesArr,
            context,
            build: buildParam !== null && buildParam !== undefined
        };
        this._config = result;
        this.cleanUpUrl();
        return result;
    }
    cleanUpUrl() {
        const cleanedSearch = this.removeQueryParams(window.location.search, [EmptyFrameQueryParam]);
        const hash = window.location.hash || "";
        const newUrl = window.location.origin + window.location.pathname + cleanedSearch + hash;
        window.history.replaceState(null, document.title, newUrl);
    }
    removeQueryParams(search, params) {
        params.forEach((p) => {
            const queryParams = new URLSearchParams(search);
            const value = queryParams.get(p);
            const containsKey = Array.from(queryParams.keys()).indexOf(p) > -1;
            if (containsKey) {
                search = search.replace(`${p}=${value}`, "");
            }
        });
        if (search[search.length - 1] === "&") {
            search = search.substr(0, search.length - 1);
        }
        search = search.replace("&&", "&");
        search = search.replace("?&", "?");
        return search === "?" ? "" : search;
    }
}
var startupReader = new StartupReader();

class LayoutsManager {
    constructor(resolver, _glue, _configFactory, _configConverter, _constraintsValidator, _platformCommunicator) {
        this.resolver = resolver;
        this._glue = _glue;
        this._configFactory = _configFactory;
        this._configConverter = _configConverter;
        this._constraintsValidator = _constraintsValidator;
        this._platformCommunicator = _platformCommunicator;
        this._layoutsType = "Workspace";
        this._layoutComponentType = "Workspace";
    }
    getInitialConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // Preset initial config
            if (this._initialWorkspaceConfig) {
                return this._configFactory.generateInitialConfig(this._initialWorkspaceConfig);
            }
            const startupConfig = startupReader.config;
            // From workspace names
            if (startupConfig.workspaceNames && startupConfig.workspaceNames.length) {
                const workspaceLayoutData = yield Promise.all(startupConfig.workspaceNames.map((name) => __awaiter(this, void 0, void 0, function* () {
                    return (yield this.getWorkspaceByName(name));
                })));
                const workspaceConfigs = workspaceLayoutData.map(wld => {
                    wld.config.workspacesOptions = wld.config.workspacesOptions || {};
                    wld.config.workspacesOptions.context = wld.layoutData.context;
                    return wld.config;
                });
                const validConfigs = workspaceConfigs.filter((wc) => wc);
                if (validConfigs.length) {
                    validConfigs.forEach((c, i) => {
                        c.id = this._configFactory.getId();
                        c.workspacesOptions = c.workspacesOptions || {};
                        if (startupConfig.context && c.workspacesOptions.context) {
                            c.workspacesOptions.context = Object.assign(c.workspacesOptions.context, startupConfig.context);
                        }
                        else if (startupConfig.context) {
                            c.workspacesOptions.context = startupConfig.context;
                        }
                        c.workspacesOptions.layoutName = startupConfig.workspaceNames[i];
                    });
                    return this._configFactory.generateInitialConfig(validConfigs);
                }
            }
            else if (!((_a = startupReader.config) === null || _a === void 0 ? void 0 : _a.build)) { // Last session
                const workspaceConfigs = this.getLastSession();
                if (workspaceConfigs && workspaceConfigs.length) {
                    workspaceConfigs.forEach((wc) => {
                        if (wc) {
                            wc.id = this._configFactory.getId();
                        }
                    });
                    return this._configFactory.generateInitialConfig(workspaceConfigs);
                }
            }
            // Default
            return this._configFactory.getDefaultFrameConfig(this.resolver.getWorkspaceTitles());
        });
    }
    getLastSession() {
        var _a;
        const workspacesFrameCache = (_a = this._platformCommunicator.platformConfig.workspacesFrameCache) !== null && _a !== void 0 ? _a : true;
        if (!workspacesFrameCache) {
            return;
        }
        const workspacesFrame = storage.get(storage.LAST_SESSION_KEY) || [];
        const rendererFriendlyFrameConfig = workspacesFrame.filter((wc) => wc).map((wc) => {
            this.addWorkspaceIds(wc);
            // this.addWindowIds(wc);
            return this._configConverter.convertToRendererConfig(wc);
        });
        return rendererFriendlyFrameConfig;
    }
    getSavedWorkspaceNames() {
        return __awaiter(this, void 0, void 0, function* () {
            const allLayouts = yield this._glue.layouts.getAll(this._layoutsType);
            const workspaceLayouts = allLayouts.filter((l) => l.type === this._layoutsType);
            return workspaceLayouts.map((wl) => wl.name);
        });
    }
    export() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._glue.layouts.export(this._layoutsType);
        });
    }
    getWorkspaceByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const savedWorkspaceLayout = yield this._glue.layouts.get(name, this._layoutsType);
            const savedWorkspace = savedWorkspaceLayout.components[0].state;
            this._constraintsValidator.fixWorkspace(savedWorkspace);
            const rendererFriendlyConfig = this._configConverter.convertToRendererConfig(savedWorkspace);
            // If a positionIndex is present in the layout it should be ignored
            (_a = rendererFriendlyConfig === null || rendererFriendlyConfig === void 0 ? void 0 : rendererFriendlyConfig.workspacesOptions) === null || _a === void 0 ? true : delete _a.positionIndex;
            this.addWorkspaceIds(rendererFriendlyConfig);
            return {
                config: rendererFriendlyConfig,
                layoutData: {
                    metadata: savedWorkspaceLayout.metadata,
                    name,
                    context: (_b = savedWorkspace.context) !== null && _b !== void 0 ? _b : {}
                }
            };
        });
    }
    delete(name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._glue.layouts.remove(this._layoutsType, name);
        });
    }
    save(options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const { workspace, name, saveContext } = options;
            if (!workspace.layout && !workspace.hibernateConfig) {
                throw new Error("An empty layout cannot be saved");
            }
            (((_a = workspace.layout) === null || _a === void 0 ? void 0 : _a.config) || workspace.hibernateConfig).workspacesOptions.name = name;
            const workspaceConfig = yield this.saveWorkspaceCore(workspace, name, options);
            // Its superfluous to add the title to the layout since its never used
            if (workspaceConfig.config.title) {
                delete workspaceConfig.config.title;
            }
            workspaceConfig.config.allowMultiple = (_b = options.allowMultiple) !== null && _b !== void 0 ? _b : true;
            let workspaceContext = undefined;
            if (saveContext) {
                try {
                    workspaceContext = yield this.getWorkspaceContext(workspace.id);
                }
                catch (error) {
                    // can throw an exception when reloading
                }
            }
            const layoutToImport = {
                name,
                type: this._layoutsType,
                metadata: (_c = options.metadata) !== null && _c !== void 0 ? _c : {},
                components: [{
                        type: this._layoutComponentType,
                        state: {
                            children: workspaceConfig.children,
                            config: workspaceConfig.config,
                            context: workspaceContext !== null && workspaceContext !== void 0 ? workspaceContext : {}
                        }
                    }]
            };
            try {
                yield this._glue.layouts.import([layoutToImport], "merge");
            }
            catch (error) {
                console.error(error);
                throw error;
            }
            return layoutToImport;
        });
    }
    generateLayout(name, workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!workspace.layout) {
                throw new Error("An empty layout cannot be generated");
            }
            workspace.layout.config.workspacesOptions.name = name;
            const workspaceConfig = yield this.saveWorkspaceCore(workspace, name);
            // Its superfluous to add the title to the layout since its never used
            if (workspaceConfig.config.title) {
                delete workspaceConfig.config.title;
            }
            return {
                name,
                type: this._layoutsType,
                metadata: {},
                components: [{
                        type: this._layoutComponentType, state: {
                            children: workspaceConfig.children,
                            config: workspaceConfig.config,
                            context: {}
                        }
                    }]
            };
        });
    }
    saveWorkspacesFrame(workspaces) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const workspacesFrameCache = (_b = (_a = this._platformCommunicator.platformConfig) === null || _a === void 0 ? void 0 : _a.workspacesFrameCache) !== null && _b !== void 0 ? _b : true;
            if (!workspacesFrameCache) {
                return;
            }
            const configPromises = workspaces.map((w) => {
                return this.saveWorkspaceCoreSync(w);
            });
            const configs = yield Promise.all(configPromises);
            storage.set(storage.LAST_SESSION_KEY, configs);
        });
    }
    setInitialWorkspaceConfig(config) {
        this._initialWorkspaceConfig = config;
    }
    applyWindowLayoutState(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const applyWindowLayoutStateRecursive = (configToTraverse) => __awaiter(this, void 0, void 0, function* () {
                if (configToTraverse.type === "window") {
                    if (configToTraverse.config.appName === PlaceholderAppName || !configToTraverse.config.appName) {
                        configToTraverse.config.appName = PlaceholderAppName;
                        const windowLayoutState = yield this.getWindowLayoutState(configToTraverse.config.windowId);
                        configToTraverse.config.noAppWindowState = windowLayoutState;
                    }
                }
                else {
                    configToTraverse.children.forEach((i) => {
                        applyWindowLayoutStateRecursive(i);
                    });
                }
            });
            yield Promise.all(config.children.map((ic) => __awaiter(this, void 0, void 0, function* () {
                yield applyWindowLayoutStateRecursive(ic);
            })));
        });
    }
    applyWindowChannels(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const applyWindowLayoutStateRecursive = (configToTraverse) => __awaiter(this, void 0, void 0, function* () {
                if (configToTraverse.type === "window") {
                    if (configToTraverse.config.windowId) {
                        const ioConnectWin = this._glue.windows.findById(configToTraverse.config.windowId);
                        try {
                            const channel = yield (ioConnectWin === null || ioConnectWin === void 0 ? void 0 : ioConnectWin.getChannel());
                            configToTraverse.config.channelId = channel;
                        }
                        catch (error) {
                            // if we fail to get the channel the layout save should not save (e.g if the window is not a io.Connect client)
                        }
                    }
                }
                else {
                    configToTraverse.children.forEach((i) => {
                        applyWindowLayoutStateRecursive(i);
                    });
                }
            });
            yield Promise.all(config.children.map((ic) => __awaiter(this, void 0, void 0, function* () {
                yield applyWindowLayoutStateRecursive(ic);
            })));
        });
    }
    applyInstanceIds(configToPopulate) {
        const applyRecursive = (itemConfig) => {
            if (itemConfig.type === "window") {
                itemConfig.config.instanceId = itemConfig.config.windowId;
            }
            else {
                itemConfig.children.forEach((i) => applyRecursive(i));
            }
        };
        applyRecursive(configToPopulate);
    }
    removeWorkspaceItemIds(configToClean) {
        const removeRecursive = (config) => {
            var _a;
            if ("id" in config) {
                delete config.id;
            }
            if (config.type !== "window") {
                (_a = config.children) === null || _a === void 0 ? void 0 : _a.forEach((i) => removeRecursive(i));
            }
        };
        removeRecursive(configToClean);
    }
    removeWorkspaceWindowWindowIds(configToClean) {
        const removeRecursive = (config) => {
            var _a;
            if (config.type === "window") {
                delete config.config.windowId;
            }
            if (config.type !== "window") {
                (_a = config.children) === null || _a === void 0 ? void 0 : _a.forEach((i) => removeRecursive(i));
            }
        };
        removeRecursive(configToClean);
    }
    applySavedContexts(workspace, layoutRequestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const windows = getAllWindowsFromItem(workspace);
            const validWindowIds = windows.map((win) => win.config.windowId).filter((windowId) => typeof windowId === "string");
            const windowIdsToContext = yield this._platformCommunicator.requestOnLayoutSaveContexts({
                layoutName: layoutRequestConfig.layoutName,
                layoutType: layoutRequestConfig.layoutType,
                context: layoutRequestConfig.context,
                windowIds: validWindowIds,
                saveWindowContexts: layoutRequestConfig.saveWindowContexts
            });
            windowIdsToContext.forEach(({ windowId, windowContext }) => {
                const windowToReceiveContext = windows.find((w) => w.config.windowId === windowId);
                if (!windowToReceiveContext) {
                    return;
                }
                windowToReceiveContext.config.context = windowContext;
            });
        });
    }
    applyEmptyContexts(workspace) {
        const windows = getAllWindowsFromItem(workspace);
        windows.forEach((win) => {
            win.config.context = {};
        });
    }
    saveWorkspaceCore(workspace, layoutName, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!workspace.layout && !workspace.hibernateConfig) {
                return undefined;
            }
            const workspaceConfig = this.resolver.getWorkspaceConfig(workspace.id);
            if (workspaceConfig.workspacesOptions.layoutName) {
                delete workspaceConfig.workspacesOptions.layoutName;
            }
            const workspaceItem = this._configConverter.convertToAPIConfig(workspaceConfig);
            this.removeWorkspaceItemIds(workspaceItem);
            yield this.applyWindowChannels(workspaceItem);
            yield this.applyWindowLayoutState(workspaceItem);
            yield this.applySavedContexts(workspaceItem, { layoutName, layoutType: "Workspace", saveWindowContexts: options === null || options === void 0 ? void 0 : options.saveWindowContexts });
            this.applyInstanceIds(workspaceItem);
            // The excess properties should be cleaned
            this.windowSummariesToWindowLayout(workspaceItem);
            this.workspaceSummaryToWorkspaceLayout(workspaceItem);
            return workspaceItem;
        });
    }
    saveWorkspaceCoreSync(workspace) {
        if (!workspace.layout && !workspace.hibernateConfig) {
            return undefined;
        }
        const workspaceConfig = this.resolver.getWorkspaceConfig(workspace.id);
        const workspaceItem = this._configConverter.convertToAPIConfig(workspaceConfig);
        this.removeWorkspaceItemIds(workspaceItem);
        this.applyInstanceIds(workspaceItem);
        // The excess properties should be cleaned
        this.windowSummariesToWindowLayout(workspaceItem);
        this.workspaceSummaryToWorkspaceLayout(workspaceItem);
        return workspaceItem;
    }
    windowSummariesToWindowLayout(workspaceItem) {
        const transform = (item) => {
            if (item.type === "window") {
                delete item.config.isLoaded;
                delete item.config.windowId;
                delete item.config.workspaceId;
                delete item.config.frameId;
                delete item.config.positionIndex;
                if (item.config.appName) {
                    delete item.config.url;
                }
                return;
            }
            item.children.forEach(c => transform(c));
        };
        transform(workspaceItem);
    }
    workspaceSummaryToWorkspaceLayout(workspaceItem) {
        if (workspaceItem === null || workspaceItem === void 0 ? void 0 : workspaceItem.config) {
            delete workspaceItem.config.frameId;
            delete workspaceItem.config.positionIndex;
        }
    }
    addWorkspaceIds(configToPopulate) {
        if (!configToPopulate) {
            return;
        }
        const addRecursive = (config) => {
            config.id = this._configFactory.getId();
            if (config.type && config.type === "component") {
                config.componentName = `app${config.id}`;
            }
            if (config.type !== "component" && config.content) {
                config.content.forEach((i) => addRecursive(i));
            }
        };
        addRecursive(configToPopulate);
    }
    getWorkspaceContext(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._glue.contexts.get(getWorkspaceContextName(id));
        });
    }
    getWindowLayoutState(windowId) {
        return __awaiter(this, void 0, void 0, function* () {
            const window = this._glue.windows.findById(windowId);
            return {
                bounds: {},
                createArgs: {
                    url: yield (window === null || window === void 0 ? void 0 : window.getURL())
                }
            };
        });
    }
}

class LayoutStateResolver {
    constructor(_frameId, _layoutEventEmitter, frameController, converter, wrapperFactory) {
        this._frameId = _frameId;
        this._layoutEventEmitter = _layoutEventEmitter;
        this.frameController = frameController;
        this.converter = converter;
        this.wrapperFactory = wrapperFactory;
    }
    getWindowSummary(windowId) {
        return __awaiter(this, void 0, void 0, function* () {
            windowId = Array.isArray(windowId) ? windowId[0] : windowId;
            let windowContentItem = store.getWindowContentItem(windowId);
            if (!windowContentItem) {
                yield this.waitForWindowContentItem(windowId);
                windowContentItem = store.getWindowContentItem(windowId);
            }
            const wrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem });
            return wrapper.summary;
        });
    }
    getWindowSummarySync(windowId, contentItem) {
        windowId = Array.isArray(windowId) ? windowId[0] : windowId;
        const windowContentItem = contentItem || store.getWindowContentItem(windowId);
        const wrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem });
        return wrapper.summary;
    }
    getWorkspaceConfig(workspaceId) {
        const workspace = store.getById(workspaceId);
        if (!workspace) {
            throw new Error(`Could find workspace to remove with id ${workspaceId}`);
        }
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
        return wrapper.config;
    }
    getWorkspaceSnapshot(workspaceId, manager, excludeIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaceSnapshotWithoutContext = this.getWorkspaceSnapshotSync(workspaceId, manager);
            yield manager.layoutsManager.applyWindowLayoutState(workspaceSnapshotWithoutContext);
            if (excludeIds) {
                manager.layoutsManager.removeWorkspaceItemIds(workspaceSnapshotWithoutContext);
                manager.layoutsManager.removeWorkspaceWindowWindowIds(workspaceSnapshotWithoutContext);
            }
            return {
                id: workspaceId,
                children: workspaceSnapshotWithoutContext.children,
                config: workspaceSnapshotWithoutContext.config,
                frameSummary: manager.getFrameSummary(this._frameId),
                context: yield manager.getWorkspaceContext(workspaceSnapshotWithoutContext.id)
            };
        });
    }
    getAllWorkspacesLayouts(manager, layoutRequestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaces = store.workspaceIds.map((wid) => this.getWorkspaceSnapshotSync(wid, manager));
            const allLayouts = yield Promise.all(workspaces.map((workspace) => __awaiter(this, void 0, void 0, function* () {
                const workspaceId = workspace.id;
                yield manager.layoutsManager.applyWindowLayoutState(workspace);
                yield this.applyWorkspaceWindowContexts(manager, workspace, layoutRequestConfig);
                yield manager.layoutsManager.applyWindowChannels(workspace);
                manager.layoutsManager.applyInstanceIds(workspace);
                manager.layoutsManager.removeWorkspaceItemIds(workspace);
                manager.layoutsManager.removeWorkspaceWindowWindowIds(workspace);
                const context = layoutRequestConfig.ignoreContexts ? {} : yield manager.getWorkspaceContext(workspaceId);
                return {
                    id: workspaceId,
                    children: workspace.children,
                    config: workspace.config,
                    frameSummary: manager.getFrameSummary(this._frameId),
                    context
                };
            })));
            return allLayouts;
        });
    }
    getWorkspaceSummary(workspaceId) {
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspaceId });
        return wrapper.summary;
    }
    isWindowMaximized(id) {
        const placementId = idAsString(id);
        const windowContentItem = store.getWindowContentItem(placementId);
        const wrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem });
        return wrapper.isMaximized;
    }
    isWindowInMaximizedContainer(id) {
        const placementId = Array.isArray(id) ? id[0] : id;
        const windowContentItem = store.getWindowContentItem(placementId);
        const findMaximizedItem = (contentItem) => {
            if (!contentItem || contentItem.isRoot) {
                return;
            }
            if (contentItem.hasId("__glMaximised")) {
                return contentItem;
            }
            return findMaximizedItem(contentItem.parent);
        };
        return !!findMaximizedItem(windowContentItem);
    }
    isWindowSelected(id) {
        const placementId = idAsString(id);
        const windowContentItem = store.getWindowContentItem(placementId);
        const wrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem });
        return wrapper.isSelected;
    }
    isWorkspaceHibernated(id) {
        const workspace = store.getById(id);
        if (!workspace) {
            throw new Error(`Could not find workspace ${id} in ${this._frameId} to check if hibernated`);
        }
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
        return wrapper.isHibernated;
    }
    getContainerSummary(containerId) {
        containerId = idAsString(containerId);
        const contentItem = store.getContainer(containerId);
        const wrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: contentItem });
        return wrapper.summary;
    }
    getContainerSummaryByReference(item, workspaceId) {
        if (item.type === "component") {
            throw new Error(`Tried to get container summary from item ${item.type} ${item.config.id}`);
        }
        const wrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId });
        return wrapper.summary;
    }
    isWindowInWorkspace(windowId) {
        return !!store.getWindowContentItem(windowId);
    }
    getFrameSnapshot(manager, excludeIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const allWorkspaceSnapshots = yield Promise.all(store.workspaceIds.map(wid => this.getWorkspaceSnapshot(wid, manager, excludeIds)));
            const constraints = this.getFrameConstraints();
            return {
                id: this._frameId,
                config: Object.assign({}, constraints),
                workspaces: allWorkspaceSnapshots
            };
        });
    }
    getSnapshot(itemId, manager) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.getWorkspaceConfig(itemId);
            }
            catch (error) {
                return this.getFrameSnapshot(manager);
            }
        });
    }
    getWorkspaceSnapshotSync(itemId, manager) {
        const workspaceConfig = this.getWorkspaceConfig(itemId);
        const workspaceItem = this.converter.convertToAPIConfig(workspaceConfig);
        return {
            id: workspaceItem.id,
            children: workspaceItem.children,
            config: workspaceItem.config,
            frameSummary: manager.getFrameSummary(this._frameId),
        };
    }
    isWindowLoaded(id) {
        return this.frameController.hasFrame(idAsString(id));
    }
    getRendererWindowBounds() {
        return {
            left: window.visualViewport.offsetLeft,
            top: window.visualViewport.offsetTop,
            width: window.visualViewport.width,
            height: window.visualViewport.height
        };
    }
    getFrameConstraints() {
        const workspaceWrappers = store.workspaceIds.map((wId) => {
            return this.wrapperFactory.getWorkspaceWrapper({ workspaceId: wId });
        });
        const result = workspaceWrappers.reduce((acc, ww) => {
            const rendererBounds = this.getRendererWindowBounds();
            const horizontalExtraSpace = rendererBounds.width - ww.bounds.width;
            const verticalExtraSpace = rendererBounds.height - ww.bounds.height;
            const newMinWidth = Math.ceil(Math.max(ww.minWidth + horizontalExtraSpace, acc.minWidth));
            const newMinHeight = Math.ceil(Math.max(ww.minHeight + verticalExtraSpace, acc.minHeight));
            const newMaxWidth = Math.ceil(Math.min(ww.maxWidth + horizontalExtraSpace, acc.maxWidth));
            const newMaxHeight = Math.ceil(Math.min(ww.maxHeight + verticalExtraSpace, acc.maxHeight));
            if (newMinHeight <= newMaxHeight && newMinWidth <= newMaxWidth) {
                acc.minWidth = newMinWidth;
                acc.minHeight = newMinHeight;
                acc.maxWidth = newMaxWidth;
                acc.maxHeight = newMaxHeight;
            }
            return acc;
        }, {
            minWidth: DefaultMinSize,
            maxWidth: DefaultMaxSize,
            minHeight: DefaultMinSize,
            maxHeight: DefaultMaxSize
        });
        return result;
    }
    getWorkspaceIcon(workspaceId) {
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspaceId });
        return wrapper.icon;
    }
    getWorkspaceTitles() {
        return store.workspaceIds.map((wid) => {
            const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspaceId: wid });
            return wrapper.title;
        });
    }
    getFrameBounds() {
        return {
            top: window.screenTop,
            left: window.screenLeft,
            width: window.innerWidth,
            height: window.innerHeight
        };
    }
    waitForWindowContentItem(windowId) {
        return new Promise((res) => {
            const unsub = this._layoutEventEmitter.onContentComponentCreated((component) => {
                if (component.config.id === windowId) {
                    unsub();
                    res();
                }
            });
            const windowContentItem = store.getWindowContentItem(windowId);
            if (windowContentItem) {
                unsub();
                res();
            }
        });
    }
    applyWorkspaceWindowContexts(manager, workspace, layoutRequestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            if (layoutRequestConfig.ignoreContexts) {
                manager.layoutsManager.applyEmptyContexts(workspace);
                return;
            }
            yield manager.layoutsManager.applySavedContexts(workspace, layoutRequestConfig);
        });
    }
}

class TitleGenerator {
    constructor() {
        this._pattern = /^Untitled ([0-9]+)$/;
    }
    getTitle(currentTitles, offset = 0) {
        const titlesMatchingPattern = currentTitles.filter((t) => this._pattern.test(t));
        const titleNumbers = titlesMatchingPattern.map((t) => parseInt(this._pattern.exec(t)[1], 10));
        const biggestNumber = titleNumbers.length ? titleNumbers.sort((a, b) => a - b)[titleNumbers.length - 1] : 0;
        return `Untitled ${biggestNumber + 1 + offset}`;
    }
}

class WorkspacesConfigurationFactory {
    constructor(glue) {
        this._titleGenerator = new TitleGenerator();
        this._defaultWorkspaceLayoutSettings = {
            showCloseIcon: false,
            showMaximizeIcon: false,
            showPopoutIcon: false,
            disableDragProxy: true,
            mode: "workspace",
        };
        this._glue = glue;
    }
    createEmptyVisibleWindowConfig() {
        return Object.assign(Object.assign({}, this.createWindowConfigurationCore()), {
            componentState: {
                header: false
            }
        });
    }
    createGDWindowConfig(args) {
        const baseConfiguration = this.createWindowConfigurationCore(args.id);
        const workspacesConfig = {
            allowExtract: args.allowExtract,
            allowReorder: args.allowReorder,
            showCloseButton: args.showCloseButton,
            minWidth: args.minWidth,
            minHeight: args.minHeight,
            maxWidth: args.maxWidth,
            maxHeight: args.maxHeight,
            positionIndex: args.positionIndex,
            isMaximized: args.isMaximized,
            noAppWindowState: args.noAppWindowState,
            channelId: args.channelId
        };
        return Object.assign(Object.assign({}, baseConfiguration), {
            componentName: `app${baseConfiguration.id}`,
            windowId: args.windowId,
            title: args.title,
            componentState: {
                windowId: args.windowId,
                appName: args.appName,
                url: args.url,
                title: args.title,
                context: args.context
            },
            workspacesConfig
        });
    }
    createApiWindow(args) {
        return {
            id: Array.isArray(args.id) ? args.id[0] : args.id,
            type: "window",
            config: {
                windowId: args.windowId,
                isMaximized: args.isMaximized,
                isLoaded: args.windowId !== undefined,
                isFocused: args.isFocused,
                isSelected: args.isSelected,
                appName: args.appName,
                url: args.url,
                title: args.title,
                workspaceId: args.workspaceId,
                frameId: args.frameId,
                positionIndex: args.positionIndex,
                allowExtract: args.allowExtract,
                allowReorder: args.allowReorder,
                showCloseButton: args.showCloseButton,
                minWidth: args.minWidth,
                maxWidth: args.maxWidth,
                minHeight: args.minHeight,
                maxHeight: args.maxHeight,
                widthInPx: args.widthInPx,
                heightInPx: args.heightInPx
            }
        };
    }
    getWorkspaceLayoutComponentName(workspaceId) {
        return `workspace${workspaceId}`;
    }
    getWorkspaceTitle(currentTitles) {
        return this._titleGenerator.getTitle(currentTitles);
    }
    getId() {
        return generateId();
    }
    getDefaultWorkspaceSettings() {
        return {
            mode: "default",
            showCloseIcon: false,
            showPopoutIcon: true
        };
    }
    getDefaultFrameConfig(workspaceTitles) {
        const workspaceId = generateId();
        const workspaceConfig = this.getDefaultWorkspaceConfig();
        const workspacesConfig = {
            settings: this._defaultWorkspaceLayoutSettings,
            content: [
                {
                    type: "stack",
                    content: [
                        {
                            type: "component",
                            id: workspaceId,
                            componentName: this.getWorkspaceLayoutComponentName(workspaceId),
                            componentState: {},
                            workspacesConfig: {},
                            title: this.getWorkspaceTitle(workspaceTitles)
                        }
                    ],
                    workspacesConfig: {}
                }
            ]
        };
        return {
            frameId: undefined,
            workspaceConfigs: [{
                    id: workspaceId,
                    config: workspaceConfig
                }],
            workspaceLayout: workspacesConfig
        };
    }
    getDefaultWorkspaceConfig() {
        return undefined;
    }
    generateInitialConfig(workspaceContentConfigs) {
        const selectedWorkspace = workspaceContentConfigs.find((wcc) => { var _a; return (_a = wcc === null || wcc === void 0 ? void 0 : wcc.workspacesOptions) === null || _a === void 0 ? void 0 : _a.selected; });
        const workspacesConfig = {
            settings: this._defaultWorkspaceLayoutSettings,
            content: [
                {
                    type: "stack",
                    activeItemIndex: selectedWorkspace ? workspaceContentConfigs.indexOf(selectedWorkspace) : workspaceContentConfigs.length - 1,
                    content: workspaceContentConfigs.map((wcc) => {
                        var _a, _b, _c;
                        const defaultId = generateId();
                        return {
                            workspacesConfig: Object.assign({}, wcc.workspacesOptions),
                            type: "component",
                            id: (wcc === null || wcc === void 0 ? void 0 : wcc.id) || defaultId,
                            componentName: this.getWorkspaceLayoutComponentName(idAsString(wcc === null || wcc === void 0 ? void 0 : wcc.id) || defaultId),
                            componentState: {},
                            noTabHeader: (_a = wcc === null || wcc === void 0 ? void 0 : wcc.workspacesOptions) === null || _a === void 0 ? void 0 : _a.noTabHeader,
                            title: ((_b = wcc === null || wcc === void 0 ? void 0 : wcc.workspacesOptions) === null || _b === void 0 ? void 0 : _b.title) || ((_c = wcc === null || wcc === void 0 ? void 0 : wcc.workspacesOptions) === null || _c === void 0 ? void 0 : _c.name) || this.getWorkspaceTitle(store.workspaceIds),
                        };
                    }),
                    workspacesConfig: {}
                }
            ]
        };
        return {
            frameId: undefined,
            workspaceConfigs: workspaceContentConfigs.map((wcc, i) => {
                let id = wcc === null || wcc === void 0 ? void 0 : wcc.id;
                if (!id && workspacesConfig.content[0].type !== "component") {
                    id = workspacesConfig.content[0].content[i].id;
                }
                return {
                    id,
                    config: wcc
                };
            }),
            workspaceLayout: workspacesConfig
        };
    }
    wrapInGroup(content) {
        return this.wrap(content, "stack");
    }
    getAppNameFromWindowId(windowId) {
        const instance = this._glue.appManager.instances().find(i => i.id === windowId);
        return instance === null || instance === void 0 ? void 0 : instance.application.name;
    }
    convertLayoutOptionsToWorkspaceItem(name, options, layoutManager) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const savedConfigWithData = yield layoutManager.getWorkspaceByName(name);
            const savedConfig = savedConfigWithData.config;
            savedConfig.workspacesOptions.context = savedConfigWithData.layoutData.context;
            if ((options === null || options === void 0 ? void 0 : options.context) && savedConfig.workspacesOptions.context) {
                savedConfig.workspacesOptions.context = Object.assign(savedConfigWithData.layoutData.context, options === null || options === void 0 ? void 0 : options.context);
            }
            else if (options === null || options === void 0 ? void 0 : options.context) {
                savedConfig.workspacesOptions.context = options === null || options === void 0 ? void 0 : options.context;
            }
            savedConfig.workspacesOptions.title = (options === null || options === void 0 ? void 0 : options.title) || name;
            savedConfig.workspacesOptions.icon = (_a = options === null || options === void 0 ? void 0 : options.icon) !== null && _a !== void 0 ? _a : savedConfig.workspacesOptions.icon;
            savedConfig.workspacesOptions.allowSystemHibernation = (_b = options === null || options === void 0 ? void 0 : options.allowSystemHibernation) !== null && _b !== void 0 ? _b : savedConfig.workspacesOptions.allowSystemHibernation;
            if (savedConfig && savedConfig.workspacesOptions && !savedConfig.workspacesOptions.name) {
                savedConfig.workspacesOptions.name = name;
            }
            if (savedConfig) {
                savedConfig.workspacesOptions = savedConfig.workspacesOptions || {};
                savedConfig.workspacesOptions.layoutName = savedConfigWithData.layoutData.name;
            }
            if (savedConfig && options) {
                savedConfig.workspacesOptions.loadingStrategy = options.loadingStrategy;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.noTabHeader) !== undefined) {
                savedConfig.workspacesOptions = savedConfig.workspacesOptions || {};
                savedConfig.workspacesOptions.noTabHeader = options === null || options === void 0 ? void 0 : options.noTabHeader;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.isPinned) !== undefined) {
                savedConfig.workspacesOptions = savedConfig.workspacesOptions || {};
                savedConfig.workspacesOptions.isPinned = options === null || options === void 0 ? void 0 : options.isPinned;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.isSelected) !== undefined) {
                savedConfig.workspacesOptions = savedConfig.workspacesOptions || {};
                savedConfig.workspacesOptions.selected = options === null || options === void 0 ? void 0 : options.isSelected;
            }
            return savedConfig;
        });
    }
    getEmptyWorkspaceConfig(title) {
        return Object.assign(Object.assign({}, this.getDefaultWorkspaceSettings()), { content: [], workspacesOptions: {
                title
            } });
    }
    createWindowConfigurationCore(id) {
        return {
            workspacesConfig: {},
            type: "component",
            id: id || this.getId(),
            componentName: EmptyVisibleWindowName,
        };
    }
    wrap(content, wrapper) {
        return {
            workspacesConfig: {
                wrapper: true,
                isMaximized: wrapper === "stack" && content.some(c => c.workspacesConfig.isMaximized) // only valid for windows placed directly in row/col
            },
            type: wrapper,
            content
        };
    }
}

class ConfigConverter {
    constructor(_configFactory) {
        this._configFactory = _configFactory;
        this.flat = (arr) => arr.reduce((acc, i) => [...acc, ...(Array.isArray(i) ? i : [i])], []);
    }
    convertToRendererConfig(config) {
        if (!config) {
            return undefined;
        }
        return this.convertToRendererConfigCore(config, undefined);
    }
    convertToAPIConfig(apiConfig) {
        if (!apiConfig) {
            return undefined;
        }
        return this.convertToApiConfigCore(apiConfig);
    }
    convertToRendererConfigCore(config, parent) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37;
        let glConfig = {
            type: config.type,
            content: [],
            workspacesOptions: config.config || {},
        };
        if (config.type === "workspace" || !config.type) {
            glConfig = this.applyDefaultRendererConfig({
                content: [],
                workspacesOptions: config.config,
            });
        }
        if (config.type === "workspace" || !config.type) {
            const workspaceItem = config;
            const { children } = workspaceItem;
            if (children.length > 1 && children.every((c) => c.type === "column")) {
                glConfig.content.push(this.wrap(children.map((c) => this.convertToRendererConfigCore(c, workspaceItem)), "row"));
            }
            else if (children.length > 1 && children.every((c) => c.type === "row")) {
                glConfig.content.push(this.wrap(children.map((c) => this.convertToRendererConfigCore(c, workspaceItem)), "column"));
            }
            else {
                glConfig.content.push(...children.map((c) => this.convertToRendererConfigCore(c, workspaceItem)));
            }
            return glConfig;
        }
        else if (config.type === "column" || config.type === "row") {
            glConfig.content.push(...config.children.map((c) => this.convertToRendererConfigCore(c, config)));
            if (glConfig.content.length === 0) {
                glConfig.content.push(this.getGroupWithEmptyVisibleWindow());
            }
            if (!glConfig.workspacesConfig) {
                glConfig.workspacesConfig = {};
            }
            glConfig.workspacesConfig.allowDrop = (_a = config.config) === null || _a === void 0 ? void 0 : _a.allowDrop;
            glConfig.workspacesConfig.allowSplitters = (_b = config.config) === null || _b === void 0 ? void 0 : _b.allowSplitters;
            glConfig.workspacesConfig.isPinned = (_c = config.config) === null || _c === void 0 ? void 0 : _c.isPinned;
            glConfig.workspacesConfig.maxWidth = (_d = config.config) === null || _d === void 0 ? void 0 : _d.maxWidth;
            glConfig.workspacesConfig.minWidth = (_e = config.config) === null || _e === void 0 ? void 0 : _e.minWidth;
            glConfig.workspacesConfig.maxHeight = (_f = config.config) === null || _f === void 0 ? void 0 : _f.maxHeight;
            glConfig.workspacesConfig.minHeight = (_g = config.config) === null || _g === void 0 ? void 0 : _g.minHeight;
            glConfig.workspacesConfig.positionIndex = (_h = config.config) === null || _h === void 0 ? void 0 : _h.positionIndex;
            glConfig.workspacesConfig.isMaximized = (_j = config.config) === null || _j === void 0 ? void 0 : _j.isMaximized;
            glConfig.width = this.convertSizeToRendererConfigSafely((_k = config.config) === null || _k === void 0 ? void 0 : _k.width);
            glConfig.height = this.convertSizeToRendererConfigSafely((_l = config.config) === null || _l === void 0 ? void 0 : _l.height);
            glConfig.workspacesConfig.maximizationBoundary = (_m = config.config) === null || _m === void 0 ? void 0 : _m.maximizationBoundary;
            return glConfig;
        }
        else if (config.type === "group") {
            glConfig.type = "stack";
            glConfig.content.push(...config.children.map((c) => this.convertToRendererConfigCore(c, config)));
            if (glConfig.content.length === 0) {
                glConfig.content.push(this._configFactory.createEmptyVisibleWindowConfig());
            }
            if (!glConfig.workspacesConfig) {
                glConfig.workspacesConfig = {};
            }
            glConfig.workspacesConfig.allowDrop = (_o = config.config) === null || _o === void 0 ? void 0 : _o.allowDrop;
            glConfig.workspacesConfig.allowDropHeader = (_p = config.config) === null || _p === void 0 ? void 0 : _p.allowDropHeader;
            glConfig.workspacesConfig.allowDropLeft = (_q = config.config) === null || _q === void 0 ? void 0 : _q.allowDropLeft;
            glConfig.workspacesConfig.allowDropRight = (_r = config.config) === null || _r === void 0 ? void 0 : _r.allowDropRight;
            glConfig.workspacesConfig.allowDropTop = (_s = config.config) === null || _s === void 0 ? void 0 : _s.allowDropTop;
            glConfig.workspacesConfig.allowDropBottom = (_t = config.config) === null || _t === void 0 ? void 0 : _t.allowDropBottom;
            glConfig.workspacesConfig.allowExtract = (_u = config.config) === null || _u === void 0 ? void 0 : _u.allowExtract;
            glConfig.workspacesConfig.allowReorder = (_v = config.config) === null || _v === void 0 ? void 0 : _v.allowReorder;
            glConfig.workspacesConfig.showMaximizeButton = (_w = config.config) === null || _w === void 0 ? void 0 : _w.showMaximizeButton;
            glConfig.workspacesConfig.showEjectButton = (_x = config.config) === null || _x === void 0 ? void 0 : _x.showEjectButton;
            glConfig.workspacesConfig.showAddWindowButton = (_y = config.config) === null || _y === void 0 ? void 0 : _y.showAddWindowButton;
            glConfig.workspacesConfig.maxWidth = (_z = config.config) === null || _z === void 0 ? void 0 : _z.maxWidth;
            glConfig.workspacesConfig.minWidth = (_0 = config.config) === null || _0 === void 0 ? void 0 : _0.minWidth;
            glConfig.workspacesConfig.maxHeight = (_1 = config.config) === null || _1 === void 0 ? void 0 : _1.maxHeight;
            glConfig.workspacesConfig.minHeight = (_2 = config.config) === null || _2 === void 0 ? void 0 : _2.minHeight;
            glConfig.activeItemIndex = (_3 = config.config) === null || _3 === void 0 ? void 0 : _3.activeTabIndex;
            glConfig.workspacesConfig.positionIndex = (_4 = config.config) === null || _4 === void 0 ? void 0 : _4.positionIndex;
            glConfig.workspacesConfig.isMaximized = (_5 = config.config) === null || _5 === void 0 ? void 0 : _5.isMaximized;
            glConfig.width = this.convertSizeToRendererConfigSafely((_6 = config.config) === null || _6 === void 0 ? void 0 : _6.width);
            glConfig.height = this.convertSizeToRendererConfigSafely((_7 = config.config) === null || _7 === void 0 ? void 0 : _7.height);
            return glConfig;
        }
        else if (config.type === "window") {
            let appName = ((_8 = config.config) === null || _8 === void 0 ? void 0 : _8.appName) || config.appName;
            const windowId = ((_9 = config.config) === null || _9 === void 0 ? void 0 : _9.windowId) || config.windowId;
            if (!appName && windowId) {
                appName = this._configFactory.getAppNameFromWindowId(windowId);
            }
            const resultWindow = this._configFactory.createGDWindowConfig({
                windowId,
                id: config.id,
                appName,
                url: ((_10 = config.config) === null || _10 === void 0 ? void 0 : _10.url) || config.url,
                title: ((_11 = config.config) === null || _11 === void 0 ? void 0 : _11.title) || config.title,
                context: ((_12 = config.config) === null || _12 === void 0 ? void 0 : _12.context) || config.context,
                allowExtract: (_14 = (_13 = config === null || config === void 0 ? void 0 : config.config) === null || _13 === void 0 ? void 0 : _13.allowExtract) !== null && _14 !== void 0 ? _14 : config.allowExtract,
                allowReorder: (_16 = (_15 = config === null || config === void 0 ? void 0 : config.config) === null || _15 === void 0 ? void 0 : _15.allowReorder) !== null && _16 !== void 0 ? _16 : config.allowReorder,
                showCloseButton: (_18 = (_17 = config === null || config === void 0 ? void 0 : config.config) === null || _17 === void 0 ? void 0 : _17.showCloseButton) !== null && _18 !== void 0 ? _18 : config.showCloseButton,
                minWidth: (_20 = (_19 = config === null || config === void 0 ? void 0 : config.config) === null || _19 === void 0 ? void 0 : _19.minWidth) !== null && _20 !== void 0 ? _20 : config.minWidth,
                maxWidth: (_22 = (_21 = config === null || config === void 0 ? void 0 : config.config) === null || _21 === void 0 ? void 0 : _21.maxWidth) !== null && _22 !== void 0 ? _22 : config.maxWidth,
                minHeight: (_24 = (_23 = config === null || config === void 0 ? void 0 : config.config) === null || _23 === void 0 ? void 0 : _23.minHeight) !== null && _24 !== void 0 ? _24 : config.minHeight,
                maxHeight: (_26 = (_25 = config === null || config === void 0 ? void 0 : config.config) === null || _25 === void 0 ? void 0 : _25.maxHeight) !== null && _26 !== void 0 ? _26 : config.maxHeight,
                positionIndex: (_28 = (_27 = config === null || config === void 0 ? void 0 : config.config) === null || _27 === void 0 ? void 0 : _27.positionIndex) !== null && _28 !== void 0 ? _28 : config.positionIndex,
                isMaximized: (_30 = (_29 = config === null || config === void 0 ? void 0 : config.config) === null || _29 === void 0 ? void 0 : _29.isMaximized) !== null && _30 !== void 0 ? _30 : config.isMaximized,
                noAppWindowState: (_32 = (_31 = config === null || config === void 0 ? void 0 : config.config) === null || _31 === void 0 ? void 0 : _31.noAppWindowState) !== null && _32 !== void 0 ? _32 : config.noAppWindowState,
                channelId: ((_33 = config === null || config === void 0 ? void 0 : config.config) === null || _33 === void 0 ? void 0 : _33.channelId) || config.channelId,
            });
            if (parent.type !== "group") {
                resultWindow.componentState.header = false;
                const group = this.wrap([resultWindow], "stack");
                group.width = (_35 = (_34 = config === null || config === void 0 ? void 0 : config.config) === null || _34 === void 0 ? void 0 : _34.width) !== null && _35 !== void 0 ? _35 : config.width;
                group.height = (_37 = (_36 = config === null || config === void 0 ? void 0 : config.config) === null || _36 === void 0 ? void 0 : _36.height) !== null && _37 !== void 0 ? _37 : config.height;
                return group;
            }
            return resultWindow;
        }
    }
    convertToApiConfigCore(config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        if (!config.type || config.type === "workspace") {
            config = config;
            const children = this.flat(config.content.map((c) => this.convertToApiConfigCore(c)));
            return {
                id: idAsString(config.id),
                config: config.workspacesOptions,
                children
            };
        }
        if (config.type === "component" && config.componentName === EmptyVisibleWindowName) {
            return [];
        }
        else if (config.type !== "component" && config.workspacesConfig && config.workspacesConfig.wrapper) {
            const items = this.flat(config.content.map((c) => this.convertToApiConfigCore(c)));
            items.forEach((i) => {
                i.config.width = config.width;
                i.config.height = config.height;
            });
            return items;
        }
        else if (config.type === "component") {
            const wspsConfig = config.workspacesConfig;
            const resultWindow = this._configFactory.createApiWindow({
                id: config.id,
                isFocused: false,
                isMaximized: wspsConfig.isMaximized,
                isSelected: wspsConfig.isSelected,
                windowId: config.componentState.windowId,
                appName: config.componentState.appName,
                url: config.componentState.url,
                frameId: wspsConfig.frameId,
                workspaceId: wspsConfig.workspaceId,
                title: wspsConfig.title,
                positionIndex: wspsConfig.positionIndex,
                allowExtract: wspsConfig.allowExtract,
                allowReorder: wspsConfig.allowReorder,
                showCloseButton: wspsConfig.showCloseButton,
                maxHeight: wspsConfig.maxHeight,
                maxWidth: wspsConfig.maxWidth,
                minHeight: wspsConfig.minHeight,
                minWidth: wspsConfig.minWidth,
                widthInPx: wspsConfig.widthInPx,
                heightInPx: wspsConfig.heightInPx
            });
            return resultWindow;
        }
        const configAsAny = config;
        const containerResult = {
            id: idAsString(config.id),
            type: config.type === "stack" ? "group" : config.type,
            children: this.flat(config.content.map((c) => this.convertToApiConfigCore(c))),
            config: {
                positionIndex: (_a = configAsAny.workspacesConfig) === null || _a === void 0 ? void 0 : _a.positionIndex,
                frameId: (_b = configAsAny.workspacesConfig) === null || _b === void 0 ? void 0 : _b.frameId,
                workspaceId: (_c = configAsAny.workspacesConfig) === null || _c === void 0 ? void 0 : _c.workspaceId,
                activeTabIndex: configAsAny.activeItemIndex,
                width: configAsAny.width,
                height: configAsAny.height,
                allowDrop: (_d = configAsAny.workspacesConfig) === null || _d === void 0 ? void 0 : _d.allowDrop,
                allowDropHeader: (_e = configAsAny.workspacesConfig) === null || _e === void 0 ? void 0 : _e.allowDropHeader,
                allowDropLeft: (_f = configAsAny.workspacesConfig) === null || _f === void 0 ? void 0 : _f.allowDropLeft,
                allowDropRight: (_g = configAsAny.workspacesConfig) === null || _g === void 0 ? void 0 : _g.allowDropRight,
                allowDropTop: (_h = configAsAny.workspacesConfig) === null || _h === void 0 ? void 0 : _h.allowDropTop,
                allowDropBottom: (_j = configAsAny.workspacesConfig) === null || _j === void 0 ? void 0 : _j.allowDropBottom,
                isPinned: (_k = configAsAny.workspacesConfig) === null || _k === void 0 ? void 0 : _k.isPinned,
                allowExtract: (_l = configAsAny.workspacesConfig) === null || _l === void 0 ? void 0 : _l.allowExtract,
                allowReorder: (_m = configAsAny.workspacesConfig) === null || _m === void 0 ? void 0 : _m.allowReorder,
                showMaximizeButton: (_o = configAsAny.workspacesConfig) === null || _o === void 0 ? void 0 : _o.showMaximizeButton,
                showEjectButton: (_p = configAsAny.workspacesConfig) === null || _p === void 0 ? void 0 : _p.showEjectButton,
                showAddWindowButton: (_q = configAsAny.workspacesConfig) === null || _q === void 0 ? void 0 : _q.showAddWindowButton,
                allowSplitters: (_r = configAsAny.workspacesConfig) === null || _r === void 0 ? void 0 : _r.allowSplitters,
                minWidth: (_s = configAsAny.workspacesConfig) === null || _s === void 0 ? void 0 : _s.minWidth,
                maxWidth: (_t = configAsAny.workspacesConfig) === null || _t === void 0 ? void 0 : _t.maxWidth,
                minHeight: (_u = configAsAny.workspacesConfig) === null || _u === void 0 ? void 0 : _u.minHeight,
                maxHeight: (_v = configAsAny.workspacesConfig) === null || _v === void 0 ? void 0 : _v.maxHeight,
                widthInPx: (_w = configAsAny.workspacesConfig) === null || _w === void 0 ? void 0 : _w.widthInPx,
                heightInPx: (_x = configAsAny.workspacesConfig) === null || _x === void 0 ? void 0 : _x.heightInPx,
                isMaximized: (_y = configAsAny.workspacesConfig) === null || _y === void 0 ? void 0 : _y.isMaximized,
                maximizationBoundary: (_z = configAsAny.workspacesConfig) === null || _z === void 0 ? void 0 : _z.maximizationBoundary
            }
        };
        if (containerResult.type !== "group") {
            delete containerResult.config.allowExtract;
            delete containerResult.config.allowReorder;
            delete containerResult.config.allowDropHeader;
            delete containerResult.config.allowDropLeft;
            delete containerResult.config.allowDropTop;
            delete containerResult.config.allowDropRight;
            delete containerResult.config.allowDropBottom;
            delete containerResult.config.showMaximizeButton;
            delete containerResult.config.showEjectButton;
            delete containerResult.config.showAddWindowButton;
        }
        else {
            delete containerResult.config.allowSplitters;
        }
        return containerResult;
    }
    wrap(content, wrapper) {
        return {
            workspacesConfig: {
                wrapper: true,
                isMaximized: wrapper === "stack" && content.some(c => c.workspacesConfig.isMaximized) // only valid for windows placed directly in row/col
            },
            type: wrapper,
            content
        };
    }
    applyDefaultRendererConfig(config) {
        return Object.assign({ settings: Object.assign({}, this._configFactory.getDefaultWorkspaceSettings()) }, config);
    }
    getGroupWithEmptyVisibleWindow() {
        return this.wrap([this._configFactory.createEmptyVisibleWindowConfig()], "stack");
    }
    convertSizeToRendererConfigSafely(size) {
        // If the size is positive golden layout can work with it
        // however if the size is below or equal to zero it has been set manually to an invalid value
        // so it should be discarded -> undefined width/height will be transformed to default
        return size > 0 ? size : undefined;
    }
}

class PopupManagerComposer {
    constructor(_externalPopupManager, _componentPopupManager, _componentFactory) {
        this._externalPopupManager = _externalPopupManager;
        this._componentPopupManager = _componentPopupManager;
        this._componentFactory = _componentFactory;
    }
    showAddWindowPopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this._componentFactory) === null || _a === void 0 ? void 0 : _a.createAddApplicationPopup) {
                yield this._componentPopupManager.showAddWindowPopup(targetBounds, payload);
            }
            else {
                yield this._externalPopupManager.showAddWindowPopup(targetBounds, payload);
            }
        });
    }
    showOpenWorkspacePopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this._componentFactory) === null || _a === void 0 ? void 0 : _a.createAddWorkspacePopup) {
                yield this._componentPopupManager.showOpenWorkspacePopup(targetBounds, payload);
            }
            else {
                yield this._externalPopupManager.showOpenWorkspacePopup(targetBounds, payload);
            }
        });
    }
    showSaveWorkspacePopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this._componentFactory) === null || _a === void 0 ? void 0 : _a.createSaveWorkspacePopup) {
                yield this._componentPopupManager.showSaveWorkspacePopup(targetBounds, payload);
            }
            else {
                yield this._externalPopupManager.showSaveWorkspacePopup(targetBounds, payload);
            }
        });
    }
    showChannelsSelector(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._componentPopupManager.showChannelsSelector(targetBounds, payload);
        });
    }
    hidePopup() {
        this._externalPopupManager.hidePopup();
        if (this._componentFactory) {
            this._componentPopupManager.hidePopup();
        }
    }
    onPopupStateChanged(callback) {
        const exUnsub = this._externalPopupManager.onPopupStateChanged(callback);
        const componentUnsub = this._componentPopupManager.onPopupStateChanged(callback);
        return () => {
            exUnsub();
            componentUnsub();
        };
    }
}

class BasePopupManager {
    constructor(componentFactory) {
        this.componentFactory = componentFactory;
        this.openPopupInfo = undefined;
        this.registry = registryFactory();
    }
    showAddWindowPopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.openPopupInfo = { type: "addApplication", workspaceId: payload.workspaceId, boxId: payload.boxId };
            this.notifyCustomElements(this.openPopupInfo, true);
            this.registry.execute("popup-state-changed", this.openPopupInfo, true);
        });
    }
    showOpenWorkspacePopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.openPopupInfo = { type: "openWorkspace" };
            this.notifyCustomElements(this.openPopupInfo, true);
            this.registry.execute("popup-state-changed", this.openPopupInfo, true);
        });
    }
    showSaveWorkspacePopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.openPopupInfo = { type: "saveWorkspace", workspaceId: payload.workspaceId };
            this.registry.execute("popup-state-changed", this.openPopupInfo, true);
        });
    }
    showChannelsSelector(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            this.openPopupInfo = { type: "channelsSelector", workspaceId: payload.workspaceId, windowId: payload.windowId };
            this.registry.execute("popup-state-changed", this.openPopupInfo, true);
        });
    }
    hidePopup() {
        if (this.openPopupInfo) {
            this.registry.execute("popup-state-changed", this.openPopupInfo, false);
        }
        this.notifyCustomElements(this.openPopupInfo, false);
        this.openPopupInfo = undefined;
    }
    onPopupStateChanged(callback) {
        return this.registry.add("popup-state-changed", callback);
    }
    notifyCustomElements(popupInfo, isActive) {
        if ((popupInfo === null || popupInfo === void 0 ? void 0 : popupInfo.type) === "openWorkspace") {
            componentStateMonitor.decoratedFactory.updateAddWorkspace({
                isAddWorkspacePopupActive: isActive
            });
        }
        else if ((popupInfo === null || popupInfo === void 0 ? void 0 : popupInfo.type) === "addApplication") {
            componentStateMonitor.decoratedFactory.updateAfterGroupTabs({
                isAddWindowPopupActive: isActive,
                workspaceId: popupInfo.workspaceId,
                groupId: popupInfo.boxId
            });
            componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({
                isAddWindowPopupActive: isActive,
                workspaceId: popupInfo.workspaceId,
                groupId: popupInfo.boxId
            });
        }
    }
}

class ExternalPopupManager extends BasePopupManager {
    constructor(glue, componentFactory) {
        super(componentFactory);
        this._addApplicationType = "addApplication";
        this._openWorkspaceType = "openWorkspace";
        this._saveWorkspaceType = "saveWorkspace";
        this._showPopupMethod = "T42.Workspaces.ShowPopup";
        this._glue = glue;
        this.initPopup();
        this.registerHideMethod();
        this.registerResizeMethod();
    }
    showAddWindowPopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showAddWindowPopup: { get: () => super.showAddWindowPopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.hidePopup();
            const popupSize = yield this.getPopupSize(this._addApplicationType, payload);
            this.showElement(this._popup, targetBounds, popupSize);
            _super.showAddWindowPopup.call(this, targetBounds, payload);
        });
    }
    showOpenWorkspacePopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showOpenWorkspacePopup: { get: () => super.showOpenWorkspacePopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.hidePopup();
            const popupSize = yield this.getPopupSize(this._openWorkspaceType, payload);
            this.showElement(this._popup, targetBounds, popupSize);
            _super.showOpenWorkspacePopup.call(this, targetBounds, payload);
        });
    }
    showSaveWorkspacePopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showSaveWorkspacePopup: { get: () => super.showSaveWorkspacePopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.hidePopup();
            const popupSize = yield this.getPopupSize(this._saveWorkspaceType, payload);
            this.showElement(this._popup, targetBounds, popupSize);
            _super.showSaveWorkspacePopup.call(this, targetBounds, payload);
        });
    }
    hidePopup() {
        $(this._popup).css("visibility", "hidden");
        super.hidePopup();
    }
    initPopup() {
        // const base = location.origin;
        // const workspacesIndexInPath = location.pathname.lastIndexOf("/workspaces/");
        // const workspacesPath = location.pathname.substr(0, workspacesIndexInPath);
        // const path = `${base}${workspacesPath}/workspaces/popups/index.html`;
        // const nodes = $.parseHTML(this.getPopupWindowTemplate(path), document, false);
        // document.body.append(...nodes);
        // this._popup = document.getElementById("popup") as HTMLIFrameElement;
        // (this._popup.contentWindow as PopupContentWindow).frameTarget = this._glue.agm.instance.instance;
    }
    showElement(element, targetBounds, elementSize) {
        $(element)
            .css("visibility", "visible")
            .css("top", `${targetBounds.top}px`)
            .css("left", `${targetBounds.left}px`);
        if (elementSize.height) {
            $(element).css("height", `${elementSize.height}px`);
        }
        if (elementSize.width) {
            $(element).css("width", `${elementSize.width}px`);
        }
        const elementBounds = element.getBoundingClientRect();
        const bodyBounds = document.body.getBoundingClientRect();
        const leftCorrection = bodyBounds.width - elementBounds.right - 10;
        const topCorrection = bodyBounds.height - elementBounds.bottom - 10;
        if (leftCorrection < 0) {
            $(element).css("left", targetBounds.left + leftCorrection);
        }
        if (topCorrection < 0) {
            $(element).css("top", targetBounds.top + topCorrection);
        }
    }
    resizePopup(size) {
        const popup = $(this._popup);
        if (size.height) {
            popup.css("height", `${size.height}px`);
        }
        if (size.width) {
            popup.css("width", `${size.width}px`);
        }
        const elementBounds = this._popup.getBoundingClientRect();
        const bodyBounds = document.body.getBoundingClientRect();
        const leftCorrection = bodyBounds.width - elementBounds.right - 10;
        const topCorrection = bodyBounds.height - elementBounds.bottom - 10;
        if (leftCorrection < 0) {
            const leftCss = popup.css("left");
            const currentLeft = parseInt(leftCss.substring(0, leftCss.length - 2));
            popup.css("left", currentLeft + leftCorrection);
        }
        if (topCorrection < 0) {
            const topCss = popup.css("top");
            const currentTop = parseInt(topCss.substring(0, topCss.length - 2));
            popup.css("top", currentTop + topCorrection);
        }
    }
    getPopupSize(type, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const windowId = this.getPopupInteropId();
            const instance = this._glue.agm.servers().find((i) => i.windowId === windowId);
            return (yield this._glue.agm.invoke(this._showPopupMethod, { type, payload }, instance)).returned;
        });
    }
    registerHideMethod() {
        // To enable application popups uncomment this
        // this._glue.agm.register("T42.Workspaces.HidePopup", () => {
        //     this.hidePopup();
        // });
    }
    registerResizeMethod() {
        // To enable application popups uncomment this
        // this._glue.agm.register("T42.Workspaces.ResizePopup", (args: { size: Size }) => {
        //     this.resizePopup(args.size);
        // });
    }
    getPopupInteropId() {
        try {
            return this._popup.contentWindow.interopId || "best";
        }
        catch (error) {
            // tslint:disable-next-line: no-console
            console.warn("Could not get the popup interop id using best");
        }
        return "best";
    }
    getPopupWindowTemplate(path) {
        return `<iframe id="popup" src="${path}" class="popup"></iframe>`;
    }
}

class ComponentPopupManager extends BasePopupManager {
    constructor(componentFactory, frameId) {
        super(componentFactory);
        this._addApplicationType = "addApplication";
        this._openWorkspaceType = "openWorkspace";
        this._saveWorkspaceType = "saveWorkspace";
        this._channelsSelectorType = "channelsSelector";
        this._popupSizes = {
            [this._addApplicationType]: { height: 200, width: 200 },
            [this._openWorkspaceType]: { height: 200, width: 200 },
            [this._saveWorkspaceType]: { height: 200, width: 200 },
            [this._channelsSelectorType]: { height: 200, width: 200 }
        };
        this.hidePopup = () => {
            document.body.onclick = undefined;
            $(this._popup).css("visibility", "hidden");
            super.hidePopup();
            return new Promise((res) => {
                var _a;
                if ((_a = this.componentFactory) === null || _a === void 0 ? void 0 : _a.hideSystemPopups) {
                    this.componentFactory.hideSystemPopups(res);
                }
                else {
                    res();
                }
            });
        };
        this._frameId = frameId;
        this.initPopup();
    }
    showAddWindowPopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showAddWindowPopup: { get: () => super.showAddWindowPopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.showInternalAddAppPopup(targetBounds, payload.boxId, payload.workspaceId);
            _super.showAddWindowPopup.call(this, targetBounds, payload);
        });
    }
    showOpenWorkspacePopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showOpenWorkspacePopup: { get: () => super.showOpenWorkspacePopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.showInternalOpenWorkspacePopup(targetBounds);
            _super.showOpenWorkspacePopup.call(this, targetBounds, payload);
        });
    }
    showSaveWorkspacePopup(targetBounds, payload) {
        const _super = Object.create(null, {
            showSaveWorkspacePopup: { get: () => super.showSaveWorkspacePopup }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.showInternalSaveWorkspacePopup(targetBounds, payload);
            _super.showSaveWorkspacePopup.call(this, targetBounds, payload);
        });
    }
    showChannelsSelector(targetBounds, payload) {
        const _super = Object.create(null, {
            showChannelsSelector: { get: () => super.showChannelsSelector }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.showInternalChannelsSelector(targetBounds, payload);
            _super.showChannelsSelector.call(this, targetBounds, payload);
        });
    }
    showInternalSaveWorkspacePopup(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hidePopup();
            const popupSize = this.getPopupSize(this._saveWorkspaceType);
            this.showElement(this._popup, targetBounds, popupSize);
            this.componentFactory.createSaveWorkspacePopup({
                frameId: this._frameId,
                domNode: this._popup,
                resizePopup: (s) => this.resizePopup(s, this._saveWorkspaceType, $(this._popup)),
                hidePopup: this.hidePopup,
                workspaceId: payload.workspaceId,
                buildMode: payload.buildMode
            });
        });
    }
    showInternalOpenWorkspacePopup(targetBounds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hidePopup();
            const popupSize = this.getPopupSize(this._openWorkspaceType);
            this.showElement(this._popup, targetBounds, popupSize);
            this.componentFactory.createAddWorkspacePopup({
                domNode: this._popup,
                frameId: this._frameId,
                hidePopup: this.hidePopup,
                resizePopup: (s) => this.resizePopup(s, this._openWorkspaceType, $(this._popup))
            });
        });
    }
    showInternalAddAppPopup(targetBounds, boxId, workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hidePopup();
            const popupSize = this.getPopupSize(this._addApplicationType);
            this.showElement(this._popup, targetBounds, popupSize);
            this.componentFactory.createAddApplicationPopup({
                domNode: this._popup,
                boxId,
                resizePopup: (s) => this.resizePopup(s, this._addApplicationType, $(this._popup)),
                hidePopup: this.hidePopup,
                workspaceId,
                frameId: this._frameId
            });
        });
    }
    showInternalChannelsSelector(targetBounds, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hidePopup();
            const popupSize = this.getPopupSize(this._channelsSelectorType);
            this.showElement(this._popup, targetBounds, popupSize);
            this.componentFactory.createChannelsSelector({
                domNode: this._popup,
                resizePopup: (s) => this.resizePopup(s, this._channelsSelectorType, $(this._popup)),
                hidePopup: this.hidePopup,
                frameId: this._frameId,
                workspaceId: payload.workspaceId,
                windowId: payload.windowId
            });
        });
    }
    initPopup() {
        this._popup = document.createElement("div");
        this._popup.classList.add("workspaces-system-popup");
        document.body.appendChild(this._popup);
    }
    showElement(element, targetBounds, elementSize) {
        document.body.onclick = (e) => {
            const path = e.composedPath();
            if (path.indexOf(this._popup) === -1) {
                this.hidePopup();
            }
        };
        document.body.onblur = () => {
            if (document.activeElement.tagName.toLowerCase() === "iframe") {
                this.hidePopup();
            }
        };
        $(element)
            .css("visibility", "visible")
            .css("top", `${targetBounds.top}px`)
            .css("left", `${targetBounds.left}px`);
        if (elementSize.height) {
            $(element).css("height", `${elementSize.height}px`);
        }
        if (elementSize.width) {
            $(element).css("width", `${elementSize.width}px`);
        }
        const elementBounds = element.getBoundingClientRect();
        const bodyBounds = document.body.getBoundingClientRect();
        const leftCorrection = bodyBounds.width - elementBounds.right - 10;
        const topCorrection = bodyBounds.height - elementBounds.bottom - 10;
        if (leftCorrection < 0) {
            $(element).css("left", targetBounds.left + leftCorrection);
        }
        if (topCorrection < 0) {
            $(element).css("top", targetBounds.top + topCorrection);
        }
    }
    resizePopup(size, type, popup) {
        if (size.height) {
            popup.css("height", `${size.height}px`);
            this._popupSizes[type].height = size.height;
        }
        if (size.width) {
            popup.css("width", `${size.width}px`);
            this._popupSizes[type].width = size.width;
        }
        const elementBounds = popup[0].getBoundingClientRect();
        const bodyBounds = document.body.getBoundingClientRect();
        const leftCorrection = bodyBounds.width - elementBounds.right - 10;
        const topCorrection = bodyBounds.height - elementBounds.bottom - 10;
        if (leftCorrection < 0) {
            const leftCss = popup.css("left");
            const currentLeft = parseInt(leftCss.substring(0, leftCss.length - 2), 10);
            popup.css("left", currentLeft + leftCorrection);
        }
        if (topCorrection < 0) {
            const topCss = popup.css("top");
            const currentTop = parseInt(topCss.substring(0, topCss.length - 2), 10);
            popup.css("top", currentTop + topCorrection);
        }
    }
    getPopupSize(type) {
        return this._popupSizes[type];
    }
}

class ApplicationFactory {
    constructor(_glue, _stateResolver, _frameController, _manager, _delayedExecutor, _platformCommunicator, _systemSettings, _linkController) {
        this._glue = _glue;
        this._stateResolver = _stateResolver;
        this._frameController = _frameController;
        this._manager = _manager;
        this._delayedExecutor = _delayedExecutor;
        this._platformCommunicator = _platformCommunicator;
        this._systemSettings = _systemSettings;
        this._linkController = _linkController;
        this.registry = registryFactory();
        this.WAIT_FOR_WINDOWS_TIMEOUT = 30000;
        this.idToWindowPromise = {};
    }
    start(component, workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (component.config.componentName === EmptyVisibleWindowName) {
                return;
            }
            if (typeof this.idToWindowPromise[idAsString(component.config.id)] !== "undefined") {
                return this.idToWindowPromise[idAsString(component.config.id)];
            }
            const workspace = store.getById(workspaceId);
            if (!workspace) {
                return;
            }
            const startPromise = this.startCore(component, workspace);
            this.idToWindowPromise[idAsString(component.config.id)] = startPromise;
            const unsub = this._frameController.onFrameRemoved((frameId) => {
                if (frameId === idAsString(component.config.id)) {
                    unsub();
                    delete this.idToWindowPromise[frameId];
                }
            });
            return startPromise;
        });
    }
    getLoadingStrategy(systemSettings, contentConfig, restoreConfig) {
        var _a, _b;
        if (restoreConfig === null || restoreConfig === void 0 ? void 0 : restoreConfig.loadingStrategy) {
            return restoreConfig.loadingStrategy;
        }
        else if ((_a = contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.workspacesOptions) === null || _a === void 0 ? void 0 : _a.loadingStrategy) {
            return contentConfig.workspacesOptions.loadingStrategy;
        }
        else if (systemSettings === null || systemSettings === void 0 ? void 0 : systemSettings.loadingStrategy) {
            return (_b = systemSettings === null || systemSettings === void 0 ? void 0 : systemSettings.loadingStrategy) === null || _b === void 0 ? void 0 : _b.defaultStrategy;
        }
    }
    startLazy(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
                return;
            }
            const allComponentsInWorkspace = workspace.layout.root.getItemsByType("component");
            const result = this.getComponentsByVisibility(allComponentsInWorkspace.map((c) => c));
            return Promise.all(result.visibleComponents.map((c) => this.start(c, workspaceId)));
        });
    }
    startDelayed(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
                return;
            }
            const allComponentsInWorkspace = workspace.layout.root.getItemsByType("component");
            const result = this.getComponentsByVisibility(allComponentsInWorkspace.map((c) => c));
            const visiblePromises = result.visibleComponents.map((c) => this.start(c, workspaceId));
            const loadingStrategy = (yield this._systemSettings.getSettings()).loadingStrategy;
            const loadPromises = Promise.all(visiblePromises).then(() => {
                var _a, _b, _c;
                return this._delayedExecutor.startExecution(result.notImmediatelyVisibleComponents.map((c) => ({
                    id: idAsString(c.config.id),
                    action: () => this.start(c, workspaceId)
                })), {
                    batchSize: ((_a = loadingStrategy === null || loadingStrategy === void 0 ? void 0 : loadingStrategy.delayed) === null || _a === void 0 ? void 0 : _a.batch) || 1,
                    executionInterval: ((_b = loadingStrategy === null || loadingStrategy === void 0 ? void 0 : loadingStrategy.delayed) === null || _b === void 0 ? void 0 : _b.interval) || 5000,
                    initialDelay: ((_c = loadingStrategy === null || loadingStrategy === void 0 ? void 0 : loadingStrategy.delayed) === null || _c === void 0 ? void 0 : _c.initialOffsetInterval) || 1000
                });
            });
            return loadPromises;
        });
    }
    startDirect(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout)) {
                return;
            }
            const allComponentsInWorkspace = workspace.layout.root.getItemsByType("component");
            yield Promise.all(allComponentsInWorkspace.map((c) => {
                return this.start(c, workspaceId);
            }));
        });
    }
    onStarted(callback) {
        return this.registry.add("on-started", callback);
    }
    onLoaded(callback) {
        return this.registry.add("on-loaded", callback);
    }
    onFailed(callback) {
        return this.registry.add("on-failed", callback);
    }
    waitForWindows(workspaceId, windowComponentIds) {
        return new Promise((res, rej) => {
            let loadedUnsub = () => { };
            let failedUnsub = () => { };
            let timeout;
            const [ready, result] = this.waitFor(windowComponentIds.length, () => {
                res();
                loadedUnsub();
                failedUnsub();
                clearTimeout(timeout);
            });
            timeout = setTimeout(() => {
                rej(`Waiting for windows ${JSON.stringify(windowComponentIds)} in workspace ${workspaceId}, but only heard ${JSON.stringify(result())} in ${this.WAIT_FOR_WINDOWS_TIMEOUT} seconds`);
            }, this.WAIT_FOR_WINDOWS_TIMEOUT);
            loadedUnsub = this.onLoaded(({ summary }) => {
                if (summary.config.workspaceId === workspaceId && windowComponentIds.includes(summary.itemId)) {
                    ready(summary.itemId);
                }
            });
            failedUnsub = this.onFailed((args) => {
                if (args.workspaceId === workspaceId && windowComponentIds.includes(idAsString(args.component.config.id))) {
                    ready(args.component.config.id);
                }
            });
        });
    }
    getUrlByAppName(appName) {
        var _a, _b, _c, _d;
        if (!appName) {
            return undefined;
        }
        return (_d = (_c = (_b = (_a = this._glue.appManager) === null || _a === void 0 ? void 0 : _a.application(appName)) === null || _b === void 0 ? void 0 : _b.userProperties) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.url;
    }
    raiseFailed(component, workspaceId) {
        this.registry.execute("on-failed", { component, workspaceId });
    }
    getTitleByAppName(appName) {
        var _a, _b;
        if (!appName) {
            return undefined;
        }
        return (_b = (_a = this._glue.appManager) === null || _a === void 0 ? void 0 : _a.application(appName)) === null || _b === void 0 ? void 0 : _b.title;
    }
    getAppNameByWindowId(windowId) {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this._glue.appManager) === null || _a === void 0 ? void 0 : _a.instances()) === null || _b === void 0 ? void 0 : _b.find(i => i.id === windowId)) === null || _c === void 0 ? void 0 : _c.application) === null || _d === void 0 ? void 0 : _d.name;
    }
    waitFor(numberOfTriggers, callback) {
        const triggersActivated = [];
        return [
            (x) => {
                triggersActivated.push(x);
                if (triggersActivated.length === numberOfTriggers) {
                    callback();
                }
            },
            () => triggersActivated
        ];
    }
    validateTitle(title) {
        if (!(title === null || title === void 0 ? void 0 : title.length)) {
            return undefined;
        }
        return title;
    }
    getComponentsByVisibility(components) {
        const visibleComponents = components.filter((c) => this._stateResolver.isWindowSelected(c.config.id));
        const notImmediatelyVisibleComponents = components.filter(c => !visibleComponents.includes(c));
        return {
            visibleComponents,
            notImmediatelyVisibleComponents
        };
    }
    startCore(component, workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const newWindowBounds = getElementBounds(component.element);
            const { componentState } = component.config;
            const { title } = componentState;
            const appName = this.getAppName(component);
            let { windowId } = componentState;
            const componentId = idAsString(component.config.id);
            const applicationTitle = this.getTitleByAppName(appName);
            const windowTitle = this.validateTitle(title) || this.validateTitle(applicationTitle) || this.validateTitle(appName) || "Glue";
            const windowContext = yield this.getContextForNewWindow(component);
            let url = this.getUrlByAppName(appName) || ((_c = (_b = (_a = component.config.workspacesConfig) === null || _a === void 0 ? void 0 : _a.noAppWindowState) === null || _b === void 0 ? void 0 : _b.createArgs) === null || _c === void 0 ? void 0 : _c.url);
            const isNewWindow = !this._frameController.hasFrame(componentId);
            const isHibernatedWindow = workspace.hibernatedWindows.some(w => w.id === idAsString(component.config.id));
            const channelId = component.config.workspacesConfig.channelId;
            store.addWindow({
                id: componentId,
                bounds: newWindowBounds,
                windowId,
                url,
                appName
            }, workspace.id);
            if (!url && windowId) {
                const win = this._glue.windows.list().find((w) => w.id === windowId);
                url = yield win.getURL();
                const newlyAddedWindow = store.getWindow(componentId);
                newlyAddedWindow.url = url;
            }
            windowId = windowId || generateWindowId();
            if ((_d = component.config.componentState) === null || _d === void 0 ? void 0 : _d.context) {
                delete component.config.componentState.context;
            }
            component.config.componentState.url = url;
            component.config.componentState.appName = appName;
            if (windowTitle) {
                component.setTitle(windowTitle);
                componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId: componentId, title: windowTitle });
            }
            if (isNewWindow && !isHibernatedWindow) {
                const windowSummary = this._stateResolver.getWindowSummarySync(component.config.id, component);
                this._manager.workspacesEventEmitter.raiseWindowEvent({
                    action: "added",
                    payload: {
                        windowSummary
                    }
                });
                const glueWinOutsideOfWorkspace = this._glue.windows.findById(windowId);
                if (glueWinOutsideOfWorkspace) {
                    try {
                        // Glue windows with the given id should be closed
                        yield glueWinOutsideOfWorkspace.close();
                    }
                    catch (error) {
                        // because of chrome security policy this call can fail,
                        // however the opening of a new window should continue
                    }
                }
            }
            const notifyArgs = {
                windowId,
                appName,
                context: windowContext,
                title: windowTitle,
                workspaceId: workspace.id,
                channelId
            };
            try {
                yield this._platformCommunicator.notifyFrameWillStart(notifyArgs);
                yield this._frameController.startFrame(componentId, url, undefined, windowId, appName);
                const newlyAddedWindow = store.getWindow(componentId);
                component.config.componentState.windowId = windowId;
                newlyAddedWindow.windowId = windowId;
                componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId: componentId, windowId });
                const newlyOpenedWindow = this._glue.windows.findById(windowId);
                newlyOpenedWindow.getTitle().then((winTitle) => {
                    if (this.validateTitle(winTitle)) {
                        component.setTitle(winTitle);
                        componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId: componentId, title: winTitle });
                    }
                }).catch((e) => {
                    console.warn("Failed while setting the window title", e);
                });
                this._frameController.moveFrame(componentId, getElementBounds(component.element));
                if (isNewWindow && !isHibernatedWindow) {
                    this._manager.workspacesEventEmitter.raiseWindowEvent({
                        action: "loaded",
                        payload: {
                            windowSummary: yield this._stateResolver.getWindowSummary(componentId)
                        }
                    });
                }
                const maximizedItems = component.layoutManager.root.getItemsByFilter((ci) => ci.isMaximized && ci.type !== "component");
                const components = maximizedItems.reduce((acc, mi) => [...acc, ...mi.getItemsByFilter((ci) => ci.type === "component")], []);
                if (components.some(c => c === component)) {
                    this._frameController.maximizeTab(componentId);
                    this._frameController.selectionChanged([componentId], []);
                }
            }
            catch (error) {
                this.raiseFailed(component, workspace.id);
                if (url) {
                    this._frameController.moveFrame(componentId, getElementBounds(component.element));
                }
                else {
                    // Making sure the windowId is set so the platform can remove the window as well
                    component.config.componentState.windowId = windowId;
                    yield this._manager.closeTab(component, false);
                }
                // If a frame doesn't initialize properly remove its windowId
                component.config.componentState.windowId = undefined;
                const wsp = store.getById(workspace.id);
                if (!wsp) {
                    throw new Error(`Workspace ${workspace.id} failed ot initialize because none of the specified windows were able to load
                Internal error: ${error}`);
                }
            }
            finally {
                workspace.hibernatedWindows = workspace.hibernatedWindows.filter((hw) => hw.id !== idAsString(component.config.id));
            }
        });
    }
    getContextForNewWindow(component) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { windowId, context } = (_b = (_a = component === null || component === void 0 ? void 0 : component.config) === null || _a === void 0 ? void 0 : _a.componentState) !== null && _b !== void 0 ? _b : {};
            if (!windowId) {
                return context;
            }
            const win = this._glue.windows.findById(windowId);
            if (!win) {
                return context;
            }
            const winContext = yield win.getContext();
            return Object.assign(Object.assign({}, winContext), context || {});
        });
    }
    getAppName(component) {
        var _a, _b;
        const { appName, windowId } = (_b = (_a = component === null || component === void 0 ? void 0 : component.config) === null || _a === void 0 ? void 0 : _a.componentState) !== null && _b !== void 0 ? _b : {};
        return appName || this.getAppNameByWindowId(windowId);
    }
}

class DelayedExecutor {
    constructor() {
        this.actionsInProgress = [];
    }
    startExecution(actions, executionOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const batchesArray = this.splitInBatches(actions, executionOptions.batchSize);
            yield this.waitFor(executionOptions.initialDelay);
            const results = batchesArray.reduce((acc, batch) => __awaiter(this, void 0, void 0, function* () {
                const awaited = yield acc;
                awaited.push(...yield this.executeBatch(batch));
                yield this.waitFor(executionOptions.executionInterval);
                return Promise.resolve(awaited);
            }), Promise.resolve([]));
            return results.then(() => {
                this.actionsInProgress = [];
            });
        });
    }
    isActionInProgress(id) {
        return this.actionsInProgress.some((a) => a.id === id);
    }
    executeBatch(batch) {
        this.actionsInProgress = batch;
        return Promise.all(batch.map((b) => b.action()));
    }
    splitInBatches(actions, batchSize) {
        return actions.reduce((acc, a, i) => {
            if (i % batchSize === 0) {
                acc.push([a]);
            }
            else {
                const lastArray = acc.pop();
                lastArray.push(a);
                acc.push(lastArray);
            }
            return acc;
        }, []);
    }
    waitFor(ms) {
        return new Promise((res) => {
            setTimeout(() => {
                res();
            }, ms);
        });
    }
}

class WorkspacesSystemSettingsProvider {
    constructor(_platformCommunicator) {
        this._platformCommunicator = _platformCommunicator;
    }
    getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.settings) {
                this.settings = yield this._platformCommunicator.askForSettings();
            }
            return this.settings;
        });
    }
}

class ConstraintsValidator {
    validateWorkspace(workspace) {
        const allItemsInWorkspace = this.getAllItemsFromWorkspace(workspace);
        const invalidItems = allItemsInWorkspace.filter((itemInWorkspace) => {
            return !this.areConstraintsValid(this.getConstraintsFromItem(itemInWorkspace));
        });
        return !invalidItems.length;
    }
    fixWorkspace(workspace) {
        const allItemsInWorkspace = this.getAllItemsFromWorkspace(workspace);
        const invalidItems = allItemsInWorkspace.filter((itemInWorkspace) => {
            return !this.areConstraintsValid(this.getConstraintsFromItem(itemInWorkspace));
        });
        if (invalidItems.length) {
            allItemsInWorkspace.forEach((itemInWorkspace) => {
                if (!itemInWorkspace.config) {
                    return;
                }
                itemInWorkspace.config.minWidth = DefaultMinSize;
                itemInWorkspace.config.minHeight = DefaultMinSize;
                itemInWorkspace.config.maxWidth = DefaultMaxSize;
                itemInWorkspace.config.maxHeight = DefaultMaxSize;
            });
            return false;
        }
        return true;
    }
    fixNewWindow(window, workspace, parentId) {
        var _a, _b, _c, _d;
        let parent;
        if (((_a = window.config) === null || _a === void 0 ? void 0 : _a.minWidth) === undefined &&
            ((_b = window.config) === null || _b === void 0 ? void 0 : _b.maxWidth) === undefined &&
            ((_c = window.config) === null || _c === void 0 ? void 0 : _c.minHeight) === undefined &&
            ((_d = window.config) === null || _d === void 0 ? void 0 : _d.maxHeight) === undefined) {
            return;
        }
        const traverse = (item, parentIdToFind) => {
            if (parent) {
                return;
            }
            if (item.type === "window") {
                return;
            }
            if (item.id === parentIdToFind) {
                parent = item;
                return;
            }
            item.children.forEach((c) => {
                traverse(c, parentId);
            });
        };
        traverse(workspace, parentId);
        parent.children.push(window);
        if (!this.validateWorkspace(workspace)) {
            window.config.minWidth = DefaultMinSize;
            window.config.maxWidth = DefaultMaxSize;
            window.config.minHeight = DefaultMinSize;
            window.config.maxHeight = DefaultMaxSize;
        }
    }
    fixNewContainer(container, workspace, parentId) {
        let parent;
        const traverse = (item, parentIdToFind) => {
            if (parent) {
                return;
            }
            if (item.type === "window") {
                return;
            }
            if (item.id === parentIdToFind) {
                parent = item;
                return;
            }
            item.children.forEach((c) => {
                traverse(c, parentId);
            });
        };
        traverse(workspace, parentId);
        parent.children.push(container);
        if (!this.validateWorkspace(workspace)) {
            const disableConstraintsRecursive = (item) => {
                if (item.config) {
                    item.config.minWidth = DefaultMinSize;
                    item.config.maxWidth = DefaultMaxSize;
                    item.config.minHeight = DefaultMinSize;
                    item.config.maxHeight = DefaultMaxSize;
                }
                if (item.type === "window") {
                    return;
                }
                item.children.forEach((c) => disableConstraintsRecursive(c));
            };
            disableConstraintsRecursive(container);
        }
    }
    getAllItemsFromWorkspace(workspace) {
        const allItemsInWorkspace = [];
        const traverse = (item) => {
            allItemsInWorkspace.push(item);
            if (item.type === "window") {
                return;
            }
            item.children.forEach((c) => traverse(c));
        };
        traverse(workspace);
        return allItemsInWorkspace;
    }
    areConstraintsValid(constraints) {
        return constraints.minWidth <= constraints.maxWidth &&
            constraints.minHeight <= constraints.maxHeight;
    }
    getConstraintsFromItem(item) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const itemMinWidth = (_b = (_a = item.config) === null || _a === void 0 ? void 0 : _a.minWidth) !== null && _b !== void 0 ? _b : DefaultMinSize;
        const itemMaxWidth = (_d = (_c = item.config) === null || _c === void 0 ? void 0 : _c.maxWidth) !== null && _d !== void 0 ? _d : DefaultMaxSize;
        const itemMinHeight = (_f = (_e = item.config) === null || _e === void 0 ? void 0 : _e.minHeight) !== null && _f !== void 0 ? _f : DefaultMinSize;
        const itemMaxHeight = (_h = (_g = item.config) === null || _g === void 0 ? void 0 : _g.maxHeight) !== null && _h !== void 0 ? _h : DefaultMaxSize;
        let childrenMinWidth = 0;
        let childrenMaxWidth = 0;
        let childrenMinHeight = 0;
        let childrenMaxHeight = 0;
        if (item.type === "window") {
            return {
                minWidth: itemMinWidth,
                maxWidth: itemMaxWidth,
                minHeight: itemMinHeight,
                maxHeight: itemMaxHeight,
            };
        }
        else if (item.type === "row") {
            item.children.forEach((ci) => {
                var _a, _b, _c, _d;
                const childConstraints = this.getConstraintsFromItem(ci);
                childrenMinWidth += (_a = childConstraints.minWidth) !== null && _a !== void 0 ? _a : DefaultMinSize;
                childrenMaxWidth += (_b = childConstraints.maxWidth) !== null && _b !== void 0 ? _b : DefaultMaxSize;
                childrenMinHeight = Math.max((_c = childConstraints.minHeight) !== null && _c !== void 0 ? _c : DefaultMinSize, childrenMinHeight);
                childrenMaxHeight = Math.min((_d = childConstraints.maxHeight) !== null && _d !== void 0 ? _d : DefaultMaxSize, childrenMaxHeight || itemMaxHeight);
            });
        }
        else if (item.type === "column") {
            item.children.forEach((ci) => {
                var _a, _b, _c, _d;
                const childConstraints = this.getConstraintsFromItem(ci);
                childrenMinWidth = Math.max((_a = childConstraints.minWidth) !== null && _a !== void 0 ? _a : DefaultMinSize, childrenMinWidth);
                childrenMaxWidth = Math.min((_b = childConstraints.maxWidth) !== null && _b !== void 0 ? _b : DefaultMaxSize, childrenMaxWidth || itemMaxWidth);
                childrenMinHeight += (_c = childConstraints.minHeight) !== null && _c !== void 0 ? _c : DefaultMinSize;
                childrenMaxHeight += (_d = childConstraints.maxHeight) !== null && _d !== void 0 ? _d : DefaultMaxSize;
            });
        }
        else { // handles group and workspace
            item.children.forEach((ci) => {
                var _a, _b, _c, _d;
                const childConstraints = this.getConstraintsFromItem(ci);
                childrenMinWidth = Math.max((_a = childConstraints.minWidth) !== null && _a !== void 0 ? _a : DefaultMinSize, childrenMinWidth);
                childrenMaxWidth = Math.min((_b = childConstraints.maxWidth) !== null && _b !== void 0 ? _b : DefaultMaxSize, childrenMaxWidth || itemMaxWidth);
                childrenMinHeight = Math.max((_c = childConstraints.minHeight) !== null && _c !== void 0 ? _c : DefaultMinSize, childrenMinHeight);
                childrenMaxHeight = Math.min((_d = childConstraints.maxHeight) !== null && _d !== void 0 ? _d : DefaultMaxSize, childrenMaxHeight || itemMaxHeight);
            });
        }
        childrenMaxWidth = childrenMaxWidth || itemMaxWidth;
        childrenMaxHeight = childrenMaxHeight || itemMaxHeight;
        return {
            minWidth: Math.max(itemMinWidth, childrenMinWidth),
            maxWidth: Math.min(itemMaxWidth, childrenMaxWidth),
            minHeight: Math.max(itemMinHeight, childrenMinHeight),
            maxHeight: Math.min(itemMaxHeight, childrenMaxHeight),
        };
    }
}

class PlatformCommunicator {
    constructor(_glue, _frameId) {
        this._glue = _glue;
        this._frameId = _frameId;
    }
    get platformConfig() {
        return window.glue42core || window.iobrowser;
    }
    requestOnLayoutSaveContexts(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const isOperationSupported = yield this.isOperationSupported({ domain: "workspaces", operation: "getWorkspaceWindowsOnLayoutSaveContext" });
            if (!isOperationSupported) {
                console.warn(`Workspace layout ${data.layoutName} won't save the window contexts because the platform must be at lease version 1.13.0`);
                return [];
            }
            try {
                const result = yield this._glue.agm.invoke(PlatformControlMethod, {
                    domain: "workspaces",
                    operation: "getWorkspaceWindowsOnLayoutSaveContext",
                    data
                });
                return (_b = (_a = result === null || result === void 0 ? void 0 : result.returned) === null || _a === void 0 ? void 0 : _a.windowsOnSaveData) !== null && _b !== void 0 ? _b : [];
            }
            catch (error) {
                console.warn("The save of window contexts unexpectedly failed with ", error);
            }
            return [];
        });
    }
    notifyFrameWillStart(args) {
        const browserGlobal = window.glue42core || window.iobrowser;
        const systemId = browserGlobal.communicationId;
        const domain = args.appName ? "appManager" : "windows";
        const operation = args.appName ? "registerWorkspaceApp" : "registerWorkspaceWindow";
        const data = Object.assign({ name: `${args.appName || "window"}_${args.windowId}`, frameId: this._frameId }, args);
        return this._glue.interop.invoke(PlatformControlMethod, { domain, operation, data }, systemId ? { instance: systemId } : undefined);
    }
    notifyFrameWillClose(windowId, appName) {
        const domain = appName ? "appManager" : "windows";
        const operation = appName ? "unregisterWorkspaceApp" : "unregisterWorkspaceWindow";
        const data = { windowId };
        return this.sendControllMessage(domain, operation, data);
    }
    sendEjectWindowCommand(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const domain = "workspaces";
            const operation = "ejectWindow";
            const result = yield this.sendControllMessage(domain, operation, data);
            return result.returned;
        });
    }
    askForSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._systemSettings) {
                return this._systemSettings;
            }
            const result = yield this.sendControllMessage("workspaces", "getWorkspacesConfig", {});
            this._systemSettings = result.returned;
            return this._systemSettings;
        });
    }
    isOperationSupported(config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this._glue.agm.invoke(PlatformControlMethod, {
                    domain: config.domain,
                    operation: "operationCheck",
                    data: { operation: config.operation }
                });
                return result.returned.isSupported;
            }
            catch (error) {
                return false;
            }
        });
    }
    sendControllMessage(domain, operation, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const browserGlobal = window.glue42core || window.iobrowser;
            const systemId = browserGlobal.communicationId;
            return this._glue.interop.invoke(PlatformControlMethod, {
                domain,
                operation,
                data
            }, systemId ? { instance: systemId } : undefined);
        });
    }
}

class WorkspaceContainerWrapper {
    constructor(wrapperFactory, layoutEventEmitter, containerContentItem, frameId, workspaceId) {
        this.wrapperFactory = wrapperFactory;
        this.layoutEventEmitter = layoutEventEmitter;
        this.containerContentItem = containerContentItem;
        this.frameId = frameId;
        this.workspaceId = workspaceId;
    }
    get id() {
        var _a;
        return idAsString((_a = this.containerContentItem) === null || _a === void 0 ? void 0 : _a.config.id);
    }
    get minWidth() {
        var _a;
        return (_a = this.containerContentItem.getMinWidth()) !== null && _a !== void 0 ? _a : DefaultMinSize;
    }
    set minWidth(value) {
        if (this.containerContentItem.type === "row") {
            throw new Error(`Cannot set minWidth ${value} to a container of type row`);
        }
        if (isNaN(value) || value < 0) {
            throw new Error(`Invalued value passed for minWidth ${value}`);
        }
        this.containerContentItem.config.workspacesConfig.minWidth = value;
    }
    get minHeight() {
        var _a;
        return (_a = this.containerContentItem.getMinHeight()) !== null && _a !== void 0 ? _a : DefaultMinSize;
    }
    set minHeight(value) {
        if (this.containerContentItem.type === "column") {
            throw new Error(`Cannot set minHeight ${value} to a container of type column`);
        }
        if (isNaN(value) || value < 0) {
            throw new Error(`Invalued value passed for minHeight ${value}`);
        }
        this.containerContentItem.config.workspacesConfig.minHeight = value;
    }
    get maxWidth() {
        var _a;
        return (_a = this.containerContentItem.getMaxWidth()) !== null && _a !== void 0 ? _a : DefaultMaxSize;
    }
    set maxWidth(value) {
        if (this.containerContentItem.type === "row") {
            throw new Error(`Cannot set maxWidth ${value} to a container of type row`);
        }
        if (isNaN(value) || value < 0) {
            throw new Error(`Invalued value passed for maxWidth ${value}`);
        }
        this.containerContentItem.config.workspacesConfig.maxWidth = value;
    }
    get maxHeight() {
        var _a;
        return (_a = this.containerContentItem.getMaxHeight()) !== null && _a !== void 0 ? _a : DefaultMaxSize;
    }
    set maxHeight(value) {
        if (this.containerContentItem.type === "column") {
            throw new Error(`Cannot set maxHeight ${value} to a container of type column`);
        }
        if (isNaN(value) || value < 0) {
            throw new Error(`Invalued value passed for maxHeight ${value}`);
        }
        this.containerContentItem.config.workspacesConfig.maxHeight = value;
    }
    get allowDrop() {
        return this.getLockPropertyFromConfig("allowDrop");
    }
    set allowDrop(value) {
        this.setLockPropertyFromConfig("allowDrop", value);
        this.populateChildrenAllowDrop(value);
    }
    get allowDropHeader() {
        return this.getLockPropertyFromConfig("allowDropHeader");
    }
    set allowDropHeader(value) {
        this.setLockPropertyFromConfig("allowDropHeader", value);
    }
    get allowDropLeft() {
        return this.getLockPropertyFromConfig("allowDropLeft");
    }
    set allowDropLeft(value) {
        this.setLockPropertyFromConfig("allowDropLeft", value);
    }
    get allowDropRight() {
        return this.getLockPropertyFromConfig("allowDropRight");
    }
    set allowDropRight(value) {
        this.setLockPropertyFromConfig("allowDropRight", value);
    }
    get allowDropTop() {
        return this.getLockPropertyFromConfig("allowDropTop");
    }
    set allowDropTop(value) {
        this.setLockPropertyFromConfig("allowDropTop", value);
    }
    get allowDropBottom() {
        return this.getLockPropertyFromConfig("allowDropBottom");
    }
    set allowDropBottom(value) {
        this.setLockPropertyFromConfig("allowDropBottom", value);
    }
    get allowExtract() {
        return this.getLockPropertyFromConfig("allowExtract");
    }
    set allowExtract(value) {
        this.setLockPropertyFromConfig("allowExtract", value);
        this.populateChildrenAllowExtract(value);
    }
    get allowReorder() {
        return this.getLockPropertyFromConfig("allowReorder");
    }
    set allowReorder(value) {
        this.setLockPropertyFromConfig("allowReorder", value);
        this.populateChildrenAllowReorder(value);
    }
    get allowSplitters() {
        if (this.containerContentItem.config.type === "stack") {
            throw new Error(`Accessing allowSplitters of container ${this.containerContentItem.type} ${this.id} the property is available only for rows and columns`);
        }
        return this.getLockPropertyFromConfig("allowSplitters");
    }
    set allowSplitters(value) {
        if (this.containerContentItem.config.type === "stack") {
            throw new Error(`Setting allowSplitters of container ${this.containerContentItem.type} ${this.id} the property is available only for rows and columns`);
        }
        this.setLockPropertyFromConfig("allowSplitters", value);
        this.populateChildrenAllowSplitters(value);
    }
    get showMaximizeButton() {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Accessing showMaximizeButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        return this.getLockPropertyFromConfig("showMaximizeButton");
    }
    set showMaximizeButton(value) {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Setting showMaximizeButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        this.setLockPropertyFromConfig("showMaximizeButton", value);
    }
    get showEjectButton() {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Accessing showEjectButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        return this.getLockPropertyFromConfig("showEjectButton");
    }
    set showEjectButton(value) {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Setting showEjectButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        this.setLockPropertyFromConfig("showEjectButton", value);
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({ groupId: this.id, eject: { visible: value } });
    }
    get showAddWindowButton() {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Accessing showAddWindowButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        return this.getLockPropertyFromConfig("showAddWindowButton");
    }
    set showAddWindowButton(value) {
        if (this.containerContentItem.config.type !== "stack") {
            throw new Error(`Setting showAddWindowButton of container ${this.containerContentItem.type} ${this.id} the property is available only for stacks`);
        }
        this.setLockPropertyFromConfig("showAddWindowButton", value);
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({ groupId: this.id, addWindow: { visible: value } });
        componentStateMonitor.decoratedFactory.updateAfterGroupTabs({ groupId: this.id, addWindow: { visible: value } });
    }
    get positionIndex() {
        var _a, _b;
        return ((_b = (_a = this.containerContentItem) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.contentItems.indexOf(this.containerContentItem)) || 0;
    }
    get bounds() {
        var _a, _b, _c, _d;
        if (!this.containerContentItem) {
            return {};
        }
        if (!this.containerContentItem.config.workspacesConfig) {
            this.containerContentItem.config.workspacesConfig = {};
        }
        const workspaceId = (_a = this.workspaceId) !== null && _a !== void 0 ? _a : (_b = store.getByContainerId(this.id)) === null || _b === void 0 ? void 0 : _b.id;
        if (workspaceId && this.isWorkspaceSelected(workspaceId)) {
            const bounds = getElementBounds(this.containerContentItem.element);
            this.containerContentItem.config.workspacesConfig.cachedBounds = bounds;
            return bounds;
        }
        const elementBounds = getElementBounds(this.containerContentItem.element);
        if (elementBounds.width === 0 && elementBounds.height === 0 && ((_c = this.containerContentItem.config.workspacesConfig) === null || _c === void 0 ? void 0 : _c.cachedBounds)) {
            return (_d = this.containerContentItem.config.workspacesConfig) === null || _d === void 0 ? void 0 : _d.cachedBounds;
        }
        return elementBounds;
    }
    get isPinned() {
        var _a;
        return (_a = this.containerContentItem.config.workspacesConfig.isPinned) !== null && _a !== void 0 ? _a : false;
    }
    get maximizationBoundary() {
        var _a;
        return (_a = this.containerContentItem.config.workspacesConfig.maximizationBoundary) !== null && _a !== void 0 ? _a : false;
    }
    set maximizationBoundary(value) {
        this.containerContentItem.config.workspacesConfig.maximizationBoundary = value;
    }
    get activeItemId() {
        if (this.containerContentItem.type !== "stack") {
            return "";
        }
        return idAsString(this.containerContentItem.getActiveContentItem().config.id);
    }
    get summary() {
        var _a, _b, _c;
        const workspaceId = (_a = this.workspaceId) !== null && _a !== void 0 ? _a : (_b = store.getByContainerId(this.id)) === null || _b === void 0 ? void 0 : _b.id;
        const userFriendlyType = this.getUserFriendlyType(((_c = this.containerContentItem) === null || _c === void 0 ? void 0 : _c.type) || "workspace");
        let config = {
            workspaceId,
            frameId: this.frameId,
            positionIndex: this.positionIndex,
            allowDrop: this.allowDrop,
            minWidth: this.minWidth,
            maxWidth: this.maxWidth,
            minHeight: this.minHeight,
            maxHeight: this.maxHeight,
            widthInPx: this.bounds.width,
            heightInPx: this.bounds.height,
            isPinned: this.isPinned,
            isMaximized: this.isMaximized,
            maximizationBoundary: this.maximizationBoundary
        };
        const type = userFriendlyType === "window" ? undefined : userFriendlyType;
        if (type === "group") {
            config = Object.assign(Object.assign({}, config), { allowExtract: this.allowExtract, allowReorder: this.allowReorder, showMaximizeButton: this.showMaximizeButton, showEjectButton: this.showEjectButton, showAddWindowButton: this.showAddWindowButton, allowDropHeader: this.allowDropHeader, allowDropLeft: this.allowDropLeft, allowDropRight: this.allowDropRight, allowDropTop: this.allowDropTop, allowDropBottom: this.allowDropBottom });
        }
        if (type !== "group") {
            config = Object.assign(Object.assign({}, config), { allowSplitters: this.allowSplitters });
        }
        return {
            itemId: this.id,
            type: userFriendlyType === "window" ? undefined : userFriendlyType,
            config
        };
    }
    get config() {
        var _a;
        const workspace = store.getByContainerId(this.containerContentItem.config.id) ||
            store.getByWindowId(this.id);
        const workspaceConfig = workspace.layout.toConfig();
        const containerConfig = this.findElementInConfig(this.id, workspaceConfig);
        containerConfig.workspacesConfig.isPinned = (_a = containerConfig.workspacesConfig.isPinned) !== null && _a !== void 0 ? _a : false;
        return containerConfig;
    }
    get isMaximized() {
        return this.containerContentItem.hasId("__glMaximised");
    }
    populateBoundsCache() {
        if (this.isWorkspaceSelected(this.workspaceId)) {
            const bounds = getElementBounds(this.containerContentItem.element);
            this.containerContentItem.config.workspacesConfig.cachedBounds = bounds;
        }
    }
    populateChildrenAllowDrop(value) {
        const lockChildren = (children) => {
            children.forEach((c) => {
                if (c.type === "component") {
                    return;
                }
                const wrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: c });
                wrapper.allowDrop = value;
                lockChildren(c.contentItems);
            });
        };
        lockChildren(this.containerContentItem.contentItems);
    }
    populateChildrenAllowExtract(value) {
        const lockChildren = (children) => {
            children.forEach((c) => {
                if (c.type === "component") {
                    const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: c });
                    windowWrapper.allowExtract = value;
                    return;
                }
                if (c.type === "stack") {
                    const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: c });
                    containerWrapper.allowExtract = value;
                }
                lockChildren(c.contentItems);
            });
        };
        lockChildren(this.containerContentItem.contentItems);
    }
    populateChildrenAllowReorder(value) {
        const lockChildren = (children) => {
            children.forEach((c) => {
                if (c.type === "component") {
                    const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: c });
                    windowWrapper.allowReorder = value;
                    return;
                }
                if (c.type === "stack") {
                    const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: c });
                    containerWrapper.allowReorder = value;
                }
                lockChildren(c.contentItems);
            });
        };
        lockChildren(this.containerContentItem.contentItems);
    }
    populateChildrenAllowSplitters(value) {
        const lockChildren = (children) => {
            children.forEach((c) => {
                if (c.type === "component" || c.type === "stack") {
                    return;
                }
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: c });
                containerWrapper.allowSplitters = value;
                lockChildren(c.contentItems);
            });
        };
        lockChildren(this.containerContentItem.contentItems);
    }
    getUserFriendlyType(type) {
        if (type === "stack") {
            return "group";
        }
        else if (type === "root") {
            return "workspace";
        }
        else if (type === "component") {
            return "window";
        }
        return type;
    }
    findElementInConfig(elementId, config) {
        const search = (glConfig) => {
            if (idAsString(glConfig.id) === elementId) {
                return [glConfig];
            }
            const contentToTraverse = glConfig.content || [];
            return contentToTraverse.reduce((acc, ci) => [...acc, ...search(ci)], []);
        };
        const searchResult = search(config);
        return searchResult.find((i) => i.id);
    }
    isWorkspaceSelected(workspaceId) {
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspaceId });
        return wrapper.isSelected;
    }
    getLockPropertyFromConfig(propertyName) {
        var _a;
        return (_a = this.containerContentItem.config.workspacesConfig[propertyName]) !== null && _a !== void 0 ? _a : true;
    }
    setLockPropertyFromConfig(propertyName, value) {
        const previousValue = this.getLockPropertyFromConfig(propertyName);
        this.containerContentItem.config.workspacesConfig[propertyName] = value;
        const newValue = this.getLockPropertyFromConfig(propertyName);
        if (previousValue !== newValue) {
            this.layoutEventEmitter.raiseEvent("container-lock-configuration-changed", { item: this.containerContentItem });
        }
    }
}

class WorkspaceWindowWrapper {
    constructor(wrapperFactory, layoutEventEmitter, windowContentItem, frameId) {
        this.wrapperFactory = wrapperFactory;
        this.layoutEventEmitter = layoutEventEmitter;
        this.windowContentItem = windowContentItem;
        this.frameId = frameId;
    }
    get minWidth() {
        return this.windowContentItem.getMinWidth();
    }
    set minWidth(value) {
        this.windowContentItem.config.workspacesConfig.minWidth = value;
    }
    get maxWidth() {
        return this.windowContentItem.getMaxWidth();
    }
    set maxWidth(value) {
        this.windowContentItem.config.workspacesConfig.maxWidth = value;
    }
    get minHeight() {
        return this.windowContentItem.getMinHeight();
    }
    set minHeight(value) {
        this.windowContentItem.config.workspacesConfig.minHeight = value;
    }
    get maxHeight() {
        return this.windowContentItem.getMaxHeight();
    }
    set maxHeight(value) {
        this.windowContentItem.config.workspacesConfig.maxHeight = value;
    }
    get allowExtract() {
        return this.getLockPropertyFromConfig("allowExtract");
    }
    set allowExtract(value) {
        this.setLockPropertyInConfig("allowExtract", value);
    }
    get allowReorder() {
        return this.getLockPropertyFromConfig("allowReorder");
    }
    set allowReorder(value) {
        this.setLockPropertyInConfig("allowReorder", value);
    }
    get showCloseButton() {
        return this.getLockPropertyFromConfig("showCloseButton");
    }
    set showCloseButton(value) {
        this.setLockPropertyInConfig("showCloseButton", value);
        componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId: this.placementId, close: { visible: value } });
    }
    get isMaximized() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.windowContentItem) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.isMaximized) !== null && _c !== void 0 ? _c : false;
    }
    get isSelected() {
        var _a, _b;
        if (typeof ((_a = this.windowContentItem) === null || _a === void 0 ? void 0 : _a.parent.getActiveContentItem) !== "function") {
            return false;
        }
        return idAsString((_b = this.windowContentItem) === null || _b === void 0 ? void 0 : _b.parent.getActiveContentItem().config.id) === this.placementId;
    }
    get index() {
        var _a, _b;
        return ((_b = (_a = this.windowContentItem.parent) === null || _a === void 0 ? void 0 : _a.contentItems) === null || _b === void 0 ? void 0 : _b.indexOf(this.windowContentItem)) || 0;
    }
    get isTabless() {
        var _a, _b, _c;
        const parent = (_a = this.windowContentItem) === null || _a === void 0 ? void 0 : _a.parent;
        return !!((_c = (_b = parent === null || parent === void 0 ? void 0 : parent.config) === null || _b === void 0 ? void 0 : _b.workspacesConfig) === null || _c === void 0 ? void 0 : _c.wrapper);
    }
    get summary() {
        return this.getSummaryCore();
    }
    get config() {
        var _a;
        return (_a = this.windowContentItem) === null || _a === void 0 ? void 0 : _a.config;
    }
    get bounds() {
        var _a, _b, _c;
        if (!this.windowContentItem) {
            return {};
        }
        if (!this.windowContentItem.config.workspacesConfig) {
            this.windowContentItem.config.workspacesConfig = {};
        }
        const workspaceId = (_a = store.getByWindowId(this.placementId)) === null || _a === void 0 ? void 0 : _a.id;
        if (workspaceId && this.isWorkspaceSelected(workspaceId)) {
            const bounds = getElementBounds(this.windowContentItem.element);
            this.windowContentItem.config.workspacesConfig.cachedBounds = bounds;
            return bounds;
        }
        const elementBounds = getElementBounds(this.windowContentItem.element);
        if (elementBounds.width === 0 && elementBounds.height === 0 && ((_b = this.windowContentItem.config.workspacesConfig) === null || _b === void 0 ? void 0 : _b.cachedBounds)) {
            return (_c = this.windowContentItem.config.workspacesConfig) === null || _c === void 0 ? void 0 : _c.cachedBounds;
        }
        return elementBounds;
    }
    get placementId() {
        return idAsString(this.windowContentItem.config.id);
    }
    get workspaceId() {
        var _a, _b;
        return (_a = this.windowContentItem.layoutManager.config.workspacesOptions.workspaceId) !== null && _a !== void 0 ? _a : (_b = store.getByWindowId(this.placementId)) === null || _b === void 0 ? void 0 : _b.id;
    }
    populateBoundsCache() {
        if (this.isWorkspaceSelected(this.workspaceId)) {
            const bounds = getElementBounds(this.windowContentItem.element);
            this.windowContentItem.config.workspacesConfig.cachedBounds = bounds;
        }
    }
    getSummaryCore() {
        var _a, _b;
        const isLoaded = this.windowContentItem.config.componentState.windowId !== undefined;
        const positionIndex = this.index;
        const { appName, url, windowId } = this.windowContentItem.config.componentState;
        const userFriendlyParent = this.getUserFriendlyParent(this.windowContentItem);
        return {
            itemId: this.placementId,
            parentId: (_b = idAsString((_a = userFriendlyParent === null || userFriendlyParent === void 0 ? void 0 : userFriendlyParent.config) === null || _a === void 0 ? void 0 : _a.id)) !== null && _b !== void 0 ? _b : this.placementId,
            config: {
                frameId: this.frameId,
                isLoaded,
                isFocused: false,
                isSelected: this.isSelected,
                positionIndex,
                workspaceId: this.workspaceId,
                windowId,
                isMaximized: this.isMaximized,
                appName,
                url,
                title: this.windowContentItem.config.title,
                allowExtract: this.allowExtract,
                allowReorder: this.allowReorder,
                showCloseButton: this.showCloseButton,
                minWidth: this.minWidth,
                maxWidth: this.maxWidth,
                minHeight: this.minHeight,
                maxHeight: this.maxHeight,
                widthInPx: this.bounds.width,
                heightInPx: this.bounds.height
            }
        };
    }
    getUserFriendlyParent(contentItem) {
        var _a, _b, _c;
        if (!contentItem.parent) {
            return contentItem;
        }
        if ((_c = (_b = (_a = contentItem.parent) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.workspacesConfig) === null || _c === void 0 ? void 0 : _c.wrapper) {
            return this.getUserFriendlyParent(contentItem.parent);
        }
        return contentItem.parent;
    }
    isWorkspaceSelected(workspaceId) {
        const wrapper = this.wrapperFactory.getWorkspaceWrapper({ workspaceId });
        return wrapper.isSelected;
    }
    getPropertyFromConfig(propertyName) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.windowContentItem) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.workspacesConfig) !== null && _c !== void 0 ? _c : {})[propertyName];
    }
    getLockPropertyFromConfig(propertyName) {
        var _a;
        return (_a = this.getPropertyFromConfig(propertyName)) !== null && _a !== void 0 ? _a : true; // TODO allowReorder
    }
    setPropertyInConfig(propertyName, value) {
        this.windowContentItem.config.workspacesConfig[propertyName] = value;
    }
    setLockPropertyInConfig(propertyName, value) {
        const previousValue = this.getLockPropertyFromConfig(propertyName); // TODO allowReorder
        this.setPropertyInConfig(propertyName, value);
        const newValue = this.getLockPropertyFromConfig(propertyName);
        if (previousValue !== newValue) {
            this.layoutEventEmitter.raiseEvent("window-lock-configuration-changed", { item: this.windowContentItem });
        }
    }
}

class WorkspaceWrapper {
    constructor(wrapperFactory, layoutEventEmitter, workspace, workspaceContentItem, frameId) {
        this.wrapperFactory = wrapperFactory;
        this.layoutEventEmitter = layoutEventEmitter;
        this.workspace = workspace;
        this.workspaceContentItem = workspaceContentItem;
        this.frameId = frameId;
    }
    get id() {
        return this.workspace.id;
    }
    get title() {
        var _a;
        const component = this.workspaceContentItem;
        return ((_a = component.tab) === null || _a === void 0 ? void 0 : _a.title) || component.config.workspacesOptions.title || component.config.title || component.config.componentName;
    }
    get lastFocusedWindowId() {
        var _a, _b, _c, _d, _e, _f;
        if (!((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout)) {
            return "";
        }
        const focusedWindowId = (_c = (_b = this.workspace.layout.config) === null || _b === void 0 ? void 0 : _b.workspacesOptions) === null || _c === void 0 ? void 0 : _c.focusedWindowId;
        if (!focusedWindowId) {
            const focusedGroupId = (_e = (_d = this.workspace.layout.config) === null || _d === void 0 ? void 0 : _d.workspacesOptions) === null || _e === void 0 ? void 0 : _e.focusedGroupId;
            const groupContentItem = this.workspace.layout.root.getItemsById(focusedGroupId)[0];
            if (groupContentItem && groupContentItem.type !== "component" && groupContentItem.contentItems.length) {
                const focusedItemInGroup = groupContentItem.contentItems[groupContentItem.contentItems.length - 1].config.id;
                return idAsString(focusedItemInGroup);
            }
        }
        else {
            return focusedWindowId;
        }
        return (_f = this.workspace.windows.filter((w) => {
            const wrapper = this.wrapperFactory.getWindowWrapper({ itemId: w.id, workspaceId: this.workspace.id });
            return wrapper.isSelected;
        })[0]) === null || _f === void 0 ? void 0 : _f.id;
    }
    get isSelected() {
        const workspaceLayoutStack = store.workspaceLayout.root.getItemsById(this.workspace.id)[0].parent;
        const activeContentItem = workspaceLayoutStack.getActiveContentItem();
        return idAsString(activeContentItem.config.id) === this.workspace.id;
    }
    get isHibernated() {
        return typeof this.workspace.hibernateConfig !== "undefined" && this.workspace.hibernateConfig !== null;
    }
    get tabIndex() {
        const workspaceLayoutStack = store.workspaceLayout.root.getItemsById(this.workspace.id)[0].parent;
        const workspaceIndex = workspaceLayoutStack.header
            .tabs
            .findIndex((t) => idAsString(t.contentItem.config.id) === this.workspace.id);
        return workspaceIndex;
    }
    get isPinned() {
        return !!this.workspaceContentItem.tab.isPinned;
    }
    get config() {
        const workspace = this.workspace;
        if (this.isHibernated) {
            workspace.hibernateConfig.workspacesOptions.isPinned = this.isPinned;
            return workspace.hibernateConfig;
        }
        const glConfig = workspace.layout ? workspace.layout.toConfig() : { workspacesOptions: {}, content: [], id: workspace.id };
        glConfig.workspacesOptions.frameId = this.frameId;
        glConfig.workspacesOptions.positionIndex = this.tabIndex;
        glConfig.workspacesOptions.isHibernated = this.isHibernated;
        glConfig.workspacesOptions.isSelected = this.isSelected;
        glConfig.workspacesOptions.allowDrop = this.allowDrop;
        glConfig.workspacesOptions.allowDropLeft = this.allowDropLeft;
        glConfig.workspacesOptions.allowDropTop = this.allowDropTop;
        glConfig.workspacesOptions.allowDropRight = this.allowDropRight;
        glConfig.workspacesOptions.allowDropBottom = this.allowDropBottom;
        glConfig.workspacesOptions.allowExtract = this.allowExtract;
        glConfig.workspacesOptions.allowWindowReorder = this.allowWindowReorder;
        glConfig.workspacesOptions.allowSystemHibernation = this.allowSystemHibernation;
        glConfig.workspacesOptions.showCloseButton = this.showCloseButton;
        glConfig.workspacesOptions.showSaveButton = this.showSaveButton;
        glConfig.workspacesOptions.allowWorkspaceTabReorder = this.allowWorkspaceTabReorder;
        glConfig.workspacesOptions.allowSplitters = this.allowSplitters;
        glConfig.workspacesOptions.showAddWindowButtons = this.showAddWindowButtons;
        glConfig.workspacesOptions.showEjectButtons = this.showEjectButtons;
        glConfig.workspacesOptions.showWindowCloseButtons = this.showWindowCloseButtons;
        glConfig.workspacesOptions.minWidth = Math.max(this.minWidth, DefaultMinSize);
        glConfig.workspacesOptions.maxWidth = Math.min(this.maxWidth, DefaultMaxSize);
        glConfig.workspacesOptions.minHeight = Math.max(this.minHeight, DefaultMinSize);
        glConfig.workspacesOptions.maxHeight = Math.min(this.maxHeight, DefaultMaxSize);
        glConfig.workspacesOptions.widthInPx = this.bounds.width;
        glConfig.workspacesOptions.heightInPx = this.bounds.height;
        glConfig.workspacesOptions.isPinned = this.isPinned;
        glConfig.workspacesOptions.icon = this.icon;
        glConfig.workspacesOptions.lastActive = workspace.lastActive;
        if (!glConfig.workspacesOptions.title) {
            glConfig.workspacesOptions.title = this.title;
        }
        glConfig.workspacesOptions.name = glConfig.workspacesOptions.name || glConfig.workspacesOptions.title;
        this.transformComponentsToWindowSummary(glConfig);
        this.transformParentsToContainerSummary(glConfig);
        return glConfig;
    }
    get summary() {
        const config = this.config;
        const workspaceIndex = this.tabIndex;
        const summaryConfig = {
            frameId: this.frameId,
            positionIndex: workspaceIndex,
            title: this.title,
            name: config.workspacesOptions.name || this.title,
            layoutName: config.workspacesOptions.layoutName,
            isHibernated: this.isHibernated,
            isSelected: this.isSelected,
            lastActive: this.workspace.lastActive,
            allowDrop: this.allowDrop,
            allowDropLeft: this.allowDropLeft,
            allowDropTop: this.allowDropTop,
            allowDropRight: this.allowDropRight,
            allowDropBottom: this.allowDropBottom,
            allowExtract: this.allowExtract,
            allowWindowReorder: this.allowWindowReorder,
            allowSystemHibernation: this.allowSystemHibernation,
            allowSplitters: this.allowSplitters,
            showCloseButton: this.showCloseButton,
            showSaveButton: this.showSaveButton,
            allowWorkspaceTabReorder: this.allowWorkspaceTabReorder,
            showAddWindowButtons: this.showAddWindowButtons,
            showEjectButtons: this.showEjectButtons,
            showWindowCloseButtons: this.showWindowCloseButtons,
            minWidth: this.minWidth,
            maxWidth: this.maxWidth,
            minHeight: this.minHeight,
            maxHeight: this.maxHeight,
            widthInPx: this.bounds.width,
            heightInPx: this.bounds.height,
            isPinned: this.isPinned,
            icon: this.icon
        };
        if (config.workspacesOptions.layoutName) {
            summaryConfig.layoutName = config.workspacesOptions.layoutName;
        }
        return {
            config: summaryConfig,
            id: this.workspace.id
        };
    }
    get allowDrop() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowDrop")) !== null && _a !== void 0 ? _a : true;
    }
    set allowDrop(value) {
        this.setLockPropertyInConfig("allowDrop", value);
        this.populateChildrenAllowDrop(value);
    }
    get allowDropLeft() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowDropLeft")) !== null && _a !== void 0 ? _a : true;
    }
    set allowDropLeft(value) {
        this.setLockPropertyInConfig("allowDropLeft", value);
    }
    get allowDropTop() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowDropTop")) !== null && _a !== void 0 ? _a : true;
    }
    set allowDropTop(value) {
        this.setLockPropertyInConfig("allowDropTop", value);
    }
    get allowDropRight() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowDropRight")) !== null && _a !== void 0 ? _a : true;
    }
    set allowDropRight(value) {
        this.setLockPropertyInConfig("allowDropRight", value);
    }
    get allowDropBottom() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowDropBottom")) !== null && _a !== void 0 ? _a : true;
    }
    set allowDropBottom(value) {
        this.setLockPropertyInConfig("allowDropBottom", value);
    }
    get allowExtract() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowExtract")) !== null && _a !== void 0 ? _a : true;
    }
    set allowExtract(value) {
        this.setLockPropertyInConfig("allowExtract", value);
        this.populateChildrenAllowExtract(value);
    }
    get allowWindowReorder() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowWindowReorder")) !== null && _a !== void 0 ? _a : true;
    }
    set allowWindowReorder(value) {
        this.setLockPropertyInConfig("allowWindowReorder", value);
        this.populateChildrenAllowReorder(value);
    }
    get allowSplitters() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowSplitters")) !== null && _a !== void 0 ? _a : true;
    }
    set allowSplitters(value) {
        this.setLockPropertyInConfig("allowSplitters", value);
        this.populateChildrenAllowSplitters(value);
    }
    get showSaveButton() {
        var _a;
        return (_a = this.getPropertyFromConfig("showSaveButton")) !== null && _a !== void 0 ? _a : true;
    }
    set showSaveButton(value) {
        this.setLockPropertyInConfig("showSaveButton", value);
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId: this.workspace.id, showSaveButton: value });
    }
    get allowWorkspaceTabReorder() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowWorkspaceTabReorder")) !== null && _a !== void 0 ? _a : true;
    }
    set allowWorkspaceTabReorder(value) {
        this.setLockPropertyInConfig("allowWorkspaceTabReorder", value);
    }
    get showCloseButton() {
        var _a;
        return (_a = this.getPropertyFromConfig("showCloseButton")) !== null && _a !== void 0 ? _a : true;
    }
    set showCloseButton(value) {
        this.setLockPropertyInConfig("showCloseButton", value);
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId: this.workspace.id, showCloseButton: value });
    }
    get showAddWindowButtons() {
        var _a;
        return (_a = this.getPropertyFromConfig("showAddWindowButtons")) !== null && _a !== void 0 ? _a : true;
    }
    set showAddWindowButtons(value) {
        this.setLockPropertyInConfig("showAddWindowButtons", value);
        this.populateChildrenShowAddWindowButtons(value);
    }
    get showEjectButtons() {
        var _a;
        return (_a = this.getPropertyFromConfig("showEjectButtons")) !== null && _a !== void 0 ? _a : true;
    }
    set showEjectButtons(value) {
        this.setLockPropertyInConfig("showEjectButtons", value);
        this.populateChildrenShowEjectButtons(value);
    }
    get showWindowCloseButtons() {
        var _a;
        return (_a = this.getPropertyFromConfig("showWindowCloseButtons")) !== null && _a !== void 0 ? _a : true;
    }
    set showWindowCloseButtons(value) {
        this.setLockPropertyInConfig("showWindowCloseButtons", value);
        this.populateChildrenShowWindowCloseButtons(value);
    }
    get allowSystemHibernation() {
        var _a;
        return (_a = this.getPropertyFromConfig("allowSystemHibernation")) !== null && _a !== void 0 ? _a : true;
    }
    set allowSystemHibernation(value) {
        this.setLockPropertyInConfig("allowSystemHibernation", value);
    }
    get minWidth() {
        var _a, _b;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            return (_b = this.workspace.layout.root.getMinWidth()) !== null && _b !== void 0 ? _b : DefaultMinSize;
        }
        return DefaultMinSize;
    }
    get maxWidth() {
        var _a, _b;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            return (_b = this.workspace.layout.root.getMaxWidth()) !== null && _b !== void 0 ? _b : DefaultMaxSize;
        }
        return DefaultMaxSize;
    }
    get minHeight() {
        var _a, _b;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            return (_b = this.workspace.layout.root.getMinHeight()) !== null && _b !== void 0 ? _b : DefaultMinSize;
        }
        return DefaultMinSize;
    }
    get maxHeight() {
        var _a, _b;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            return (_b = this.workspace.layout.root.getMaxHeight()) !== null && _b !== void 0 ? _b : DefaultMaxSize;
        }
        return DefaultMaxSize;
    }
    get bounds() {
        if (!this.isSelected) {
            return getElementBounds(this.workspaceContentItem.element[0].parentElement);
        }
        else {
            return getElementBounds(this.workspaceContentItem.element);
        }
    }
    get hasMaximizedItems() {
        const layout = this.workspace.layout;
        if (!layout) {
            return false;
        }
        const items = layout.root.getItemsById("__glMaximised");
        return items.length > 0;
    }
    get windowSummaries() {
        let windowSummaries = [];
        if (this.isHibernated) {
            const snapshot = this.config;
            windowSummaries = extractWindowSummariesFromSnapshot(snapshot);
        }
        else {
            windowSummaries = this.workspace.windows.map((w) => {
                if (store.getWindowContentItem(w.id)) {
                    return this.getWindowSummary(w.id);
                }
            }).filter(ws => ws);
        }
        return windowSummaries;
    }
    getMaximizedItemInRoot(layout) {
        var _a, _b;
        return (_a = layout === null || layout === void 0 ? void 0 : layout._maximizedItem) !== null && _a !== void 0 ? _a : (_b = this.workspace.layout) === null || _b === void 0 ? void 0 : _b._maximizedItem;
    }
    get maximizedItemsInContainer() {
        var _a, _b;
        return Object.values(((_b = (_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b._maximizedItemsInTargetContainer) || {});
    }
    get icon() {
        return this.getPropertyFromConfig("icon");
    }
    set icon(value) {
        var _a;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            this.workspace.layout.config.workspacesOptions.icon = value;
        }
        this.workspaceContentItem.config.workspacesConfig.icon = value;
        componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId: this.workspace.id, icon: value });
    }
    populateBoundsCache() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.root) === null || _c === void 0 ? void 0 : _c.getItemsByFilter((i) => !!i).forEach((ci) => {
            if (ci.isComponent) {
                const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: ci });
                windowWrapper.populateBoundsCache();
            }
            else {
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: ci });
                containerWrapper.populateBoundsCache();
            }
        });
    }
    transformComponentsToWindowSummary(glConfig) {
        var _a;
        if (glConfig.type === "component" && glConfig.componentName === EmptyVisibleWindowName) {
            return;
        }
        if (glConfig.type === "component") {
            const summary = this.getWindowSummary(glConfig.id);
            glConfig.workspacesConfig = glConfig.workspacesConfig || {};
            glConfig.workspacesConfig = Object.assign(Object.assign({}, glConfig.workspacesConfig), summary.config);
            return;
        }
        (_a = glConfig.content) === null || _a === void 0 ? void 0 : _a.map((c) => this.transformComponentsToWindowSummary(c));
    }
    transformParentsToContainerSummary(glConfig) {
        var _a;
        if (glConfig.type === "component") {
            return;
        }
        if (glConfig.type === "stack" || glConfig.type === "row" || glConfig.type === "column") {
            const summary = this.getContainerSummary(glConfig.id);
            glConfig.workspacesConfig = glConfig.workspacesConfig || {};
            glConfig.workspacesConfig = Object.assign(Object.assign({}, glConfig.workspacesConfig), summary.config);
        }
        (_a = glConfig.content) === null || _a === void 0 ? void 0 : _a.map((c) => this.transformParentsToContainerSummary(c));
    }
    populateChildrenAllowDrop(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                return;
            }
            const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
            containerWrapper.allowDrop = value;
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenAllowSplitters(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component" || item.type === "stack") {
                return;
            }
            const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
            containerWrapper.allowSplitters = value;
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenAllowExtract(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: item });
                windowWrapper.allowExtract = value;
                return;
            }
            if (item.type === "stack") {
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
                containerWrapper.allowExtract = value;
            }
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenAllowReorder(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: item });
                windowWrapper.allowReorder = value;
                return;
            }
            if (item.type === "stack") {
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
                containerWrapper.allowReorder = value;
            }
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenShowAddWindowButtons(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                return;
            }
            if (item.type === "stack") {
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
                containerWrapper.showAddWindowButton = value;
            }
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenShowEjectButtons(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                return;
            }
            if (item.type === "stack") {
                const containerWrapper = this.wrapperFactory.getContainerWrapper({ containerContentItem: item, workspaceId: this.workspace.id });
                containerWrapper.showEjectButton = value;
            }
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    populateChildrenShowWindowCloseButtons(value) {
        const { layout } = this.workspace;
        if (!layout) {
            return;
        }
        const populateRecursive = (item) => {
            if (item.type === "component") {
                const windowWrapper = this.wrapperFactory.getWindowWrapper({ windowContentItem: item });
                windowWrapper.showCloseButton = value;
                return;
            }
            item.contentItems.forEach((ci) => {
                populateRecursive(ci);
            });
        };
        layout.root.contentItems.forEach((ci) => {
            populateRecursive(ci);
        });
    }
    getPropertyFromConfig(propertyName) {
        var _a;
        let result;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            result = this.workspace.layout.config.workspacesOptions[propertyName];
        }
        else {
            result = this.workspaceContentItem.config.workspacesConfig[propertyName];
        }
        return result;
    }
    setPropertyInConfig(propertyName, value) {
        var _a;
        if ((_a = this.workspace) === null || _a === void 0 ? void 0 : _a.layout) {
            this.workspace.layout.config.workspacesOptions[propertyName] = value;
        }
        this.workspaceContentItem.config.workspacesConfig[propertyName] = value;
    }
    setLockPropertyInConfig(propertyName, value) {
        var _a, _b;
        const previousValue = (_a = this.getPropertyFromConfig(propertyName)) !== null && _a !== void 0 ? _a : true; // TODO reorder options
        this.setPropertyInConfig(propertyName, value);
        const currentValue = (_b = this.getPropertyFromConfig(propertyName)) !== null && _b !== void 0 ? _b : true; // TODO reorder options
        if (previousValue !== currentValue) {
            this.layoutEventEmitter.raiseEvent("workspace-lock-configuration-changed", { itemId: this.workspace.id });
        }
    }
    getWindowSummary(id) {
        const wrapper = this.wrapperFactory.getWindowWrapper({ itemId: id });
        return wrapper.summary;
    }
    getContainerSummary(id) {
        const wrapper = this.wrapperFactory.getContainerWrapper({ itemId: id, workspaceId: this.id });
        return wrapper.summary;
    }
}

class WorkspacesWrapperFactory {
    constructor(layoutEventEmitter, frameId) {
        this.layoutEventEmitter = layoutEventEmitter;
        this.frameId = frameId;
    }
    getWorkspaceWrapper(config) {
        let workspace = config.workspace;
        if (workspace === undefined || workspace == null) {
            workspace = config.workspaceId ? store.getById(config.workspaceId) : undefined;
        }
        let workspaceContentItem = config.workspaceContentItem;
        if (workspaceContentItem === undefined || workspaceContentItem == null) {
            workspaceContentItem = config.workspaceId ? store.getWorkspaceContentItem(config.workspaceId) : undefined;
        }
        return new WorkspaceWrapper(this, this.layoutEventEmitter, workspace, workspaceContentItem, this.frameId);
    }
    getWindowWrapper(config) {
        let windowContentItem = config.windowContentItem;
        if (windowContentItem === undefined || windowContentItem == null) {
            windowContentItem = config.itemId ? store.getWindowContentItem(idAsString(config.itemId)) : undefined;
        }
        return new WorkspaceWindowWrapper(this, this.layoutEventEmitter, windowContentItem, this.frameId);
    }
    getContainerWrapper(config) {
        let containerContentItem = config.containerContentItem;
        if (containerContentItem === undefined || containerContentItem == null) {
            containerContentItem = config.itemId ? store.getContainer(config.itemId) : undefined;
        }
        if (containerContentItem.type === "component") {
            throw new Error("Cannot get container wrapper for a component");
        }
        return new WorkspaceContainerWrapper(this, this.layoutEventEmitter, containerContentItem, this.frameId, config.workspaceId);
    }
}

class WorkspacesEventEmitter {
    constructor() {
        this.registry = registryFactory();
    }
    onFrameEvent(callback) {
        return this.registry.add("frame", callback);
    }
    onWindowEvent(callback) {
        return this.registry.add("window", callback);
    }
    onContainerEvent(callback) {
        return this.registry.add("container", callback);
    }
    onWorkspaceEvent(callback) {
        return this.registry.add("workspace", callback);
    }
    raiseFrameEvent(args) {
        this.registry.execute("frame", args.action, args.payload);
    }
    raiseWindowEvent(args) {
        this.registry.execute("window", args.action, args.payload);
    }
    raiseContainerEvent(args) {
        this.registry.execute("container", args.action, args.payload);
    }
    raiseWorkspaceEvent(args) {
        this.registry.execute("workspace", args.action, args.payload);
    }
}

class WorkspacesEventBundler extends WorkspacesEventEmitter {
    constructor() {
        super(...arguments);
        this.groupedLockEvents = {
            workspace: {
                group: false,
                state: {}
            },
            window: {
                group: false,
                state: {}
            },
            container: {
                group: false,
                state: {}
            }
        };
    }
    raiseWindowEvent(args) {
        if (args.action === "lock-configuration-changed") {
            this.raiseLockConfigurationChanged("window", args.payload.windowSummary.itemId, args.payload);
        }
        else {
            super.raiseWindowEvent(args);
        }
    }
    raiseContainerEvent(args) {
        if (args.action === "lock-configuration-changed") {
            this.raiseLockConfigurationChanged("container", args.payload.containerSummary.itemId, args.payload);
        }
        else {
            super.raiseContainerEvent(args);
        }
    }
    raiseWorkspaceEvent(args) {
        if (args.action === "lock-configuration-changed") {
            this.raiseLockConfigurationChanged("workspace", args.payload.workspaceSummary.id, args.payload);
        }
        else {
            super.raiseWorkspaceEvent(args);
        }
    }
    startContainerLockConfigurationChangedGrouping() {
        this.startLockConfigurationChangedGrouping("container");
    }
    endContainerLockConfigurationChangedGrouping() {
        this.endLockConfigurationChangedGrouping("container");
    }
    startWorkspaceLockConfigurationChangedGrouping() {
        this.startLockConfigurationChangedGrouping("workspace");
    }
    endWorkspaceLockConfigurationChangedGrouping() {
        this.endLockConfigurationChangedGrouping("workspace");
    }
    startWindowLockConfigurationChangedGrouping() {
        this.startLockConfigurationChangedGrouping("window");
    }
    endWindowLockConfigurationChangedGrouping() {
        this.endLockConfigurationChangedGrouping("window");
    }
    startLockConfigurationChangedGrouping(type) {
        this.groupedLockEvents[type].group = true;
    }
    raiseLockConfigurationChanged(type, id, payload) {
        if (this.groupedLockEvents[type].group) {
            this.groupedLockEvents[type].state[id] = payload;
        }
        else {
            if (type === "window") {
                const windowPayload = payload;
                super.raiseWindowEvent({ action: "lock-configuration-changed", payload: windowPayload });
            }
            else if (type === "container") {
                const containerPayload = payload;
                super.raiseContainerEvent({ action: "lock-configuration-changed", payload: containerPayload });
            }
            else {
                const workspacePayload = payload;
                super.raiseWorkspaceEvent({ action: "lock-configuration-changed", payload: workspacePayload });
            }
        }
    }
    endLockConfigurationChangedGrouping(type) {
        try {
            this.groupedLockEvents[type].group = false;
            const keys = Object.keys(this.groupedLockEvents[type].state);
            keys.forEach((key) => {
                this.raiseLockConfigurationChanged(type, key, this.groupedLockEvents[type].state[key]);
            });
        }
        catch (error) {
            console.warn(error);
        }
        finally {
            this.groupedLockEvents[type].state = {};
        }
    }
}

class LayoutComponentsFactory {
    constructor(_emitter, _configFactory) {
        this._emitter = _emitter;
        this._configFactory = _configFactory;
        this.componentNameToCleanup = {};
    }
    registerWindowComponent(layout, placementId) {
        this.registerComponent(layout, `app${placementId}`, (container) => {
            const div = this.createWindowDomElement(placementId);
            container.getElement().append(div);
        });
    }
    unregisterWindowComponent(layout, name) {
        layout.unregisterComponent(name);
    }
    registerEmptyWindowComponent(layout, workspaceId) {
        this.registerComponent(layout, EmptyVisibleWindowName, (container) => {
            const emptyContainerDiv = this.createPlaceholderEmptyBackground();
            const newButton = this.createPlaceholderWindowAddButton(container, workspaceId);
            emptyContainerDiv.append(newButton);
            container.getElement().append(emptyContainerDiv);
        });
    }
    registerWorkspaceComponent(workspaceId) {
        const name = this._configFactory.getWorkspaceLayoutComponentName(workspaceId);
        this.registerComponent(store.workspaceLayout, name, (container) => {
            var _a, _b;
            const div = this.createWorkspaceEmptyBackground(workspaceId);
            const newButton = this.createAddButtonInWorkspace(container, workspaceId, name);
            div.appendChild(newButton);
            if ((_a = componentStateMonitor.decoratedFactory) === null || _a === void 0 ? void 0 : _a.createWorkspaceContents) {
                document.body.append(div);
                div.style.display = "none";
                (_b = componentStateMonitor.decoratedFactory) === null || _b === void 0 ? void 0 : _b.createWorkspaceContents({
                    workspaceId,
                    domNode: container.getElement()[0]
                });
            }
            else {
                container.getElement().append(div);
            }
            $(newButton).hide();
        });
    }
    unregisterWorkspaceComponent(name) {
        if (typeof this.componentNameToCleanup[name] === "function") {
            this.componentNameToCleanup[name]();
            delete this.componentNameToCleanup[name];
        }
        store.workspaceLayout.unregisterComponent(name);
    }
    registerComponent(layout, name, callback) {
        try {
            // tslint:disable-next-line:only-arrow-functions
            layout.registerComponent(name, function (container, componentState) {
                if (callback) {
                    callback(container, componentState);
                }
            });
        }
        catch (error) {
            // tslint:disable-next-line:no-console
            console.log(`Tried to register and already existing component - ${name}`);
        }
    }
    createAddButtonInWorkspace(container, workspaceId, name) {
        const newButton = document.createElement("button");
        const span = document.createElement("span");
        const icon = document.createElement("i");
        newButton.ariaLabel = AddWindowButtonLabel;
        newButton.title = AddWindowButtonLabel;
        newButton.classList.add("add-button", "io-btn-icon", "io-btn-icon-circle", "io-btn-icon-size-24");
        span.classList.add("icon");
        icon.classList.add("icon-add");
        const onClick = (e) => {
            e.stopPropagation();
            const contentItem = container.tab.contentItem;
            this._emitter.raiseEvent("add-button-clicked", {
                args: {
                    laneId: idAsString(contentItem.parent.id),
                    workspaceId,
                    bounds: getElementBounds(newButton)
                }
            });
        };
        span.appendChild(icon);
        newButton.appendChild(span);
        newButton.addEventListener("click", onClick);
        this.componentNameToCleanup[name] = () => {
            newButton.removeEventListener("click", onClick);
            newButton.remove();
        };
        return newButton;
    }
    createWorkspaceEmptyBackground(workspaceId) {
        const div = document.createElement("div");
        div.classList.add("wsp-empty-container");
        div.id = getWorkspaceLayoutContainerId(workspaceId);
        return div;
    }
    createWindowDomElement(placementId) {
        const div = document.createElement("div");
        div.setAttribute("style", "height:100%;");
        div.id = `app${placementId}`;
        return div;
    }
    createPlaceholderWindowAddButton(container, workspaceId) {
        const newButton = document.createElement("button");
        newButton.classList.add("add-button", "io-btn-icon", "io-btn-icon-circle", "io-btn-icon-size-24");
        newButton.title = AddWindowButtonLabel;
        newButton.onclick = (e) => {
            e.stopPropagation();
            const contentItem = container.tab.contentItem;
            const parentType = contentItem.parent.type === "stack" ? "group" : contentItem.parent.type;
            if (contentItem.parent.config.workspacesConfig.wrapper) {
                this._emitter.raiseEvent("add-button-clicked", {
                    args: {
                        laneId: idAsString(contentItem.parent.parent.config.id),
                        workspaceId,
                        parentType: contentItem.parent.parent.type,
                        bounds: getElementBounds(newButton)
                    }
                });
                return;
            }
            this._emitter.raiseEvent("add-button-clicked", {
                args: {
                    laneId: idAsString(contentItem.parent.config.id),
                    workspaceId,
                    parentType,
                    bounds: getElementBounds(newButton)
                }
            });
        };
        return newButton;
    }
    createPlaceholderEmptyBackground() {
        const emptyContainerDiv = document.createElement("div");
        emptyContainerDiv.classList.add("wsp-empty-container");
        return emptyContainerDiv;
    }
}

class WorkspacesLayoutLockingController {
    constructor(_wrapperFactory) {
        this._wrapperFactory = _wrapperFactory;
    }
    enableWorkspaceDrop(workspaceId, workspaceDropOptions) {
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const workspace = store.getById(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowDrop = workspaceDropOptions.allowDrop;
        wrapper.allowDropLeft = workspaceDropOptions.allowDropLeft;
        wrapper.allowDropTop = workspaceDropOptions.allowDropTop;
        wrapper.allowDropRight = workspaceDropOptions.allowDropRight;
        wrapper.allowDropBottom = workspaceDropOptions.allowDropBottom;
    }
    disableWorkspaceDrop(workspaceId, workspaceDropOptions) {
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const workspace = store.getById(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowDropLeft = workspaceDropOptions.allowDropLeft;
        wrapper.allowDropTop = workspaceDropOptions.allowDropTop;
        wrapper.allowDropRight = workspaceDropOptions.allowDropRight;
        wrapper.allowDropBottom = workspaceDropOptions.allowDropBottom;
    }
    enableWorkspaceSaveButton(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showSaveButton = true;
    }
    disableWorkspaceSaveButton(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showSaveButton = false;
    }
    enableWorkspaceReorder(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowWorkspaceTabReorder = true;
    }
    disableWorkspaceReorder(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowWorkspaceTabReorder = false;
    }
    enableWorkspaceCloseButton(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showCloseButton = true;
    }
    disableWorkspaceCloseButton(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showCloseButton = false;
    }
    enableSplitters(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowSplitters = true;
    }
    disableSplitters(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowSplitters = false;
    }
    enableWorkspaceExtract(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowExtract = true;
    }
    disableWorkspaceExtract(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowExtract = false;
    }
    enableWorkspaceWindowReorder(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowWindowReorder = true;
    }
    disableWorkspaceWindowReorder(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.allowWindowReorder = false;
    }
    enableWorkspaceWindowCloseButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showWindowCloseButtons = true;
    }
    disableWorkspaceWindowCloseButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showWindowCloseButtons = false;
    }
    enableWorkspaceEjectButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showEjectButtons = true;
    }
    disableWorkspaceEjectButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showEjectButtons = false;
    }
    enableWorkspaceAddWindowButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showAddWindowButtons = true;
    }
    disableWorkspaceAddWindowButtons(workspaceId) {
        const workspace = store.getById(workspaceId);
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
        wrapper.showAddWindowButtons = false;
    }
    enableWindowExtract(windowId, value) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.allowExtract = value;
    }
    disableWindowExtract(windowId) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.allowExtract = false;
    }
    enableWindowReorder(windowId, value) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.allowReorder = value;
    }
    disableWindowReorder(windowId) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.allowReorder = false;
    }
    enableWindowCloseButton(windowId, value) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.showCloseButton = value;
    }
    disableWindowCloseButton(windowId) {
        const windowContentItem = store.getWindowContentItem(windowId);
        const wrapper = this._wrapperFactory.getWindowWrapper({ windowContentItem });
        wrapper.showCloseButton = false;
    }
    enableColumnDrop(itemId, allowDrop) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "column") {
            throw new Error(`Expected item with type column but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = allowDrop;
    }
    disableColumnDrop(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "column") {
            throw new Error(`Expected item with type column but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = false;
    }
    enableRowDrop(itemId, allowDrop) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "row") {
            throw new Error(`Expected item with type row but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = allowDrop;
    }
    disableRowDrop(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "row") {
            throw new Error(`Expected item with type row but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = false;
    }
    enableColumnSplitters(itemId, allowSplitters) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "column") {
            throw new Error(`Expected item with type column but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowSplitters = allowSplitters;
    }
    disableColumnSplitters(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "column") {
            throw new Error(`Expected item with type column but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowSplitters = false;
    }
    enableRowSplitters(itemId, allowSplitters) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "row") {
            throw new Error(`Expected item with type row but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowSplitters = allowSplitters;
    }
    disableRowSplitters(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "row") {
            throw new Error(`Expected item with type row but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowSplitters = false;
    }
    enableGroupDrop(itemId, groupDropOptions) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = groupDropOptions.allowDrop;
        wrapper.allowDropHeader = groupDropOptions.allowDropHeader;
        wrapper.allowDropLeft = groupDropOptions.allowDropLeft;
        wrapper.allowDropTop = groupDropOptions.allowDropTop;
        wrapper.allowDropRight = groupDropOptions.allowDropRight;
        wrapper.allowDropBottom = groupDropOptions.allowDropBottom;
    }
    disableGroupDrop(itemId, groupDropOptions) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowDrop = false;
        wrapper.allowDropHeader = groupDropOptions.allowDropHeader;
        wrapper.allowDropLeft = groupDropOptions.allowDropLeft;
        wrapper.allowDropTop = groupDropOptions.allowDropTop;
        wrapper.allowDropRight = groupDropOptions.allowDropRight;
        wrapper.allowDropBottom = groupDropOptions.allowDropBottom;
    }
    enableGroupMaximizeButton(itemId, showMaximizeButton) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showMaximizeButton = showMaximizeButton;
    }
    disableGroupMaximizeButton(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showMaximizeButton = false;
    }
    enableGroupEjectButton(itemId, showEjectButton) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showEjectButton = showEjectButton;
    }
    disableGroupEjectButton(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showEjectButton = false;
    }
    enableGroupAddWindowButton(itemId, showAddWindowButton) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showAddWindowButton = showAddWindowButton;
    }
    disableGroupAddWindowButton(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.showAddWindowButton = false;
    }
    enableGroupExtract(itemId, allowExtract) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowExtract = allowExtract;
    }
    disableGroupExtract(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowExtract = false;
    }
    enableGroupReorder(itemId, allowReorder) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowReorder = allowReorder;
    }
    disableGroupReorder(itemId) {
        const containerContentItem = store.getContainer(itemId);
        if (containerContentItem.type !== "stack") {
            throw new Error(`Expected item with type stack but received ${containerContentItem.type} ${itemId}`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem });
        wrapper.allowReorder = false;
    }
    disableWorkspaceHibernation(workspaceId) {
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId });
        wrapper.allowSystemHibernation = false;
    }
    enableWorkspaceHibernation(workspaceId) {
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId });
        wrapper.allowSystemHibernation = true;
    }
}

class ThemeController {
    constructor(_glue, _uiExecutor) {
        this._glue = _glue;
        this._uiExecutor = _uiExecutor;
    }
    applyTheme() {
        return __awaiter(this, void 0, void 0, function* () {
            const isThemesAPISupported = yield this.isThemesAPISupported();
            if (!isThemesAPISupported) {
                return;
            }
            this._glue.themes.onChanged((theme) => __awaiter(this, void 0, void 0, function* () {
                this.changeTheme(theme.name);
            }));
            const currentTheme = yield this._glue.themes.getCurrent();
            this.changeTheme(currentTheme.name);
        });
    }
    isThemesAPISupported() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._glue.themes) {
                return false;
            }
            try {
                yield this._glue.themes.getCurrent();
                return true;
            }
            catch (error) {
                return false;
            }
        });
    }
    changeTheme(newThemeName) {
        return __awaiter(this, void 0, void 0, function* () {
            const allThemes = yield this._glue.themes.list();
            const allThemeNames = allThemes.map(t => t.name);
            this._uiExecutor.changeTheme(newThemeName, allThemeNames);
        });
    }
}

function compose(externalFactory, defaultFactory) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        createLogo: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createLogo, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createLogo),
        createWorkspaceTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createWorkspaceTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createWorkspaceTabs),
        createAddWorkspace: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createAddWorkspace, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createAddWorkspace),
        createSystemButtons: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createSystemButtons, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createSystemButtons),
        createWorkspaceContents: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createWorkspaceContents, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createWorkspaceContents),
        createBeforeGroupTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createBeforeGroupTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createBeforeGroupTabs),
        createWorkspaceWindowTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createWorkspaceWindowTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createWorkspaceWindowTabs),
        createAfterGroupTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createAfterGroupTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createAfterGroupTabs),
        createGroupHeaderButtons: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createGroupHeaderButtons, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createGroupHeaderButtons),
        createAddApplicationPopup: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createAddApplicationPopup, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createAddApplicationPopup),
        createSaveWorkspacePopup: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createSaveWorkspacePopup, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createSaveWorkspacePopup),
        createAddWorkspacePopup: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createAddWorkspacePopup, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createAddWorkspacePopup),
        hideSystemPopups: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.hideSystemPopups, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.hideSystemPopups),
        updateWorkspaceTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.updateWorkspaceTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.updateWorkspaceTabs),
        updateWorkspaceWindowTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.updateWorkspaceWindowTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.updateWorkspaceWindowTabs),
        updateAfterGroupTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.updateAfterGroupTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.updateAfterGroupTabs),
        updateGroupHeaderButtons: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.updateGroupHeaderButtons, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.updateGroupHeaderButtons),
        removeWorkspaceTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeWorkspaceTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeWorkspaceTabs),
        removeWorkspaceContents: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeWorkspaceContents, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeWorkspaceContents),
        removeBeforeGroupTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeBeforeGroupTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeBeforeGroupTabs),
        removeWorkspaceWindowTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeWorkspaceWindowTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeWorkspaceWindowTabs),
        removeAfterGroupTabs: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeAfterGroupTabs, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeAfterGroupTabs),
        removeGroupHeaderButtons: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.removeGroupHeaderButtons, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.removeGroupHeaderButtons),
        externalPopupApplications: {
            addApplication: getComponent((_a = externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.externalPopupApplications) === null || _a === void 0 ? void 0 : _a.addApplication, (_b = defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.externalPopupApplications) === null || _b === void 0 ? void 0 : _b.addApplication),
            saveWorkspace: getComponent((_c = externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.externalPopupApplications) === null || _c === void 0 ? void 0 : _c.saveWorkspace, (_d = defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.externalPopupApplications) === null || _d === void 0 ? void 0 : _d.saveWorkspace),
            addWorkspace: getComponent((_e = externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.externalPopupApplications) === null || _e === void 0 ? void 0 : _e.addWorkspace, (_f = defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.externalPopupApplications) === null || _f === void 0 ? void 0 : _f.addWorkspace),
        },
        settings: {
            splitterSize: getComponent((_g = externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.settings) === null || _g === void 0 ? void 0 : _g.splitterSize, (_h = defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.settings) === null || _h === void 0 ? void 0 : _h.splitterSize),
        },
        createId: getComponent(externalFactory === null || externalFactory === void 0 ? void 0 : externalFactory.createId, defaultFactory === null || defaultFactory === void 0 ? void 0 : defaultFactory.createId),
    };
}
function getComponent(externalComponent, defaultComponent) {
    return externalComponent !== null && externalComponent !== void 0 ? externalComponent : defaultComponent;
}

class BaseElement {
    init(options) {
        this.createOptions = options;
    }
    update(options) {
        this.createOptions = Object.assign(Object.assign({}, this.createOptions), options);
    }
}

class AddWorkspaceButtonElement extends BaseElement {
    init(options) {
        super.init(options);
        const liItem = document.createElement("li");
        const button = document.createElement("button");
        const span = document.createElement("span");
        const icon = document.createElement("i");
        button.classList.add("io-btn-icon", "io-btn-icon-circle", "io-btn-icon-size-24");
        button.title = "Add Workspace";
        span.classList.add("icon");
        icon.classList.add("icon-add");
        liItem.classList.add("lm_add_button");
        liItem.title = AddWorkspaceButtonLabel;
        span.appendChild(icon);
        button.appendChild(span);
        liItem.appendChild(button);
        options.domNode.appendChild(liItem);
    }
    update(options) {
        super.update(options);
        // do nothing
    }
    destroy() {
        // do nothing
    }
}

class AfterGroupTabsElement extends BaseElement {
    init(options) {
        super.init(options);
        this.initAddWindowButton();
        this.updateButtonVisibility();
        this.updateButtonTitles();
    }
    update(options) {
        super.update(options);
        this.updateButtonVisibility();
        this.updateButtonTitles();
    }
    destroy() {
        // do nothing
    }
    updateButtonVisibility() {
        this.addWindowButton.hidden = !this.createOptions.addWindow.visible;
    }
    updateButtonTitles() {
        var _a;
        this.addWindowButton.title = (_a = this.createOptions.addWindow.title) !== null && _a !== void 0 ? _a : AddWindowButtonLabel;
    }
    generateButtonIcon(name, size, isCicle, title) {
        const button = document.createElement("button");
        const span = document.createElement("span");
        const icon = document.createElement("i");
        button.classList.add("io-btn-icon", `io-btn-icon-size-${size}`);
        if (isCicle) {
            button.classList.add("io-btn-icon-circle");
        }
        span.classList.add("icon");
        icon.classList.add(name);
        span.appendChild(icon);
        button.appendChild(span);
        button.title = title !== null && title !== void 0 ? title : "";
        return button;
    }
    initAddWindowButton() {
        this.addWindowButton = document.createElement("li");
        this.addWindowButton.classList.add("lm_add_button");
        this.addWindowButton.onclick = (e) => {
            e.stopPropagation();
            manager.showAddWindowPopup(this.createOptions.workspaceId, this.createOptions.groupId, getElementBounds(this.addWindowButton));
        };
        this.addWindowButton.appendChild(this.generateButtonIcon("icon-add", 16, true, "Add App"));
        this.createOptions.domNode.appendChild(this.addWindowButton);
    }
}

/* eslint-disable @typescript-eslint/no-unused-vars */
class GroupHeaderButtonsElement extends BaseElement {
    init(options) {
        super.init(options);
        this.initEjectButton();
        this.initMaximizeButton();
        this.initRestoreButton();
        this.updateButtonVisibility();
        this.updateButtonTitles();
    }
    update(options) {
        super.update(options);
        this.updateButtonVisibility();
        this.updateButtonTitles();
    }
    destroy() {
        // do nothing
    }
    updateButtonVisibility() {
        this.ejectButton.hidden = !this.createOptions.eject.visible;
        this.maximizeButton.hidden = !this.createOptions.maximize.visible;
        this.restoreButton.hidden = !this.createOptions.restore.visible;
    }
    updateButtonTitles() {
        var _a, _b, _c;
        this.ejectButton.title = (_a = this.createOptions.eject.title) !== null && _a !== void 0 ? _a : EjectButtonLabel;
        this.maximizeButton.title = (_b = this.createOptions.maximize.title) !== null && _b !== void 0 ? _b : GroupHeaderMaximizeLabel;
        this.restoreButton.title = (_c = this.createOptions.restore.title) !== null && _c !== void 0 ? _c : GroupHeaderRestoreLabel;
    }
    generateButtonIcon(name, size, isCicle, title) {
        const button = document.createElement("button");
        const span = document.createElement("span");
        const icon = document.createElement("i");
        button.classList.add("io-btn-icon", `io-btn-icon-size-${size}`);
        if (isCicle) {
            button.classList.add("io-btn-icon-circle");
        }
        span.classList.add("icon");
        icon.classList.add(name);
        span.appendChild(icon);
        button.appendChild(span);
        button.title = title !== null && title !== void 0 ? title : "";
        return button;
    }
    initEjectButton() {
        this.ejectButton = document.createElement("li");
        this.ejectButton.classList.add("lm_popout");
        this.ejectButton.appendChild(this.generateButtonIcon("icon-pop-out", 24, true, "Extract"));
        this.ejectButton.onclick = () => {
            manager.ejectActiveWindow(this.createOptions.groupId);
        };
        this.createOptions.domNode.appendChild(this.ejectButton);
    }
    initMaximizeButton() {
        this.maximizeButton = document.createElement("li");
        this.maximizeButton.classList.add("lm_maximise", "workspace_content");
        this.maximizeButton.appendChild(this.generateButtonIcon("icon-resize", 24, true, "Maximize"));
        this.maximizeButton.onclick = () => {
            manager.maximizeItem(this.createOptions.groupId);
        };
        this.createOptions.domNode.appendChild(this.maximizeButton);
    }
    initRestoreButton() {
        this.restoreButton = document.createElement("li");
        this.restoreButton.classList.add("lm_restore", "workspace_content");
        this.restoreButton.appendChild(this.generateButtonIcon("icon-minimize", 24, true, "Restore"));
        this.restoreButton.onclick = () => {
            manager.restoreItem(this.createOptions.groupId);
        };
        this.createOptions.domNode.appendChild(this.restoreButton);
    }
}

class LogoElement extends BaseElement {
    init(options) {
        super.init(options);
        const glueLogo = document.createElement("span");
        glueLogo.classList.add("wsp-logo");
        options.domNode.appendChild(glueLogo);
    }
    update(options) {
        super.update(options);
        // do nothing
    }
    destroy() {
        // do nothing
    }
}

/* eslint-disable @typescript-eslint/no-unused-vars */
class WorkspaceWindowTabElement extends BaseElement {
    init(options) {
        super.init(options);
        this.initChannelsSelector();
        this.initTitle();
        this.initCloseButton();
        this.updateVisibility();
        this.updateLinkColor();
    }
    update(options) {
        super.update(options);
        this.updateTitle();
        this.updateVisibility();
        this.updateLinkColor();
    }
    destroy() {
        // do nothing
    }
    initChannelsSelector() {
        this.channelsLinkElement = document.createElement("span");
        this.channelsLinkElement.classList.add("wsp-channels-link", "icon", "icon-size-12");
        const innerDiv = document.createElement("i");
        innerDiv.classList.add("icon-link");
        this.channelsLinkElement.appendChild(innerDiv);
        this.channelsLinkElement.addEventListener("mousedown", (e) => {
            e.stopPropagation();
        });
        this.channelsLinkElement.addEventListener("click", (e) => {
            e.stopPropagation();
            const bounds = getElementBounds(this.channelsLinkElement);
            manager.showChannelsSelector(this.createOptions.placementId, bounds);
        });
        this.createOptions.domNode.appendChild(this.channelsLinkElement);
    }
    initTitle() {
        this.titleElement = document.createElement("div");
        this.titleElement.classList.add("lm_title");
        this.updateTitle();
        this.createOptions.domNode.appendChild(this.titleElement);
    }
    initCloseButton() {
        var _a;
        this.closeButtonElement = document.createElement("button");
        this.closeButtonElement.title = (_a = this.createOptions.title) !== null && _a !== void 0 ? _a : WorkspaceWindowCloseButtonLabel;
        this.closeButtonElement.classList.add("lm_close_tab", "io-btn-icon", "io-btn-icon-circle", "io-btn-icon-size-16");
        const iconWrapper = document.createElement("span");
        const icon = document.createElement("i");
        iconWrapper.classList.add("icon", "icon-size-12");
        icon.classList.add("icon-close");
        const listener = (e) => {
            e.stopPropagation();
            manager.closeItem(this.createOptions.placementId);
        };
        this.closeButtonElement.onclick = listener;
        this.closeButtonElement.onmousedown = listener;
        iconWrapper.appendChild(icon);
        this.closeButtonElement.appendChild(iconWrapper);
        this.createOptions.domNode.appendChild(this.closeButtonElement);
    }
    updateVisibility() {
        this.channelsLinkElement.style.display = this.createOptions.channels.visible ? "" : "none";
        this.closeButtonElement.style.display = this.createOptions.close.visible ? "" : "none";
    }
    updateTitle() {
        this.titleElement.textContent = this.createOptions.title;
    }
    getContrastTextColor(bgColor) {
        var _a, _b;
        if (!bgColor || bgColor.toLowerCase() === "transparent") {
            return "transparent"; // Return a CSS variable for default text color
        }
        let r, g, b;
        if (bgColor.startsWith("#")) {
            // Convert HEX to RGB
            let hex = bgColor.slice(1);
            if (hex.length === 3)
                hex = hex.split("").map(x => x + x).join(""); // Convert #abc to #aabbcc
            [r, g, b] = [0, 2, 4].map(offset => parseInt(hex.slice(offset, offset + 2), 16));
        }
        else if (bgColor.startsWith("rgb")) {
            // Extract RGB values
            [r, g, b] = (_b = (_a = bgColor.match(/\d+/g)) === null || _a === void 0 ? void 0 : _a.map(Number)) !== null && _b !== void 0 ? _b : [0, 0, 0];
        }
        else {
            // Convert named color using <canvas>
            const ctx = document.createElement("canvas").getContext("2d");
            if (!ctx)
                return "transparent"; // Fallback if canvas isn't available
            ctx.fillStyle = bgColor;
            return this.getContrastTextColor(ctx.fillStyle); // Convert named color and re-run
        }
        // Calculate relative luminance
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5 ? "black-link-icon" : "white-link-icon";
    }
    updateLinkColor() {
        const textColor = this.getContrastTextColor(this.createOptions.channels.color);
        this.channelsLinkElement.style.setProperty("background-color", this.createOptions.channels.color);
        this.channelsLinkElement.classList.remove("black-link-icon", "white-link-icon");
        this.channelsLinkElement.classList.add(textColor);
    }
}

class DefaultComponentsFactory {
    constructor() {
        this.state = {
            logo: undefined,
            addWorkspaceButton: undefined,
            workspaceWindowTabs: {},
            afterGroupTabs: {},
            groupHeaderButtons: {}
        };
        this.createLogo = (options) => {
            this.state.logo = new LogoElement();
            this.state.logo.init(options);
        };
        this.createAddWorkspace = (options) => {
            this.state.addWorkspaceButton = new AddWorkspaceButtonElement();
            this.state.addWorkspaceButton.init(options);
        };
        this.createWorkspaceWindowTabs = (options) => {
            this.state.workspaceWindowTabs[options.placementId] = new WorkspaceWindowTabElement();
            this.state.workspaceWindowTabs[options.placementId].init(options);
        };
        this.createAfterGroupTabs = (options) => {
            this.state.afterGroupTabs[options.groupId] = new AfterGroupTabsElement();
            this.state.afterGroupTabs[options.groupId].init(options);
        };
        this.createGroupHeaderButtons = (options) => {
            this.state.groupHeaderButtons[options.groupId] = new GroupHeaderButtonsElement();
            this.state.groupHeaderButtons[options.groupId].init(options);
        };
        this.updateWorkspaceWindowTabs = (options) => {
            if (!this.state.workspaceWindowTabs[options.placementId]) {
                return;
            }
            this.state.workspaceWindowTabs[options.placementId].update(options);
        };
        this.updateAfterGroupTabs = (options) => {
            if (!this.state.afterGroupTabs[options.groupId]) {
                return;
            }
            this.state.afterGroupTabs[options.groupId].update(options);
        };
        this.updateGroupHeaderButtons = (options) => {
            if (!this.state.groupHeaderButtons[options.groupId]) {
                return;
            }
            this.state.groupHeaderButtons[options.groupId].update(options);
        };
        this.removeWorkspaceWindowTabs = (options) => {
            if (!this.state.workspaceWindowTabs[options.elementId]) {
                return;
            }
            this.state.workspaceWindowTabs[options.elementId].destroy();
            delete this.state.workspaceWindowTabs[options.elementId];
        };
        this.removeAfterGroupTabs = (options) => {
            if (!this.state.afterGroupTabs[options.elementId]) {
                return;
            }
            this.state.afterGroupTabs[options.elementId].destroy();
            delete this.state.afterGroupTabs[options.elementId];
        };
        this.removeGroupHeaderButtons = (options) => {
            if (!this.state.groupHeaderButtons[options.elementId]) {
                return;
            }
            this.state.groupHeaderButtons[options.elementId].destroy();
            delete this.state.groupHeaderButtons[options.elementId];
        };
    }
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var deepMerge = /*@__PURE__*/getDefaultExportFromCjs(cjs);

class LinkController {
    constructor(io, stateResolver) {
        this.io = io;
        this.stateResolver = stateResolver;
        this.windowSubscriptions = new Map();
        this.channelColors = new Map();
    }
    show(placementId, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const color = yield this.getChannelColor(channel);
            this.updateCustomLinkProperties(placementId, true, color);
            const windowSummary = this.stateResolver.getWindowSummarySync(placementId);
            const windowId = windowSummary.config.windowId;
            const window = yield this.io.windows.findById(windowId);
            if (!this.windowSubscriptions.has(windowId)) {
                const unsub = window.onChannelsChanged((channels) => {
                    this.updateColor(placementId, channels[0]);
                });
                this.windowSubscriptions.set(windowId, unsub);
            }
            this.channelColors.set(placementId, channel);
        });
    }
    cleanupChannelsForWindow(placementId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.windowSubscriptions.has(placementId)) {
                this.windowSubscriptions.get(placementId)();
            }
            this.windowSubscriptions.delete(placementId);
            this.channelColors.delete(placementId);
        });
    }
    remove(placementId) {
        this.updateCustomLinkProperties(placementId, false, undefined);
        this.channelColors.delete(placementId);
    }
    updateColor(placementId, channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const linkColor = (yield this.getChannelColor(channel)) || "transparent";
            this.updateCustomLinkProperties(placementId, true, linkColor);
            this.channelColors.set(placementId, channel);
        });
    }
    refreshLinks(placementIds) {
        return Promise.all(placementIds.map((id) => this.show(id)));
    }
    reapplyLink(placementId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.channelColors.has(placementId)) {
                return;
            }
            const channel = this.channelColors.get(placementId);
            this.show(placementId, channel);
        });
    }
    updateCustomLinkProperties(placementId, visible, color) {
        const linkColor = color || "transparent";
        if (typeof componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs === "function") {
            componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({ placementId, channels: { visible, color: linkColor } });
        }
    }
    getChannelColor(channel) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const channels = yield this.io.channels.list();
            return (_c = (_b = (_a = channels.find((c) => c.name === channel)) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : channel;
        });
    }
}

class Fdc3WebRequestsHandler {
    constructor(iframeController, platformCommunicator) {
        this.iframeController = iframeController;
        this.platformCommunicator = platformCommunicator;
        window.addEventListener("message", this.handleMessage.bind(this));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleMessage(event) {
        var _a;
        if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === FDC3HelloRequestType) {
            this.processFDC3WebRequest(event);
            return;
        }
    }
    processFDC3WebRequest(event) {
        var _a;
        const sourceWindowId = this.iframeController.getWindowIdByWindow(event.source);
        if (!sourceWindowId) {
            console.warn("[Workspaces Frame] FDC3 Web request received from an unknown window.");
            return;
        }
        const connectionHelloResponse = {
            type: FDC3HelloResponseType,
            meta: {
                connectionAttemptUuid: (_a = event.data) === null || _a === void 0 ? void 0 : _a.meta.connectionAttemptUuid,
                timestamp: (new Date()).toISOString()
            },
            payload: {
                iframeUrl: `${this.platformCommunicator.platformConfig.fdc3.webProxyUrl}?parentId=${sourceWindowId}`,
            }
        };
        event.source.postMessage(connectionHelloResponse, event.origin);
    }
}

class WorkspacesManager {
    constructor() {
        this._isLayoutInitialized = false;
        this._initPromise = Promise.resolve();
        this._workspacesEventEmitter = new WorkspacesEventBundler();
        this.getComponentBounds = () => {
            return this._controller.bounds;
        };
        this.subscribeForWindowClicked = (cb) => {
            if (!this._frameController) {
                // tslint:disable-next-line: no-console
                console.warn("Your subscription to window clicked wasn't successful, because the Workspaces library isn't initialized yet");
                return () => { };
            }
            return this._frameController.onFrameContentClicked(cb);
        };
        this.cleanUp = () => {
            var _a;
            if ((_a = startupReader.config) === null || _a === void 0 ? void 0 : _a.build) {
                return;
            }
            const windowSummaries = [];
            const workspaceSummaries = store.workspaceIds.map((wid) => {
                const workspace = store.getById(wid);
                const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
                windowSummaries.push(...wrapper.windowSummaries);
                return this.stateResolver.getWorkspaceSummary(wid);
            });
            windowSummaries.forEach((ws) => {
                this._platformCommunicator.notifyFrameWillClose(ws.config.windowId, ws.config.appName).catch((e) => {
                    // Log the error
                });
                this.workspacesEventEmitter.raiseWindowEvent({ action: "removed", payload: { windowSummary: ws } });
            });
            workspaceSummaries.forEach((ws) => {
                this.workspacesEventEmitter.raiseWorkspaceEvent({ action: "closed", payload: { frameSummary: { id: this.frameId }, workspaceSummary: ws, frameBounds: this.stateResolver.getFrameBounds() } });
            });
            const currentWorkspaces = store.layouts.filter(l => { var _a, _b, _c; return !((_c = (_b = (_a = l.layout) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.workspacesOptions) === null || _c === void 0 ? void 0 : _c.noTabHeader); });
            this._layoutsManager.saveWorkspacesFrame(currentWorkspaces);
            this.workspacesEventEmitter.raiseFrameEvent({ action: "closed", payload: { frameSummary: { id: this.frameId }, frameBounds: this.stateResolver.getFrameBounds() } });
        };
    }
    get stateResolver() {
        return this._stateResolver;
    }
    get workspacesEventEmitter() {
        return this._workspacesEventEmitter;
    }
    get initPromise() {
        return this._initPromise;
    }
    get initialized() {
        return this._initialized;
    }
    get frameId() {
        if (!window.name) {
            throw new Error("The frame id is not available because the platform is still initializing");
        }
        return window.name;
    }
    get layoutsManager() {
        return this._layoutsManager;
    }
    init(glue, facade, componentFactory) {
        var _a;
        this._glue = glue;
        this._facade = facade;
        const startupConfig = startupReader.loadConfig();
        if (this._initialized) {
            componentStateMonitor.reInitialize(compose(componentFactory, this._defaultComponentsFactory));
            return { cleanUp: () => { } };
        }
        this._initialized = true;
        this._defaultComponentsFactory = new DefaultComponentsFactory();
        this._configFactory = new WorkspacesConfigurationFactory(glue);
        const converter = new ConfigConverter(this._configFactory);
        componentStateMonitor.init(this.frameId, compose(componentFactory, this._defaultComponentsFactory));
        this._platformCommunicator = new PlatformCommunicator(this._glue, this.frameId);
        this._frameController = new IFrameController(glue, this._platformCommunicator);
        const eventEmitter = new LayoutEventEmitter(registryFactory());
        this._wrapperFactory = new WorkspacesWrapperFactory(eventEmitter, this.frameId);
        this._layoutLockingController = new WorkspacesLayoutLockingController(this._wrapperFactory);
        this._stateResolver = new LayoutStateResolver(this.frameId, eventEmitter, this._frameController, converter, this._wrapperFactory);
        const layoutComponentsFactory = new LayoutComponentsFactory(eventEmitter, this._configFactory);
        const linkController = new LinkController(this._glue, this._stateResolver);
        this._controller = new LayoutController(eventEmitter, this._stateResolver, startupConfig, this._configFactory, this._wrapperFactory, layoutComponentsFactory, linkController);
        this._systemSettings = new WorkspacesSystemSettingsProvider(this._platformCommunicator);
        this._applicationFactory = new ApplicationFactory(glue, this.stateResolver, this._frameController, this, new DelayedExecutor(), this._platformCommunicator, this._systemSettings, linkController);
        this._layoutsManager = new LayoutsManager(this.stateResolver, glue, this._configFactory, converter, new ConstraintsValidator(), this._platformCommunicator);
        this._popupManager = new PopupManagerComposer(new ExternalPopupManager(glue, componentFactory), new ComponentPopupManager(componentFactory, this.frameId), componentFactory);
        this._fdc3WebRequestHandler = new Fdc3WebRequestsHandler(this._frameController, this._platformCommunicator);
        this._themeController = new ThemeController(this._glue, uiExecutor);
        this._themeController.applyTheme();
        if (!startupConfig.emptyFrame && !((_a = this._platformCommunicator.platformConfig) === null || _a === void 0 ? void 0 : _a.initAsEmptyFrame)) {
            this.initLayout();
        }
        return { cleanUp: this.cleanUp };
    }
    initFrameLayout(workspaces, keepWorkspaces) {
        return __awaiter(this, void 0, void 0, function* () {
            workspaces.forEach((wsp) => {
                wsp.id = this._configFactory.getId();
            });
            this._layoutsManager.setInitialWorkspaceConfig(workspaces);
            if (this._isLayoutInitialized && !(keepWorkspaces === null || keepWorkspaces === void 0 ? void 0 : keepWorkspaces.length)) {
                this._initPromise = this.reinitLayout();
            }
            else if (this._isLayoutInitialized && (keepWorkspaces === null || keepWorkspaces === void 0 ? void 0 : keepWorkspaces.length)) {
                this._initPromise = this.updateFrameLayoutNaive(workspaces, keepWorkspaces);
            }
            else {
                this._initPromise = this.initLayout();
            }
            yield this._initPromise;
            return workspaces.map((w) => idAsString(w.id));
        });
    }
    saveWorkspace(name, id, saveContext, allowMultiple, metadata, saveWindowContexts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const workspace = store.getById(id) || store.getActiveWorkspace();
            const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
            const result = yield this._layoutsManager.save({
                name,
                workspace,
                title: wrapper.title,
                saveContext,
                allowMultiple,
                metadata,
                saveWindowContexts
            });
            const config = ((_a = workspace.layout) === null || _a === void 0 ? void 0 : _a.config) || workspace.hibernateConfig;
            config.workspacesOptions.layoutName = name;
            if ((_b = componentStateMonitor.decoratedFactory) === null || _b === void 0 ? void 0 : _b.createWorkspaceTabs) {
                componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId: workspace.id, layoutName: name });
            }
            if (config.workspacesOptions.noTabHeader) {
                delete config.workspacesOptions.noTabHeader;
            }
            return result;
        });
    }
    openWorkspace(name, options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const savedConfigWithData = yield this._layoutsManager.getWorkspaceByName(name);
            const savedConfig = savedConfigWithData.config;
            savedConfig.workspacesOptions.context = savedConfigWithData.layoutData.context;
            if ((options === null || options === void 0 ? void 0 : options.context) && savedConfig.workspacesOptions.context) {
                savedConfig.workspacesOptions.context = Object.assign(savedConfigWithData.layoutData.context, options === null || options === void 0 ? void 0 : options.context);
            }
            else if (options === null || options === void 0 ? void 0 : options.context) {
                savedConfig.workspacesOptions.context = options === null || options === void 0 ? void 0 : options.context;
            }
            savedConfig.workspacesOptions.title = (options === null || options === void 0 ? void 0 : options.title) || name;
            savedConfig.workspacesOptions.icon = (_a = options === null || options === void 0 ? void 0 : options.icon) !== null && _a !== void 0 ? _a : savedConfig.workspacesOptions.icon;
            savedConfig.workspacesOptions.positionIndex = (_b = options === null || options === void 0 ? void 0 : options.positionIndex) !== null && _b !== void 0 ? _b : savedConfig.workspacesOptions.positionIndex;
            savedConfig.workspacesOptions.allowSystemHibernation = (_c = options === null || options === void 0 ? void 0 : options.allowSystemHibernation) !== null && _c !== void 0 ? _c : savedConfig.workspacesOptions.allowSystemHibernation;
            if (savedConfig && savedConfig.workspacesOptions && !savedConfig.workspacesOptions.name) {
                savedConfig.workspacesOptions.name = name;
            }
            if (savedConfig) {
                savedConfig.workspacesOptions = savedConfig.workspacesOptions || {};
                savedConfig.workspacesOptions.layoutName = savedConfigWithData.layoutData.name;
            }
            if (savedConfig && options) {
                savedConfig.workspacesOptions.loadingStrategy = options.loadingStrategy;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.noTabHeader) !== undefined) {
                savedConfig.workspacesOptions.noTabHeader = options === null || options === void 0 ? void 0 : options.noTabHeader;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.isPinned) !== undefined) {
                savedConfig.workspacesOptions.isPinned = options === null || options === void 0 ? void 0 : options.isPinned;
            }
            if (savedConfig && (options === null || options === void 0 ? void 0 : options.isSelected) !== undefined) {
                savedConfig.workspacesOptions.selected = options === null || options === void 0 ? void 0 : options.isSelected;
            }
            if (!this._isLayoutInitialized) {
                this._layoutsManager.setInitialWorkspaceConfig([savedConfig]);
                this._initPromise = this.initLayout();
                yield this._initPromise;
                return idAsString(savedConfig.id);
            }
            else if (name) {
                savedConfig.id = (options === null || options === void 0 ? void 0 : options.reuseWorkspaceId) || this._configFactory.getId();
                if (options === null || options === void 0 ? void 0 : options.reuseWorkspaceId) {
                    const workspace = store.getById(savedConfig.id);
                    const summaries = workspace.windows.map((w) => store.getWindowContentItem(w.id))
                        .filter((w) => w).map(w => this.stateResolver.getWindowSummarySync(w.id, w));
                    yield this.reinitializeWorkspace(idAsString(savedConfig.id), savedConfig);
                    yield this.disposeOfWindowsInClosingWorkspace(summaries);
                    if ((_d = savedConfig.workspacesOptions) === null || _d === void 0 ? void 0 : _d.context) {
                        yield this._glue.contexts.set(getWorkspaceContextName(idAsString(savedConfig.id)), savedConfig.workspacesOptions.context);
                    }
                }
                else {
                    yield this.addWorkspace(idAsString(savedConfig.id), savedConfig);
                }
                return idAsString(savedConfig.id);
            }
        });
    }
    exportAllLayouts() {
        return this._layoutsManager.export();
    }
    deleteLayout(name) {
        this._layoutsManager.delete(name);
    }
    maximizeItem(itemId) {
        const container = store.getContainer(itemId);
        if (container) {
            this._controller.maximizeContainer(itemId);
            return;
        }
        const workspaceByWindowId = store.getByWindowId(itemId);
        if (workspaceByWindowId) {
            this._controller.maximizeWindow(itemId);
            return;
        }
        throw new Error(`Could not find a window or a container with id ${itemId} in frame ${this.frameId} to maximize`);
    }
    restoreItem(itemId) {
        const container = store.getContainer(itemId);
        if (container) {
            this._controller.restoreContainer(itemId);
            return;
        }
        const workspaceByWindowId = store.getByWindowId(itemId);
        if (workspaceByWindowId) {
            this._controller.restoreWindow(itemId);
            return;
        }
        throw new Error(`Could not find a window or a container with id ${itemId} in frame ${this.frameId} to restore`);
    }
    closeItem(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const win = store.getWindow(itemId);
            const container = store.getContainer(itemId);
            if (this.frameId === itemId) {
                yield Promise.all(store.workspaceIds.map((wid) => this.closeWorkspace(store.getById(wid))));
            }
            else if (win) {
                const windowContentItem = store.getWindowContentItem(itemId);
                if (!windowContentItem) {
                    throw new Error(`Could not find item ${itemId} to close`);
                }
                yield this.closeTab(windowContentItem);
            }
            else if (container) {
                this._controller.closeContainer(itemId);
            }
            else {
                const workspace = store.getById(itemId);
                yield this.closeWorkspace(workspace);
            }
        });
    }
    addContainer(config, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const configWithoutIsPinned = this.cleanIsPinned(config);
            const workspace = store.getByContainerId(parentId) || store.getById(parentId);
            const workspaceContentItem = store.getWorkspaceContentItem(workspace.id);
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
            const result = yield this._controller.addContainer(configWithoutIsPinned, parentId);
            if (workspaceWrapper.hasMaximizedItems) {
                this._controller.refreshWorkspaceSize(workspace.id);
            }
            const itemConfig = store.getContainer(result);
            if (itemConfig) {
                this.applyIsPinned(config, itemConfig);
            }
            const windowConfigs = getAllWindowsFromConfig(config.content);
            Promise.all(windowConfigs.map((itemConfig) => __awaiter(this, void 0, void 0, function* () {
                const component = store.getWindowContentItem(idAsString(itemConfig.id));
                yield this._applicationFactory.start(component, workspace.id);
            })));
            return result;
        });
    }
    addWindow(itemConfig, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const parent = store.getContainer(parentId);
            if ((!parent || parent.type !== "stack") && itemConfig.type === "component") {
                itemConfig = this._configFactory.wrapInGroup([itemConfig]);
            }
            const workspace = store.getById(parentId) || store.getByContainerId(parentId);
            const workspaceContentItem = store.getWorkspaceContentItem(workspace.id);
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
            yield this._controller.addWindow(itemConfig, parentId);
            if (workspaceWrapper.hasMaximizedItems) {
                this._controller.refreshWorkspaceSize(workspace.id);
            }
            const allWindowsInConfig = getAllWindowsFromConfig([itemConfig]);
            const component = store.getWindowContentItem(idAsString(allWindowsInConfig[0].id));
            this._applicationFactory.start(component, workspace.id);
        });
    }
    setItemTitle(itemId, title) {
        if (store.getById(itemId)) {
            this._controller.setWorkspaceTitle(itemId, title);
        }
        else {
            this._controller.setWindowTitle(itemId, title);
        }
    }
    eject(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const item = store.getWindowContentItem(itemId);
            if (!item) {
                throw new Error(`Could not find item ${itemId}`);
            }
            const { appName, url, windowId } = item.config.componentState;
            const workspaceContext = store.getWorkspaceContext(store.getByWindowId(item.config.id).id);
            const webWindow = this._glue.windows.findById(windowId);
            const workspace = store.getActiveWorkspace();
            const context = webWindow ? yield webWindow.getContext() : workspaceContext;
            const iopContext = deepMerge(context, {
                ___io___: {
                    ejectedWindow: {
                        frameId: this.frameId,
                        workspaceId: workspace.id
                    }
                }
            });
            const windowContentItem = store.getWindowContentItem(itemId);
            yield this.closeTab(windowContentItem);
            // If an appName is available it should be used instead of just opening the window with glue.windows.open
            // in order to be as close as possible to a real eject
            if (appName) {
                const options = (windowId ? { reuseId: windowId } : undefined); // making sure that the invocation is robust and can't fail easily due to corrupted state
                const ejectedInstance = yield this._glue.appManager.application(appName).start(iopContext, options);
                return { windowId: ejectedInstance.id };
            }
            const ejectedWindowUrl = this._applicationFactory.getUrlByAppName(appName) || url;
            const ejectedWindow = yield this._glue.windows.open(`${appName}_${windowId}`, ejectedWindowUrl, { context: iopContext, windowId });
            return { windowId: ejectedWindow.id };
        });
    }
    ejectActiveWindow(groupId) {
        const groupWrapper = this._wrapperFactory.getContainerWrapper({ itemId: groupId });
        const itemId = groupWrapper.activeItemId;
        // find the window item
        const item = store.getWindowContentItem(itemId);
        if (!item) {
            throw new Error(`Could not find item ${itemId}`);
        }
        const { windowId } = item.config.componentState;
        return this._platformCommunicator.sendEjectWindowCommand({ itemId, windowId });
    }
    createWorkspace(config) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!this._isLayoutInitialized) {
                config.id = this._configFactory.getId();
                this._layoutsManager.setInitialWorkspaceConfig([config]);
                this._initPromise = this.initLayout();
                yield this._initPromise;
                return idAsString(config.id);
            }
            const id = ((_a = config.workspacesOptions) === null || _a === void 0 ? void 0 : _a.reuseWorkspaceId) || this._configFactory.getId();
            if ((_b = config.workspacesOptions) === null || _b === void 0 ? void 0 : _b.reuseWorkspaceId) {
                const workspace = store.getById(id);
                if (!workspace) {
                    throw new Error(`Could not find workspace ${(_c = config.workspacesOptions) === null || _c === void 0 ? void 0 : _c.reuseWorkspaceId} to reuse`);
                }
                yield Promise.all(workspace.windows
                    .map((w) => store.getWindowContentItem(w.id))
                    .filter((w) => w)
                    .map((w) => this.closeTab(w, false)));
                yield this.reinitializeWorkspace(id, config);
                yield this._glue.contexts.set(getWorkspaceContextName(id), (_d = config.workspacesOptions.context) !== null && _d !== void 0 ? _d : {});
            }
            else {
                yield this.addWorkspace(id, config);
            }
            return id;
        });
    }
    loadWindow(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            let contentItem = store.getWindowContentItem(itemId);
            if (!contentItem) {
                throw new Error(`Could not find window ${itemId} to load`);
            }
            let windowId = this._frameController.getWindowId(itemId);
            const workspace = store.getByWindowId(itemId);
            if (!this.stateResolver.isWindowLoaded(itemId) && contentItem.type === "component") {
                this._applicationFactory.start(contentItem, workspace.id);
                yield this.waitForFrameLoaded(itemId);
                contentItem = store.getWindowContentItem(itemId);
                windowId = contentItem.config.componentState.windowId;
            }
            return new Promise((res, rej) => {
                if (!windowId) {
                    rej(`The window id of ${itemId} is missing`);
                }
                let unsub = () => {
                    // safety
                };
                const timeout = setTimeout(() => {
                    rej(`Could not load window ${windowId} for 5000ms`);
                    unsub();
                }, 5000);
                unsub = this._glue.windows.onWindowAdded((w) => {
                    if (w.id === windowId) {
                        res({ windowId });
                        unsub();
                        clearTimeout(timeout);
                    }
                });
                const win = this._glue.windows.list().find((w) => w.id === windowId);
                if (win) {
                    res({ windowId });
                    unsub();
                    clearTimeout(timeout);
                }
            });
        });
    }
    focusItem(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(itemId);
            if (this.frameId === itemId) ;
            else if (workspace) {
                if (workspace.hibernateConfig) {
                    yield this.resumeWorkspace(workspace.id);
                }
                this._controller.focusWorkspace(workspace.id);
            }
            else {
                this._controller.focusWindow(itemId);
            }
        });
    }
    bundleWorkspace(workspaceId, type) {
        if (this._stateResolver.isWorkspaceHibernated(workspaceId)) {
            throw new Error(`Could not bundle workspace ${workspaceId} because its hibernated`);
        }
        this._controller.bundleWorkspace(workspaceId, type);
    }
    bundleItem(itemId, type) {
        const workspace = store.getByContainerId(itemId);
        if (!workspace) {
            throw new Error(`Could not find workspace that contains item with id${itemId} in frame ${this.frameId}`);
        }
        if (this._stateResolver.isWorkspaceHibernated(workspace.id)) {
            throw new Error(`Could not bundle workspace ${workspace.id} because its hibernated`);
        }
        this._controller.bundleItem(itemId, type);
    }
    move(location) {
        return this._glue.windows.my().moveTo(location.y, location.x);
    }
    getFrameSummary(itemId) {
        const workspace = store.getByContainerId(itemId) || store.getByWindowId(itemId) || store.getById(itemId);
        const isFrameId = this.frameId === itemId;
        if (this._context) {
            return {
                id: (workspace || isFrameId) ? this.frameId : "none",
                isInitialized: this._isLayoutInitialized,
                initializationContext: {
                    context: this._context
                }
            };
        }
        else {
            return {
                id: (workspace || isFrameId) ? this.frameId : "none",
                isInitialized: this._isLayoutInitialized,
            };
        }
    }
    moveWindowTo(itemId, containerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const sourceWorkspace = store.getByWindowId(itemId);
            const targetWorkspace = store.getByContainerId(containerId) || store.getById(containerId);
            if (!targetWorkspace) {
                throw new Error(`Could not find container ${containerId} in frame ${this.frameId}`);
            }
            if (!sourceWorkspace) {
                throw new Error(`Could not find window ${itemId} in frame ${this.frameId}`);
            }
            if (this._stateResolver.isWorkspaceHibernated(targetWorkspace.id)) {
                throw new Error(`Could not move window ${itemId} to workspace ${targetWorkspace.id} because its hibernated`);
            }
            if (this._stateResolver.isWorkspaceHibernated(sourceWorkspace.id)) {
                throw new Error(`Could not move window ${itemId} from workspace ${sourceWorkspace.id} because its hibernated`);
            }
            const targetWindow = store.getWindowContentItem(itemId);
            if (!targetWindow) {
                throw new Error(`Could not find window ${itemId} in frame ${this.frameId}`);
            }
            const movedWindow = sourceWorkspace.windows.find(w => w.id === itemId || w.windowId === itemId);
            const windowSummaryBeforeMove = this.stateResolver.getWindowSummarySync(movedWindow.id);
            this._controller.removeLayoutElement(itemId);
            store.removeWindow(movedWindow, sourceWorkspace.id);
            store.addWindow(movedWindow, targetWorkspace.id);
            // this.closeTab(targetWindow);
            yield this._controller.addWindow(targetWindow.config, containerId);
            const windowSummary = this.stateResolver.getWindowSummarySync(movedWindow.id);
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "removed",
                payload: {
                    windowSummary: windowSummaryBeforeMove
                }
            });
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "added",
                payload: {
                    windowSummary
                }
            });
        });
    }
    generateWorkspaceLayout(name, itemId) {
        const workspace = store.getById(itemId);
        if (!workspace) {
            throw new Error(`Could not find workspace with id ${itemId}`);
        }
        return this._layoutsManager.generateLayout(name, workspace);
    }
    resumeWorkspace(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            if (!workspace) {
                throw new Error(`Could not find workspace ${workspaceId} in any of the frames`);
            }
            const hibernatedConfig = workspace.hibernateConfig;
            if (!hibernatedConfig.workspacesOptions) {
                hibernatedConfig.workspacesOptions = {};
            }
            hibernatedConfig.workspacesOptions.reuseWorkspaceId = workspaceId;
            // the start mode should always be eager
            yield this.createWorkspace(hibernatedConfig);
            workspace.hibernateConfig = undefined;
            this.workspacesEventEmitter.raiseWorkspaceEvent({
                action: "resumed",
                payload: {
                    frameSummary: this.getFrameSummary(this.frameId),
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspaceId),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
        });
    }
    lockWorkspace(lockConfig) {
        var _a, _b, _c, _d;
        if (!lockConfig.config) {
            lockConfig.config = {
                allowDrop: false,
                allowDropLeft: false,
                allowDropTop: false,
                allowDropRight: false,
                allowDropBottom: false,
                allowSystemHibernation: false,
                allowExtract: false,
                allowWindowReorder: false,
                allowSplitters: false,
                showCloseButton: false,
                showSaveButton: false,
                allowWorkspaceTabReorder: false,
                showWindowCloseButtons: false,
                showEjectButtons: false,
                showAddWindowButtons: false
            };
        }
        Object.keys(lockConfig.config).forEach((key) => {
            const config = lockConfig.config;
            if (config[key] === undefined) {
                config[key] = true;
            }
        });
        if (typeof lockConfig.config.allowDrop === "boolean") {
            lockConfig.config.allowDropLeft = (_a = lockConfig.config.allowDropLeft) !== null && _a !== void 0 ? _a : lockConfig.config.allowDrop;
            lockConfig.config.allowDropTop = (_b = lockConfig.config.allowDropTop) !== null && _b !== void 0 ? _b : lockConfig.config.allowDrop;
            lockConfig.config.allowDropRight = (_c = lockConfig.config.allowDropRight) !== null && _c !== void 0 ? _c : lockConfig.config.allowDrop;
            lockConfig.config.allowDropBottom = (_d = lockConfig.config.allowDropBottom) !== null && _d !== void 0 ? _d : lockConfig.config.allowDrop;
        }
        const { allowDrop, allowExtract, allowWindowReorder, allowSplitters, showCloseButton, showSaveButton, allowWorkspaceTabReorder, showAddWindowButtons, showWindowCloseButtons, showEjectButtons, allowSystemHibernation } = lockConfig.config;
        const { workspaceId } = lockConfig;
        try {
            this.workspacesEventEmitter.startWorkspaceLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.startContainerLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.startWindowLockConfigurationChangedGrouping();
            if (allowDrop === false) {
                this._layoutLockingController.disableWorkspaceDrop(workspaceId, lockConfig.config);
            }
            else {
                this._layoutLockingController.enableWorkspaceDrop(workspaceId, lockConfig.config);
            }
            if (allowExtract === false) {
                this._layoutLockingController.disableWorkspaceExtract(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceExtract(workspaceId);
            }
            if (allowWindowReorder === false) {
                this._layoutLockingController.disableWorkspaceWindowReorder(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceWindowReorder(workspaceId);
            }
            if (allowSplitters === false) {
                this._layoutLockingController.disableSplitters(workspaceId);
            }
            else {
                this._layoutLockingController.enableSplitters(workspaceId);
            }
            if (showCloseButton === false) {
                this._layoutLockingController.disableWorkspaceCloseButton(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceCloseButton(workspaceId);
            }
            if (showSaveButton === false) {
                this._layoutLockingController.disableWorkspaceSaveButton(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceSaveButton(workspaceId);
            }
            if (allowWorkspaceTabReorder === false) {
                this._layoutLockingController.disableWorkspaceReorder(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceReorder(workspaceId);
            }
            if (showAddWindowButtons === false) {
                this._layoutLockingController.disableWorkspaceAddWindowButtons(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceAddWindowButtons(workspaceId);
            }
            if (showEjectButtons === false) {
                this._layoutLockingController.disableWorkspaceEjectButtons(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceEjectButtons(workspaceId);
            }
            if (showWindowCloseButtons === false) {
                this._layoutLockingController.disableWorkspaceWindowCloseButtons(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceWindowCloseButtons(workspaceId);
            }
            if (allowSystemHibernation === false) {
                this._layoutLockingController.disableWorkspaceHibernation(workspaceId);
            }
            else {
                this._layoutLockingController.enableWorkspaceHibernation(workspaceId);
            }
        }
        finally {
            this.workspacesEventEmitter.endWorkspaceLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.endContainerLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.endWindowLockConfigurationChangedGrouping();
        }
    }
    lockContainer(lockConfig) {
        var _a, _b, _c, _d, _e;
        if (!lockConfig.config && lockConfig.type === "column") {
            lockConfig.config = {
                allowDrop: false,
                allowSplitters: false
            };
        }
        else if (!lockConfig.config && lockConfig.type === "row") {
            lockConfig.config = {
                allowDrop: false,
                allowSplitters: false
            };
        }
        else if (!lockConfig.config && lockConfig.type === "group") {
            lockConfig.config = {
                allowDrop: false,
                allowDropHeader: false,
                allowDropLeft: false,
                allowDropRight: false,
                allowDropTop: false,
                allowDropBottom: false,
                allowExtract: false,
                allowReorder: false,
                showAddWindowButton: false,
                showEjectButton: false,
                showMaximizeButton: false
            };
        }
        if (typeof lockConfig.config.allowDrop !== "undefined" && lockConfig.type === "group") {
            lockConfig.config.allowDropHeader = (_a = lockConfig.config.allowDropHeader) !== null && _a !== void 0 ? _a : lockConfig.config.allowDrop;
            lockConfig.config.allowDropLeft = (_b = lockConfig.config.allowDropLeft) !== null && _b !== void 0 ? _b : lockConfig.config.allowDrop;
            lockConfig.config.allowDropTop = (_c = lockConfig.config.allowDropTop) !== null && _c !== void 0 ? _c : lockConfig.config.allowDrop;
            lockConfig.config.allowDropRight = (_d = lockConfig.config.allowDropRight) !== null && _d !== void 0 ? _d : lockConfig.config.allowDrop;
            lockConfig.config.allowDropBottom = (_e = lockConfig.config.allowDropBottom) !== null && _e !== void 0 ? _e : lockConfig.config.allowDrop;
        }
        Object.keys(lockConfig.config).forEach((key) => {
            const config = lockConfig.config;
            if (config[key] === undefined) {
                config[key] = true;
            }
        });
        try {
            this.workspacesEventEmitter.startContainerLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.startWindowLockConfigurationChangedGrouping();
            switch (lockConfig.type) {
                case "column":
                    this.handleColumnLockRequested(lockConfig);
                    break;
                case "row":
                    this.handleRowLockRequested(lockConfig);
                    break;
                case "group":
                    this.handleGroupLockRequested(lockConfig);
                    break;
            }
        }
        finally {
            this.workspacesEventEmitter.endContainerLockConfigurationChangedGrouping();
            this.workspacesEventEmitter.endWindowLockConfigurationChangedGrouping();
        }
    }
    lockWindow(lockConfig) {
        if (!lockConfig.config) {
            lockConfig.config = {
                allowExtract: false,
                allowReorder: false,
                showCloseButton: false,
            };
        }
        Object.keys(lockConfig.config).forEach((key) => {
            const config = lockConfig.config;
            if (config[key] === undefined) {
                config[key] = true;
            }
        });
        const { allowExtract, allowReorder, showCloseButton } = lockConfig.config;
        const { windowPlacementId } = lockConfig;
        try {
            this.workspacesEventEmitter.startWindowLockConfigurationChangedGrouping();
            if (allowExtract === false) {
                this._layoutLockingController.disableWindowExtract(windowPlacementId);
            }
            else {
                this._layoutLockingController.enableWindowExtract(windowPlacementId, allowExtract);
            }
            if (allowReorder === false) {
                this._layoutLockingController.disableWindowReorder(windowPlacementId);
            }
            else {
                this._layoutLockingController.enableWindowReorder(windowPlacementId, allowReorder);
            }
            if (showCloseButton === false) {
                this._layoutLockingController.disableWindowCloseButton(windowPlacementId);
            }
            else {
                this._layoutLockingController.enableWindowCloseButton(windowPlacementId, showCloseButton);
            }
        }
        finally {
            this.workspacesEventEmitter.endWindowLockConfigurationChangedGrouping();
        }
        const workspace = store.getByWindowId(windowPlacementId);
        if (workspace === null || workspace === void 0 ? void 0 : workspace.layout) {
            workspace.layout.updateSize();
        }
    }
    hibernateWorkspace(workspaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspace = store.getById(workspaceId);
            if (store.getActiveWorkspace().id === workspace.id) {
                throw new Error(`Cannot hibernate workspace ${workspace.id} because its active`);
            }
            if (this.stateResolver.isWorkspaceHibernated(workspaceId)) {
                throw new Error(`Cannot hibernate workspace ${workspaceId} because it has already been hibernated`);
            }
            if (!workspace.layout) {
                throw new Error(`Cannot hibernate workspace ${workspace.id} because its empty`);
            }
            const snapshot = this.stateResolver.getWorkspaceConfig(workspace.id);
            workspace.hibernatedWindows = workspace.windows;
            snapshot.workspacesOptions.isHibernated = true;
            workspace.hibernateConfig = snapshot;
            const currentWorkspaceContext = yield this.getWorkspaceContext(workspace.id);
            // done as a more stylish way to handle the possibly undefined workspaceOptions
            workspace.hibernateConfig.workspacesOptions = Object.assign({}, Object.assign({}, workspace.hibernateConfig.workspacesOptions), { context: currentWorkspaceContext });
            yield Promise.all(workspace.windows.map((w) => store.getWindowContentItem(w.id)).map((w) => this.closeTab(w, false)));
            store.removeLayout(workspace.id);
            this._controller.showHibernationIcon(workspaceId);
            this.workspacesEventEmitter.raiseWorkspaceEvent({
                action: "hibernated",
                payload: {
                    frameSummary: this.getFrameSummary(this.frameId),
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspaceId),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
            return snapshot;
        });
    }
    closeTab(item, emptyWorkspaceCheck = true) {
        const itemId = idAsString(item.config.id);
        const workspace = store.getByWindowId(itemId);
        const windowSummary = this.stateResolver.getWindowSummarySync(itemId);
        this._controller.removeLayoutElement(itemId);
        this._frameController.remove(itemId);
        this._controller.linkController.cleanupChannelsForWindow(itemId);
        const notifyPromise = this._platformCommunicator.notifyFrameWillClose(windowSummary.config.windowId, windowSummary.config.appName).catch((e) => {
            // Log the error
        });
        if (!workspace.hibernatedWindows.some((hw) => windowSummary.itemId === hw.id)) {
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "removed",
                payload: {
                    windowSummary
                }
            });
        }
        if (!workspace.windows.length && emptyWorkspaceCheck) {
            this._controller.resetWorkspace(workspace.id);
        }
        return notifyPromise;
    }
    closeDisposingWindow(windowSummary) {
        this._frameController.remove(windowSummary.itemId);
        this._controller.linkController.cleanupChannelsForWindow(windowSummary.itemId);
        const notifyPromise = this._platformCommunicator.notifyFrameWillClose(windowSummary.config.windowId, windowSummary.config.appName).catch((e) => {
            // Log the error
        });
        this.workspacesEventEmitter.raiseWindowEvent({
            action: "removed",
            payload: {
                windowSummary
            }
        });
        return notifyPromise;
    }
    resizeItem(args) {
        if (args.itemId === this.frameId) {
            throw new Error(`Cannot resize frame ${args.itemId}`);
        }
        else {
            return this.resizeWorkspaceItem(args);
        }
    }
    unmount() {
        try {
            this._popupManager.hidePopup();
        }
        catch (error) {
            // tslint:disable-next-line: no-console
            console.warn(error);
        }
    }
    pinWorkspace(workspaceId, icon) {
        this._controller.pinWorkspace(workspaceId, icon);
    }
    unpinWorkspace(workspaceId) {
        this._controller.unpinWorkspace(workspaceId);
    }
    setWorkspaceIcon(workspaceId, icon) {
        const workspaceContentItem = store.getWorkspaceContentItem(workspaceId);
        const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId, workspaceContentItem });
        wrapper.icon = icon;
    }
    setFrameContext(context) {
        this._context = context;
    }
    showSaveWorkspacePopup(workspaceId, targetBounds) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                frameId: this.frameId,
                workspaceId,
                peerId: this._glue.agm.instance.peerId,
                buildMode: startupReader.config.build,
                domNode: undefined,
                resizePopup: undefined,
                hidePopup: undefined
            };
            store
                .getWorkspaceLayoutItemById(workspaceId)
                .tab
                .element
                .find(".lm_saveButton");
            yield this._popupManager.showSaveWorkspacePopup(targetBounds, payload);
        });
    }
    getWorkspaceContext(workspaceId) {
        return this._glue.contexts.get(getWorkspaceContextName(workspaceId));
    }
    setMaximizationBoundary(itemId, value) {
        const container = store.getContainer(itemId);
        if (!container) {
            throw new Error(`Could not find container ${itemId} in frame ${this.frameId} to set the maximizationBoundary to ${value}`);
        }
        if (container.type === "stack") {
            throw new Error(`Could not set the maximization boundary of group ${itemId} to ${value} because only rows and columns can be considered maximizationBoundaries`);
        }
        const wrapper = this._wrapperFactory.getContainerWrapper({ containerContentItem: container });
        wrapper.maximizationBoundary = value;
    }
    showChannelsSelector(placementId, bounds) {
        var _a;
        const windowSummary = this.stateResolver.getWindowSummarySync(placementId);
        if (!((_a = windowSummary === null || windowSummary === void 0 ? void 0 : windowSummary.config) === null || _a === void 0 ? void 0 : _a.windowId)) {
            return;
        }
        this._popupManager.showChannelsSelector(bounds, {
            frameId: this.frameId,
            peerId: this._glue.agm.instance.peerId,
            workspaceId: store.getActiveWorkspace().id,
            windowId: windowSummary.config.windowId
        });
    }
    showAddWindowPopup(workspaceId, groupId, bounds) {
        this._popupManager.showAddWindowPopup(bounds, {
            boxId: groupId,
            parentType: "group",
            frameId: this.frameId,
            peerId: this._glue.agm.instance.peerId,
            workspaceId
        });
    }
    getDecorationsSize(itemId) {
        if (itemId === this.frameId) {
            return uiExecutor.getFrameDecorationsSize();
        }
        else if (store.getById(itemId)) {
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId: itemId });
            return uiExecutor.getWorkspaceDecorationsSize(workspaceWrapper.bounds);
        }
        else {
            return uiExecutor.getGroupDecorationsSize(itemId);
        }
    }
    showChannelsLink(windowId, channelsNames) {
        return __awaiter(this, void 0, void 0, function* () {
            const window = this._wrapperFactory.getWindowWrapper({ windowContentItem: store.getWindowContentItem(windowId) });
            return this._controller.linkController.show(window.placementId, channelsNames[0]);
        });
    }
    changeChannelLinkColor(windowId, color) {
        const window = this._wrapperFactory.getWindowWrapper({ windowContentItem: store.getWindowContentItem(windowId) });
        return this._controller.linkController.updateColor(window.placementId, color);
    }
    hideChannelsLink(windowId) {
        const window = this._wrapperFactory.getWindowWrapper({ windowContentItem: store.getWindowContentItem(windowId) });
        return this._controller.linkController.remove(window.placementId);
    }
    resizeWorkspaceItem(args) {
        var _a, _b;
        const item = store.getContainer(args.itemId) || store.getWindowContentItem(args.itemId);
        if (!item) {
            throw new Error(`Could not find container ${args.itemId} in frame ${this.frameId}`);
        }
        if (item.type === "column" && args.height) {
            throw new Error(`Requested resize for ${item.type} ${args.itemId}, however an unsupported argument (height) was passed`);
        }
        if (item.type === "row" && args.width) {
            throw new Error(`Requested resize for ${item.type} ${args.itemId}, however an unsupported argument (width) was passed`);
        }
        const workspace = store.getByContainerId(item.config.id) || store.getByWindowId(idAsString(item.config.id));
        let maximizedWindow;
        let maximizedContainer;
        if (this.stateResolver.isWorkspaceHibernated(workspace.id)) {
            throw new Error(`Requested resize for ${item.type} ${args.itemId}, however the workspace ${workspace.id} is hibernated`);
        }
        if (workspace) {
            maximizedWindow = workspace.windows.find((w) => {
                return this.stateResolver.isWindowMaximized(w.id);
            });
            maximizedContainer = (_b = (_a = workspace.layout) === null || _a === void 0 ? void 0 : _a.root) === null || _b === void 0 ? void 0 : _b.getItemsByFilter((layoutItem) => {
                return layoutItem.hasId("__glMaximised") && layoutItem.type !== "component";
            })[0];
        }
        if (maximizedWindow) {
            this._controller.restoreWindow(maximizedWindow.id);
        }
        if (maximizedContainer) {
            this._controller.restoreContainer(idAsString(maximizedContainer.config.id));
        }
        if (item.type === "row") {
            this._controller.resizeRow(workspace, item, args.height);
        }
        else if (item.type === "column") {
            this._controller.resizeColumn(workspace, item, args.width);
        }
        else if (item.type === "stack") {
            this._controller.resizeStack(workspace, item, args.width, args.height);
        }
        else {
            this._controller.resizeComponent(workspace, item, args.width, args.height);
        }
        if (maximizedWindow) {
            this._controller.maximizeWindow(maximizedWindow.id);
        }
        if (maximizedContainer) {
            this._controller.maximizeContainer(idAsString(maximizedContainer.config.id));
        }
    }
    initLayout() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const workspacesSystemSettings = yield this._systemSettings.getSettings();
            const config = yield this._layoutsManager.getInitialConfig();
            this.subscribeForPopups();
            this.subscribeForLayout();
            this._isLayoutInitialized = true;
            yield Promise.all(config.workspaceConfigs.map(c => {
                var _a, _b;
                return this._glue.contexts.set(getWorkspaceContextName(c.id), ((_b = (_a = c.config) === null || _a === void 0 ? void 0 : _a.workspacesOptions) === null || _b === void 0 ? void 0 : _b.context) || {});
            }));
            yield this._controller.init({
                frameId: this.frameId,
                workspaceLayout: config.workspaceLayout,
                workspaceConfigs: config.workspaceConfigs,
                showLoadingIndicator: ((_a = workspacesSystemSettings === null || workspacesSystemSettings === void 0 ? void 0 : workspacesSystemSettings.loadingStrategy) === null || _a === void 0 ? void 0 : _a.showDelayedIndicator) || false
            });
            Promise.all(store.workspaceIds.map((wid) => {
                const loadingStrategy = this._applicationFactory.getLoadingStrategy(workspacesSystemSettings, config.workspaceConfigs[0].config);
                return this.handleWindows(wid, loadingStrategy);
            }));
            store.layouts.map((l) => l.layout).filter((l) => l).forEach((l) => this.reportLayoutStructure(l));
            if (startupReader.config.emptyFrame) {
                this._workspacesEventEmitter.raiseFrameEvent({
                    action: "opened", payload: {
                        frameSummary: {
                            id: this.frameId
                        },
                        frameBounds: this.stateResolver.getFrameBounds()
                    }
                });
            }
        });
    }
    reinitLayout() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const workspacesSystemSettings = yield this._systemSettings.getSettings();
            const config = yield this._layoutsManager.getInitialConfig();
            this._isLayoutInitialized = true;
            yield Promise.all(config.workspaceConfigs.map(c => {
                var _a, _b;
                return this._glue.contexts.set(getWorkspaceContextName(c.id), ((_b = (_a = c.config) === null || _a === void 0 ? void 0 : _a.workspacesOptions) === null || _b === void 0 ? void 0 : _b.context) || {});
            }));
            yield Promise.all(store.workspaceIds.map((wid) => {
                return this.discardWorkspaceWithoutClosing(store.getById(wid));
            }));
            yield this._controller.reinit({
                frameId: this.frameId,
                workspaceLayout: config.workspaceLayout,
                workspaceConfigs: config.workspaceConfigs,
                showLoadingIndicator: ((_a = workspacesSystemSettings === null || workspacesSystemSettings === void 0 ? void 0 : workspacesSystemSettings.loadingStrategy) === null || _a === void 0 ? void 0 : _a.showDelayedIndicator) || false
            });
            Promise.all(store.workspaceIds.map((wid) => {
                const loadingStrategy = this._applicationFactory.getLoadingStrategy(workspacesSystemSettings, config.workspaceConfigs[0].config);
                return this.handleWindows(wid, loadingStrategy);
            }));
            store.layouts.map((l) => l.layout).filter((l) => l).forEach((l) => this.reportLayoutStructure(l));
        });
    }
    updateFrameLayoutNaive(newWorkspaces, keepWorkspaces) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaceIdsToClose = store.workspaceIds.filter((wid) => !keepWorkspaces.includes(wid));
            const workspacesToClose = workspaceIdsToClose.map((wid) => store.getById(wid));
            const closePromise = Promise.all(workspacesToClose.map((wtc) => this.closeWorkspace(wtc)));
            const createPromise = Promise.all(newWorkspaces.map((nwc) => this.createWorkspace(nwc)));
            yield Promise.all([closePromise, createPromise]);
        });
    }
    reinitializeWorkspace(id, config) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._controller.reinitializeWorkspace(id, config);
            const workspacesSystemSettings = yield this._systemSettings.getSettings();
            const loadingStrategy = this._applicationFactory.getLoadingStrategy(workspacesSystemSettings, config);
            this.handleWindows(id, loadingStrategy);
        });
    }
    subscribeForLayout() {
        this._controller.emitter.onContentItemResized((target, id) => {
            this._frameController.moveFrame(id, getElementBounds(target));
        });
        this._controller.emitter.onTabCloseRequested((item) => {
            store.getByWindowId(idAsString(item.config.id));
            // const windowSummary = await this.stateResolver.getWindowSummary(item.config.id);
            this.closeTab(item);
            const placementId = idAsString(item.config.id);
            this._controller.removeLayoutElement(placementId);
            this._frameController.remove(placementId);
            this._controller.linkController.cleanupChannelsForWindow(placementId);
        });
        this._controller.emitter.onWorkspaceTabCloseRequested((workspace) => {
            this.closeWorkspace(workspace);
        });
        this._controller.emitter.onTabElementMouseDown((tab) => {
            const tabContentSize = getElementBounds(tab.contentItem.element);
            const contentWidth = Math.min(tabContentSize.width, 800);
            const contentHeight = Math.min(tabContentSize.height, 600);
            this._controller.setDragElementSize(contentWidth, contentHeight);
        });
        this._controller.emitter.onTabDragStart((tab) => {
            const dragElement = this._controller.getDragElement();
            const mutationObserver = new MutationObserver((mutations) => {
                Array.from(mutations).forEach((m) => {
                    if (m.type === "attributes") {
                        const proxyContent = $(this._controller.getDragElement())
                            .children(".lm_content")
                            .children(".lm_item_container");
                        const proxyContentBounds = getElementBounds(proxyContent[0]);
                        const id = idAsString(tab.contentItem.config.id);
                        this._frameController.moveFrame(id, proxyContentBounds);
                        this._frameController.bringToFront(id);
                    }
                });
            });
            if (!dragElement) {
                return;
            }
            mutationObserver.observe(dragElement, {
                attributes: true
            });
            const windowSummary = this.stateResolver.getWindowSummarySync(tab.contentItem.config.id, tab.contentItem);
            componentStateMonitor.notifyWindowClosed(windowSummary.itemId);
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "removed", payload: {
                    windowSummary
                }
            });
        });
        this._controller.emitter.onItemDropped((item) => {
            const windowSummary = this.stateResolver.getWindowSummarySync(item.config.id, item);
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "added", payload: {
                    windowSummary
                }
            });
            this._controller.linkController.reapplyLink(idAsString(item.config.id));
        });
        this._controller.emitter.onSelectionChanged((toBack, toFront) => {
            this._popupManager.hidePopup();
            this._frameController.selectionChanged(toFront.map((tf) => tf.id), toBack.map((t) => t.id));
        });
        this._controller.emitter.onTabSelectionChanged((item) => {
            componentStateMonitor.decoratedFactory.updateWorkspaceWindowTabs({
                placementId: idAsString(item.config.id),
                groupId: idAsString(item.parent.config.id),
                isSelected: true
            });
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "selected", payload: {
                    windowSummary: this.stateResolver.getWindowSummarySync(item.config.id, item)
                }
            });
        });
        this._controller.emitter.onWorkspaceAdded((workspace) => {
            this.handleOnWorkspaceAdded(workspace);
        });
        this._controller.emitter.onWorkspaceSelectionChanged((workspace, toBack) => {
            this._popupManager.hidePopup();
            if (typeof componentStateMonitor.decoratedFactory.updateWorkspaceTabs === "function") {
                componentStateMonitor.decoratedFactory.updateWorkspaceTabs({ workspaceId: workspace.id, isSelected: true });
            }
            this._controller.refreshTabSizes(workspace.id);
            if (!workspace.layout) {
                this._frameController.selectionChangedDeep([], toBack.map((w) => w.id));
                this._workspacesEventEmitter.raiseWorkspaceEvent({
                    action: "selected", payload: {
                        frameSummary: { id: this.frameId },
                        workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                        frameBounds: this.stateResolver.getFrameBounds()
                    }
                });
                if (workspace.hibernateConfig) {
                    this.resumeWorkspace(workspace.id);
                }
                return;
            }
            const allWinsInLayout = getAllWindowsFromConfig(workspace.layout.toConfig().content)
                .filter((w) => this._controller.isWindowVisible(w.id));
            this._frameController.selectionChangedDeep(allWinsInLayout.map((w) => idAsString(w.id)), toBack.map((w) => w.id));
            this._workspacesEventEmitter.raiseWorkspaceEvent({
                action: "selected", payload: {
                    frameSummary: { id: this.frameId },
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
        });
        this._controller.emitter.onAddButtonClicked((_a) => __awaiter(this, [_a], void 0, function* ({ laneId, workspaceId, bounds, parentType }) {
            const payload = {
                boxId: laneId,
                workspaceId,
                parentType,
                frameId: this.frameId,
                peerId: this._glue.agm.instance.peerId,
                domNode: undefined,
                resizePopup: undefined,
                hidePopup: undefined
            };
            yield this._popupManager.showAddWindowPopup(bounds, payload);
        }));
        this._controller.emitter.onContentLayoutInit((layout) => {
            const workspace = store.getById(layout.root.config.id);
            const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem: undefined });
            if (wrapper.getMaximizedItemInRoot(layout)) {
                this._controller.hideWorkspaceRootItem(workspace.id);
            }
            this.reportLayoutStructure(layout);
        });
        this._controller.emitter.onWorkspaceAddButtonClicked(() => __awaiter(this, void 0, void 0, function* () {
            const payload = {
                frameId: this.frameId,
                peerId: this._glue.agm.instance.windowId
            };
            const addButton = store
                .workspaceLayoutHeader
                .element
                .find(".lm_workspace_controls")
                .find(".lm_add_button");
            const addButtonBounds = getElementBounds(addButton);
            yield this._popupManager.showOpenWorkspacePopup(addButtonBounds, payload);
        }));
        this._controller.emitter.onWorkspaceSaveRequested((workspaceId) => __awaiter(this, void 0, void 0, function* () {
            const saveButton = store
                .getWorkspaceLayoutItemById(workspaceId)
                .tab
                .element
                .find(".lm_saveButton");
            const targetBounds = getElementBounds(saveButton);
            yield this.showSaveWorkspacePopup(workspaceId, targetBounds);
        }));
        this._controller.emitter.onContainerMaximized((contentItem) => {
            if (contentItem.type === "component") {
                return;
            }
            const components = contentItem.getItemsByFilter((ci) => ci.type === "component");
            components.forEach((c) => {
                this._frameController.maximizeTab(idAsString(c.config.id));
            });
            contentItem.contentItems
                .filter((ci) => ci.type === "component")
                .map((c) => this.stateResolver.getWindowSummarySync(c.config.id)).forEach((ws) => {
                this.workspacesEventEmitter.raiseWindowEvent({ action: "maximized", payload: { windowSummary: ws } });
            });
            const stacks = contentItem.getItemsByFilter((ci) => ci.type === "stack");
            if (contentItem.type === "stack") {
                stacks.push(contentItem);
                this.showRestoreGroupButton(contentItem);
            }
            const [toFront, toBack] = stacks.reduce((acc, stack) => {
                const activeItem = stack.getActiveContentItem();
                const toBack = stack.contentItems.map((ci) => idAsString(ci.config.id));
                acc[0].push(idAsString(activeItem.config.id));
                acc[1] = [...acc[1], ...toBack];
                return acc;
            }, [[], []]);
            this._frameController.selectionChanged(toFront, toBack);
            const workspace = store.getById(contentItem.layoutManager.root.config.id);
            const workspaceContentItem = store.getWorkspaceContentItem(workspace.id);
            const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceContentItem });
            if (wrapper.getMaximizedItemInRoot(contentItem.layoutManager) && !contentItem.parent.isRoot) {
                this._controller.hideWorkspaceRootItem(workspace.id);
            }
            this.reportLayoutStructure(contentItem.layoutManager);
        });
        this._controller.emitter.onContainerRestored((contentItem) => {
            if (contentItem.type === "component") {
                return;
            }
            const components = contentItem.getItemsByFilter((ci) => ci.type === "component");
            components.forEach((c) => {
                this._frameController.restoreTab(idAsString(c.config.id));
            });
            contentItem.contentItems
                .filter((ci) => ci.type === "component")
                .map((c) => this.stateResolver.getWindowSummarySync(c.config.id)).forEach((ws) => {
                this.workspacesEventEmitter.raiseWindowEvent({ action: "restored", payload: { windowSummary: ws } });
            });
            const stacks = contentItem.getItemsByFilter((ci) => ci.type === "stack");
            if (contentItem.type === "stack") {
                stacks.push(contentItem);
                this.showMaximizeGroupButton(contentItem);
            }
            const [toFront, toBack] = stacks.reduce((acc, stack) => {
                const activeItem = stack.getActiveContentItem();
                const toBack = stack.contentItems.map((ci) => idAsString(ci.config.id));
                acc[0].push(idAsString(activeItem.config.id));
                acc[1] = [...acc[1], ...toBack];
                return acc;
            }, [[], []]);
            this._frameController.selectionChanged(toFront, toBack);
            const workspaceId = idAsString(contentItem.layoutManager.root.config.id);
            this._controller.showWorkspaceRootItem(workspaceId);
            this._controller.refreshWorkspaceSize(workspaceId);
            this.reportLayoutStructure(contentItem.layoutManager);
        });
        this._controller.emitter.onEjectRequested((item) => {
            if (!item.isComponent) {
                throw new Error(`Can't eject item of type ${item.type}`);
            }
            return this.eject(idAsString(item.config.id));
        });
        this._controller.emitter.onComponentSelectedInWorkspace((component, workspaceId) => {
            this._applicationFactory.start(component, workspaceId);
        });
        const resizedTimeouts = {};
        this._controller.emitter.onWorkspaceContainerResized((workspaceId) => {
            const id = idAsString(workspaceId);
            if (resizedTimeouts[id]) {
                clearTimeout(resizedTimeouts[id]);
            }
            resizedTimeouts[id] = setTimeout(() => {
                this._controller.refreshWorkspaceSize(id);
            }, 16); // 60 FPS
        });
        this._controller.emitter.onContentItemRemoved((workspaceId, item) => {
            if (item.type === "stack") {
                componentStateMonitor.notifyGroupClosed(idAsString(item.config.id));
            }
        });
        this._controller.emitter.onWorkspaceLockConfigurationChanged((itemId) => {
            this.workspacesEventEmitter.raiseWorkspaceEvent({
                action: "lock-configuration-changed",
                payload: {
                    frameSummary: this.getFrameSummary(this.frameId),
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(itemId),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
        });
        this._controller.emitter.onContainerLockConfigurationChanged((item) => {
            var _a;
            this.workspacesEventEmitter.raiseContainerEvent({
                action: "lock-configuration-changed",
                payload: {
                    containerSummary: this.stateResolver.getContainerSummaryByReference(item, (_a = store.getByContainerId(item.config.id)) === null || _a === void 0 ? void 0 : _a.id)
                }
            });
        });
        this._controller.emitter.onWindowLockConfigurationChanged((item) => {
            this.workspacesEventEmitter.raiseWindowEvent({
                action: "lock-configuration-changed",
                payload: {
                    windowSummary: this.stateResolver.getWindowSummarySync(item.config.id)
                }
            });
        });
        this._controller.emitter.onWillHideWorkspaceTab((workspaceId) => {
            const wrapper = this._wrapperFactory.getWorkspaceWrapper({ workspaceId });
            try {
                wrapper.populateBoundsCache();
            }
            catch (e) {
                // do nothing
            }
        });
        this._controller.emitter.onWorkspaceTabReorder((workspace) => {
            this._workspacesEventEmitter.raiseWorkspaceEvent({
                action: "tab-reordered",
                payload: {
                    frameSummary: { id: this.frameId },
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
        });
        this._controller.emitter.onTabReorder((item) => {
            this._workspacesEventEmitter.raiseWindowEvent({
                action: "tab-reordered",
                payload: {
                    windowSummary: this.stateResolver.getWindowSummarySync(item.config.id)
                }
            });
        });
        // debouncing because there is potential for 1ms spam
        let shownTimeout = undefined;
        componentStateMonitor.onWorkspaceContentsShown((workspaceId) => {
            const workspace = store.getActiveWorkspace();
            if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout) || workspaceId !== workspace.id) {
                return;
            }
            if (shownTimeout) {
                clearTimeout(shownTimeout);
            }
            shownTimeout = setTimeout(() => {
                const containerElement = $(`#${getWorkspaceLayoutContainerId(workspace.id)}`);
                const bounds = getElementBounds(containerElement[0]);
                workspace.layout.updateSize(bounds.width, bounds.height);
            }, 50);
            const stacks = workspace.layout.root.getItemsByFilter((e) => e.type === "stack");
            this._frameController.selectionChangedDeep(stacks.map(s => idAsString(s.getActiveContentItem().config.id)), []);
        });
        componentStateMonitor.onWorkspaceContentsHidden((workspaceId) => {
            const workspace = store.getById(workspaceId);
            if (!(workspace === null || workspace === void 0 ? void 0 : workspace.layout) || workspaceId !== workspace.id) {
                return;
            }
            this._frameController.selectionChangedDeep([], workspace.windows.map(w => w.id));
        });
        this.workspacesEventEmitter.onWorkspaceEvent((action, payload) => {
            const workspace = store.getById(payload.workspaceSummary.id);
            if (!workspace) {
                return;
            }
            workspace.lastActive = Date.now();
        });
    }
    subscribeForPopups() {
        this._frameController.onFrameContentClicked(() => {
            this._popupManager.hidePopup();
        });
        this._frameController.onWindowTitleChanged((id, title) => {
            this.setItemTitle(id, title);
        });
        this._frameController.onFrameLoaded((id) => {
            this._controller.hideLoadingIndicator(id);
        });
        this._popupManager.onPopupStateChanged((args, isActive) => {
            if ((args === null || args === void 0 ? void 0 : args.type) === "openWorkspace") {
                componentStateMonitor.decoratedFactory.updateAddWorkspace({
                    isAddWorkspacePopupActive: isActive
                });
            }
            else if ((args === null || args === void 0 ? void 0 : args.type) === "addApplication") {
                componentStateMonitor.decoratedFactory.updateAfterGroupTabs({
                    isAddWindowPopupActive: isActive,
                    workspaceId: args.workspaceId,
                    groupId: args.boxId
                });
                componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({
                    isAddWindowPopupActive: isActive,
                    workspaceId: args.workspaceId,
                    groupId: args.boxId
                });
            }
        });
    }
    reportLayoutStructure(layout) {
        const allWinsInLayout = getAllWindowsFromConfig(layout.toConfig().content);
        allWinsInLayout.forEach((w) => {
            const win = layout.root.getItemsById(w.id)[0];
            this._frameController.moveFrame(idAsString(win.config.id), getElementBounds(win.element));
        });
    }
    closeWorkspace(workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!workspace) {
                throw new Error("Could not find a workspace to close");
            }
            return this.closeWorkspaceCore(workspace);
        });
    }
    closeWorkspaceCore(workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
            const workspaceSummary = workspaceWrapper.summary;
            const windowSummaries = workspaceWrapper.windowSummaries;
            const isFrameEmpty = this.checkForEmptyWorkspace(workspace);
            this.disposeOfWindowsInClosingWorkspace(windowSummaries);
            if (isFrameEmpty) {
                return;
            }
            this.raiseWorkspaceClosedEventsInClosingWorkspace(workspaceSummary);
        });
    }
    discardWorkspaceWithoutClosing(workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            const workspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace, workspaceId: workspace.id });
            const windowSummaries = workspaceWrapper.windowSummaries;
            const workspaceSummary = workspaceWrapper.summary;
            yield this.disposeOfWindowsInClosingWorkspace(windowSummaries);
            this.raiseWorkspaceClosedEventsInClosingWorkspace(workspaceSummary);
            store.removeById(workspace.id);
        });
    }
    disposeOfWindowsInClosingWorkspace(windowSummaries) {
        return Promise.all(windowSummaries.map((ws) => this.closeDisposingWindow(ws)));
    }
    raiseWorkspaceClosedEventsInClosingWorkspace(workspaceSummary) {
        componentStateMonitor.notifyWorkspaceClosed(workspaceSummary.id);
        this.workspacesEventEmitter.raiseWorkspaceEvent({
            action: "closed",
            payload: {
                workspaceSummary,
                frameSummary: { id: this.frameId },
                frameBounds: this.stateResolver.getFrameBounds()
            }
        });
    }
    addWorkspace(id, config) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield this._glue.contexts.set(getWorkspaceContextName(id), ((_a = config === null || config === void 0 ? void 0 : config.workspacesOptions) === null || _a === void 0 ? void 0 : _a.context) || {});
            yield this._controller.addWorkspace(id, config);
            this._controller.emitter.raiseEvent("workspace-added", { workspace: store.getById(id) });
            const workspacesSystemSettings = yield this._systemSettings.getSettings();
            const loadingStrategy = this._applicationFactory.getLoadingStrategy(workspacesSystemSettings, config);
            this.handleWindows(id, loadingStrategy).catch((e) => {
                // If it fails do nothing
                console.log(e);
            });
        });
    }
    handleWindows(workspaceId, loadingStrategy) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (loadingStrategy) {
                case "delayed":
                    yield this._applicationFactory.startDelayed(workspaceId);
                    break;
                case "direct":
                    yield this._applicationFactory.startDirect(workspaceId);
                    break;
                case "lazy":
                    yield this._applicationFactory.startLazy(workspaceId);
                    break;
            }
        });
    }
    checkForEmptyWorkspace(workspace) {
        // Closing all workspaces except the last one
        const browserGlobal = window.glue42core || window.iobrowser;
        if (store.layouts.length === 1) {
            if (this._isLayoutInitialized && browserGlobal.isPlatformFrame) {
                this.replaceLastWorkspaceWithEmpty(workspace);
                return false;
            }
            else if (this._isLayoutInitialized) {
                try {
                    this._facade.executeAfterControlIsDone(() => {
                        window.close();
                    });
                }
                catch (error) {
                    // Try to close my window if it fails fallback to frame with one empty workspace
                }
                return true;
            }
        }
        else {
            this._controller.removeWorkspace(workspace.id);
        }
        return false;
    }
    replaceLastWorkspaceWithEmpty(lastWorkspace) {
        const newId = this._configFactory.getId();
        const emptyWorkspaceConfig = this._configFactory.getEmptyWorkspaceConfig();
        const lastWorkspaceWrapper = this._wrapperFactory.getWorkspaceWrapper({ workspace: lastWorkspace, workspaceId: lastWorkspace.id });
        const titlesWithoutLastWorkspace = this.stateResolver.getWorkspaceTitles().filter(t => t !== lastWorkspaceWrapper.title);
        const titleForEmptyWorkspace = this._configFactory.getWorkspaceTitle(titlesWithoutLastWorkspace);
        // Ensuring that the title will be Untitled 1
        emptyWorkspaceConfig.workspacesOptions.title = titleForEmptyWorkspace;
        this._controller.addWorkspace(newId, this._configFactory.getEmptyWorkspaceConfig()).then(() => __awaiter(this, void 0, void 0, function* () {
            yield this.handleOnWorkspaceAddedWithSnapshot(store.getById(newId));
            this.checkForEmptyWorkspace(lastWorkspace);
        })).catch(() => {
            // Can happen if the workspace has already been closed
            // e.g the closing of the last window in a workspace could potentially trigger this behavior
        });
    }
    waitForFrameLoaded(itemId) {
        return new Promise((res, rej) => {
            let unsub = () => {
                // safety
            };
            const timeout = setTimeout(() => {
                unsub();
                rej(`Did not hear frame loaded for ${itemId} in 5000ms`);
            }, 5000);
            unsub = this.workspacesEventEmitter.onWindowEvent((action, payload) => {
                if (action === "loaded" && payload.windowSummary.itemId === itemId) {
                    res();
                    clearTimeout(timeout);
                    unsub();
                }
            });
            if (this.stateResolver.isWindowLoaded(itemId)) {
                res();
                clearTimeout(timeout);
                unsub();
            }
        });
    }
    handleGroupLockRequested(data) {
        const { allowExtract, allowReorder, showAddWindowButton, showEjectButton, showMaximizeButton, allowDrop } = data.config;
        if (allowExtract === false) {
            this._layoutLockingController.disableGroupExtract(data.itemId);
        }
        else {
            this._layoutLockingController.enableGroupExtract(data.itemId, allowExtract);
        }
        if (allowReorder === false) {
            this._layoutLockingController.disableGroupReorder(data.itemId);
        }
        else {
            this._layoutLockingController.enableGroupReorder(data.itemId, allowReorder);
        }
        if (showAddWindowButton === false) {
            this._layoutLockingController.disableGroupAddWindowButton(data.itemId);
        }
        else {
            this._layoutLockingController.enableGroupAddWindowButton(data.itemId, showAddWindowButton);
        }
        if (showEjectButton === false) {
            this._layoutLockingController.disableGroupEjectButton(data.itemId);
        }
        else {
            this._layoutLockingController.enableGroupEjectButton(data.itemId, showEjectButton);
        }
        if (showMaximizeButton === false) {
            this._layoutLockingController.disableGroupMaximizeButton(data.itemId);
        }
        else {
            this._layoutLockingController.enableGroupMaximizeButton(data.itemId, showMaximizeButton);
        }
        if (allowDrop === false) {
            this._layoutLockingController.disableGroupDrop(data.itemId, data.config);
        }
        else {
            this._layoutLockingController.enableGroupDrop(data.itemId, data.config);
        }
        const workspace = store.getByContainerId(data.itemId);
        if (workspace === null || workspace === void 0 ? void 0 : workspace.layout) {
            workspace.layout.updateSize();
        }
    }
    handleRowLockRequested(data) {
        const { allowDrop, allowSplitters } = data.config;
        if (allowDrop === false) {
            this._layoutLockingController.disableRowDrop(data.itemId);
        }
        else {
            this._layoutLockingController.enableRowDrop(data.itemId, allowDrop);
        }
        if (allowSplitters === false) {
            this._layoutLockingController.disableRowSplitters(data.itemId);
        }
        else {
            this._layoutLockingController.enableRowSplitters(data.itemId, allowSplitters);
        }
    }
    handleColumnLockRequested(data) {
        const { allowDrop, allowSplitters } = data.config;
        if (allowDrop === false) {
            this._layoutLockingController.disableColumnDrop(data.itemId);
        }
        else {
            this._layoutLockingController.enableColumnDrop(data.itemId, allowDrop);
        }
        if (allowSplitters === false) {
            this._layoutLockingController.disableColumnSplitters(data.itemId);
        }
        else {
            this._layoutLockingController.enableColumnSplitters(data.itemId, allowSplitters);
        }
    }
    cleanIsPinned(data) {
        if (data.type !== "row" && data.type !== "column") {
            return data;
        }
        let hasFoundIsPinned = false;
        const clone = JSON.parse(JSON.stringify(data));
        const traverseAndClean = (item) => {
            if (item.workspacesConfig.isPinned) {
                hasFoundIsPinned = true;
                item.workspacesConfig.isPinned = false;
            }
            if (item.type === "component") {
                return;
            }
            item.content.forEach((c) => traverseAndClean(c));
        };
        traverseAndClean(clone);
        if (hasFoundIsPinned) {
            return clone;
        }
        return data;
    }
    applyIsPinned(initialConfig, currentConfig) {
        if (initialConfig.type !== "row" && initialConfig.type !== "column") {
            return;
        }
        if (currentConfig.config.type !== "row" && currentConfig.config.type !== "column") {
            return;
        }
        const traverseAndApply = (initialItem, currentItem) => {
            if (initialItem.workspacesConfig.isPinned) {
                currentItem.config.workspacesConfig.isPinned = true;
            }
            if (initialItem.type === "component" || currentItem.type === "component") {
                return;
            }
            initialItem.content.forEach((c, i) => traverseAndApply(c, currentItem.contentItems[i]));
        };
        traverseAndApply(initialConfig, currentConfig);
    }
    handleOnWorkspaceAdded(workspace) {
        var _a;
        const allOtherWindows = store.workspaceIds.filter((wId) => wId !== workspace.id).reduce((acc, w) => {
            return [...acc, ...store.getById(w).windows];
        }, []);
        this._workspacesEventEmitter.raiseWorkspaceEvent({
            action: "opened",
            payload: {
                frameSummary: { id: this.frameId },
                workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                frameBounds: this.stateResolver.getFrameBounds()
            }
        });
        if (store.getActiveWorkspace().id === workspace.id) {
            this._workspacesEventEmitter.raiseWorkspaceEvent({
                action: "selected",
                payload: {
                    frameSummary: { id: this.frameId },
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                    frameBounds: this.stateResolver.getFrameBounds(),
                }
            });
            if (!workspace.layout) {
                this._frameController.selectionChangedDeep([], allOtherWindows.map((w) => w.id));
                return;
            }
            const allWinsInLayout = getAllWindowsFromConfig(workspace.layout.toConfig().content);
            this._frameController.selectionChangedDeep(allWinsInLayout.map((w) => idAsString(w.id)), allOtherWindows.map((w) => w.id));
        }
        if (!workspace.layout) {
            return;
        }
        const workspaceOptions = workspace.layout.config.workspacesOptions;
        const title = workspaceOptions.title || workspaceOptions.name;
        if (title) {
            (_a = store.getWorkspaceLayoutItemById(workspace.id)) === null || _a === void 0 ? void 0 : _a.setTitle(title);
        }
    }
    handleOnWorkspaceAddedWithSnapshot(workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const allOtherWindows = store.workspaceIds.filter((wId) => wId !== workspace.id).reduce((acc, w) => {
                return [...acc, ...store.getById(w).windows];
            }, []);
            const snapshot = yield this._stateResolver.getWorkspaceSnapshot(workspace.id, this);
            this._workspacesEventEmitter.raiseWorkspaceEvent({
                action: "opened",
                payload: {
                    frameSummary: { id: this.frameId },
                    workspaceSnapshot: snapshot,
                    workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                    frameBounds: this.stateResolver.getFrameBounds()
                }
            });
            if (store.getActiveWorkspace().id === workspace.id) {
                this._workspacesEventEmitter.raiseWorkspaceEvent({
                    action: "selected",
                    payload: {
                        frameSummary: { id: this.frameId },
                        workspaceSummary: this.stateResolver.getWorkspaceSummary(workspace.id),
                        frameBounds: this.stateResolver.getFrameBounds()
                    }
                });
                if (!workspace.layout) {
                    this._frameController.selectionChangedDeep([], allOtherWindows.map((w) => w.id));
                    return;
                }
                const allWinsInLayout = getAllWindowsFromConfig(workspace.layout.toConfig().content);
                this._frameController.selectionChangedDeep(allWinsInLayout.map((w) => idAsString(w.id)), allOtherWindows.map((w) => w.id));
            }
            if (!workspace.layout) {
                return;
            }
            const workspaceOptions = workspace.layout.config.workspacesOptions;
            const title = workspaceOptions.title || workspaceOptions.name;
            if (title) {
                (_a = store.getWorkspaceLayoutItemById(workspace.id)) === null || _a === void 0 ? void 0 : _a.setTitle(title);
            }
        });
    }
    showMaximizeGroupButton(stack) {
        const wrapper = this._wrapperFactory.getContainerWrapper({
            containerContentItem: stack
        });
        if (!wrapper.showMaximizeButton) {
            return;
        }
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({
            groupId: idAsString(stack.config.id),
            restore: {
                visible: false
            },
            maximize: {
                visible: true
            }
        });
    }
    showRestoreGroupButton(stack) {
        const wrapper = this._wrapperFactory.getContainerWrapper({
            containerContentItem: stack
        });
        if (!wrapper.showMaximizeButton) {
            return;
        }
        componentStateMonitor.decoratedFactory.updateGroupHeaderButtons({
            groupId: idAsString(stack.config.id),
            restore: {
                visible: true
            },
            maximize: {
                visible: false
            }
        });
    }
}
var manager = new WorkspacesManager();

class WorkspacesLocker {
    constructor(manager) {
        this.manager = manager;
    }
    applyLockConfiguration(workspacesConfig, snapshot) {
        const traverse = (item, snapshotItem) => __awaiter(this, void 0, void 0, function* () {
            if (item.type === "window") {
                if (this.doesWindowContainLockProperties(item)) {
                    this.manager.lockWindow({
                        windowPlacementId: snapshotItem.id,
                        config: item.config
                    });
                }
                return;
            }
            else if (item.type === "group" || item.type === "row" || item.type === "column") {
                if (this.doesContainerContainLockProperties(item)) {
                    this.manager.lockContainer({
                        itemId: snapshotItem.id,
                        type: item.type,
                        config: item.config
                    });
                }
            }
            else {
                if (this.doesWorkspaceContainLockProperties(item)) {
                    this.manager.lockWorkspace({
                        workspaceId: snapshot.id,
                        config: item.config
                    });
                }
            }
            yield Promise.all(item.children.map((i, index) => {
                return traverse(i, snapshotItem.children[index]);
            }));
        });
        return traverse(workspacesConfig, snapshot);
    }
    applyWindowLockConfiguration(windowSummary) {
        const item = {
            config: windowSummary.config,
            id: windowSummary.itemId,
            type: "window"
        };
        if (this.doesWindowContainLockProperties(item)) {
            this.manager.lockWindow({
                windowPlacementId: windowSummary.itemId,
                config: windowSummary.config
            });
        }
    }
    applyContainerLockConfiguration(definition, workspace, itemId) {
        const snapshot = this.getItemFromWorkspace(workspace, itemId);
        const traverse = (item, snapshotItem) => {
            if (item.type === "window") {
                if (this.doesWindowContainLockProperties(item)) {
                    this.manager.lockWindow({
                        windowPlacementId: snapshotItem.id,
                        config: item.config
                    });
                }
                return;
            }
            else if (item.type === "group" || item.type === "row" || item.type === "column") {
                if (this.doesContainerContainLockProperties(item)) {
                    this.manager.lockContainer({
                        itemId: snapshotItem.id,
                        type: item.type,
                        config: item.config
                    });
                }
            }
            else {
                if (this.doesWorkspaceContainLockProperties(item)) {
                    this.manager.lockWorkspace({
                        workspaceId: item.id,
                        config: item.config
                    });
                }
            }
            item.children.forEach((i, index) => {
                return traverse(i, snapshotItem.children[index]);
            });
        };
        return traverse(definition, snapshot);
    }
    doesWindowContainLockProperties(window) {
        var _a, _b, _c;
        return this.isLockPropertySet((_a = window.config) === null || _a === void 0 ? void 0 : _a.showCloseButton) || this.isLockPropertySet((_b = window.config) === null || _b === void 0 ? void 0 : _b.allowExtract) || this.isLockPropertySet((_c = window.config) === null || _c === void 0 ? void 0 : _c.allowReorder);
    }
    doesContainerContainLockProperties(container) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return this.isLockPropertySet((_a = container.config) === null || _a === void 0 ? void 0 : _a.allowDrop) ||
            this.isLockPropertySet((_b = container.config) === null || _b === void 0 ? void 0 : _b.allowDropHeader) ||
            this.isLockPropertySet((_c = container.config) === null || _c === void 0 ? void 0 : _c.allowDropLeft) ||
            this.isLockPropertySet((_d = container.config) === null || _d === void 0 ? void 0 : _d.allowDropRight) ||
            this.isLockPropertySet((_e = container.config) === null || _e === void 0 ? void 0 : _e.allowDropTop) ||
            this.isLockPropertySet((_f = container.config) === null || _f === void 0 ? void 0 : _f.allowDropBottom) ||
            this.isLockPropertySet((_g = container.config) === null || _g === void 0 ? void 0 : _g.allowExtract) ||
            this.isLockPropertySet((_h = container.config) === null || _h === void 0 ? void 0 : _h.allowReorder) ||
            this.isLockPropertySet((_j = container.config) === null || _j === void 0 ? void 0 : _j.showExtractButton) ||
            this.isLockPropertySet((_k = container.config) === null || _k === void 0 ? void 0 : _k.showMaximizeButton) ||
            this.isLockPropertySet((_l = container.config) === null || _l === void 0 ? void 0 : _l.showAddWindowButton) ||
            this.isLockPropertySet((_m = container.config) === null || _m === void 0 ? void 0 : _m.allowSplitters);
    }
    doesWorkspaceContainLockProperties(workspace) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return this.isLockPropertySet((_a = workspace.config) === null || _a === void 0 ? void 0 : _a.allowDrop) ||
            this.isLockPropertySet((_b = workspace.config) === null || _b === void 0 ? void 0 : _b.allowDropLeft) ||
            this.isLockPropertySet((_c = workspace.config) === null || _c === void 0 ? void 0 : _c.allowDropTop) ||
            this.isLockPropertySet((_d = workspace.config) === null || _d === void 0 ? void 0 : _d.allowDropRight) ||
            this.isLockPropertySet((_e = workspace.config) === null || _e === void 0 ? void 0 : _e.allowDropBottom) ||
            this.isLockPropertySet((_f = workspace.config) === null || _f === void 0 ? void 0 : _f.allowExtract) ||
            this.isLockPropertySet((_g = workspace.config) === null || _g === void 0 ? void 0 : _g.allowWindowReorder) ||
            this.isLockPropertySet((_h = workspace.config) === null || _h === void 0 ? void 0 : _h.allowHibernation) ||
            this.isLockPropertySet((_j = workspace.config) === null || _j === void 0 ? void 0 : _j.showExtractButtons) ||
            this.isLockPropertySet((_k = workspace.config) === null || _k === void 0 ? void 0 : _k.showWindowCloseButtons) ||
            this.isLockPropertySet((_l = workspace.config) === null || _l === void 0 ? void 0 : _l.showAddWindowButtons) ||
            this.isLockPropertySet((_m = workspace.config) === null || _m === void 0 ? void 0 : _m.showSaveButton) ||
            this.isLockPropertySet((_o = workspace.config) === null || _o === void 0 ? void 0 : _o.allowWorkspaceTabReorder) ||
            this.isLockPropertySet((_p = workspace.config) === null || _p === void 0 ? void 0 : _p.showCloseButton) ||
            this.isLockPropertySet((_q = workspace.config) === null || _q === void 0 ? void 0 : _q.allowSplitters);
    }
    isLockPropertySet(value) {
        return typeof value === "boolean";
    }
    getItemFromWorkspace(workspaceItem, itemId) {
        const find = (item) => {
            if (item.id === itemId) {
                return item;
            }
            if (item.type === "window") {
                return;
            }
            return item.children.map((c) => find(c)).find((r) => r);
        };
        return find(workspaceItem);
    }
}

class GlueFacade {
    constructor() {
        this._workspacesControlMethod = "T42.Workspaces.Control";
        this._workspacesEventMethod = "T42.Workspaces.Events";
        this._inDisposing = false;
        this._controlPromise = Promise.resolve();
        this.handleControlCore = (args, caller, successCallback, errorCallback) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield manager.initPromise;
                switch (args.operation) {
                    case "isWindowInWorkspace":
                        successCallback(this.handleIsWindowInWorkspace(args.operationArguments));
                        break;
                    case "addWindow":
                        successCallback(yield this.handleAddWindow(args.operationArguments));
                        break;
                    case "addContainer":
                        successCallback(yield this.handleAddContainer(args.operationArguments));
                        break;
                    case "getWorkspaceSnapshot":
                        successCallback(yield this.handleGetWorkspaceSnapshot(args.operationArguments));
                        break;
                    case "openWorkspace":
                        successCallback(yield this.handleOpenWorkspace(args.operationArguments));
                        break;
                    case "saveLayout":
                        successCallback(yield this.handleSaveLayout(args.operationArguments));
                        break;
                    case "exportAllLayouts":
                        successCallback(yield this.handleExportAllLayouts());
                        break;
                    case "deleteLayout":
                        this.handleDeleteLayout(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "getAllWorkspacesSummaries":
                        successCallback(this.handleGetAllWorkspaceSummaries());
                        break;
                    case "maximizeItem":
                        this.handleMaximizeItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "restoreItem":
                        this.handleRestoreItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "closeItem":
                        yield this.handleCloseItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "setItemTitle":
                        yield this.handleSetItemTitle(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "addWorkspaceChildren":
                        yield this.handleAddWorkspaceChildren(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "ejectWindow":
                        successCallback(yield this.handleEject(args.operationArguments));
                        break;
                    case "createWorkspace":
                        successCallback(yield this.handleCreateWorkspace(args.operationArguments));
                        break;
                    case "forceLoadWindow":
                        successCallback(yield this.handleForceLoadWindow(args.operationArguments));
                        break;
                    case "focusItem":
                        yield this.handleFocusItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "bundleWorkspace":
                        this.handleBundleWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "bundleItem":
                        this.handleBundleItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "getFrameSummary":
                        successCallback(yield this.handleGetFrameSummary(args.operationArguments));
                        break;
                    case "moveFrame":
                        yield this.handleMoveFrame(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "getFrameSnapshot":
                        successCallback(yield this.handleGetFrameSnapshot(args.operationArguments));
                        break;
                    case "getSnapshot":
                        successCallback(yield this.handleGetSnapshot(args.operationArguments));
                        break;
                    case "moveWindowTo":
                        yield this.handleMoveWindowTo(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "generateLayout":
                        successCallback(yield this.handleGenerateLayout(args.operationArguments));
                        break;
                    case "ping":
                        successCallback(this.handlePing());
                        break;
                    case "hibernateWorkspace":
                        yield this.handleHibernateWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "resumeWorkspace":
                        yield this.handleResumeWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "lockWorkspace":
                        this.handleLockWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "lockContainer":
                        this.handleLockContainer(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "lockWindow":
                        this.handleLockWindow(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "resizeItem":
                        this.handleResizeItem(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "pinWorkspace":
                        this.handlePinWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "unpinWorkspace":
                        this.handleUnpinWorkspace(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "getWorkspaceIcon":
                        successCallback(this.handleGetWorkspaceIcon(args.operationArguments));
                        break;
                    case "setWorkspaceIcon":
                        this.handleSetWorkspaceIcon(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "initFrame":
                        yield this.handleInitFrame(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "createFrame":
                        successCallback(this.handleCreateFrame(args.operationArguments));
                        break;
                    case "initFrameFromSnapshot":
                        yield this.handleInitFrameFromSnapshot(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "getWorkspacesLayouts":
                        successCallback(yield this.handleGetWorkspaceLayouts(args.operationArguments));
                        break;
                    case "setMaximizationBoundary":
                        this.handleSetMaximizationBoundary(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "operationCheck":
                        successCallback(this.handleOperationCheck(args.operationArguments));
                        break;
                    case "getDecorationsSize":
                        successCallback(this.handleGetDecorationsSize(args.operationArguments));
                        break;
                    case "showChannelsLink":
                        yield this.handleShowChannelsLink(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "changeChannelsLinkColor":
                        yield this.handleChangeChannelsLinkColor(args.operationArguments);
                        successCallback(undefined);
                        break;
                    case "hideChannelsLink":
                        this.handleHideChannelsLink(args.operationArguments);
                        successCallback(undefined);
                        break;
                    default:
                        errorCallback(`Invalid operation - ${args.operation}`);
                }
            }
            catch (error) {
                errorCallback(error.message);
                console.warn(error);
            }
        });
        this.handleControl = (args, caller, successCallback, errorCallback) => __awaiter(this, void 0, void 0, function* () {
            const controlPromise = this.handleControlCore(args, caller, successCallback, errorCallback);
            this._controlPromise = controlPromise;
            yield controlPromise;
        });
    }
    init(glue) {
        return __awaiter(this, void 0, void 0, function* () {
            this._glue = glue;
            this._configFactory = new WorkspacesConfigurationFactory(glue);
            this._converter = new ConfigConverter(this._configFactory);
            this._locker = new WorkspacesLocker(manager);
            this._constraintValidator = new ConstraintsValidator();
            if (this._glue) {
                yield this.registerAgmMethods();
            }
        });
    }
    dispose() {
        this._inDisposing = true;
    }
    subscribeForWorkspaceEvents() {
        manager.workspacesEventEmitter.onFrameEvent((action, payload) => {
            this.publishEventData(action, payload, "frame");
        });
        manager.workspacesEventEmitter.onWindowEvent((action, payload) => {
            this.publishEventData(action, payload, "window");
        });
        manager.workspacesEventEmitter.onWorkspaceEvent((action, payload) => {
            this.publishEventData(action, payload, "workspace");
        });
        manager.workspacesEventEmitter.onContainerEvent((action, payload) => {
            this.publishEventData(action, payload, "container");
        });
    }
    executeAfterControlIsDone(cb) {
        this._controlPromise.finally(() => {
            return cb();
        });
    }
    registerAgmMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._glue.agm.registerAsync({
                name: this._workspacesControlMethod
            }, this.handleControl);
        });
    }
    handleOpenWorkspace(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = yield manager.openWorkspace(operationArguments.name, operationArguments.restoreOptions);
            return manager.stateResolver.getWorkspaceSnapshot(id, manager);
        });
    }
    handleExportAllLayouts() {
        return __awaiter(this, void 0, void 0, function* () {
            const layouts = yield manager.exportAllLayouts();
            return {
                layouts
            };
        });
    }
    handleSaveLayout(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield manager.saveWorkspace(operationArguments.name, operationArguments.workspaceId, operationArguments.saveContext, operationArguments.allowMultiple, operationArguments.metadata, operationArguments.saveWindowContexts);
        });
    }
    handleDeleteLayout(operationArguments) {
        manager.deleteLayout(operationArguments.name);
    }
    handleGetWorkspaceSnapshot(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return manager.stateResolver.getWorkspaceSnapshot(operationArguments.itemId, manager);
        });
    }
    handleGetAllWorkspaceSummaries() {
        const summaries = store.layouts.map((w) => {
            const summary = manager.stateResolver.getWorkspaceSummary(w.id);
            return summary;
        });
        return {
            summaries
        };
    }
    handleCloseItem(operationArguments) {
        return manager.closeItem(operationArguments.itemId);
    }
    handleRestoreItem(operationArguments) {
        manager.restoreItem(operationArguments.itemId);
    }
    handleMaximizeItem(operationArguments) {
        manager.maximizeItem(operationArguments.itemId);
    }
    handleAddContainer(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            if (operationArguments.definition.type === "workspace") {
                throw new Error(`Unsuported add container type ${operationArguments.definition.type}`);
            }
            const workspace = store.getByContainerId(operationArguments.parentId) || store.getById(operationArguments.parentId);
            const workspaceItem = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspace.id));
            this._constraintValidator.fixNewContainer(operationArguments.definition, workspaceItem, operationArguments.parentId);
            const rendererFriendlyConfig = this._converter.convertToRendererConfig(operationArguments.definition);
            if (rendererFriendlyConfig.type === "workspace") {
                throw new Error("Unsuccessful conversion");
            }
            const containerDefinition = {
                id: idAsString(rendererFriendlyConfig.id),
                content: rendererFriendlyConfig.content,
                type: rendererFriendlyConfig.type,
                workspacesConfig: rendererFriendlyConfig.workspacesConfig
            };
            const itemId = yield manager.addContainer(containerDefinition, operationArguments.parentId);
            const workspaceItemAferAdd = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspace.id));
            this._locker.applyContainerLockConfiguration(operationArguments.definition, workspaceItemAferAdd, itemId);
            return {
                itemId
            };
        });
    }
    handleAddWindow(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            const constraintsValidator = new ConstraintsValidator();
            const workspace = store.getByContainerId(operationArguments.parentId) || store.getById(operationArguments.parentId);
            const workspaceItem = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspace.id));
            constraintsValidator.fixNewWindow(operationArguments.definition, workspaceItem, operationArguments.parentId);
            const windowConfig = this._configFactory.createGDWindowConfig({
                windowId: operationArguments.definition.windowId,
                id: undefined,
                appName: operationArguments.definition.appName,
                url: operationArguments.definition.url,
                context: operationArguments.definition.context,
                allowExtract: (_a = operationArguments.definition.config) === null || _a === void 0 ? void 0 : _a.allowExtract,
                allowReorder: (_b = operationArguments.definition.config) === null || _b === void 0 ? void 0 : _b.allowReorder,
                showCloseButton: (_c = operationArguments.definition.config) === null || _c === void 0 ? void 0 : _c.showCloseButton,
                minWidth: (_d = operationArguments.definition.config) === null || _d === void 0 ? void 0 : _d.minWidth,
                maxWidth: (_e = operationArguments.definition.config) === null || _e === void 0 ? void 0 : _e.maxWidth,
                minHeight: (_f = operationArguments.definition.config) === null || _f === void 0 ? void 0 : _f.minHeight,
                maxHeight: (_g = operationArguments.definition.config) === null || _g === void 0 ? void 0 : _g.maxHeight,
            });
            yield manager.addWindow(windowConfig, operationArguments.parentId);
            const notLoadedSummary = manager.stateResolver.getWindowSummarySync(windowConfig.id);
            this._locker.applyWindowLockConfiguration(notLoadedSummary);
            return {
                itemId: idAsString(windowConfig.id),
            };
        });
    }
    handleSetItemTitle(operationArguments) {
        manager.setItemTitle(operationArguments.itemId, operationArguments.title);
    }
    handleAddWorkspaceChildren(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            const hasRows = operationArguments.children.some((c) => c.type === "row");
            const hasColumns = operationArguments.children.some((c) => c.type === "column");
            if (hasColumns && hasRows) {
                throw new Error("Can't add both row and column workspace children");
            }
            let itemConfig = {
                type: "column",
                children: operationArguments.children
            };
            if (hasColumns) {
                itemConfig = {
                    type: "row",
                    children: operationArguments.children
                };
            }
            const convertedConfig = this._converter.convertToRendererConfig(itemConfig);
            yield manager.addContainer(convertedConfig, operationArguments.workspaceId);
        });
    }
    handleEject(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield manager.eject(operationArguments.itemId);
        });
    }
    handleCreateWorkspace(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!operationArguments.config) {
                operationArguments.config = {};
            }
            const workspaceItem = this.convertCreateWorkspaceArgumentsToWorkspaceItem(operationArguments);
            this._constraintValidator.fixWorkspace(workspaceItem);
            const config = this._converter.convertToRendererConfig(workspaceItem);
            const workspaceId = yield manager.createWorkspace(config);
            const apiConfig = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspaceId));
            this._locker.applyLockConfiguration(workspaceItem, apiConfig);
            return manager.stateResolver.getWorkspaceSnapshot(workspaceId, manager);
        });
    }
    handleForceLoadWindow(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield manager.loadWindow(operationArguments.itemId);
        });
    }
    handleFocusItem(operationArguments) {
        return manager.focusItem(operationArguments.itemId);
    }
    handleBundleWorkspace(operationArguments) {
        return manager.bundleWorkspace(operationArguments.workspaceId, operationArguments.type);
    }
    handleBundleItem(operationArguments) {
        return manager.bundleItem(operationArguments.itemId, operationArguments.type);
    }
    handleIsWindowInWorkspace(operationArguments) {
        return {
            inWorkspace: manager.stateResolver.isWindowInWorkspace(operationArguments.itemId)
        };
    }
    handleGetFrameSummary(operationArguments) {
        return manager.getFrameSummary(operationArguments.itemId);
    }
    handleMoveFrame(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            yield manager.move(operationArguments.location);
        });
    }
    handleGetFrameSnapshot(operationArguments) {
        return manager.stateResolver.getFrameSnapshot(manager, operationArguments.excludeIds);
    }
    handleGetSnapshot(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            if (manager.frameId === operationArguments.itemId) {
                return manager.stateResolver.getFrameSnapshot(manager);
            }
            else if (store.getById(operationArguments.itemId)) {
                return manager.stateResolver.getWorkspaceSnapshot(operationArguments.itemId, manager);
            }
        });
    }
    handleMoveWindowTo(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return manager.moveWindowTo(operationArguments.itemId, operationArguments.containerId);
        });
    }
    handleGenerateLayout(operationArguments) {
        return manager.generateWorkspaceLayout(operationArguments.name, operationArguments.workspaceId);
    }
    handlePing() {
        return { live: !this._inDisposing };
    }
    handleHibernateWorkspace(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return manager.hibernateWorkspace(operationArguments.workspaceId);
        });
    }
    handleResumeWorkspace(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return manager.resumeWorkspace(operationArguments.workspaceId);
        });
    }
    handleLockWorkspace(operationArguments) {
        return manager.lockWorkspace(operationArguments);
    }
    handleLockWindow(operationArguments) {
        return manager.lockWindow(operationArguments);
    }
    handleLockContainer(operationArguments) {
        return manager.lockContainer(operationArguments);
    }
    handleResizeItem(operationArguments) {
        return manager.resizeItem(operationArguments);
    }
    handlePinWorkspace(operationArguments) {
        return manager.pinWorkspace(operationArguments.workspaceId, operationArguments.icon);
    }
    handleUnpinWorkspace(operationArguments) {
        return manager.unpinWorkspace(operationArguments.workspaceId);
    }
    handleGetWorkspaceIcon(operationArguments) {
        const icon = manager.stateResolver.getWorkspaceIcon(operationArguments.workspaceId);
        if (icon) {
            return { icon };
        }
        else {
            return {};
        }
    }
    handleSetWorkspaceIcon(operationArguments) {
        manager.setWorkspaceIcon(operationArguments.workspaceId, operationArguments.icon);
    }
    handleInitFrame(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!operationArguments.workspaces.length) {
                throw new Error("Cannot initialize frame without workspaces");
            }
            const contentConfigs = yield Promise.all(operationArguments.workspaces.map((def) => __awaiter(this, void 0, void 0, function* () {
                const defAsLayout = def;
                const defAsWorkspace = def;
                if (defAsLayout.name) {
                    return this._configFactory.convertLayoutOptionsToWorkspaceItem(defAsLayout.name, defAsLayout.restoreOptions, manager.layoutsManager);
                }
                return this._converter.convertToRendererConfig(this.convertCreateWorkspaceArgumentsToWorkspaceItem(defAsWorkspace));
            })));
            const workspaceIds = yield manager.initFrameLayout(contentConfigs);
            workspaceIds.forEach((workspaceId, i) => {
                const workspaceItem = operationArguments.workspaces[i];
                if (!workspaceItem.children) {
                    return;
                }
                const apiConfig = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspaceId));
                this._locker.applyLockConfiguration(workspaceItem, apiConfig);
            });
        });
    }
    handleInitFrameFromSnapshot(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            const contentConfigs = operationArguments.workspaces.map((def) => {
                return this._converter.convertToRendererConfig(this.convertCreateWorkspaceArgumentsToWorkspaceItem(def));
            });
            const workspaceIds = yield manager.initFrameLayout(contentConfigs, operationArguments.keepWorkspaces);
            workspaceIds.forEach((workspaceId, i) => {
                const workspaceItem = operationArguments.workspaces[i];
                if (!workspaceItem.children) {
                    return;
                }
                const apiConfig = this._converter.convertToAPIConfig(manager.stateResolver.getWorkspaceConfig(workspaceId));
                this._locker.applyLockConfiguration(workspaceItem, apiConfig);
            });
        });
    }
    handleGetWorkspaceLayouts(operationArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                workspaces: yield manager.stateResolver.getAllWorkspacesLayouts(manager, operationArguments)
            };
        });
    }
    handleSetMaximizationBoundary(operationArguments) {
        manager.setMaximizationBoundary(operationArguments.itemId, operationArguments.enabled);
    }
    handleOperationCheck(operationArguments) {
        return { isSupported: isOperationSupported(operationArguments.operation) };
    }
    handleGetDecorationsSize(operationArguments) {
        return manager.getDecorationsSize(operationArguments.itemId);
    }
    handleShowChannelsLink(operationArguments) {
        return manager.showChannelsLink(operationArguments.windowId, operationArguments.channelsNames);
    }
    handleChangeChannelsLinkColor(operationArguments) {
        return manager.changeChannelLinkColor(operationArguments.windowId, operationArguments.color);
    }
    handleHideChannelsLink(operationArguments) {
        return manager.hideChannelsLink(operationArguments.windowId);
    }
    handleCreateFrame(operationArguments) {
        manager.setFrameContext(operationArguments === null || operationArguments === void 0 ? void 0 : operationArguments.context);
        return manager.getFrameSummary(manager.frameId);
    }
    publishEventData(action, payload, type) {
        const hasEventMethod = this._glue.agm.methods().some(m => m.name === this._workspacesEventMethod);
        if (hasEventMethod) {
            const methodPayload = {
                action,
                type,
                payload
            };
            this._glue.agm.invoke(this._workspacesEventMethod, methodPayload).catch(() => {
                // console.warn(`Could not push data to ${this._workspacesEventMethod} because ${e.message}`);
            });
        }
    }
    convertCreateWorkspaceArgumentsToWorkspaceItem(args) {
        var _a, _b;
        const workspaceItem = Object.assign({}, args);
        if (!workspaceItem.config) {
            workspaceItem.config = {};
        }
        if (typeof ((_a = args.config) === null || _a === void 0 ? void 0 : _a.isSelected) === "boolean") {
            // The API friendly flag name is isSelected and to preserve backwards compatibility (the global layouts will use selected) the mapping is being made
            workspaceItem.config.selected = args.config.isSelected;
        }
        workspaceItem.config.context = ((_b = args.config) === null || _b === void 0 ? void 0 : _b.context) || args.context;
        workspaceItem.config.allowDrop = undefined; // The property isn't supported in core
        return workspaceItem;
    }
}
var facade = new GlueFacade();

var jquery$1 = {exports: {}};

/*!
 * jQuery JavaScript Library v3.5.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-04-10T15:07Z
 */

(function (module) {
	( function( global, factory ) {

		{

			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		}

	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : commonjsGlobal, function( window, noGlobal ) {

	var arr = [];

	var getProto = Object.getPrototypeOf;

	var slice = arr.slice;

	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};


	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call( Object );

	var support = {};

	var isFunction = function isFunction( obj ) {

	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };


	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};


	var document = window.document;



		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};

		function DOMEval( code, node, doc ) {
			doc = doc || document;

			var i, val,
				script = doc.createElement( "script" );

			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {

					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}


	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module



	var
		version = "3.5.0",

		// Define a local copy of jQuery
		jQuery = function( selector, context ) {

			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function() {
			return slice.call( this );
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {

			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}

			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},

		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},

		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},

		first: function() {
			return this.eq( 0 );
		},

		last: function() {
			return this.eq( -1 );
		},

		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},

		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},

		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},

		end: function() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;

		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;

			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}

		for ( ; i < length; i++ ) {

			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {

				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];

						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );

					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend( {

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function( msg ) {
			throw new Error( msg );
		},

		noop: function() {},

		isPlainObject: function( obj ) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}

			proto = getProto( obj );

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},

		isEmptyObject: function( obj ) {
			var name;

			for ( name in obj ) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},

		each: function( obj, callback ) {
			var length, i = 0;

			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}

			return obj;
		},

		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];

			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}

			return ret;
		},

		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;

			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}

			first.length = i;

			return first;
		},

		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];

			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}

			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}
			}

			// Flatten any nested arrays
			return flat( ret );
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );

	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}

	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

	function isArrayLike( obj ) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );

		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}

		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,

		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,

		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},

		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,

		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},

		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",

		// Regular expressions

		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",

		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +

			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",

		pseudos = ":(" + identifier + ")(?:\\((" +

			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

			// 3. anything else (capture 2)
			".*" +
			")\\)|)",

		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),

		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),

		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),

		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},

		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,

		rnative = /^[^{]+\{\s*\[native \w/,

		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

		rsibling = /[+~]/,

		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;

			return nonHex ?

				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :

				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},

		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},

		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},

		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);

	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);

		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?

			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :

			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;

				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}

	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,

			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

		results = results || [];

		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

			return results;
		}

		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;

			if ( documentIsHTML ) {

				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

					// ID selector
					if ( ( m = match[ 1 ] ) ) {

						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}

						// Element context
						} else {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {

								results.push( elem );
								return results;
							}
						}

					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;

					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {

						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}

				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

					newSelector = selector;
					newContext = context;

					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;

						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {

							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}

						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}

					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}

		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}

	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];

		function cache( key, value ) {

			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {

				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}

	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}

	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );

		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {

			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}

			// release memory in IE
			el = null;
		}
	}

	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;

		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}

	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;

		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}

		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}

		return a ? 1 : -1;
	}

	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {

		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {

			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {

				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {

					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}

					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}

				return elem.disabled === disabled;

			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}

			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}

	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;

				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}

	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}

	// Expose support vars for convenience
	support = Sizzle.support = {};

	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;

		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};

	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;

		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}

		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );

		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );

			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}

		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );

		/* Attributes
		---------------------------------------------------------------------- */

		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );

		/* getElement(s)By*
		---------------------------------------------------------------------- */

		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );

		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );

		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );

		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};

			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );

					if ( elem ) {

						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}

						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}

					return [];
				}
			};
		}

		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );

				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :

			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,

					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );

				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}

					return tmp;
				}
				return results;
			};

		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};

		/* QSA/matchesSelector
		---------------------------------------------------------------------- */

		// QSA and matchesSelector support

		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];

		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];

		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {

				var input;

				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";

				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}

				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}

				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}

				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}

				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}

				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}

				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );

			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";

				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );

				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}

				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}

		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {

			assert( function( el ) {

				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );

				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}

		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );

		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};

		/* Sorting
		---------------------------------------------------------------------- */

		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {

			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}

			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :

				// Otherwise we know they are disconnected
				1;

			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}

				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}

			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {

			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];

			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;

			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}

			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}

			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}

			return i ?

				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :

				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};

		return document;
	};

	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};

	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );

		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

			try {
				var ret = matches.call( elem, expr );

				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}

		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};

	Sizzle.contains = function( context, elem ) {

		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};

	Sizzle.attr = function( elem, name ) {

		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}

		var fn = Expr.attrHandle[ name.toLowerCase() ],

			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;

		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};

	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};

	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};

	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;

		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );

		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}

		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;

		return results;
	};

	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {

				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	};

	Expr = Sizzle.selectors = {

		// Can be adjusted by the user
		cacheLength: 50,

		createPseudo: markFunction,

		match: matchExpr,

		attrHandle: {},

		find: {},

		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},

		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );

				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );

				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}

				return match.slice( 0, 4 );
			},

			"CHILD": function( match ) {

				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();

				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}

					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				return match;
			},

			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];

				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}

				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&

					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&

					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}

				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},

		filter: {

			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},

			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];

				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},

			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );

					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}

					result += "";

					/* eslint-disable max-len */

					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */

				};
			},

			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";

				return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :

					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;

						if ( parent ) {

							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {

											return false;
										}
									}

									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [ forward ? parent.firstChild : parent.lastChild ];

							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {

								// Seek `elem` from a previously-cached index

								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];

								while ( ( node = ++nodeIndex && node && node[ dir ] ||

									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}

							} else {

								// Use previously-cached element index if available
								if ( useCache ) {

									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );

									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {

									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {

										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {

											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );

												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );

												uniqueCache[ type ] = [ dirruns, diff ];
											}

											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},

			"PSEUDO": function( pseudo, argument ) {

				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );

				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}

				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}

				return fn;
			}
		},

		pseudos: {

			// Potentially complex pseudos
			"not": markFunction( function( selector ) {

				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );

				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;

						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );

						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),

			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),

			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),

			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {

				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),

			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},

			"root": function( elem ) {
				return elem === docElem;
			},

			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},

			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),

			"checked": function( elem ) {

				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},

			"selected": function( elem ) {

				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}

				return elem.selected === true;
			},

			// Contents
			"empty": function( elem ) {

				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},

			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},

			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},

			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},

			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},

			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&

					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},

			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),

			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),

			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),

			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),

			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};

	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}

	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();

	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];

		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}

		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;

		while ( soFar ) {

			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {

					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}

			matched = false;

			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,

					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}

			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}

			if ( !matched ) {
				break;
			}
		}

		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :

				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};

	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}

	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;

		return combinator.first ?

			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );

							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {

								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}

	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}

	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}

	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;

		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}

		return newUnmatched;
	}

	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,

				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),

				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,

				matcherOut = matcher ?

					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

						// ...intermediate processing is necessary
						[] :

						// ...otherwise use results directly
						results :
					matcherIn;

			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}

			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );

				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}

			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {

						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {

								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}

					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}

			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}

	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,

			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );

				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];

		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {

					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}

		return elementMatcher( matchers );
	}

	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,

					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;

				if ( outermost ) {

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if ( bySet ) {

						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}

					if ( seed ) {

						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}

					// Add matches to results
					push.apply( results, setMatched );

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {

						Sizzle.uniqueSort( results );
					}
				}

				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}

	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];

		if ( !cached ) {

			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}

			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);

			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};

	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );

		results = results || [];

		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {

			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;

				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}

				selector = selector.slice( tokens.shift().value.length );
			}

			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];

				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {

					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {

						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}

						break;
					}
				}
			}
		}

		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};

	// One-time assignments

	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;

	// Initialize against the default document
	setDocument();

	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {

		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );

	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}

	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}

	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}

	return Sizzle;

	} )( window );



	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;

	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;




	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};


	var siblings = function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	};


	var rneedsContext = jQuery.expr.match.needsContext;



	function nodeName( elem, name ) {

	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

	}	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}

		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}

	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];

		if ( not ) {
			expr = ":not(" + expr + ")";
		}

		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}

		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};

	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;

			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}

			ret = this.pushStack( [] );

			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}

			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,

				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );


	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,

		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;

			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}

			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;

			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {

					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];

				} else {
					match = rquickExpr.exec( selector );
				}

				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {

					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;

						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );

						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {

								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );

								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}

						return this;

					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );

						if ( elem ) {

							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}

				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}

			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;

			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :

					// Execute immediately if ready is not present
					selector( jQuery );
			}

			return jQuery.makeArray( selector, this );
		};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery( document );


	var rparentsprev = /^(?:parents|prev(?:Until|All))/,

		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};

	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;

			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},

		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );

			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :

							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {

							matched.push( cur );
							break;
						}
					}
				}
			}

			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},

		// Determine the position of an element within the set
		index: function( elem ) {

			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}

			// Locate the position of the desired element
			return indexOf.call( this,

				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},

		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},

		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );

	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}

	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&

				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {

				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}

			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );

			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}

			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}

			if ( this.length > 1 ) {

				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}

				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}

			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}

	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );

		var // Flag to know if list is currently firing
			firing,

			// Last fire value for non-forgettable lists
			memory,

			// Flag to know if list was already fired
			fired,

			// Flag to prevent firing
			locked,

			// Actual callback list
			list = [],

			// Queue of execution data for repeatable lists
			queue = [],

			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,

			// Fire callbacks
			fire = function() {

				// Enforce single-firing
				locked = locked || options.once;

				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {

						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {

							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}

				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}

				firing = false;

				// Clean up if we're done firing for good
				if ( locked ) {

					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];

					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},

			// Actual Callbacks object
			self = {

				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {

						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}

						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {

									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );

						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},

				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );

							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},

				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},

				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},

				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},

				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},

				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},

				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},

				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};

		return self;
	};


	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}

	function adoptValue( value, resolve, reject, noValue ) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );

			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );

			// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}

		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}

	jQuery.extend( {

		Deferred: function( func ) {
			var tuples = [

					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},

					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;

						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {

								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;

										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}

										returned = handler.apply( that, args );

										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}

										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&

											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;

										// Handle a returned thenable
										if ( isFunction( then ) ) {

											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);

											// Normal processors (resolve) also hook into progress
											} else {

												// ...and disregard older resolution values
												maxDepth++;

												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}

										// Handle all other returned values
										} else {

											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}

											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},

									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {

												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}

												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {

													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}

													deferred.rejectWith( that, args );
												}
											}
										};

								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {

									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}

						return jQuery.Deferred( function( newDefer ) {

							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);

							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);

							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},

					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};

			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;

				// Handle state
				if ( stateString ) {
					list.add(
						function() {

							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},

						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,

						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,

						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,

						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );

			// Make the deferred a promise
			promise.promise( deferred );

			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function( singleValue ) {
			var

				// count of uncompleted subordinates
				remaining = arguments.length,

				// count of unprocessed arguments
				i = remaining,

				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),

				// the master Deferred
				master = jQuery.Deferred(),

				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};

			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

					return master.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}

			return master.promise();
		}
	} );


	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	jQuery.Deferred.exceptionHook = function( error, stack ) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};




	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};




	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function( fn ) {

		readyList
			.then( fn )

			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );

		return this;
	};

	jQuery.extend( {

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function( wait ) {

			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );

	} else {

		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );

		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}




	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;

		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}

		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;

			if ( !isFunction( value ) ) {
				raw = true;
			}

			if ( bulk ) {

				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;

				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}

			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}

		if ( chainable ) {
			return elems;
		}

		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}

		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};


	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};




	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function( owner ) {

			// Check if the owner object already has a cache
			var value = owner[ this.expando ];

			// If not, create one
			if ( !value ) {
				value = Object.create( null );

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;

					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}

			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;

			// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :

				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {

				return this.get( owner, key );
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];

			if ( cache === undefined ) {
				return;
			}

			if ( key !== undefined ) {

				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}

				i = key.length;

				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}

			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();



	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;

	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}

		if ( data === "false" ) {
			return false;
		}

		if ( data === "null" ) {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}

		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}

		return data;
	}

	function dataAttr( elem, key, data ) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );

			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},

		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},

		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},

		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );

	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;

			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );

					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {

							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}

				return data;
			}

			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}

			return access( this, function( value ) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each( function() {

					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},

		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );


	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;

			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );

				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},

		dequeue: function( elem, type ) {
			type = type || "fx";

			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};

			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}

			if ( fn ) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}

			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );

	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;

			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}

			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}

			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );

					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );

					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};

			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

	var documentElement = document.documentElement;



		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };

		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {

			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;

			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&

				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&

				jQuery.css( elem, "display" ) === "none";
		};



	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );

		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while ( maxIterations-- ) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;

			}

			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}


	var defaultDisplayMap = {};

	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];

		if ( display ) {
			return display;
		}

		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );

		temp.parentNode.removeChild( temp );

		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;

		return display;
	}

	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;

		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}

			display = elem.style.display;
			if ( show ) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";

					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}

		return elements;
	}

	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}

			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );

	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );

		div.appendChild( input );

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();


	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}


	function getAll( context, tag ) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;

		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );

		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );

		} else {
			ret = [];
		}

		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}

		return ret;
	}


	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}


	var rhtml = /<|&#?\w+;/;

	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( toType( elem ) === "object" ) {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {

			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}

			attached = isAttached( elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	}


	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}

	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}

	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {

			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}

		if ( data == null && fn == null ) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {

				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}

	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {

		global: {},

		add: function( elem, types, handler, data, selector ) {

			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );

			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );

				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}

				if ( special.add ) {
					special.add.call( elem, handleObj );

					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}

		},

		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {

			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}

				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];

					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );

						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

						jQuery.removeEvent( elem, type, elemData.handle );
					}

					delete events[ type ];
				}
			}

			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},

		dispatch: function( nativeEvent ) {

			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),

				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),

				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;

			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;

				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {

					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );

						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}

			return event.result;
		},

		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;

			// Find delegate handlers
			if ( delegateCount &&

				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&

				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {

				for ( ; cur !== this; cur = cur.parentNode || this ) {

					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];

							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";

							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}

			return handlerQueue;
		},

		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},

				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},

		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {

				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {

						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {

						leverageNative( el, "click" );
					}

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},

			beforeunload: {
				postDispatch: function( event ) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {

		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}

		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );

				if ( ( event.isTrigger & 1 ) && this[ type ] ) {

					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {

						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );

						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {

							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}

					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}

				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {

					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(

							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );

					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}

	jQuery.removeEvent = function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};

	jQuery.Event = function( src, props ) {

		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}

		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&

					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

		// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,

		which: function( event ) {
			var button = event.button;

			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}

				if ( button & 2 ) {
					return 3;
				}

				if ( button & 4 ) {
					return 2;
				}

				return 0;
			}

			return event.which;
		}
	}, jQuery.event.addProp );

	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {

			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {

				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {

				// Force setup before trigger
				leverageNative( this, type );

				// Return non-false to allow normal event-path propagation
				return true;
			},

			delegateType: delegateType
		};
	} );

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,

			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );

	jQuery.fn.extend( {

		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {

				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );


	var

		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,

		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}

		return elem;
	}

	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;

		if ( dest.nodeType !== 1 ) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;

			if ( events ) {
				dataPriv.remove( dest, "handle events" );

				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}

		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );

			dataUser.set( dest, udataCur );
		}
	}

	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;

		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip( collection, args, callback, ignored ) {

		// Flatten any nested arrays
		args = flat( args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}

		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( collection[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {

							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;

		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}

			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}

		return elem;
	}

	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},

		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );

			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {

				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}

			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );

					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}

			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;

			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );

								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );

	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},

		remove: function( selector ) {
			return remove( this, selector );
		},

		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},

		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},

		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},

		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},

		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},

		empty: function() {
			var elem,
				i = 0;

			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {

					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},

		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;

				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

					value = jQuery.htmlPrefilter( value );

					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};

							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}

						elem = 0;

					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}

				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},

		replaceWith: function() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;

				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}

			// Force callback invocation
			}, ignored );
		}
	} );

	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;

			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}

			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

	var getStyles = function( elem ) {

			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;

			if ( !view || !view.opener ) {
				view = window;
			}

			return view.getComputedStyle( elem );
		};

	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};

		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}

		ret = callback.call( elem );

		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}

		return ret;
	};


	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



	( function() {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );

			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

			documentElement.removeChild( container );

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}

		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );

		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},

			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );

					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";

					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );

					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();


	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,

			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];

			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}


	function addGetHookIf( conditionFn, hookFn ) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}


	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};

	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {

		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;

		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}

	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];

		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}


	var

		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};

	function setPositiveNumber( _elem, value, subtract ) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?

			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}

	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;

		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}

		for ( ; i < 4; i += 2 ) {

			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {

				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}

			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}

				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5

			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}

		return delta;
	}

	function getWidthOrHeight( elem, dimension, extra ) {

		// Start with computed style
		var styles = getStyles( elem ),

			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,

			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}


		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||

			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||

			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

			// Make sure the element is visible & connected
			elem.getClientRects().length ) {

			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}

		// Normalize "" and auto
		val = parseFloat( val ) || 0;

		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,

				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}

	jQuery.extend( {

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {

						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {

			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}

			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;

				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );

					// Fixes bug #9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}

				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {

					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}

			} else {

				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},

		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}

			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}

			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}

			return val;
		}
	} );

	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},

			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),

					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",

					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}

				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {

					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}

				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );

	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);

	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},

					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];

				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}

				return expanded;
			}
		};

		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );

	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;

				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;

					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}

					return map;
				}

				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );


	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];

			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];

			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;

			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}

			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};




	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;

	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}

	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}

		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );

		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always( function() {

				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}

		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;

					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}

			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {

					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}

		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {

			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}

				/* eslint-disable no-loop-func */

				anim.done( function() {

				/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}

			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}

			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}

			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}

	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {

				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;

				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}

				deferred.notifyWith( elem, [ animation, percent, remaining ] );

				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}

				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}

				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,

						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}

					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;

		propFilter( props, animation.opts.specialEasing );

		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}

		jQuery.map( props, createTween, animation );

		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}

		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );

		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);

		return animation;
	}

	jQuery.Animation = jQuery.extend( Animation, {

		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},

		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}

			var prop,
				index = 0,
				length = props.length;

			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},

		prefilters: [ defaultPrefilter ],

		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );

	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};

		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;

		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];

				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}

			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};

		return opt;
	};

	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {

			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {

					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );

					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;

			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};

			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}

			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );

				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}

				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {

						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue( this, type, [] );

				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}

				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}

				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}

				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );

	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );

	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );

	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;

		fxNow = Date.now();

		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];

			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}

		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function() {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};


	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";

		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};


	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();


	var boolHook,
		attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},

		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );

	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}

			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}

				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				elem.setAttribute( name, value + "" );
				return value;
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function( elem, value ) {
			var name,
				i = 0,

				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );

			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );

	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};

	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;

		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();

			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );




	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},

		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );

	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}

			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				return ( elem[ name ] = value );
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			return elem[ name ];
		},

		propHooks: {
			tabIndex: {
				get: function( elem ) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );

					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}

					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;

					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );




		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}


	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}

	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}

	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );

					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {

							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );

			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}

			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}

			return this.each( function() {
				var className, i, self, classNames;

				if ( isValidValue ) {

					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );

					while ( ( className = classNames[ i++ ] ) ) {

						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}

				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {

						// Store className if set
						dataPriv.set( this, "__className__", className );
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},

		hasClass: function( selector ) {
			var className, elem,
				i = 0;

			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}

			return false;
		}
	} );




	var rreturn = /\r/g;

	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];

			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];

					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction( value );

			return this.each( function( i ) {
				var val;

				if ( this.nodeType !== 1 ) {
					return;
				}

				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";

				} else if ( typeof val === "number" ) {
					val += "";

				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}

				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );

	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {

					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :

						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;

					if ( index < 0 ) {
						i = max;

					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&

								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {

							// Get the specific value for the option
							value = jQuery( option ).val();

							// We don't need an array for one selects
							if ( one ) {
								return value;
							}

							// Multi-Selects return an array
							values.push( value );
						}
					}

					return values;
				},

				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;

					while ( i-- ) {
						option = options[ i ];

						/* eslint-disable no-cond-assign */

						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );

	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );




	// Return jQuery for attributes-only inclusion


	support.focusin = "onfocusin" in window;


	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};

	jQuery.extend( jQuery.event, {

		trigger: function( event, data, elem, onlyHandlers ) {

			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}

			if ( type.indexOf( "." ) > -1 ) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );

			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;

				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}

				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {

				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];

						if ( tmp ) {
							elem[ ontype ] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}

						elem[ type ]();

						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}

						jQuery.event.triggered = undefined;

						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);

			jQuery.event.trigger( e, null, elem );
		}

	} );

	jQuery.fn.extend( {

		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );


	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};

			jQuery.event.special[ fix ] = {
				setup: function() {

					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );

					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;

					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );

					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;

	var nonce = { guid: Date.now() };

	var rquery = ( /\?/ );



	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}

		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};


	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams( prefix, obj, traditional, add ) {
		var name;

		if ( Array.isArray( obj ) ) {

			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {

					// Treat each array item as a scalar.
					add( prefix, v );

				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );

		} else if ( !traditional && toType( obj ) === "object" ) {

			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}

		} else {

			// Serialize scalar item.
			add( prefix, obj );
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {

				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;

				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};

		if ( a == null ) {
			return "";
		}

		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );

		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}

		// Return the resulting serialization
		return s.join( "&" );
	};

	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();

				if ( val == null ) {
					return null;
				}

				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}

				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );


	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,

		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},

		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},

		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),

		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {

			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

			if ( isFunction( func ) ) {

				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {

					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

		var inspected = {},
			seekingTransport = ( structure === transports );

		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}

		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}

		return target;
	}

	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}

		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {

			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}

	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},

			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while ( current ) {

			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}

			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}

			prev = current;
			current = dataTypes.shift();

			if ( current ) {

				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {

					current = prev;

				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {

					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];

					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {

							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {

								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {

									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];

									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if ( conv !== true ) {

						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend( {

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?

				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},

		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),

		// Main method
		ajax: function( url, options ) {

			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,

				// URL without anti-cache param
				cacheURL,

				// Response headers
				responseHeadersString,
				responseHeaders,

				// timeout handle
				timeoutTimer,

				// Url cleanup var
				urlAnchor,

				// Request state (becomes false upon send and true upon completion)
				completed,

				// To know if global events are to be dispatched
				fireGlobals,

				// Loop variable
				i,

				// uncached part of the url
				uncached,

				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),

				// Callbacks context
				callbackContext = s.context || s,

				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,

				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),

				// Status-dependent callbacks
				statusCode = s.statusCode || {},

				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},

				// Default abort message
				strAbort = "canceled",

				// Fake xhr
				jqXHR = {
					readyState: 0,

					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},

					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},

					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},

					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},

					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {

								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {

								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},

					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};

			// Attach deferreds
			deferred.promise( jqXHR );

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );

			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}

			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );

			// More options handling for requests with no content
			if ( !s.hasContent ) {

				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );

				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}

			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);

			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}

			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );

			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}

				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}

				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}

				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {

					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}

					// Propagate others as results
					done( -1, e );
				}
			}

			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;

				// Ignore repeat invocations
				if ( completed ) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}

				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );

				// If successful, handle type chaining
				if ( isSuccess ) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}

					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";

					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";

					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";

				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}

				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;

				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}

				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}

			return jqXHR;
		},

		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},

		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );

	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {

			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );

	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );


	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,

			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};


	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;

			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}

				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}

				wrap.map( function() {
					var elem = this;

					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}

					return elem;
				} ).append( this );
			}

			return this;
		},

		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}

			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();

				if ( contents.length ) {
					contents.wrapAll( html );

				} else {
					self.append( html );
				}
			} );
		},

		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );

			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},

		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );


	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};




	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};

	var xhrSuccessStatus = {

			// File protocol always yields status code 0, assume 200
			0: 200,

			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();

					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}

					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;

								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(

											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,

										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};

					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {

							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}

					// Create the abort callback
					callback = callback( "abort" );

					try {

						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {

						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},

				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );

	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );

	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {

		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;

			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};

			// Force json dataType
			s.dataTypes[ 0 ] = "json";

			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always( function() {

				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );

				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}

				// Save back as free
				if ( s[ callbackName ] ) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}

				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}

				responseContainer = overwritten = undefined;
			} );

			// Delegate to script
			return "script";
		}
	} );




	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();


	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if ( !context ) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];

		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}

		parsed = buildFragment( [ data ], context, scripts );

		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}

		return jQuery.merge( [], parsed.childNodes );
	};


	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );

		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}

		// If it's a function
		if ( isFunction( params ) ) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {

				// Save response for use in complete callback
				response = arguments;

				self.html( selector ?

					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

					// Otherwise use the full result
					responseText );

			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}

		return this;
	};




	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};




	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};

			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;

			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}

			if ( isFunction( options ) ) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}

			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}

			if ( "using" in options ) {
				options.using.call( elem, props );

			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};

	jQuery.fn.extend( {

		// offset() relates an element's border box to the document origin
		offset: function( options ) {

			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}

			var rect, win,
				elem = this[ 0 ];

			if ( !elem ) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}

			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();

			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {

					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;

				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			} );
		}
	} );

	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;

		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {

				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}

				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}

				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);

				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );

					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );


	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

				return access( this, function( elem, type, value ) {
					var doc;

					if ( isWindow( elem ) ) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}

					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}

					return value === undefined ?

						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :

						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );


	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );




	jQuery.fn.extend( {

		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},

		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},

		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );

	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {

			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );




	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};

	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};




	var

		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,

		// Map over the $ in case of overwrite
		_$ = window.$;

	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}

		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}




	return jQuery;
	} ); 
} (jquery$1));

var jqueryExports = jquery$1.exports;
var jquery = /*@__PURE__*/getDefaultExportFromCjs(jqueryExports);

/* eslint-disable @typescript-eslint/no-unused-vars */
window.$ = jquery;
let done;
// the existence of a connectionProtocolVersion property indicates that the platform is using the new connection protocol
// this new connection protocol disconnects clients on pagehide, otherwise it will disconnect them on beforeunload
// this check ensures the frame cleans up before it gets disconnected from the GW
window.addEventListener("pagehide", () => {
    var _a;
    const connectionProtocolVersion = (_a = window.iobrowser) === null || _a === void 0 ? void 0 : _a.connectionProtocolVersion;
    if (!connectionProtocolVersion) {
        return;
    }
    facade.dispose();
    if (done) {
        done();
    }
});
window.addEventListener("beforeunload", () => {
    var _a;
    const connectionProtocolVersion = (_a = window.iobrowser) === null || _a === void 0 ? void 0 : _a.connectionProtocolVersion;
    if (connectionProtocolVersion) {
        return;
    }
    facade.dispose();
    if (done) {
        done();
    }
});
const init = (glue, componentFactory) => {
    const isInitialized = manager.initialized;
    if (isInitialized) {
        manager.init(glue, facade, componentFactory);
        return;
    }
    facade.subscribeForWorkspaceEvents();
    const result = manager.init(glue, facade, componentFactory);
    done = result.cleanUp;
    facade.init(glue).then(() => {
        if (!startupReader.config.emptyFrame) {
            manager.workspacesEventEmitter.raiseFrameEvent({ action: "opened", payload: { frameSummary: { id: glue.agm.instance.windowId }, frameBounds: manager.stateResolver.getFrameBounds() } });
        }
    }).catch(console.warn);
    return manager;
};
const workspacesManagerAPI = {
    init,
    getFrameId: () => {
        return manager.frameId;
    },
    notifyMoveAreaChanged: () => {
        return;
    },
    getComponentBounds: () => {
        return manager.getComponentBounds();
    },
    registerPopup: (element) => {
        return "";
    },
    removePopup: (element) => {
        return;
    },
    removePopupById: (element) => {
        return;
    },
    unmount: () => {
        manager.unmount();
        return;
    },
    subscribeForWindowFocused: (callback) => {
        return manager.subscribeForWindowClicked(callback);
    },
    notifyWorkspacePopupChanged: (element) => {
        return;
    },
    requestFocus: () => {
        return;
    },
    closeWorkspace: (id) => {
        manager.closeItem(id);
    },
    showSaveWorkspacePopup: (workspaceId, bounds) => {
        manager.showSaveWorkspacePopup(workspaceId, bounds);
    },
    closeWindow: (id) => {
        manager.closeItem(id);
    },
    restoreGroup: (id) => {
        manager.restoreItem(id);
    },
    maximizeGroup: (id) => {
        manager.maximizeItem(id);
    },
    ejectActiveWindow: (id) => {
        manager.ejectActiveWindow(id);
    },
    showChannelsSelector: (placementId, bounds) => {
        manager.showChannelsSelector(placementId, bounds);
    },
    showAddApplicationPopup: (workspaceId, groupId, bounds) => {
        manager.showAddWindowPopup(workspaceId, groupId, bounds);
    }
};

export { workspacesManagerAPI as default };
//# sourceMappingURL=export.js.map
